/*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-SR-7Q4M2 */
(function () {
  "use strict";
  /*! © School House Learning Centre (shlc-tutor.co.uk). All rights reserved. Not licensed for reuse, redistribution, resale or derivative works. Enquiries: info@shlc-tutor.co.uk · build SHLC-SR-7Q4M2 */
  /* host lock: only starts on our own hostnames; anywhere else it returns before the game is built.
     Allowed: shlc-tutor.co.uk + subdomains, the store myshopify host (theme previews), localhost, file://. */
  try { var __shlcH = String(location.hostname || '').toLowerCase();
    if (!(/(^|\.)shlc-tutor\.co\.uk$/.test(__shlcH) || __shlcH === 'c44a55-2.myshopify.com'
          || __shlcH === 'localhost' || __shlcH === '127.0.0.1' || __shlcH === '')) return;
  } catch (e) { return; }
  try { (window.SHLC_BUILD = window.SHLC_BUILD || {})['SR'] = 'SHLC-SR-7Q4M2'; } catch (e) {}
  var roots = document.querySelectorAll("[data-shlc-cnt]");
  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.cntReady === "true") return;
    root.dataset.cntReady = "true";

    /* ============================================================
       1. VECTOR + ROTATION CORE
       Cube frame: X=[1,0,0] right, Y=[0,1,0] front, Z=[0,0,1] top.
       ============================================================ */
    function vNeg(v) { return [-v[0], -v[1], -v[2]]; }
    function vEq(a, b) { return a[0] === b[0] && a[1] === b[1] && a[2] === b[2]; }
    function vDot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
    function vKey(v) { return v[0] + "," + v[1] + "," + v[2]; }
    function mApply(m, v) { return [vDot(m[0], v), vDot(m[1], v), vDot(m[2], v)]; }
    function mMul(a, b) {
      var out = [[0,0,0],[0,0,0],[0,0,0]];
      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          out[i][j] = a[i][0] * b[0][j] + a[i][1] * b[1][j] + a[i][2] * b[2][j];
        }
      }
      return out;
    }
    function mKey(m) { return m.map(function (r) { return r.join(","); }).join(";"); }
    var ROT_X = [[1,0,0],[0,0,-1],[0,1,0]];
    var ROT_Y = [[0,0,1],[0,1,0],[-1,0,0]];
    var ROT_Z = [[0,-1,0],[1,0,0],[0,0,1]];
    var IDENTITY = [[1,0,0],[0,1,0],[0,0,1]];
    var ROTS24 = (function () {
      var seen = {};
      var list = [];
      var queue = [IDENTITY];
      seen[mKey(IDENTITY)] = true;
      while (queue.length) {
        var m = queue.shift();
        list.push(m);
        [ROT_X, ROT_Y, ROT_Z].forEach(function (g) {
          var nm = mMul(g, m);
          var k = mKey(nm);
          if (!seen[k]) { seen[k] = true; queue.push(nm); }
        });
      }
      return list; /* exactly 24 proper rotations of the cube */
    })();

    /* Canonical on-screen axes for each cube face, as seen from outside.
       Invariant: R x D = n for every entry (verified analytically). */
    var ROLE_AXES = {
      top:    { n: [0,0,1],  R: [1,0,0],  D: [0,1,0]  },
      bottom: { n: [0,0,-1], R: [1,0,0],  D: [0,-1,0] },
      front:  { n: [0,1,0],  R: [1,0,0],  D: [0,0,-1] },
      back:   { n: [0,-1,0], R: [-1,0,0], D: [0,0,-1] },
      right:  { n: [1,0,0],  R: [0,-1,0], D: [0,0,-1] },
      left:   { n: [-1,0,0], R: [0,1,0],  D: [0,0,-1] }
    };
    var ROLE_BY_NKEY = {};
    Object.keys(ROLE_AXES).forEach(function (role) {
      ROLE_BY_NKEY[vKey(ROLE_AXES[role].n)] = role;
    });
    var VISIBLE_ROLES = ["top", "front", "right"];

    /* Clockwise quarter-turn angle that carries canonical axes (R,D)
       onto glyph axes (gR,gD) within the face plane. */
    function axisAngle(R, D, gR) {
      if (vEq(gR, R)) return 0;
      if (vEq(gR, D)) return 90;
      if (vEq(gR, vNeg(R))) return 180;
      return 270;
    }

    function shuffle(arr) {
      var copy = arr.slice();
      for (var i = copy.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = copy[i]; copy[i] = copy[j]; copy[j] = t;
      }
      return copy;
    }
    function choice(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
    function esc(s) {
      return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

    /* ---- persistence (best scores, preferences) ---- */
    var STORE_KEY = "shlc_spatial_v1";
    function loadStore() {
      try {
        var s = JSON.parse(localStorage.getItem(STORE_KEY));
        if (s && typeof s === "object") return s;
      } catch (e) {}
      return {};
    }
    var store = loadStore();
    store.prefs = store.prefs || {};
    store.best = store.best || {};
    store.hist = store.hist || [];
    function saveStore() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(store)); } catch (e) {}
    }
    function bestKey(qtype, len) { return qtype + "|" + len; }

    /* ---- sound effects: the shared SHLC sound kit v2 (WebAudio, no asset files) ---- */
    var muted = store.prefs.muted === true;
/* SHLC sound kit v2, source: shared/shlc-sounds.js */
var SHLCSounds = (function(){
var PENTA = [0, 2, 4, 7, 9];
function mtof(m){ return 440 * Math.pow(2, (m - 69) / 12); }
function rnd(a, b){ return a + Math.random() * (b - a); }
function build(a){
var comp = a.createDynamicsCompressor();
comp.threshold.value = -14; comp.knee.value = 10; comp.ratio.value = 4;
comp.attack.value = 0.003; comp.release.value = 0.18;
var out = a.createGain(); out.gain.value = 1;
out.connect(comp); comp.connect(a.destination);
var len = Math.floor(a.sampleRate), nb = a.createBuffer(1, len, a.sampleRate), d = nb.getChannelData(0);
for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
var room = null;
try {
var rl = Math.floor(a.sampleRate * 1.1), ir = a.createBuffer(2, rl, a.sampleRate);
for (var c = 0; c < 2; c++){
var ch = ir.getChannelData(c);
for (var j = 0; j < rl; j++) ch[j] = (Math.random() * 2 - 1) * Math.pow(1 - j / rl, 3.2);
}
var conv = a.createConvolver(); conv.buffer = ir;
var wet = a.createGain(); wet.gain.value = 0.5;
room = a.createGain(); room.gain.value = 1;
room.connect(conv); conv.connect(wet); wet.connect(out);
} catch (e) { room = null; }
return { a: a, out: out, room: room, noise: nb };
}
function shared(){
var w = window;
if (w.__shlcAudio) return w.__shlcAudio;
var AC = w.AudioContext || w.webkitAudioContext;
if (!AC) return null;
w.__shlcAudio = build(new AC());
return w.__shlcAudio;
}
function unlockOnce(isOn){
var w = window;
(w.__shlcAudioOn = w.__shlcAudioOn || []).push(isOn);
if (w.__shlcAudioUnlock) return;
w.__shlcAudioUnlock = true;
var wake = function(){
w.__shlcAudioTapped = true;
try {
var want = false;
for (var i = 0; i < w.__shlcAudioOn.length; i++) if (w.__shlcAudioOn[i]()) want = true;
if (!want) return;
var S = shared();
if (S && S.a.state === 'suspended' && S.a.resume) S.a.resume();
} catch (e) {}
};
['pointerdown', 'keydown', 'touchend'].forEach(function(ev){ document.addEventListener(ev, wake, true); });
}
return function(cfg){
cfg = cfg || {};
var S = null, bus = null, wet = null, baseT = 0;
var root = cfg.root || 60;
var level = cfg.volume == null ? 0.6 : cfg.volume;
var free = !!cfg.ctx;
var last = {}, recent = {}, lastPick = {}, streak = 0, tock = false;
function on(){ try { return cfg.on ? !!cfg.on() : true; } catch (e) { return false; } }
if (!free) unlockOnce(on);
function tapped(){
try { if (navigator.userActivation) return navigator.userActivation.hasBeenActive; } catch (e) {}
return !!window.__shlcAudioTapped;
}
function A(){
if (!on()) return null;
if (!free && (document.hidden || !tapped())) return null;
try {
if (!S){
S = free ? build(cfg.ctx) : shared();
if (!S) return null;
busses();
}
if (S.a.state === 'suspended' && S.a.resume && !free) S.a.resume();
return S.a;
} catch (e) { return null; }
}
function busses(){
bus = S.a.createGain(); bus.gain.value = level; bus.connect(S.out);
wet = null;
if (S.room){ wet = S.a.createGain(); wet.gain.value = 1; wet.connect(S.room); }
}
function log(n, arg, v, f){
try { var L = window.__sfxLog; if (L && L.push) L.push({ n: n, a: arg, v: v, f: f ? Math.round(f) : 0, t: Date.now() }); } catch (e) {}
}
function gate(name, gap){
if (!on()) return false;
if (free) return true;
var now = Date.now();
if (last[name] && now - last[name] < (gap || 35)) return false;
last[name] = now;
var r = recent[name];
recent[name] = (r && now - r.t < 1400) ? { t: now, c: Math.min(r.c + 1, 6) } : { t: now, c: 0 };
return true;
}
function tired(name){ var r = recent[name]; return r ? Math.max(0.5, 1 - r.c * 0.1) : 1; }
function pick(name, count){
if (cfg.variant != null) return cfg.variant % count;
var p = lastPick[name], v = Math.floor(Math.random() * count);
if (count > 1 && v === p) v = (p + 1 + Math.floor(Math.random() * (count - 1))) % count;
lastPick[name] = v;
return v;
}
function vary(f, cents){ return f * Math.pow(2, rnd(-cents, cents) / 1200); }
function N(i, base){
var o = Math.floor(i / 5), r = ((i % 5) + 5) % 5;
return mtof((base == null ? root : base) + 12 * o + PENTA[r]);
}
function panOf(i){ return i == null ? 0 : Math.max(-0.4, Math.min(0.4, -0.4 + (i % 5) * 0.2)); }
function tone(o){
var a = A(); if (!a) return;
try {
var t = a.currentTime + 0.006 + baseT + (o.t || 0), dur = o.dur || 0.15, f = o.f, f1 = o.f1;
if (!o.raw) while (f > 4800){ f /= 2; if (f1) f1 /= 2; }
var osc = a.createOscillator(), g = a.createGain(), node = osc;
osc.type = o.type || 'sine';
osc.frequency.setValueAtTime(f, t);
if (f1) osc.frequency.exponentialRampToValueAtTime(f1, t + (o.glide || dur * 0.6));
if (o.lp){
var lp = a.createBiquadFilter(); lp.type = 'lowpass'; lp.Q.value = o.q || 0.7;
lp.frequency.setValueAtTime(o.lp, t);
if (o.lp1) lp.frequency.exponentialRampToValueAtTime(o.lp1, t + dur);
node.connect(lp); node = lp;
}
g.gain.setValueAtTime(0.0001, t);
g.gain.exponentialRampToValueAtTime(Math.max(0.0002, o.vol || 0.1), t + (o.att || 0.005));
g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
node.connect(g);
var dest = g;
if (o.pan && a.createStereoPanner){ var p = a.createStereoPanner(); p.pan.value = Math.max(-1, Math.min(1, o.pan)); g.connect(p); dest = p; }
dest.connect(bus);
if (o.room && wet){ var sg = a.createGain(); sg.gain.value = o.room * level; dest.connect(sg); sg.connect(wet); }
if (o.wob){
var l = a.createOscillator(), lg = a.createGain();
l.frequency.setValueAtTime(o.wob, t);
lg.gain.setValueAtTime(f * (o.wobd || 0.16), t);
lg.gain.exponentialRampToValueAtTime(0.5, t + dur);
l.connect(lg); lg.connect(osc.frequency); l.start(t); l.stop(t + dur + 0.05);
}
osc.start(t); osc.stop(t + dur + 0.05);
} catch (e) {}
}
function noise(o){
var a = A(); if (!a) return;
try {
var t = a.currentTime + 0.006 + baseT + (o.t || 0), dur = o.dur || 0.1;
var s = a.createBufferSource(), fl = a.createBiquadFilter(), g = a.createGain();
s.buffer = S.noise;
fl.type = o.kind || 'bandpass'; fl.Q.value = o.q || 1;
fl.frequency.setValueAtTime(o.f || 1000, t);
if (o.f1) fl.frequency.exponentialRampToValueAtTime(o.f1, t + dur);
g.gain.setValueAtTime(0.0001, t);
g.gain.exponentialRampToValueAtTime(Math.max(0.0002, o.vol || 0.05), t + (o.att || 0.004));
g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
s.connect(fl); fl.connect(g);
var dest = g;
if (o.pan && a.createStereoPanner){ var p = a.createStereoPanner(); p.pan.value = Math.max(-1, Math.min(1, o.pan)); g.connect(p); dest = p; }
dest.connect(bus);
s.start(t, Math.random() * Math.max(0, 0.95 - dur)); s.stop(t + dur + 0.03);
} catch (e) {}
}
function marimba(f, o){ o = o || {}; var v = o.vol || 0.1;
tone({ f: f, dur: o.dur || 0.26, vol: v, att: 0.003, t: o.t, pan: o.pan, room: o.room });
if (f * 4 < 11000) tone({ f: f * 4, dur: 0.045, vol: v * 0.3, att: 0.002, t: o.t, pan: o.pan, raw: true });
noise({ f: Math.min(f * 3, 9000), q: 2.5, dur: 0.02, vol: v * 0.6, t: o.t, pan: o.pan });
}
function glass(f, o){ o = o || {}; var v = o.vol || 0.09;
tone({ f: f, dur: o.dur || 0.6, vol: v, att: 0.002, t: o.t, pan: o.pan, room: o.room == null ? 0.25 : o.room });
if (f * 2.76 < 11000) tone({ f: f * 2.76, dur: 0.22, vol: v * 0.28, att: 0.002, t: o.t, pan: o.pan, raw: true });
if (f * 5.4 < 11000) tone({ f: f * 5.4, dur: 0.08, vol: v * 0.12, att: 0.002, t: o.t, pan: o.pan, raw: true });
}
function bubble(f, o){ o = o || {}; var v = o.vol || 0.1;
tone({ f: f * 0.55, f1: f, glide: 0.05, dur: o.dur || 0.14, vol: v, att: 0.004, t: o.t, pan: o.pan });
}
function arcade(f, o){ o = o || {}; var v = o.vol || 0.06;
tone({ f: f, dur: o.dur || 0.09, vol: v, type: 'square', lp: 2600, att: 0.002, t: o.t, pan: o.pan });
tone({ f: f * 2, dur: 0.04, vol: v * 0.4, type: 'square', lp: 3000, att: 0.002, t: (o.t || 0) + 0.045, pan: o.pan });
}
function wood(f, o){ o = o || {}; var v = o.vol || 0.08;
tone({ f: f * 1.5, f1: f, glide: 0.012, dur: 0.06, vol: v, att: 0.001, t: o.t, pan: o.pan });
noise({ f: Math.min(f * 2.2, 9000), q: 4, dur: 0.025, vol: v * 1.5, t: o.t, pan: o.pan });
}
function pluck(f, o){ o = o || {}; var v = o.vol || 0.09;
tone({ f: f, dur: o.dur || 0.32, vol: v, type: 'triangle', lp: f * 6, lp1: f * 1.2, att: 0.002, t: o.t, pan: o.pan, room: o.room });
if (f * 3 < 11000) tone({ f: f * 3, dur: 0.05, vol: v * 0.2, att: 0.001, t: o.t, pan: o.pan, raw: true });
}
var INST = { marimba: marimba, glass: glass, bubble: bubble, arcade: arcade, wood: wood, pluck: pluck };
function thud(){ tone({ f: 150, f1: 80, glide: 0.07, dur: 0.1, vol: 0.12, att: 0.003, lp: 600 }); }
function sparkle(t, count){
for (var j = 0; j < count; j++){
tone({ f: N(10 + Math.floor(Math.random() * 6), root + 12), dur: 0.09, vol: 0.03, att: 0.002, t: t + j * rnd(0.035, 0.06), pan: rnd(-0.6, 0.6), room: 0.3 });
}
}
function key(k){
if (!gate('key:' + k, 25)) return;
var s = String(k).toLowerCase(), d = parseInt(s, 10), b = root + 12;
if (/^[0-9]$/.test(s)){
var i = d === 0 ? -1 : d - 1, f = vary(N(i, b), 5);
var pan = d === 0 ? 0 : [-0.28, 0, 0.28][(d - 1) % 3];
(INST[cfg.keys] || marimba)(f, { vol: 0.09 * Math.pow(0.975, i) * tired('key:' + k), pan: pan });
log('key', d, 0, f);
return;
}
switch (s){
case 'del': case 'back': case 'backspace': case 'delete': case 'erase':
tone({ f: vary(N(5, b), 10), f1: N(0, b), glide: 0.07, dur: 0.1, vol: 0.08, att: 0.003 });
noise({ f: 2800, q: 1.5, dur: 0.025, vol: 0.06 });
s = 'del'; break;
case 'clear': case 'c':
marimba(N(4, b), { vol: 0.04 }); marimba(N(1, b), { vol: 0.035, t: 0.06 }); marimba(N(-2, b), { vol: 0.03, t: 0.12 });
s = 'clear'; break;
case '-': case 'minus': case '−':
wood(N(-3, b), { vol: 0.14 }); s = '-'; break;
case '.': case 'point':
wood(N(12, b), { vol: 0.09 }); s = '.'; break;
case 'enter': case 'ok': case 'go':
marimba(N(0, b), { vol: 0.035 }); marimba(N(4, b), { vol: 0.04, t: 0.05 }); s = 'enter'; break;
default:
thud(); s = 'full';
}
log('key', s);
}
function combo(tier){
var steps = Math.min(3 + tier, 7), b = root + 12;
for (var j = 0; j < steps; j++) glass(N(j * 2, b), { vol: 0.07 + j * 0.006, t: j * 0.055, pan: -0.3 + j * (0.6 / steps), room: 0.2 });
sparkle(steps * 0.055, 4 + tier);
}
function right(n){
if (!gate('right', 60)) return;
streak = n == null ? streak + 1 : n;
if (cfg.combo !== false && streak > 0 && streak % 5 === 0){ combo(streak / 5); log('right', streak, 'combo', N(0, root + 12)); return; }
var i = streak <= 10 ? Math.max(0, streak - 1) : 7 + (streak % 3);
var v = pick('right', 3), f = vary(N(i, root + 12), 4), pan = rnd(-0.12, 0.12);
if (v === 0){ glass(f, { vol: 0.095, pan: pan }); glass(f * 1.5, { vol: 0.04, t: 0.07, pan: pan, room: 0.15 }); }
else if (v === 1){ marimba(f, { vol: 0.095, pan: pan }); glass(N(i + 2, root + 12), { vol: 0.064, t: 0.075, pan: pan }); }
else { bubble(f, { vol: 0.1, pan: pan }); glass(N(i + 5, root + 12), { vol: 0.06, t: 0.06, pan: pan }); }
log('right', streak, v, f);
}
function ok(){
if (!gate('ok', 120)) return;
glass(N(2, root + 12), { vol: 0.03 }); glass(N(4, root + 12), { vol: 0.033, t: 0.09 });
log('ok');
}
function wrong(){
if (!gate('wrong', 120)) return;
streak = 0;
var v = pick('wrong', 3), k = tired('wrong');
if (v === 0){
tone({ f: vary(mtof(root + 7), 6), dur: 0.13, vol: 0.052 * k, type: 'triangle', lp: 1500, att: 0.01 });
tone({ f: vary(mtof(root + 4), 6), f1: mtof(root + 4) * 0.96, glide: 0.2, dur: 0.24, vol: 0.052 * k, type: 'triangle', lp: 1100, att: 0.01, t: 0.13 });
} else if (v === 1){
tone({ f: vary(mtof(root + 4), 8), f1: mtof(root - 3), glide: 0.09, dur: 0.2, vol: 0.13 * k, lp: 900, wob: 22, wobd: 0.05, att: 0.004 });
} else {
tone({ f: vary(mtof(root), 6), dur: 0.1, vol: 0.041 * k, type: 'square', lp: 700, att: 0.01 });
tone({ f: vary(mtof(root - 3), 6), f1: mtof(root - 3) * 0.97, glide: 0.15, dur: 0.2, vol: 0.041 * k, type: 'square', lp: 600, att: 0.01, t: 0.11 });
}
log('wrong', null, v);
}
function almost(){
if (!gate('almost', 150)) return;
tone({ f: N(1, root + 12), dur: 0.1, vol: 0.07, type: 'triangle', att: 0.004 });
tone({ f: N(2, root + 12), f1: N(2, root + 12) * 1.02, dur: 0.2, vol: 0.07, type: 'triangle', att: 0.004, t: 0.1 });
log('almost');
}
function reveal(){
if (!gate('reveal', 150)) return;
glass(N(4, root + 12), { vol: 0.043 }); glass(N(2, root + 12), { vol: 0.036, t: 0.12 });
log('reveal');
}
function finish(pct, pass){
if (!on()) return;
log('finish', pct == null ? null : Math.round(pct * 100), pass);
if (pct == null) win(0);
else if (pass != null && pct < pass) done();
else if (pct >= 1) win(2);
else if (pct >= Math.max(0.8, pass || 0)) win(1);
else if (pct >= 0.5 || pass != null) win(0);
else done();
}
function done(){
if (!gate('done', 400)) return;
var b = root + 12;
marimba(N(2, b), { vol: 0.044 }); marimba(N(1, b), { vol: 0.041, t: 0.12 }); marimba(N(3, b), { vol: 0.047, t: 0.24, dur: 0.4 });
glass(N(5, b), { vol: 0.017, t: 0.26 });
log('done');
}
function tick(left){
if (!gate('tick', 150)) return;
tock = !tock;
var urgent = left != null && left <= 3, f = (tock ? 1850 : 1400) * (urgent ? 1.26 : 1);
noise({ f: f, q: 6, dur: 0.028, vol: urgent ? 0.4 : 0.3 });
tone({ f: f / 2, dur: 0.03, vol: urgent ? 0.12 : 0.08, att: 0.001 });
log('tick', left, tock ? 1 : 0, f);
}
function timeUp(){
if (!gate('timeup', 400)) return;
tone({ f: 1050, f1: 330, glide: 0.42, dur: 0.48, vol: 0.057, wob: 9, wobd: 0.03, att: 0.01 });
tone({ f: 110, f1: 70, glide: 0.1, dur: 0.18, vol: 0.09, t: 0.44, att: 0.004 });
log('timeup');
}
function count(n){
if (!gate('count' + n, 200)) return;
var i = n >= 3 ? 0 : n === 2 ? 2 : 4, f = N(i, root + 12);
wood(f, { vol: 0.085 }); marimba(f, { vol: 0.14 });
log('count', n, 0, f);
}
function go(){
if (!gate('go', 200)) return;
[0, 4, 7, 12].forEach(function(s, j){ tone({ f: mtof(root + 12 + s), dur: 0.42, vol: 0.06, type: 'triangle', att: 0.004, t: j * 0.012, room: 0.2 }); });
noise({ kind: 'bandpass', f: 500, f1: 4200, dur: 0.3, vol: 0.12, q: 0.8 });
log('go', null, 0, mtof(root + 12));
}
var MOTIFS = [[0, 2, 4, 5], [2, 4, 2, 5], [0, 3, 4, 7], [4, 3, 4, 6], [0, 1, 2, 5]];
function win(tier){
if (!gate('win', 600)) return;
tier = tier || 0;
var v = pick('win', MOTIFS.length), m = MOTIFS[v], b = root + 12, step = 0.105;
m.forEach(function(i, j){ marimba(N(i, b), { vol: 0.12, t: j * step, pan: -0.2 + j * 0.13 }); });
var tc = m.length * step + 0.02, top = m[m.length - 1];
[top - 5, top - 3, top - 1, top].forEach(function(i){
tone({ f: vary(N(i, b), 6), dur: 0.8 + tier * 0.4, vol: 0.05, type: 'triangle', att: 0.01, t: tc, room: 0.25 });
});
glass(N(top + 5, b), { vol: 0.06, t: tc + 0.02 });
if (tier > 0){
for (var j = 0; j < 8; j++) glass(N(top + j, b), { vol: 0.035, t: tc + 0.12 + j * 0.045, pan: rnd(-0.5, 0.5), room: 0.3 });
tone({ f: N(top - 10, b), dur: 1.0, vol: 0.08, type: 'triangle', t: tc, att: 0.01 });
}
for (var c = 0; c < 6 + tier * 4; c++) noise({ kind: 'highpass', f: rnd(2000, 5200), dur: 0.045, vol: 0.12, t: tc + 0.18 + c * rnd(0.06, 0.1), pan: rnd(-0.7, 0.7) });
log('win', tier, v);
}
function medal(t){
if (!gate('medal', 300)) return;
t = Math.max(1, Math.min(3, t || 1));
for (var j = 0; j <= t; j++) glass(N(j * 2, root + 12), { vol: 0.08, t: j * 0.09, room: 0.25 });
if (t >= 3) sparkle((t + 1) * 0.09 + 0.05, 8);
log('medal', t);
}
function star(i){
if (!gate('star' + i, 80)) return;
glass(N(5 + (i || 0) * 2, root + 12), { vol: 0.08, room: 0.25 });
noise({ kind: 'highpass', f: 5000, dur: 0.06, vol: 0.08, t: 0.02 });
log('star', i);
}
function best(){
if (!gate('best', 400)) return;
[5, 7, 10].forEach(function(i, j){ glass(N(i, root + 12), { vol: 0.09, t: j * 0.1 }); });
sparkle(0.32, 7);
log('best');
}
function tally(i){
if (!gate('tally', 45)) return;
wood(N((i || 0) % 12, root + 12), { vol: 0.07 * tired('tally') });
log('tally', i);
}
function ui(kind, i){
if (!gate('ui:' + kind + (i == null ? '' : ':' + i), 40)) return;
var b = root + 12, v, hz = 0;
switch (kind){
case 'play':
bubble(N(0, b), { vol: 0.045 }); bubble(N(2, b), { vol: 0.045, t: 0.07 }); bubble(N(5, b), { vol: 0.055, t: 0.14, dur: 0.2 });
noise({ kind: 'bandpass', f: 600, f1: 3200, dur: 0.22, vol: 0.04, q: 0.9, t: 0.06 }); break;
case 'next':
marimba(N(2, b), { vol: 0.045 }); marimba(N(5, b), { vol: 0.05, t: 0.08 }); break;
case 'open':
noise({ kind: 'bandpass', f: 500, f1: 2600, dur: 0.16, vol: 0.1, q: 1.1 }); wood(N(7, b), { vol: 0.045, t: 0.08 }); break;
case 'close':
noise({ kind: 'bandpass', f: 2400, f1: 450, dur: 0.16, vol: 0.1, q: 1.1 }); wood(N(0, b), { vol: 0.045, t: 0.08 }); break;
case 'back':
wood(N(5, b), { vol: 0.07 }); wood(N(2, b), { vol: 0.06, t: 0.07 });
noise({ kind: 'bandpass', f: 1800, f1: 700, dur: 0.08, vol: 0.06, q: 1.2 }); break;
case 'help':
tone({ f: N(0, b), dur: 0.09, vol: 0.045, type: 'triangle', att: 0.004 });
tone({ f: N(3, b), f1: N(3, b) * 1.03, dur: 0.16, vol: 0.045, type: 'triangle', att: 0.004, t: 0.09 }); break;
case 'on':
wood(N(4, b), { vol: 0.06 }); tone({ f: N(5, b), f1: N(7, b), glide: 0.04, dur: 0.08, vol: 0.07, t: 0.03 }); break;
case 'off':
wood(N(2, b), { vol: 0.06 }); tone({ f: N(4, b), f1: N(1, b), glide: 0.05, dur: 0.09, vol: 0.06, t: 0.03 }); break;
case 'select':
hz = N(i == null ? Math.floor(Math.random() * 5) : i % 10, b);
pluck(hz, { vol: 0.08, pan: panOf(i) }); break;
case 'tab':
hz = N(((i || 0) % 8) + 2, b);
wood(hz, { vol: 0.1 }); break;
case 'level':
hz = N(((i || 1) - 1) % 10, b);
pluck(hz, { vol: 0.08 }); break;
case 'slide':
hz = N(Math.round((i || 0) * 10), b);
wood(hz, { vol: 0.06 }); break;
case 'pause':
tone({ f: N(4, b), dur: 0.08, vol: 0.052, type: 'triangle', lp: 2000 });
tone({ f: N(1, b), dur: 0.14, vol: 0.052, type: 'triangle', lp: 1400, t: 0.08 }); break;
case 'resume':
tone({ f: N(1, b), dur: 0.08, vol: 0.052, type: 'triangle', lp: 2000 });
tone({ f: N(4, b), dur: 0.14, vol: 0.052, type: 'triangle', lp: 2400, t: 0.08 }); break;
case 'restart':
tone({ f: 900, f1: 180, glide: 0.24, dur: 0.26, vol: 0.05, type: 'sawtooth', lp: 1600, lp1: 500, wob: 28, wobd: 0.08 });
wood(N(0, b), { vol: 0.06, t: 0.25 }); break;
case 'undo':
tone({ f: N(5, b), f1: N(1, b), glide: 0.07, dur: 0.11, vol: 0.1, att: 0.003 }); break;
case 'hint':
noise({ kind: 'bandpass', f: 700, f1: 5200, dur: 0.35, vol: 0.06, q: 0.8 });
for (var j = 0; j < 3; j++) glass(N(7 + j * 2 + Math.min(i || 0, 4), b), { vol: 0.028, t: 0.05 + j * 0.07, room: 0.3 }); break;
case 'skip':
noise({ kind: 'bandpass', f: 1200, f1: 3800, dur: 0.09, vol: 0.28, q: 1.4 }); break;
case 'denied':
thud(); break;
case 'ask':
wood(N(-2, b), { vol: 0.07 });
tone({ f: N(1, b), f1: N(2, b) * 1.02, glide: 0.12, dur: 0.18, vol: 0.05, type: 'triangle', att: 0.006, t: 0.08 }); break;
case 'start':
var up = i == null ? 5 : 3 + ((i * 3) % 7);
noise({ kind: 'bandpass', f: 400, f1: 2600, dur: 0.28, vol: 0.08, q: 0.9 });
tone({ f: N(0, root), f1: N(up, root), glide: 0.18, dur: 0.22, vol: 0.05 }); break;
default:
v = pick('tap', 3);
wood([N(9, b), N(10, b), N(8, b)][v], { vol: 0.07 });
kind = 'tap';
}
log('ui', kind, i, hz);
}
function cell(i){
if (!gate('cell', 30)) return;
var f = N(((i || 0) % 10) + 3, root + 12);
var k = tired('cell');
tone({ f: f, dur: 0.05, vol: 0.075 * k, att: 0.002, type: 'triangle' });
noise({ f: Math.min(f * 2, 8000), q: 5, dur: 0.018, vol: 0.11 });
log('cell', i, 0, f);
}
function place(p, pan){
if (!gate('place', 30)) return;
var i = p == null ? Math.floor(Math.random() * 8) : Math.round(Math.max(0, Math.min(1, p)) * 9);
var f = vary(N(i, root + 12), 5);
(INST[cfg.place] || bubble)(f, { vol: 0.11, pan: pan });
noise({ f: 2400, q: 3, dur: 0.03, vol: 0.08 });
log('place', p, 0, f);
}
function remove(p){
if (!gate('remove', 40)) return;
var f = N(p == null ? 5 : Math.round(p * 9) + 2, root + 12);
tone({ f: f, f1: f * 0.4, glide: 0.13, dur: 0.15, vol: 0.09 });
log('remove', p, 0, f);
}
function land(){
if (!gate('land', 60)) return;
var v = pick('land', 3), f0 = [190, 220, 170][v];
tone({ f: f0, f1: f0 * 2.9, glide: 0.06, dur: 0.36, vol: 0.095, type: 'triangle', wob: 16 + v * 2, wobd: 0.16, t: 0.04 });
log('land', null, v);
}
function lift(){
if (!gate('lift', 60)) return;
tone({ f: N(2, root + 12), f1: N(4, root + 12), glide: 0.05, dur: 0.07, vol: 0.08 });
log('lift');
}
function drag(i, fits){
if (!gate('drag', 55)) return;
wood(N((i || 0) % 15, root + 12), { vol: 0.05 * tired('drag') });
if (fits) glass(N(((i || 0) % 10) + 5, root + 12), { vol: 0.03, dur: 0.25, room: 0.15 });
log('drag', i, fits ? 1 : 0);
}
function group(kind, count, idx){
if (!gate('group', 120)) return;
var s = ((kind || 0) % 3) * 2 + ((idx || 0) % 2), n = 2 + Math.max(1, Math.min(3, count || 1));
for (var j = 0; j < n; j++) glass(N(5 + s + j, root), { vol: 0.045 + j * 0.004, t: j * 0.06, pan: -0.2 + j * 0.1 });
if (n >= 5) sparkle(n * 0.06, 4);
log('group', kind, count || 1);
}
function pencil(){
if (!gate('pencil', 30)) return;
noise({ kind: 'highpass', f: rnd(3800, 5200), dur: rnd(0.035, 0.06), vol: 0.11 });
noise({ kind: 'bandpass', f: rnd(2500, 3200), q: 3, dur: 0.03, vol: 0.065, t: 0.035 });
log('pencil');
}
function scribble(){
if (!gate('scribble', 120)) return;
for (var j = 0; j < 4; j++) noise({ kind: 'bandpass', f: rnd(1800, 3400), q: 1.8, dur: 0.05, vol: 0.16, t: j * 0.055 });
log('scribble');
}
function sign(op){
if (!gate('sign', 30)) return;
var b = root + 12, o = String(op);
if (o === '+'){ pluck(N(2, b), { vol: 0.056 }); pluck(N(4, b), { vol: 0.042, t: 0.045 }); }
else if (o === '-' || o === '−'){ pluck(N(4, b), { vol: 0.056 }); pluck(N(2, b), { vol: 0.042, t: 0.045 }); }
else if (o === '*' || o === 'x' || o === '×'){ glass(N(5, b), { vol: 0.038, dur: 0.3 }); glass(N(7, b), { vol: 0.03, t: 0.035, dur: 0.3 }); }
else { pluck(N(1, b), { vol: 0.052, pan: -0.25 }); pluck(N(6, b), { vol: 0.045, t: 0.06, pan: 0.25 }); }
log('sign', o);
}
function card(i){
if (!gate('card', 40)) return;
var j = i == null ? Math.floor(Math.random() * 10) : i;
var k = tired('card');
noise({ kind: 'bandpass', f: rnd(2200, 3200), q: 1.2, dur: 0.05, vol: 0.2 * k, pan: rnd(-0.2, 0.2) });
noise({ kind: 'lowpass', f: 420, q: 0.8, dur: 0.05, vol: 0.2, t: 0.02 });
var f = N(j % 10, root + 12);
tone({ f: f, dur: 0.07, vol: 0.025, att: 0.002, t: 0.015 });
log('card', i, 0, f);
}
function flip(i){
if (!gate('flip', 40)) return;
noise({ kind: 'bandpass', f: 1500, f1: 4200, dur: 0.08, vol: 0.19 * tired('flip'), q: 1.4 });
var f = N(((i || 0) % 10) + 2, root + 12);
pluck(f, { vol: 0.028, t: 0.05 });
log('flip', i, 0, f);
}
function letter(i, vowel){
if (!gate('letter', 30)) return;
var f = N((i || 0) % 10, root + 12);
if (vowel) glass(f * 2, { vol: 0.07, dur: 0.35 }); else marimba(f, { vol: 0.1 });
log('letter', i, vowel ? 1 : 0, f);
}
function type(ch){
if (!gate('type', 20)) return;
var c = String(ch == null ? ' ' : ch).charCodeAt(0) || 0;
noise({ kind: 'bandpass', f: 2200 + (c % 7) * 260, q: 2.2, dur: 0.018, vol: 0.35 });
tone({ f: 180 + (c % 5) * 22, dur: 0.02, vol: 0.09, att: 0.001 });
log('type', ch);
}
function option(i){
if (!gate('opt:' + i, 30)) return;
pluck(N((i || 0) * 2, root + 12), { vol: 0.08, pan: panOf(i) });
log('option', i, 0, N((i || 0) * 2, root + 12));
}
function swish(dir){
if (!gate('swish', 50)) return;
var up = dir !== 'down' && dir !== -1;
noise({ kind: 'bandpass', f: up ? 600 : 3000, f1: up ? 3000 : 600, dur: 0.14, vol: 0.55, q: 1.3 });
log('swish', dir);
}
function fold(dir){
if (!gate('fold', 60)) return;
var open = dir === 'open' || dir === -1;
for (var j = 0; j < 3; j++) noise({ kind: 'bandpass', f: rnd(1500, 3500), q: 2, dur: 0.025, vol: 0.12, t: j * rnd(0.02, 0.04) });
tone({ f: open ? 160 : 240, f1: open ? 250 : 160, glide: 0.06, dur: 0.08, vol: 0.05, t: 0.07 });
if (open) noise({ kind: 'bandpass', f: 900, f1: 2600, dur: 0.12, vol: 0.12, q: 1.2, t: 0.03 });
log('fold', open ? 'open' : dir);
}
function shuffle(){
if (!gate('shuffle', 150)) return;
var b = root + 12;
for (var j = 0; j < 5; j++) wood(N(Math.floor(Math.random() * 10), b), { vol: 0.05, t: j * 0.045, pan: rnd(-0.4, 0.4) });
bubble(N(5, b), { vol: 0.06, t: 0.25 });
log('shuffle');
}
function nitro(){
if (!gate('nitro', 200)) return;
tone({ f: 110, f1: 520, glide: 0.45, dur: 0.55, vol: 0.13, type: 'sawtooth', lp: 500, lp1: 3000 });
noise({ kind: 'bandpass', f: 400, f1: 3600, dur: 0.5, vol: 0.2, q: 0.7 });
log('nitro');
}
function skid(){
if (!gate('skid', 150)) return;
noise({ kind: 'bandpass', f: 2600, f1: 900, dur: 0.32, vol: 0.18, q: 3 });
tone({ f: 420, f1: 300, glide: 0.3, dur: 0.3, vol: 0.02, type: 'sawtooth', lp: 1200, wob: 30, wobd: 0.04 });
log('skid');
}
function lap(n, final){
if (!gate('lap', 300)) return;
var b = root + 12, i = (n || 1) * 2;
glass(N(i, b), { vol: 0.07 }); glass(N(i + 2, b), { vol: 0.075, t: 0.1 });
if (final){ glass(N(i + 4, b), { vol: 0.08, t: 0.2 }); sparkle(0.3, 5); }
log('lap', n, final ? 1 : 0);
}
function whoosh(dir){
if (!gate('whoosh', 120)) return;
var down = dir === 'down' || dir === -1;
noise({ kind: 'bandpass', f: down ? 3000 : 600, f1: down ? 450 : 3400, dur: 0.3, vol: down ? 0.12 : 0.15, q: 1.1 });
tone({ f: down ? 640 : 420, f1: down ? 360 : 720, glide: 0.25, dur: 0.28, vol: 0.045 });
log('whoosh', down ? 'down' : dir);
}
var timers = [];
function after(ms, fn){
var id = setTimeout(function(){ timers = timers.filter(function(x){ return x !== id; }); try { fn(); } catch (e) {} }, ms);
timers.push(id);
return id;
}
function hush(){
timers.forEach(clearTimeout); timers = [];
if (!S || !bus || free) return;
try {
var now = S.a.currentTime, old = [bus, wet];
old.forEach(function(g){ if (!g) return; g.gain.cancelScheduledValues(now); g.gain.setValueAtTime(g.gain.value, now); g.gain.linearRampToValueAtTime(0.0001, now + 0.06); });
setTimeout(function(){ old.forEach(function(g){ try { if (g) g.disconnect(); } catch (e) {} }); }, 250);
busses();
} catch (e) {}
}
function bind(el, map){
if (!el || !el.addEventListener) return;
el.addEventListener('click', function(e){
var tg = e.target && e.target.closest ? e.target : (e.target && e.target.parentElement);
if (!tg) return;
for (var j = 0; j < map.length; j++){
var hit = tg.closest(map[j][0]);
if (hit && el.contains(hit)){
var s = map[j][1];
if (typeof s === 'function') s(hit, e);
else ui(s, typeof map[j][2] === 'function' ? map[j][2](hit) : map[j][2]);
return;
}
}
}, true);
}
return {
key: key, right: right, ok: ok, wrong: wrong, almost: almost, reveal: reveal,
combo: function(t){ if (gate('combo', 200)){ combo(t || 1); log('combo', t); } },
tick: tick, timeUp: timeUp, count: count, go: go,
win: win, medal: medal, star: star, best: best, tally: tally,
ui: ui, cell: cell, place: place, remove: remove, land: land, lift: lift, drag: drag, group: group,
pencil: pencil, scribble: scribble, sign: sign, card: card, flip: flip,
letter: letter, type: type, option: option, swish: swish, fold: fold, shuffle: shuffle, nitro: nitro, whoosh: whoosh,
finish: finish, done: done, skid: skid, lap: lap,
bind: bind, note: N, after: after, hush: hush,
streak: function(n){ if (n != null) streak = n; return streak; },
at: function(sec){ baseT = sec || 0; }
};
};
})();
    /* Spatial Reasoning plays in C sharp (root 61) */
    var SFX = SHLCSounds({ on: function () { return !muted; }, root: 61 });

    /* ============================================================
       2. NETS + FOLDING ENGINE
       Cells are [col,row] on a 5x5 grid; row increases downward.
       Folding convention: the root cell stays flat with outward
       normal +Z (cube TOP); every hinge folds away from the viewer,
       so net-south becomes the cube FRONT. Face orientation is
       {n,u,r}: outward normal, printed-down and printed-right in
       cube coordinates. Invariant preserved by rolls: r x u = n.
       ============================================================ */
    var NET_DEFS = [
      { id: "A", label: "Long cross",   cells: [[0,0],[0,1],[1,1],[1,2],[2,1],[3,1]] },
      { id: "B", label: "Offset cross", cells: [[0,0],[0,1],[1,1],[2,1],[2,2],[3,1]] },
      { id: "C", label: "Four row",     cells: [[0,1],[1,0],[1,1],[1,2],[1,3],[2,1]] },
      { id: "D", label: "T cross",      cells: [[0,0],[0,1],[0,2],[1,1],[2,1],[3,1]] },
      { id: "E", label: "Hook cross",   cells: [[0,1],[1,0],[1,1],[1,2],[1,3],[2,2]] },
      { id: "F", label: "Stair net",    cells: [[0,0],[0,1],[1,1],[1,2],[2,2],[2,3]] },
      { id: "G", label: "Step row",     cells: [[0,0],[0,1],[0,2],[1,2],[1,3],[1,4]] },
      { id: "H", label: "Bridge net",   cells: [[0,0],[0,1],[1,1],[1,2],[1,3],[2,1]] },
      { id: "I", label: "Side hook",    cells: [[0,0],[0,1],[1,1],[1,2],[1,3],[2,2]] },
      { id: "J", label: "Tall net",     cells: [[0,0],[0,1],[1,1],[2,1],[3,1],[3,2]] },
      { id: "K", label: "Zig zag",      cells: [[0,0],[0,1],[1,1],[1,2],[1,3],[2,3]] }
    ];
    var DIRS = [[1,0],[-1,0],[0,1],[0,-1]];

    function rollOrientation(o, dx, dy) {
      if (dx === 1 && dy === 0)  return { n: o.r.slice(), u: o.u.slice(), r: vNeg(o.n) };
      if (dx === -1 && dy === 0) return { n: vNeg(o.r),   u: o.u.slice(), r: o.n.slice() };
      if (dx === 0 && dy === -1) return { n: vNeg(o.u),   u: o.n.slice(), r: o.r.slice() };
      if (dx === 0 && dy === 1)  return { n: o.u.slice(), u: vNeg(o.n),   r: o.r.slice() };
      return o;
    }

    var FOLD_CACHE = {};
    function foldNet(netIdx) {
      if (FOLD_CACHE[netIdx]) return FOLD_CACHE[netIdx];
      var net = NETS[netIdx];
      var cells = net.cells;
      var byKey = {};
      cells.forEach(function (c, i) { byKey[c[0] + "," + c[1]] = i; });
      /* Root: the cell with the most direct neighbours (stable, deterministic). */
      var rootIdx = 0, bestScore = -999;
      cells.forEach(function (c, i) {
        var nb = 0;
        DIRS.forEach(function (d) {
          if (byKey[(c[0] + d[0]) + "," + (c[1] + d[1])] !== undefined) nb++;
        });
        var score = nb * 10 - c[0] - c[1];
        if (score > bestScore) { bestScore = score; rootIdx = i; }
      });
      var faces = cells.map(function () { return null; });
      var parents = cells.map(function () { return null; });
      var children = cells.map(function () { return []; });
      faces[rootIdx] = { n: [0,0,1], u: [0,1,0], r: [1,0,0] };
      var queue = [rootIdx];
      while (queue.length) {
        var cur = queue.shift();
        var cc = cells[cur];
        DIRS.forEach(function (d) {
          var ni = byKey[(cc[0] + d[0]) + "," + (cc[1] + d[1])];
          if (ni === undefined || faces[ni]) return;
          faces[ni] = rollOrientation(faces[cur], d[0], d[1]);
          parents[ni] = { idx: cur, dx: d[0], dy: d[1], depth: parents[cur] ? parents[cur].depth + 1 : 1 };
          children[cur].push(ni);
          queue.push(ni);
        });
      }
      var byNormal = {};
      var valid = true;
      faces.forEach(function (f, i) {
        if (!f) { valid = false; return; }
        var k = vKey(f.n);
        if (byNormal[k] !== undefined) valid = false;
        byNormal[k] = i;
      });
      var opposite = faces.map(function (f) {
        return f ? byNormal[vKey(vNeg(f.n))] : undefined;
      });
      var info = {
        rootIdx: rootIdx, faces: faces, parents: parents, children: children,
        byNormal: byNormal, opposite: opposite, valid: valid && Object.keys(byNormal).length === 6
      };
      FOLD_CACHE[netIdx] = info;
      return info;
    }

    /* Keep only nets the engine proves fold into a genuine cube. */
    var NETS = NET_DEFS;
    NETS = NET_DEFS.filter(function (_, i) {
      FOLD_CACHE = {};
      var probe = (function () {
        var cells = NET_DEFS[i].cells;
        var byKey = {};
        cells.forEach(function (c, idx) { byKey[c[0] + "," + c[1]] = idx; });
        var faces = cells.map(function () { return null; });
        faces[0] = { n: [0,0,1], u: [0,1,0], r: [1,0,0] };
        var queue = [0];
        while (queue.length) {
          var cur = queue.shift();
          var cc = cells[cur];
          DIRS.forEach(function (d) {
            var ni = byKey[(cc[0] + d[0]) + "," + (cc[1] + d[1])];
            if (ni === undefined || faces[ni]) return;
            faces[ni] = rollOrientation(faces[cur], d[0], d[1]);
            queue.push(ni);
          });
        }
        var normals = {};
        var ok = true;
        faces.forEach(function (f) {
          if (!f) { ok = false; return; }
          if (normals[vKey(f.n)]) ok = false;
          normals[vKey(f.n)] = true;
        });
        return ok && Object.keys(normals).length === 6;
      })();
      return probe;
    });
    FOLD_CACHE = {};

    function netBounds(netIdx) {
      var cells = NETS[netIdx].cells;
      var xs = cells.map(function (c) { return c[0]; });
      var ys = cells.map(function (c) { return c[1]; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
      var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      return { minX: minX, minY: minY, cols: maxX - minX + 1, rows: maxY - minY + 1 };
    }

    /* ============================================================
       3. SYMBOL REGISTRY
       Every glyph lives in a 100x100 box centred on (50,50).
       sym = rotational symmetry order (1 = none, 2 = 180deg-safe).
       ============================================================ */
    var NAVY = "#1a2347";
    function textGlyph(ch) {
      return "<text x='50' y='52' font-size='68' font-weight='900' font-family='DM Sans, Arial, sans-serif'" +
        " text-anchor='middle' dominant-baseline='central' fill='" + NAVY + "'>" + esc(ch) + "</text>";
    }
    var THEME_GLYPHS = {
      numbers: [
        { id: "n1", sym: 1, name: "the number 1", svg: textGlyph("1") },
        { id: "n2", sym: 1, name: "the number 2", svg: textGlyph("2") },
        { id: "n3", sym: 1, name: "the number 3", svg: textGlyph("3") },
        { id: "n4", sym: 1, name: "the number 4", svg: textGlyph("4") },
        { id: "n5", sym: 1, name: "the number 5", svg: textGlyph("5") },
        { id: "n7", sym: 1, name: "the number 7", svg: textGlyph("7") },
        { id: "n8", sym: 2, name: "the number 8", svg: textGlyph("8") }
      ],
      letters: [
        { id: "lF", sym: 1, name: "the letter F", svg: textGlyph("F") },
        { id: "lG", sym: 1, name: "the letter G", svg: textGlyph("G") },
        { id: "lL", sym: 1, name: "the letter L", svg: textGlyph("L") },
        { id: "lP", sym: 1, name: "the letter P", svg: textGlyph("P") },
        { id: "lR", sym: 1, name: "the letter R", svg: textGlyph("R") },
        { id: "lJ", sym: 1, name: "the letter J", svg: textGlyph("J") },
        { id: "lK", sym: 1, name: "the letter K", svg: textGlyph("K") },
        { id: "lE", sym: 1, name: "the letter E", svg: textGlyph("E") }
      ],
      squares: [
        { id: "s1", sym: 1, name: "the corner-linked squares",
          svg: "<rect x='20' y='20' width='44' height='44' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='50' y='50' width='28' height='28' fill='" + NAVY + "'/>" },
        { id: "s2", sym: 1, name: "the small square over the big square",
          svg: "<rect x='36' y='34' width='44' height='44' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='20' y='20' width='26' height='26' fill='" + NAVY + "'/>" },
        { id: "s3", sym: 1, name: "the twin overlapping squares",
          svg: "<rect x='16' y='20' width='40' height='40' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='44' y='40' width='40' height='40' fill='none' stroke='" + NAVY + "' stroke-width='6'/>" },
        { id: "s4", sym: 1, name: "the boxed square on the top edge",
          svg: "<rect x='22' y='22' width='56' height='56' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='38' y='22' width='24' height='24' fill='" + NAVY + "'/>" },
        { id: "s5", sym: 1, name: "the diamond touching the right edge",
          svg: "<rect x='20' y='20' width='60' height='60' fill='none' stroke='" + NAVY + "' stroke-width='6'/><polygon points='58,32 80,50 58,68 40,50' fill='" + NAVY + "'/>" },
        { id: "s6", sym: 1, name: "the stepped squares",
          svg: "<rect x='16' y='16' width='30' height='30' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='34' y='34' width='30' height='30' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='52' y='52' width='30' height='30' fill='" + NAVY + "'/>" },
        { id: "s7", sym: 1, name: "the half-shaded square",
          svg: "<rect x='20' y='20' width='60' height='60' fill='none' stroke='" + NAVY + "' stroke-width='6'/><path d='M20 20 L80 20 L20 80 Z' fill='" + NAVY + "'/>" },
        { id: "s8", sym: 1, name: "the square with the corner dot",
          svg: "<rect x='20' y='20' width='60' height='60' fill='none' stroke='" + NAVY + "' stroke-width='6'/><circle cx='35' cy='35' r='11' fill='" + NAVY + "'/>" }
      ],
      shapes: [
        { id: "g1", sym: 1, name: "the star",
          svg: "<path d='M50 12 L58.9 37.7 L86.1 38.3 L64.5 54.7 L72.3 80.7 L50 65.2 L27.7 80.7 L35.5 54.7 L13.9 38.3 L41.1 37.7 Z' fill='" + NAVY + "'/>" },
        { id: "g2", sym: 1, name: "the crescent",
          svg: "<path d='M62 14 A38 38 0 1 0 62 86 A30 30 0 1 1 62 14 Z' fill='" + NAVY + "'/>" },
        { id: "g3", sym: 1, name: "the corner triangle",
          svg: "<path d='M18 18 L82 82 L18 82 Z' fill='" + NAVY + "'/>" },
        { id: "g4", sym: 1, name: "the kite",
          svg: "<path d='M50 8 L76 44 L50 92 L24 44 Z' fill='none' stroke='" + NAVY + "' stroke-width='7' stroke-linejoin='round'/><circle cx='50' cy='38' r='8' fill='" + NAVY + "'/>" },
        { id: "g5", sym: 1, name: "the semicircle",
          svg: "<path d='M14 64 A36 36 0 0 1 86 64 Z' fill='" + NAVY + "'/>" },
        { id: "g6", sym: 1, name: "the heart",
          svg: "<path d='M50 84 C20 60 12 38 26 26 C36 18 48 22 50 32 C52 22 64 18 74 26 C88 38 80 60 50 84 Z' fill='" + NAVY + "'/>" },
        { id: "g7", sym: 1, name: "the lightning bolt",
          svg: "<path d='M56 8 L26 54 L46 54 L40 92 L74 40 L52 40 Z' fill='" + NAVY + "'/>" },
        { id: "g8", sym: 1, name: "the flag",
          svg: "<line x1='32' y1='14' x2='32' y2='88' stroke='" + NAVY + "' stroke-width='8' stroke-linecap='round'/><path d='M32 18 L78 30 L32 46 Z' fill='" + NAVY + "'/>" }
      ],
      arrows: [
        { id: "a1", sym: 1, name: "the straight arrow",
          svg: "<line x1='50' y1='84' x2='50' y2='34' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='50,10 30,42 70,42' fill='" + NAVY + "'/>" },
        { id: "a2", sym: 2, name: "the double-headed arrow",
          svg: "<line x1='32' y1='68' x2='68' y2='32' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='80,20 52,26 74,48' fill='" + NAVY + "'/><polygon points='20,80 48,74 26,52' fill='" + NAVY + "'/>" },
        { id: "a3", sym: 1, name: "the bent arrow",
          svg: "<path d='M28 82 L28 36 L58 36' fill='none' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round' stroke-linejoin='round'/><polygon points='84,36 54,20 54,52' fill='" + NAVY + "'/>" },
        { id: "a4", sym: 1, name: "the curved arrow",
          svg: "<path d='M74 62 A28 28 0 1 0 46 78' fill='none' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='42,94 62,72 32,64' fill='" + NAVY + "'/>" },
        { id: "a5", sym: 1, name: "the corner arrow",
          svg: "<line x1='28' y1='72' x2='58' y2='42' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='82,18 44,30 70,56' fill='" + NAVY + "'/>" },
        { id: "a6", sym: 1, name: "the hook arrow",
          svg: "<path d='M34 84 L34 40 A16 16 0 0 1 66 40 L66 50' fill='none' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='66,76 50,50 82,50' fill='" + NAVY + "'/>" },
        { id: "a7", sym: 1, name: "the barred arrow",
          svg: "<line x1='24' y1='28' x2='24' y2='72' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><line x1='24' y1='50' x2='58' y2='50' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round'/><polygon points='84,50 54,34 54,66' fill='" + NAVY + "'/>" },
        { id: "a8", sym: 1, name: "the zigzag arrow",
          svg: "<path d='M30 86 L48 58 L36 50 L56 26' fill='none' stroke='" + NAVY + "' stroke-width='9' stroke-linecap='round' stroke-linejoin='round'/><polygon points='66,10 42,16 56,32' fill='" + NAVY + "'/>" }
      ],
      dots: [
        { id: "d1", sym: 1, name: "the corner dot",
          svg: "<circle cx='31' cy='31' r='14' fill='" + NAVY + "'/>" },
        { id: "d2", sym: 1, name: "the big and small dots",
          svg: "<circle cx='30' cy='32' r='14' fill='" + NAVY + "'/><circle cx='67' cy='66' r='8' fill='" + NAVY + "'/>" },
        { id: "d3", sym: 2, name: "the three dots",
          svg: "<circle cx='26' cy='26' r='10' fill='" + NAVY + "'/><circle cx='50' cy='50' r='10' fill='" + NAVY + "'/><circle cx='74' cy='74' r='10' fill='" + NAVY + "'/>" },
        { id: "d4", sym: 2, name: "the diagonal stripe",
          svg: "<line x1='20' y1='20' x2='80' y2='80' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round'/>" },
        { id: "d5", sym: 1, name: "the quarter circle",
          svg: "<path d='M22 22 L66 22 A44 44 0 0 1 22 66 Z' fill='" + NAVY + "'/>" },
        { id: "d6", sym: 1, name: "the dot and line",
          svg: "<line x1='24' y1='76' x2='76' y2='24' stroke='" + NAVY + "' stroke-width='8' stroke-linecap='round'/><circle cx='69' cy='69' r='10' fill='" + NAVY + "'/>" },
        { id: "d7", sym: 1, name: "the three corner dots",
          svg: "<circle cx='27' cy='27' r='10' fill='" + NAVY + "'/><circle cx='73' cy='27' r='10' fill='" + NAVY + "'/><circle cx='27' cy='73' r='10' fill='" + NAVY + "'/>" },
        { id: "d8", sym: 1, name: "the T shape",
          svg: "<line x1='26' y1='28' x2='74' y2='28' stroke='" + NAVY + "' stroke-width='10' stroke-linecap='round'/><line x1='50' y1='28' x2='50' y2='80' stroke='" + NAVY + "' stroke-width='10' stroke-linecap='round'/>" }
      ],
      /* v3: the markings GL and CEM style papers actually print on faces:
         part-shaded shapes, dice dots, bars and crosses. sym = how many
         quarter turns map the drawing onto itself (1, 2 or 4). */
      shaded: [
        { id: "h1", sym: 1, name: "the half-shaded circle",
          svg: "<circle cx='50' cy='50' r='34' fill='none' stroke='" + NAVY + "' stroke-width='6'/><path d='M50 16 A34 34 0 0 0 50 84 Z' fill='" + NAVY + "'/>" },
        { id: "h2", sym: 1, name: "the quarter-shaded circle",
          svg: "<circle cx='50' cy='50' r='34' fill='none' stroke='" + NAVY + "' stroke-width='6'/><path d='M50 50 L50 16 A34 34 0 0 1 84 50 Z' fill='" + NAVY + "'/>" },
        { id: "h3", sym: 1, name: "the half-shaded triangle",
          svg: "<path d='M50 14 L86 82 L14 82 Z' fill='none' stroke='" + NAVY + "' stroke-width='6' stroke-linejoin='round'/><path d='M33 48 L67 48 L86 82 L14 82 Z' fill='" + NAVY + "'/>" },
        { id: "h4", sym: 1, name: "the square with a shaded corner",
          svg: "<rect x='18' y='18' width='64' height='64' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='18' y='18' width='32' height='32' fill='" + NAVY + "'/>" },
        { id: "h5", sym: 4, name: "the target",
          svg: "<circle cx='50' cy='50' r='34' fill='none' stroke='" + NAVY + "' stroke-width='6'/><circle cx='50' cy='50' r='13' fill='" + NAVY + "'/>" },
        { id: "h6", sym: 4, name: "the shaded diamond",
          svg: "<polygon points='50,12 88,50 50,88 12,50' fill='" + NAVY + "'/>" },
        { id: "h7", sym: 2, name: "the striped square",
          svg: "<rect x='18' y='18' width='64' height='64' fill='none' stroke='" + NAVY + "' stroke-width='6'/><rect x='26' y='30' width='48' height='8' fill='" + NAVY + "'/><rect x='26' y='46' width='48' height='8' fill='" + NAVY + "'/><rect x='26' y='62' width='48' height='8' fill='" + NAVY + "'/>" },
        { id: "h8", sym: 1, name: "the half-shaded diamond",
          svg: "<polygon points='50,12 88,50 50,88 12,50' fill='none' stroke='" + NAVY + "' stroke-width='6' stroke-linejoin='round'/><polygon points='50,12 12,50 50,88' fill='" + NAVY + "'/>" }
      ],
      dice: [
        { id: "k1", sym: 4, name: "the one dot",
          svg: "<circle cx='50' cy='50' r='12' fill='" + NAVY + "'/>" },
        { id: "k2", sym: 2, name: "the two dots",
          svg: "<circle cx='30' cy='30' r='10' fill='" + NAVY + "'/><circle cx='70' cy='70' r='10' fill='" + NAVY + "'/>" },
        { id: "k3", sym: 2, name: "the row of three dots",
          svg: "<circle cx='24' cy='50' r='9' fill='" + NAVY + "'/><circle cx='50' cy='50' r='9' fill='" + NAVY + "'/><circle cx='76' cy='50' r='9' fill='" + NAVY + "'/>" },
        { id: "k4", sym: 4, name: "the four dots",
          svg: "<circle cx='30' cy='30' r='10' fill='" + NAVY + "'/><circle cx='70' cy='30' r='10' fill='" + NAVY + "'/><circle cx='30' cy='70' r='10' fill='" + NAVY + "'/><circle cx='70' cy='70' r='10' fill='" + NAVY + "'/>" },
        { id: "k5", sym: 4, name: "the five dots",
          svg: "<circle cx='28' cy='28' r='9' fill='" + NAVY + "'/><circle cx='72' cy='28' r='9' fill='" + NAVY + "'/><circle cx='50' cy='50' r='9' fill='" + NAVY + "'/><circle cx='28' cy='72' r='9' fill='" + NAVY + "'/><circle cx='72' cy='72' r='9' fill='" + NAVY + "'/>" },
        { id: "k6", sym: 2, name: "the six dots",
          svg: "<circle cx='32' cy='26' r='9' fill='" + NAVY + "'/><circle cx='68' cy='26' r='9' fill='" + NAVY + "'/><circle cx='32' cy='50' r='9' fill='" + NAVY + "'/><circle cx='68' cy='50' r='9' fill='" + NAVY + "'/><circle cx='32' cy='74' r='9' fill='" + NAVY + "'/><circle cx='68' cy='74' r='9' fill='" + NAVY + "'/>" }
      ],
      lines: [
        { id: "x1", sym: 4, name: "the plus sign",
          svg: "<line x1='50' y1='18' x2='50' y2='82' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round'/><line x1='18' y1='50' x2='82' y2='50' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round'/>" },
        { id: "x2", sym: 4, name: "the cross",
          svg: "<line x1='22' y1='22' x2='78' y2='78' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round'/><line x1='78' y1='22' x2='22' y2='78' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round'/>" },
        { id: "x3", sym: 2, name: "the single bar",
          svg: "<line x1='50' y1='16' x2='50' y2='84' stroke='" + NAVY + "' stroke-width='13' stroke-linecap='round'/>" },
        { id: "x4", sym: 2, name: "the two bars",
          svg: "<line x1='36' y1='18' x2='36' y2='82' stroke='" + NAVY + "' stroke-width='11' stroke-linecap='round'/><line x1='64' y1='18' x2='64' y2='82' stroke='" + NAVY + "' stroke-width='11' stroke-linecap='round'/>" },
        { id: "x5", sym: 1, name: "the chevron",
          svg: "<path d='M20 32 L50 70 L80 32' fill='none' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round' stroke-linejoin='round'/>" },
        { id: "x6", sym: 1, name: "the corner bracket",
          svg: "<path d='M26 22 L26 78 L78 78' fill='none' stroke='" + NAVY + "' stroke-width='12' stroke-linecap='round' stroke-linejoin='round'/>" },
        { id: "x7", sym: 2, name: "the zigzag",
          svg: "<path d='M22 28 L78 28 L22 72 L78 72' fill='none' stroke='" + NAVY + "' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/>" },
        { id: "x8", sym: 2, name: "the three bars",
          svg: "<line x1='28' y1='18' x2='28' y2='82' stroke='" + NAVY + "' stroke-width='10' stroke-linecap='round'/><line x1='50' y1='18' x2='50' y2='82' stroke='" + NAVY + "' stroke-width='10' stroke-linecap='round'/><line x1='72' y1='18' x2='72' y2='82' stroke='" + NAVY + "' stroke-width='10' stroke-linecap='round'/>" }
      ]
    };
    /* Every glyph carries its own pastel face colour, so a symbol keeps
       its colour across nets, cubes, cards and the 3D fold - colour and
       symbol always agree and colour is never the only cue. */
    var PASTELS = ["#fdeccc", "#d8e9fd", "#d9f4e4", "#ffe3d1", "#e9e3fc", "#fbdfee"];
    var PAIR_COLOURS = ["#f47820", "#2d8cf0", "#1e7a4f"];
    var GLYPH_BY_ID = {};
    Object.keys(THEME_GLYPHS).forEach(function (t) {
      THEME_GLYPHS[t].forEach(function (g, gi) {
        g.fill = PASTELS[gi % PASTELS.length];
        GLYPH_BY_ID[g.id] = g;
      });
    });
    function glyphFill(gid) {
      return GLYPH_BY_ID[gid] && GLYPH_BY_ID[gid].fill ? GLYPH_BY_ID[gid].fill : "#ffffff";
    }
    function glyphSym(gid) { return GLYPH_BY_ID[gid] ? GLYPH_BY_ID[gid].sym : 1; }
    function glyphName(gid) { return GLYPH_BY_ID[gid] ? GLYPH_BY_ID[gid].name : "the symbol"; }
    /* Short prose name for explanations: "5", "F", "the star". */
    function sayName(gid) {
      var g = GLYPH_BY_ID[gid];
      if (!g) return "the symbol";
      if (gid.charAt(0) === "n" || gid.charAt(0) === "l") return gid.slice(1);
      return g.name;
    }
    function listJoin(xs) {
      if (xs.length <= 1) return xs.join("");
      return xs.slice(0, -1).join(", ") + " and " + xs[xs.length - 1];
    }
    function rotNorm(rot, gid) {
      var period = 360 / glyphSym(gid);
      return (((rot % 360) + 360) % 360) % period;
    }

    /* ============================================================
       4. CUBE MODEL + VIEW MATHS
       A "print" is what is stamped on one net cell:
         { g: glyphId, col: 1..3, row: 1..3, rho: 0|90|180|270 }
       (col,row) is the 3x3 grid slot; rho is the printed rotation.
       A cube model stores, for every face, the glyph identity plus
       its axes and slot offset expressed in cube coordinates - so
       rotating the whole cube is one matrix application and no
       information about symbol orientation is ever lost.
       ============================================================ */
    function glyphAxesFor(face, rho) {
      var r = face.r, u = face.u;
      if (rho === 0)   return { gR: r.slice(),  gD: u.slice() };
      if (rho === 90)  return { gR: u.slice(),  gD: vNeg(r) };
      if (rho === 180) return { gR: vNeg(r),    gD: vNeg(u) };
      return { gR: vNeg(u), gD: r.slice() };
    }
    function cubeModel(netIdx, prints) {
      var info = foldNet(netIdx);
      var faces = info.faces.map(function (f, i) {
        var p = prints[i];
        var axes = glyphAxesFor(f, p.rho);
        var px = p.col - 2, py = p.row - 2;
        return {
          faceIdx: i,
          g: p.g,
          n: f.n.slice(),
          gR: axes.gR,
          gD: axes.gD,
          posVec: [px * f.r[0] + py * f.u[0], px * f.r[1] + py * f.u[1], px * f.r[2] + py * f.u[2]]
        };
      });
      return { netIdx: netIdx, prints: prints, info: info, faces: faces };
    }
    function rotateCubeFaces(faces, m) {
      return faces.map(function (f) {
        return {
          faceIdx: f.faceIdx, g: f.g,
          n: mApply(m, f.n), gR: mApply(m, f.gR), gD: mApply(m, f.gD),
          posVec: mApply(m, f.posVec)
        };
      });
    }
    /* The exact appearance of the three faces a correct isometric
       drawing must show: top, front and right around one shared vertex. */
    function viewFromFaces(rotatedFaces) {
      var view = {};
      VISIBLE_ROLES.forEach(function (role) {
        var ax = ROLE_AXES[role];
        var face = null;
        for (var i = 0; i < rotatedFaces.length; i++) {
          if (vEq(rotatedFaces[i].n, ax.n)) { face = rotatedFaces[i]; break; }
        }
        view[role] = {
          faceIdx: face.faceIdx,
          g: face.g,
          rot: axisAngle(ax.R, ax.D, face.gR),
          col: vDot(face.posVec, ax.R) + 2,
          row: vDot(face.posVec, ax.D) + 2
        };
      });
      return view;
    }
    function viewFor(cube, m) { return viewFromFaces(rotateCubeFaces(cube.faces, m)); }
    function viewFaceSig(vf) {
      return vf.g + ":" + rotNorm(vf.rot, vf.g) + ":" + vf.col + "," + vf.row;
    }
    function viewSig(view) {
      return VISIBLE_ROLES.map(function (r) { return viewFaceSig(view[r]); }).join("|");
    }
    /* Which three symbols are visible, ignoring orientation. Used to keep
       cube options visually distinct (different corners of the cube). */
    function viewTrioKey(view) {
      return VISIBLE_ROLES.map(function (r) { return view[r].g; }).sort().join("|");
    }
    /* Brute-force ground truth: a drawn cube is makeable from this
       net if and only if one of the 24 rotations reproduces it. */
    function canProduceView(cube, targetView) {
      var target = viewSig(targetView);
      for (var i = 0; i < ROTS24.length; i++) {
        if (viewSig(viewFor(cube, ROTS24[i])) === target) return true;
      }
      return false;
    }
    /* Re-print a finished cube onto a different net shape. Solves the
       printed rotation rho and slot (col,row) for every face so the new
       net folds into the identical cube. Used to build guaranteed-valid
       alternative nets. */
    function reprintCube(cube, m, targetNetIdx) {
      var world = rotateCubeFaces(cube.faces, m);
      var byN = {};
      world.forEach(function (f) { byN[vKey(f.n)] = f; });
      var info = foldNet(targetNetIdx);
      var prints = info.faces.map(function (face) {
        var src = byN[vKey(face.n)];
        var rho;
        if (vEq(src.gR, face.r)) rho = 0;
        else if (vEq(src.gR, face.u)) rho = 90;
        else if (vEq(src.gR, vNeg(face.r))) rho = 180;
        else rho = 270;
        return {
          g: src.g,
          col: vDot(src.posVec, face.r) + 2,
          row: vDot(src.posVec, face.u) + 2,
          rho: rho
        };
      });
      return prints;
    }
    function printsSig(netIdx, prints) {
      return netIdx + "#" + prints.map(function (p) {
        return p.g + ":" + rotNorm(p.rho, p.g) + ":" + p.col + "," + p.row;
      }).join("|");
    }

    /* ============================================================
       5. SVG RENDERERS
       ============================================================ */
    function glyphSlotTransform(col, row, rot) {
      var ox = col - 2, oy = row - 2;
      var cx = 50 + ox * 29, cy = 50 + oy * 29;
      var s = (ox === 0 && oy === 0) ? 0.7 : 0.42;
      return "translate(" + cx + " " + cy + ") rotate(" + rot + ") scale(" + s + ") translate(-50 -50)";
    }
    function glyphGroup(g, rot, col, row) {
      var def = GLYPH_BY_ID[g];
      if (!def) return "";
      return "<g transform='" + glyphSlotTransform(col, row, rot) + "'>" + def.svg + "</g>";
    }
    /* Flat face card, 100x100. spec = {g,rot,col,row}; extra styling flags. */
    function faceCardSvg(spec, opts) {
      opts = opts || {};
      var w = opts.width || 84;
      var fill = opts.fill || glyphFill(spec.g);
      var out = "<svg viewBox='0 0 100 100' width='" + w + "' height='" + w + "' role='img' aria-label='" + esc(opts.label || "face card") + "'>";
      out += "<rect x='3' y='3' width='94' height='94' rx='8' fill='" + fill + "' stroke='" + NAVY + "' stroke-width='4'/>";
      out += glyphGroup(spec.g, spec.rot || 0, spec.col || 2, spec.row || 2);
      out += "</svg>";
      return out;
    }
    /* Whole net. prints[] aligned with NETS[netIdx].cells.
       opts.highlightIdx marks one face: thick orange border + tinted
       fill + dashed inner ring (colour is never the only cue). */
    function netSvg(netIdx, prints, opts) {
      opts = opts || {};
      var net = NETS[netIdx];
      var b = netBounds(netIdx);
      var W = b.cols * 100, H = b.rows * 100;
      var wpx = opts.width || Math.min(320, b.cols * 78);
      /* Tall thin nets must not tower over wide ones: cap rendered height. */
      if (opts.maxH) wpx = Math.min(wpx, Math.round(opts.maxH * b.cols / b.rows));
      var out = "<svg viewBox='0 0 " + W + " " + H + "' width='" + wpx + "' style='max-width:100%;height:auto;' role='img' aria-label='" + esc(opts.label || "cube net") + "'>";
      net.cells.forEach(function (c, i) {
        var x = (c[0] - b.minX) * 100, y = (c[1] - b.minY) * 100;
        var hl = opts.highlightIdx === i;
        var p = prints[i];
        out += "<g transform='translate(" + x + " " + y + ")'>";
        out += "<rect x='3' y='3' width='94' height='94' rx='6' fill='" + (p ? glyphFill(p.g) : "#ffffff") + "' stroke='" + (hl ? "#f47820" : NAVY) + "' stroke-width='" + (hl ? 8 : 4) + "'/>";
        if (hl) {
          out += "<rect x='11' y='11' width='78' height='78' rx='4' fill='none' stroke='" + NAVY + "' stroke-width='3' stroke-dasharray='9 6'/>";
        }
        if (p) out += glyphGroup(p.g, p.rho, p.col, p.row);
        if (opts.pairs && typeof opts.pairs[i] !== "undefined") {
          var pc = PAIR_COLOURS[opts.pairs[i] % 3];
          out += "<circle cx='82' cy='18' r='13' fill='#ffffff' stroke='" + pc + "' stroke-width='4'/>";
          out += "<text x='82' y='19' font-size='16' font-weight='900' text-anchor='middle' dominant-baseline='central' fill='" + pc + "'>" + (opts.pairs[i] + 1) + "</text>";
        }
        out += "</g>";
      });
      out += "</svg>";
      return out;
    }
    /* Isometric cube. view = {top,front,right} each {g,rot,col,row} or
       the string "hidden" behaviour via opts.hiddenRole. Faces are drawn
       by mapping face-local (0..100)^2 through a real affine projection,
       so symbols shear and rotate exactly as the folded geometry demands. */
    var ISO_S = 52;
    function isoProject(p) {
      return [
        (p[0] - p[1]) * 0.866 * ISO_S,
        (p[0] + p[1]) * 0.5 * ISO_S - p[2] * ISO_S
      ];
    }
    function isoFaceMatrix(role) {
      var ax = ROLE_AXES[role];
      var c00 = [
        ax.n[0] * 0.5 - ax.R[0] * 0.5 - ax.D[0] * 0.5,
        ax.n[1] * 0.5 - ax.R[1] * 0.5 - ax.D[1] * 0.5,
        ax.n[2] * 0.5 - ax.R[2] * 0.5 - ax.D[2] * 0.5
      ];
      var o = isoProject(c00);
      var pr = isoProject(ax.R);
      var pd = isoProject(ax.D);
      return [pr[0] / 100, pr[1] / 100, pd[0] / 100, pd[1] / 100, o[0], o[1]];
    }
    var ISO_MATRICES = { top: isoFaceMatrix("top"), front: isoFaceMatrix("front"), right: isoFaceMatrix("right") };
    var ISO_TINT = { top: "", front: "rgba(16,25,54,0.05)", right: "rgba(16,25,54,0.12)" };
    function isoCubeSvg(view, opts) {
      opts = opts || {};
      var w = opts.width || 150;
      var out = "<svg viewBox='-50 -58 100 116' width='" + w + "' height='" + Math.round(w * 1.16) + "' role='img' aria-label='" + esc(opts.label || "cube drawing") + "'>";
      VISIBLE_ROLES.forEach(function (role) {
        var mtx = ISO_MATRICES[role];
        var tf = "matrix(" + mtx.join(" ") + ")";
        out += "<g transform='" + tf + "'>";
        if (opts.hiddenRole === role) {
          out += "<rect x='2' y='2' width='96' height='96' fill='#fff8ea' stroke='" + NAVY + "' stroke-width='4' stroke-dasharray='10 7'/>";
          out += "<text x='50' y='52' font-size='52' font-weight='900' text-anchor='middle' dominant-baseline='central' fill='" + NAVY + "'>?</text>";
        } else {
          var vf = view[role];
          out += "<rect x='0' y='0' width='100' height='100' fill='" + glyphFill(vf.g) + "' stroke='" + NAVY + "' stroke-width='4'/>";
          if (ISO_TINT[role]) out += "<rect x='0' y='0' width='100' height='100' fill='" + ISO_TINT[role] + "'/>";
          out += glyphGroup(vf.g, vf.rot, vf.col, vf.row);
          if (opts.ringRole === role) {
            out += "<rect x='6' y='6' width='88' height='88' fill='none' stroke='#f47820' stroke-width='9'/>";
            out += "<rect x='15' y='15' width='70' height='70' fill='none' stroke='" + NAVY + "' stroke-width='3' stroke-dasharray='9 6'/>";
          }
        }
        out += "</g>";
      });
      out += "</svg>";
      return out;
    }
    function figureHtml(inner, caption) {
      return "<div class='cnt-figure'>" + inner + (caption ? "<span class='cnt-figcap'>" + esc(caption) + "</span>" : "") + "</div>";
    }

    /* ============================================================
       6. QUESTION FRAMEWORK
       Every builder returns:
       { typeId, prompt, stimulusHtml, options:[{html,sig,isCorrect,note}],
         correctIdx, explanation, review:{netIdx,prints} }
       finishQuestion() shuffles, validates and stamps the final object.
       ============================================================ */
    var TYPE_META = [
      { id: "opposite",     label: "Which face is opposite?" },
      { id: "cannotTouch",  label: "Which face cannot touch?" },
      { id: "canTouch",     label: "Which pair of faces can touch?" },
      { id: "missingFace",  label: "Missing face on the cube" },
      { id: "hiddenFace",   label: "Hidden face on the cube" },
      { id: "cubeCanMake",  label: "Which cube can be made?" },
      { id: "cubeCannot",   label: "Which cube cannot be made?" },
      { id: "netCanMake",   label: "Which net makes the cube?" },
      { id: "netCannot",    label: "Which net cannot make the cube?" }
    ];
    var LETTERS4 = ["A", "B", "C", "D"];
    function typeLabel(id) {
      for (var i = 0; i < TYPE_META.length; i++) if (TYPE_META[i].id === id) return TYPE_META[i].label;
      return id;
    }
    function finishQuestion(q) {
      var order = shuffle(q.options.map(function (_, i) { return i; }));
      var options = order.map(function (i) { return q.options[i]; });
      var correctIdx = -1;
      var correctCount = 0;
      var sigs = {};
      for (var i = 0; i < options.length; i++) {
        var o = options[i];
        if (!o || !o.html || !o.sig) return null;
        if (sigs[o.sig]) return null;      /* duplicate / ambiguous option */
        sigs[o.sig] = true;
        if (o.isCorrect) { correctIdx = i; correctCount++; }
      }
      if (options.length !== 4 || correctCount !== 1) return null;
      /* Wrong-option notes. Options that share a reason are grouped into one
         short line ("5, 4 and 2 all touch 3, so they are neighbours"); the rest
         keep a one-letter prefix. Keeps the explanation short on a phone. */
      var notes = [];
      var groups = {}, groupOrder = [];
      var plain = {}, plainOrder = [];
      options.forEach(function (o, i) {
        if (o.isCorrect) return;
        if (o.noteGroup) {
          var key = o.noteGroup.many;
          if (!groups[key]) { groups[key] = { whos: [], one: o.noteGroup.one, many: o.noteGroup.many }; groupOrder.push(key); }
          groups[key].whos.push(o.noteGroup.who);
        } else if (o.note) {
          if (!plain[o.note]) { plain[o.note] = []; plainOrder.push(o.note); }
          plain[o.note].push(LETTERS4[i]);
        }
      });
      plainOrder.forEach(function (n) { notes.push(listJoin(plain[n]) + ": " + n); });
      notes = groupOrder.map(function (k) {
        var g = groups[k];
        var line = g.whos.length === 1 ? g.whos[0] + " " + g.one : listJoin(g.whos) + " " + g.many;
        return line.charAt(0).toUpperCase() + line.slice(1);
      }).concat(notes);
      q.options = options;
      q.correctIdx = correctIdx;
      var ex = q.explanation.charAt(0).toUpperCase() + q.explanation.slice(1);
      q.explanation = ex + (notes.length ? "\n" + notes.join("\n") : "");
      return q;
    }
    /* Random printed layout for one net: 6 distinct glyphs, random
       slots, random printed rotations (biased towards upright). */
    function glyphPool(theme) {
      if (theme === "mixed") {
        var all = [];
        Object.keys(THEME_GLYPHS).forEach(function (t) { all = all.concat(THEME_GLYPHS[t]); });
        return all;
      }
      return THEME_GLYPHS[theme] || THEME_GLYPHS.numbers;
    }
    /* Pick 6 glyphs with 6 different face colours (every pool covers all
       six pastels, so this always succeeds). */
    function pickSixGlyphs(theme) {
      var out = [], used = {};
      shuffle(glyphPool(theme)).forEach(function (g) {
        if (out.length < 6 && !used[g.fill]) {
          used[g.fill] = true;
          out.push(g);
        }
      });
      return out;
    }
    function randomPrints(theme) {
      var pool = pickSixGlyphs(theme);
      var slots = [[1,1],[2,1],[3,1],[1,2],[3,2],[1,3],[2,3],[3,3]];
      return pool.map(function (g) {
        var centre = Math.random() < 0.5;
        var slot = centre ? [2,2] : choice(slots);
        var rho = Math.random() < 0.45 ? 0 : choice([90, 180, 270]);
        return { g: g.id, col: slot[0], row: slot[1], rho: rho };
      });
    }
    function buildBase(theme) {
      var netIdx = Math.floor(Math.random() * NETS.length);
      var prints = randomPrints(theme);
      var cube = cubeModel(netIdx, prints);
      return { netIdx: netIdx, prints: prints, cube: cube, info: cube.info };
    }
    function faceRole(base, faceIdx) {
      return ROLE_BY_NKEY[vKey(base.info.faces[faceIdx].n)];
    }
    function printCardHtml(base, faceIdx, w) {
      var p = base.prints[faceIdx];
      return faceCardSvg({ g: p.g, rot: p.rho, col: p.col, row: p.row },
        { width: w || 84, label: glyphName(p.g) });
    }

    /* ---- Type 1: Which face is opposite? ---- */
    function buildOpposite(theme) {
      var base = buildBase(theme);
      var A = Math.floor(Math.random() * 6);
      var opp = base.info.opposite[A];
      var adjacents = [];
      for (var i = 0; i < 6; i++) if (i !== A && i !== opp) adjacents.push(i);
      var wrong = shuffle(adjacents).slice(0, 3);
      var nameA = glyphName(base.prints[A].g);
      var sayA = sayName(base.prints[A].g);
      var options = [{
        html: printCardHtml(base, opp), sig: "f" + opp, isCorrect: true, note: ""
      }].concat(wrong.map(function (fi) {
        return {
          html: printCardHtml(base, fi), sig: "f" + fi, isCorrect: false,
          noteGroup: { who: sayName(base.prints[fi].g), one: "touches " + sayA + " on the cube, so it is a neighbour, not opposite.", many: "all touch " + sayA + " on the cube, so they are neighbours, not opposite." }
        };
      }));
      return finishQuestion({
        typeId: "opposite",
        prompt: "The net folds into a cube. Which face ends up OPPOSITE the face with the orange border?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { highlightIdx: A, maxH: 250 })),
        options: options,
        explanation: sayA + " and " + sayName(base.prints[opp].g) + " are opposite: one square apart in a straight line on the net.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 2: Which face cannot touch? ---- */
    function buildCannotTouch(theme) {
      var base = buildBase(theme);
      var A = Math.floor(Math.random() * 6);
      var opp = base.info.opposite[A];
      var adjacents = [];
      for (var i = 0; i < 6; i++) if (i !== A && i !== opp) adjacents.push(i);
      var wrong = shuffle(adjacents).slice(0, 3);
      var nameA = glyphName(base.prints[A].g);
      var sayA = sayName(base.prints[A].g);
      var options = [{
        html: printCardHtml(base, opp), sig: "f" + opp, isCorrect: true, note: ""
      }].concat(wrong.map(function (fi) {
        return {
          html: printCardHtml(base, fi), sig: "f" + fi, isCorrect: false,
          noteGroup: { who: sayName(base.prints[fi].g), one: "ends up next to " + sayA + ", so it can touch it.", many: "all end up next to " + sayA + ", so they can touch it." }
        };
      }));
      return finishQuestion({
        typeId: "cannotTouch",
        prompt: "Which face can NEVER touch the face with the orange border once the net is folded?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { highlightIdx: A, maxH: 250 })),
        options: options,
        explanation: sayA + " and " + sayName(base.prints[opp].g) + " are opposite faces. A face touches its four neighbours but never its opposite.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 3: Which pair of faces can touch? ---- */
    function pairOptionHtml(base, i, j) {
      return "<span class='cnt-pairopt'>" + printCardHtml(base, i, 62) +
        "<span class='cnt-amp'>&amp;</span>" + printCardHtml(base, j, 62) + "</span>";
    }
    function buildCanTouch(theme) {
      var base = buildBase(theme);
      var oppPairs = [];
      var used = {};
      for (var i = 0; i < 6; i++) {
        var o = base.info.opposite[i];
        var pk = Math.min(i, o) + "-" + Math.max(i, o);
        if (!used[pk]) { used[pk] = true; oppPairs.push([Math.min(i, o), Math.max(i, o)]); }
      }
      var a = Math.floor(Math.random() * 6);
      var others = [];
      for (var k = 0; k < 6; k++) if (k !== a && k !== base.info.opposite[a]) others.push(k);
      var b = choice(others);
      var pair = [Math.min(a, b), Math.max(a, b)];
      var options = [{
        html: pairOptionHtml(base, pair[0], pair[1]),
        sig: "p" + pair[0] + "-" + pair[1], isCorrect: true, note: ""
      }].concat(oppPairs.map(function (pp) {
        return {
          html: pairOptionHtml(base, pp[0], pp[1]),
          sig: "p" + pp[0] + "-" + pp[1], isCorrect: false,
          note: ""
        };
      }));
      return finishQuestion({
        typeId: "canTouch",
        prompt: "Which pair of faces WILL touch along an edge when the net is folded?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { maxH: 250 })),
        options: options,
        explanation: sayName(base.prints[pair[0]].g) + " and " + sayName(base.prints[pair[1]].g) + " share an edge on the cube. The other three pairs are opposite pairs and never meet.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 4: Which face is top / front / right? ---- */
    function buildWhichRole(theme) {
      var base = buildBase(theme);
      var m = choice(ROTS24);
      var view = viewFor(base.cube, m);
      var role = choice(VISIBLE_ROLES);
      var correctG = view[role].g;
      var otherVisible = VISIBLE_ROLES.filter(function (r) { return r !== role; })
        .map(function (r) { return view[r].g; });
      var hidden = base.prints.map(function (p) { return p.g; }).filter(function (g) {
        return g !== correctG && otherVisible.indexOf(g) === -1;
      });
      var wrongGs = otherVisible.concat(shuffle(hidden)).slice(0, 3);
      var options = [{
        html: faceCardSvg({ g: correctG, rot: 0, col: 2, row: 2 }, { label: glyphName(correctG) }),
        sig: "g" + correctG, isCorrect: true, note: ""
      }].concat(wrongGs.map(function (g) {
        return {
          html: faceCardSvg({ g: g, rot: 0, col: 2, row: 2 }, { label: glyphName(g) }),
          sig: "g" + g, isCorrect: false,
          noteGroup: { who: sayName(g), one: "is on a different face, not the " + role + ".", many: "are on other faces, not the " + role + "." }
        };
      }));
      return finishQuestion({
        typeId: "whichRole",
        prompt: "Which symbol is on the " + role.toUpperCase() + " face of this cube?",
        stimulusHtml: figureHtml(isoCubeSvg(view, { width: 168 }), "Top = lid, front = lower-left, right = lower-right"),
        options: options,
        explanation: "The " + role + " face shows " + sayName(correctG) + ". A symbol can look tilted in a 3D drawing, but its shape stays the same.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 5: Missing face on the cube ---- */
    function buildMissingFace(theme) {
      var base = buildBase(theme);
      var m = choice(ROTS24);
      var view = viewFor(base.cube, m);
      var hideRole = choice(VISIBLE_ROLES);
      var truth = view[hideRole];
      var sym = glyphSym(truth.g);
      var options = [{
        html: faceCardSvg(truth, { label: glyphName(truth.g) }),
        sig: "d" + viewFaceSig(truth), isCorrect: true, note: ""
      }];
      /* Distractor: right symbol, wrong turn (respecting glyph symmetry). */
      var deltas = [90, 180, 270].filter(function (d) { return d % (360 / sym) !== 0; });
      if (deltas.length) {
        var d1 = {
          g: truth.g, rot: (truth.rot + choice(deltas)) % 360,
          col: truth.col, row: truth.row
        };
        options.push({
          html: faceCardSvg(d1, { label: glyphName(truth.g) + " turned wrongly" }),
          sig: "d" + viewFaceSig(d1), isCorrect: false,
          note: "the right symbol turned the wrong way."
        });
      }
      /* Distractor: a symbol that is opposite one of the visible faces -
         geometrically impossible in this position. */
      var visRole = VISIBLE_ROLES.filter(function (r) { return r !== hideRole; })[Math.floor(Math.random() * 2)];
      var oppOfVisible = base.info.opposite[view[visRole].faceIdx];
      var d2 = { g: base.prints[oppOfVisible].g, rot: choice([0, 90, 180, 270]), col: truth.col, row: truth.row };
      options.push({
        html: faceCardSvg(d2, { label: glyphName(d2.g) }),
        sig: "d" + viewFaceSig(d2), isCorrect: false,
        note: sayName(d2.g) + " is opposite " + sayName(view[visRole].g) + ", so it can never sit beside it."
      });
      /* Distractor: right symbol, wrong slot (or another hidden face's symbol). */
      if (truth.col !== 2 || truth.row !== 2) {
        var d3 = { g: truth.g, rot: truth.rot, col: 4 - truth.col, row: 4 - truth.row };
        options.push({
          html: faceCardSvg(d3, { label: glyphName(truth.g) + " in the wrong corner" }),
          sig: "d" + viewFaceSig(d3), isCorrect: false,
          note: "the right symbol in the wrong position."
        });
      } else {
        var hiddenIdxs = [];
        for (var i = 0; i < 6; i++) {
          var isVis = VISIBLE_ROLES.some(function (r) { return view[r].faceIdx === i; });
          if (!isVis && i !== oppOfVisible) hiddenIdxs.push(i);
        }
        var fi = choice(hiddenIdxs);
        var d3b = { g: base.prints[fi].g, rot: choice([0, 90, 180, 270]), col: 2, row: 2 };
        options.push({
          html: faceCardSvg(d3b, { label: glyphName(d3b.g) }),
          sig: "d" + viewFaceSig(d3b), isCorrect: false,
          note: sayName(d3b.g) + " belongs on a different face."
        });
      }
      if (options.length < 4) return null;
      return finishQuestion({
        typeId: "missingFace",
        prompt: "One face of this cube is missing. Which option completes it EXACTLY as it would appear?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { width: 250, maxH: 220 }), "The net") +
          figureHtml(isoCubeSvg(view, { width: 168, hiddenRole: hideRole })),
        options: options.slice(0, 4),
        explanation: "The two visible faces fix the cube, so the net forces " + sayName(truth.g) + " here at exactly this angle.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 6: Hidden face on the cube ---- */
    function buildHiddenFace(theme) {
      var base = buildBase(theme);
      var m = choice(ROTS24);
      var view = viewFor(base.cube, m);
      var role = choice(VISIBLE_ROLES);
      var ringFace = view[role].faceIdx;
      var oppIdx = base.info.opposite[ringFace];
      var correctG = base.prints[oppIdx].g;
      var wrongPool = [];
      for (var i = 0; i < 6; i++) if (i !== ringFace && i !== oppIdx) wrongPool.push(base.prints[i].g);
      var wrongGs = shuffle(wrongPool).slice(0, 3);
      var options = [{
        html: faceCardSvg({ g: correctG, rot: 0, col: 2, row: 2 }, { label: glyphName(correctG) }),
        sig: "g" + correctG, isCorrect: true, note: ""
      }].concat(wrongGs.map(function (g) {
        return {
          html: faceCardSvg({ g: g, rot: 0, col: 2, row: 2 }, { label: glyphName(g) }),
          sig: "g" + g, isCorrect: false,
          noteGroup: { who: sayName(g), one: "is a neighbour of " + sayName(base.prints[ringFace].g) + ", not the face behind it.", many: "are neighbours of " + sayName(base.prints[ringFace].g) + ", not the face behind it." }
        };
      }));
      return finishQuestion({
        typeId: "hiddenFace",
        prompt: "Which symbol is on the hidden face directly opposite the ringed face?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { width: 250, maxH: 220 }), "The net") +
          figureHtml(isoCubeSvg(view, { width: 168, ringRole: role })),
        options: options,
        explanation: sayName(base.prints[ringFace].g) + " and " + sayName(correctG) + " are opposite: one square apart in a straight line on the net.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ============================================================
       7. DISTRACTOR MUTATION ENGINE (types 7-10)
       Every distractor is built by deliberately breaking one rule,
       then PROVED impossible against all 24 cube rotations before
       it is allowed on screen. Nothing is trusted, everything is
       re-checked; failures re-roll silently.
       ============================================================ */
    function cloneView(view) {
      var out = {};
      VISIBLE_ROLES.forEach(function (r) {
        var f = view[r];
        out[r] = { faceIdx: f.faceIdx, g: f.g, rot: f.rot, col: f.col, row: f.row };
      });
      return out;
    }
    var VIEW_MUTATORS = [
      { kind: "oppositeCollision", apply: function (view, base) {
          var roles = shuffle(VISIBLE_ROLES);
          var src = view[roles[0]], dst = roles[1];
          var oppIdx = base.info.opposite[src.faceIdx];
          var v = cloneView(view);
          v[dst] = { faceIdx: -1, g: base.prints[oppIdx].g, rot: choice([0, 90, 180, 270]), col: v[dst].col, row: v[dst].row };
          return { view: v, note: "it shows " + sayName(src.g) + " and " + sayName(base.prints[oppIdx].g) + " touching, but they are opposite faces." };
        } },
      { kind: "rotationDefect", apply: function (view) {
          var candidates = VISIBLE_ROLES.filter(function (r) { return glyphSym(view[r].g) < 4; });
          if (!candidates.length) return null;
          var role = choice(candidates);
          var sym = glyphSym(view[role].g);
          var deltas = [90, 180, 270].filter(function (d) { return d % (360 / sym) !== 0; });
          if (!deltas.length) return null;
          var v = cloneView(view);
          v[role] = { faceIdx: -1, g: v[role].g, rot: (v[role].rot + choice(deltas)) % 360, col: v[role].col, row: v[role].row };
          return { view: v, note: sayName(view[role].g) + " is twisted to an impossible angle." };
        } },
      { kind: "chiralityFlip", apply: function (view) {
          var roles = shuffle(VISIBLE_ROLES);
          var v = cloneView(view);
          var t = v[roles[0]];
          v[roles[0]] = v[roles[1]];
          v[roles[1]] = t;
          return { view: v, note: "a mirror image: no turn of the real cube can produce it." };
        } },
      { kind: "positionDefect", apply: function (view) {
          var candidates = VISIBLE_ROLES.filter(function (r) { return view[r].col !== 2 || view[r].row !== 2; });
          if (!candidates.length) return null;
          var role = choice(candidates);
          var v = cloneView(view);
          v[role] = { faceIdx: -1, g: v[role].g, rot: v[role].rot, col: 4 - v[role].col, row: 4 - v[role].row };
          return { view: v, note: sayName(view[role].g) + " is in the wrong position on its face." };
        } }
    ];
    function makeInvalidView(base, seedView, bannedSigs) {
      var order = shuffle(VIEW_MUTATORS);
      for (var mi = 0; mi < order.length; mi++) {
        for (var t = 0; t < 24; t++) {
          var res = order[mi].apply(cloneView(seedView), base);
          if (!res) break;
          var sig = viewSig(res.view);
          if (bannedSigs[sig]) continue;
          if (canProduceView(base.cube, res.view)) continue; /* accidentally still valid: reject */
          bannedSigs[sig] = true;
          return { view: res.view, sig: sig, note: res.note };
        }
      }
      return null;
    }
    function clonePrints(prints) {
      return prints.map(function (p) { return { g: p.g, col: p.col, row: p.row, rho: p.rho }; });
    }
    var PRINT_MUTATORS = [
      { kind: "swap", apply: function (prints) {
          var i = Math.floor(Math.random() * 6);
          var j = (i + 1 + Math.floor(Math.random() * 5)) % 6;
          var out = clonePrints(prints);
          var t = out[i]; out[i] = out[j]; out[j] = t;
          return { prints: out, note: "two symbols have swapped places." };
        } },
      { kind: "rotate", apply: function (prints) {
          var candidates = [];
          prints.forEach(function (p, i) { if (glyphSym(p.g) < 4) candidates.push(i); });
          if (!candidates.length) return null;
          var i = choice(candidates);
          var sym = glyphSym(prints[i].g);
          var deltas = [90, 180, 270].filter(function (d) { return d % (360 / sym) !== 0; });
          if (!deltas.length) return null;
          var out = clonePrints(prints);
          out[i].rho = (out[i].rho + choice(deltas)) % 360;
          return { prints: out, note: sayName(prints[i].g) + " is printed at the wrong angle." };
        } },
      { kind: "move", apply: function (prints) {
          var candidates = [];
          prints.forEach(function (p, i) { if (p.col !== 2 || p.row !== 2) candidates.push(i); });
          if (!candidates.length) return null;
          var i = choice(candidates);
          var out = clonePrints(prints);
          out[i].col = 4 - out[i].col;
          out[i].row = 4 - out[i].row;
          return { prints: out, note: sayName(prints[i].g) + " sits in the wrong position on its square." };
        } }
    ];
    function makeInvalidNet(targetView, preferredNetIdx, bannedSigs) {
      for (var t = 0; t < 60; t++) {
        var netIdx = t < 20 && preferredNetIdx !== null ? preferredNetIdx : Math.floor(Math.random() * NETS.length);
        var seed = reprintCube(TARGET_CUBE_SCRATCH, choice(ROTS24), netIdx);
        var mut = choice(PRINT_MUTATORS).apply(seed);
        if (!mut) continue;
        var sig = printsSig(netIdx, mut.prints);
        if (bannedSigs[sig]) continue;
        var cand = cubeModel(netIdx, mut.prints);
        if (canProduceView(cand, targetView)) continue; /* still makeable: reject */
        bannedSigs[sig] = true;
        return { netIdx: netIdx, prints: mut.prints, sig: sig, note: mut.note };
      }
      return null;
    }
    var TARGET_CUBE_SCRATCH = null; /* set by net-question builders before use */

    /* ---- Type 7: Which cube can be made? ---- */
    function buildCubeCanMake(theme) {
      var base = buildBase(theme);
      var correctView = viewFor(base.cube, choice(ROTS24));
      var banned = {};
      banned[viewSig(correctView)] = true;
      var usedTrios = {};
      usedTrios[viewTrioKey(correctView)] = true;
      function freshSeed() {
        var ms = shuffle(ROTS24);
        for (var j = 0; j < ms.length; j++) {
          var cand = viewFor(base.cube, ms[j]);
          if (!usedTrios[viewTrioKey(cand)]) return cand;
        }
        return viewFor(base.cube, choice(ROTS24));
      }
      var options = [{
        html: isoCubeSvg(correctView, { width: 118 }),
        sig: viewSig(correctView), isCorrect: true, note: ""
      }];
      for (var i = 0; i < 3; i++) {
        var inv = makeInvalidView(base, freshSeed(), banned);
        if (!inv) return null;
        usedTrios[viewTrioKey(inv.view)] = true;
        options.push({ html: isoCubeSvg(inv.view, { width: 118 }), sig: inv.sig, isCorrect: false, note: inv.note });
      }
      return finishQuestion({
        typeId: "cubeCanMake",
        prompt: "Which cube CAN be made by folding this net?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { maxH: 250 })),
        options: options,
        explanation: "Only one drawing matches the net. Check the symbols at the corner, their turns, and that no opposite pair touches.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 8: Which cube cannot be made? ---- */
    function buildCubeCannot(theme) {
      var base = buildBase(theme);
      var banned = {};
      var usedTrios = {};
      var valids = [];
      var ms = shuffle(ROTS24);
      for (var i = 0; i < ms.length && valids.length < 3; i++) {
        var v = viewFor(base.cube, ms[i]);
        var sig = viewSig(v);
        var trio = viewTrioKey(v);
        if (banned[sig] || usedTrios[trio]) continue;
        banned[sig] = true;
        usedTrios[trio] = true;
        valids.push({ view: v, sig: sig });
      }
      if (valids.length < 3) return null;
      var seed = null;
      var ms2 = shuffle(ROTS24);
      for (var k = 0; k < ms2.length && !seed; k++) {
        var cand = viewFor(base.cube, ms2[k]);
        if (!usedTrios[viewTrioKey(cand)]) seed = cand;
      }
      if (!seed) seed = viewFor(base.cube, choice(ROTS24));
      var inv = makeInvalidView(base, seed, banned);
      if (!inv) return null;
      var options = valids.map(function (vv) {
        return {
          html: isoCubeSvg(vv.view, { width: 118 }), sig: vv.sig, isCorrect: false,
          note: ""
        };
      });
      options.push({ html: isoCubeSvg(inv.view, { width: 118 }), sig: inv.sig, isCorrect: true, note: "" });
      return finishQuestion({
        typeId: "cubeCannot",
        prompt: "Three of these cubes can be made by folding this net. Which cube CANNOT be made?",
        stimulusHtml: figureHtml(netSvg(base.netIdx, base.prints, { maxH: 250 })),
        options: options,
        explanation: "The impossible drawing: " + inv.note + " The other three are the same cube from different angles.",
        review: { netIdx: base.netIdx, prints: base.prints }
      });
    }

    /* ---- Type 9: Which net makes the cube? ---- */
    function buildNetCanMake(theme) {
      var base = buildBase(theme);
      var targetView = viewFor(base.cube, choice(ROTS24));
      TARGET_CUBE_SCRATCH = base.cube;
      var correctNetIdx = Math.floor(Math.random() * NETS.length);
      var correctPrints = reprintCube(base.cube, choice(ROTS24), correctNetIdx);
      if (!canProduceView(cubeModel(correctNetIdx, correctPrints), targetView)) return null; /* engine self-check */
      var banned = {};
      banned[printsSig(correctNetIdx, correctPrints)] = true;
      var options = [{
        html: netSvg(correctNetIdx, correctPrints, { width: 168, maxH: 140 }),
        sig: printsSig(correctNetIdx, correctPrints), isCorrect: true, note: ""
      }];
      var otherNets = shuffle(NETS.map(function (_, i) { return i; }));
      for (var i = 0; i < 3; i++) {
        var inv = makeInvalidNet(targetView, otherNets[i % otherNets.length], banned);
        if (!inv) return null;
        options.push({
          html: netSvg(inv.netIdx, inv.prints, { width: 168, maxH: 140 }),
          sig: inv.sig, isCorrect: false, note: inv.note
        });
      }
      return finishQuestion({
        typeId: "netCanMake",
        prompt: "Which net folds up to make EXACTLY this cube?",
        stimulusHtml: figureHtml(isoCubeSvg(targetView, { width: 168 })),
        options: options,
        explanation: "Check each visible symbol on each net: its neighbours and its turn must both match. Only one net passes.",
        review: { netIdx: correctNetIdx, prints: correctPrints }
      });
    }

    /* ---- Type 10: Which net cannot make the cube? ---- */
    function buildNetCannot(theme) {
      var base = buildBase(theme);
      var targetView = viewFor(base.cube, choice(ROTS24));
      TARGET_CUBE_SCRATCH = base.cube;
      var banned = {};
      var netOrder = shuffle(NETS.map(function (_, i) { return i; }));
      var valids = [];
      for (var i = 0; i < netOrder.length && valids.length < 3; i++) {
        var prints = reprintCube(base.cube, choice(ROTS24), netOrder[i]);
        var sig = printsSig(netOrder[i], prints);
        if (banned[sig]) continue;
        if (!canProduceView(cubeModel(netOrder[i], prints), targetView)) continue; /* engine self-check */
        banned[sig] = true;
        valids.push({ netIdx: netOrder[i], prints: prints, sig: sig });
      }
      if (valids.length < 3) return null;
      var inv = makeInvalidNet(targetView, null, banned);
      if (!inv) return null;
      var options = valids.map(function (vv) {
        return {
          html: netSvg(vv.netIdx, vv.prints, { width: 168, maxH: 140 }), sig: vv.sig, isCorrect: false,
          note: ""
        };
      });
      options.push({
        html: netSvg(inv.netIdx, inv.prints, { width: 168, maxH: 140 }),
        sig: inv.sig, isCorrect: true, note: ""
      });
      return finishQuestion({
        typeId: "netCannot",
        prompt: "Three of these nets fold into the cube shown. Which net CANNOT make it?",
        stimulusHtml: figureHtml(isoCubeSvg(targetView, { width: 168 })),
        options: options,
        explanation: "The odd one out fails because " + inv.note + " The other three fold into the same cube.",
        review: { netIdx: inv.netIdx, prints: inv.prints }
      });
    }

    /* ============================================================
       8. QUESTION FACTORY with runtime pre-validation interceptor.
       A question only reaches the screen after finishQuestion() has
       proved: 4 options, exactly 1 correct, no duplicates, nothing
       empty. Failed builds are discarded and silently re-rolled.
       ============================================================ */
    var BUILDERS = {
      opposite: buildOpposite,
      cannotTouch: buildCannotTouch,
      canTouch: buildCanTouch,
      whichRole: buildWhichRole,
      missingFace: buildMissingFace,
      hiddenFace: buildHiddenFace,
      cubeCanMake: buildCubeCanMake,
      cubeCannot: buildCubeCannot,
      netCanMake: buildNetCanMake,
      netCannot: buildNetCannot
    };
    function makeQuestion(typeId, theme) {
      var q = null, tries;
      for (tries = 0; tries < 40 && !q; tries++) {
        try { q = BUILDERS[typeId](theme); } catch (e) { q = null; }
      }
      if (!q) {
        /* graceful fallback: the opposite-face builder always converges */
        for (tries = 0; tries < 40 && !q; tries++) {
          try { q = buildOpposite(theme); } catch (e2) { q = null; }
        }
      }
      return q;
    }
    var lastTypeId = null;
    function pickTypeId(selected) {
      if (selected !== "mixed") return selected;
      var pool = TYPE_META.map(function (t) { return t.id; }).filter(function (id) { return id !== lastTypeId; });
      return choice(pool);
    }

    /* ============================================================
       9. INTERACTIVE FOLD ANIMATOR
       Real CSS-3D hinge model: each net cell is a nested node that
       rotates 90deg about its shared edge, staggered by tree depth,
       so students watch the printed symbols travel into position.
       ============================================================ */
    function face3dSvg(print, pairIdx) {
      var out = "<svg viewBox='0 0 100 100' aria-hidden='true'>";
      out += "<rect x='0' y='0' width='100' height='100' fill='" + glyphFill(print.g) + "'/>";
      out += glyphGroup(print.g, print.rho, print.col, print.row);
      if (typeof pairIdx === "number") {
        var pc = PAIR_COLOURS[pairIdx % 3];
        out += "<circle cx='81' cy='19' r='14' fill='#ffffff' stroke='" + pc + "' stroke-width='5'/>";
        out += "<text x='81' y='20' font-size='18' font-weight='900' text-anchor='middle' dominant-baseline='central' fill='" + pc + "'>" + (pairIdx + 1) + "</text>";
      }
      return out + "</svg>";
    }
    function smoother(t) {
      t = clamp(t, 0, 1);
      return t * t * t * (t * (t * 6 - 15) + 10);
    }
    function mountFoldViewer(container, netIdx, prints) {
      if (container.dataset.foldMounted === "true") return;
      container.dataset.foldMounted = "true";
      var info = foldNet(netIdx);
      var F = parseFloat(getComputedStyle(root).getPropertyValue("--cnt-face3d")) || 54;
      var cr = container.getBoundingClientRect();
      if (cr.width > 0 && cr.height > 0) F = Math.round(Math.max(44, Math.min(cr.width * 0.12, cr.height * 0.22, 90)));
      var stage = document.createElement("div");
      stage.className = "cnt-fold-stage";
      stage.style.setProperty("--cnt-face3d", F + "px");
      stage.innerHTML =
        "<div class='cnt-fold-pill'>&#8635; Drag to rotate</div>" +
        "<div class='cnt-fold-scene'><div class='cnt-fold-model'></div></div>" +
        "<div class='cnt-fold-controls'><label>Flat</label>" +
        "<input class='cnt-fold-range' type='range' min='0' max='100' value='0' aria-label='Fold the net into a cube'>" +
        "<label>Cube</label></div>";
      container.appendChild(stage);
      var model = stage.querySelector(".cnt-fold-model");
      var range = stage.querySelector(".cnt-fold-range");
      var view = { fold: 0, rotX: -28, rotY: 36, dragging: false, lastX: 0, lastY: 0 };
      function makeNode(faceIdx) {
        var node = document.createElement("div");
        node.className = "cnt-node";
        var parent = info.parents[faceIdx];
        if (!parent) {
          node.classList.add("cnt-node-root");
        } else {
          node.dataset.dx = String(parent.dx);
          node.dataset.dy = String(parent.dy);
          node.dataset.depth = String(parent.depth);
          if (parent.dx === 1)  { node.style.left = F + "px";  node.style.top = "0px";   node.style.transformOrigin = "left center"; }
          if (parent.dx === -1) { node.style.left = -F + "px"; node.style.top = "0px";   node.style.transformOrigin = "right center"; }
          if (parent.dy === 1)  { node.style.left = "0px";     node.style.top = F + "px";  node.style.transformOrigin = "center top"; }
          if (parent.dy === -1) { node.style.left = "0px";     node.style.top = -F + "px"; node.style.transformOrigin = "center bottom"; }
        }
        var face = document.createElement("div");
        face.className = "cnt-3dface";
        face.innerHTML = face3dSvg(prints[faceIdx]);
        node.appendChild(face);
        info.children[faceIdx].forEach(function (childIdx) {
          node.appendChild(makeNode(childIdx));
        });
        return node;
      }
      model.appendChild(makeNode(info.rootIdx));
      function applyNodeFold(node) {
        if (node.dataset.dx !== undefined) {
          var dx = Number(node.dataset.dx), dy = Number(node.dataset.dy);
          var depth = Number(node.dataset.depth || 0);
          var delay = Math.min(0.38, depth * 0.075);
          var t = smoother(clamp((view.fold / 100 - delay) / (1 - delay), 0, 1));
          var tf = "";
          if (dx === 1)  tf = "rotateY(" + (90 * t) + "deg)";
          if (dx === -1) tf = "rotateY(" + (-90 * t) + "deg)";
          if (dy === 1)  tf = "rotateX(" + (-90 * t) + "deg)";
          if (dy === -1) tf = "rotateX(" + (90 * t) + "deg)";
          node.style.transform = tf;
        }
        Array.prototype.forEach.call(node.children, function (child) {
          if (child.classList && child.classList.contains("cnt-node")) applyNodeFold(child);
        });
      }
      function applyAll() {
        model.style.transform = "rotateX(" + view.rotX + "deg) rotateY(" + view.rotY + "deg)";
        var rootNode = model.querySelector(".cnt-node-root");
        if (rootNode) applyNodeFold(rootNode);
      }
      range.addEventListener("input", function () {
        view.fold = clamp(Number(range.value), 0, 100);
        applyAll();
      });
      stage.addEventListener("pointerdown", function (e) {
        if (e.target.closest("input, button")) return;
        view.dragging = true; view.lastX = e.clientX; view.lastY = e.clientY;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      stage.addEventListener("pointermove", function (e) {
        if (!view.dragging) return;
        view.rotY += (e.clientX - view.lastX) * 0.55;
        view.rotX -= (e.clientY - view.lastY) * 0.55;
        view.lastX = e.clientX; view.lastY = e.clientY;
        applyAll();
      });
      stage.addEventListener("pointerup", function () { view.dragging = false; });
      stage.addEventListener("pointercancel", function () { view.dragging = false; });
      applyAll();
      /* gentle welcome animation so students see it move */
      if (reduceMotion) {
        view.fold = 100;
        range.value = "100";
        applyAll();
      } else {
        var start = null;
        function intro(ts) {
          if (start === null) start = ts;
          var p = clamp((ts - start) / 2600, 0, 1);
          view.fold = 100 * smoother(p);
          range.value = String(Math.round(view.fold));
          applyAll();
          if (p < 1) requestAnimationFrame(intro);
        }
        requestAnimationFrame(intro);
      }
    }

    /* ============================================================
       12. SPATIAL TRAINER: shared helpers
       Everything from here down is the ten-door trainer built around
       the Cube Nets core above. Names are prefixed (sr, vx, fl, pp) so
       nothing collides with the nets engine.
       ============================================================ */
    var LETTERS5 = ["A", "B", "C", "D", "E"];
    var SR_NAVY = "#1a2347", SR_ORANGE = "#f47820", SR_PAPER = "#dfe5f1", SR_MUTED = "#5f6b7c";
    function ri(n) { return Math.floor(Math.random() * n); }
    function pick(arr) { return arr[ri(arr.length)]; }
    function rnd(a, b) { return a + ri(b - a + 1); }
    function fx(n) { return String(Math.round(n * 100) / 100); }
    function ptsStr(arr) { return arr.map(function (p) { return fx(p[0]) + "," + fx(p[1]); }).join(" "); }
    /* label === false draws a decorative svg (aria-hidden) for a parent that carries the name itself */
    function svgBox(inner, vb, w, h, label) {
      var a11y = label === false ? " aria-hidden='true'" : " role='img' aria-label='" + esc(label || "diagram") + "'";
      return "<svg viewBox='" + vb + "' width='" + fx(w) + "' height='" + fx(h) + "'" + a11y + ">" + inner + "</svg>";
    }
    function letterFor(i) { return LETTERS5[i] || String(i + 1); }
    function hexMix(a, b, t) {
      var pa = parseInt(a.slice(1), 16), pb = parseInt(b.slice(1), 16);
      var out = "#";
      for (var i = 16; i >= 0; i -= 8) {
        var ca = (pa >> i) & 255, cb = (pb >> i) & 255;
        var c = Math.round(ca + (cb - ca) * t);
        out += (c < 16 ? "0" : "") + c.toString(16);
      }
      return out;
    }
    function listWords(xs) { return listJoin(xs); }
    /* Misconception tags. Every wrong option's note (the wording the builders
       actually write) maps to one tag from a fixed vocabulary; the summary's
       "Watch out for" list and the review read o.tag, never the note text.
       Order matters: the first pattern that matches wins, so the specific
       wordings sit above the broad ones. */
    var NOTE_TAGS = [
      [/look-alike|nearly|one side different/i, "look-alike"],
      [/mirror image|turned over|flipped over|no turn of the real cube/i, "mirror-image"],
      [/hidden ones are missing|cubes you can see/i, "hidden-cube"],
      [/top layer/i, "top-layer"],
      [/view flipped|upside down|^flipped/i, "flipped-view"],
      [/view from the (top|front|side)/i, "wrong-view"],
      [/one square is wrong|square wrong|view is different|plan is different/i, "one-square"],
      [/wrong line|wrong crease/i, "wrong-crease"],
      [/not been opened|not been unfolded|not unfolded/i, "not-unfolded"],
      [/hole is missing|missing a copy|copy is missing/i, "missing-copy"],
      [/hole too many|extra hole/i, "extra-hole"],
      [/slipped/i, "slipped"],
      [/triangle should point|turns it over/i, "triangle-flip"],
      [/wrong corners/i, "wrong-corners"],
      [/as it was, not reflected|not mirrored|without mirroring/i, "unchanged"],
      [/spun round/i, "spun"],
      /* a mirrored notch or piece; sits below the crease, spun and unchanged wordings that also say "mirrored" */
      [/mirrored/i, "mirror-image"],
      [/one cube moved|cube moved|cubes have moved|moved together/i, "moved-cube"],
      [/too many cubes|too few cubes|add up to/i, "piece-count"],
      [/cut out instead|added on instead|instead of cut out/i, "cut-out"],
      [/do not fit|different piece|piece you already have|cut along a different line/i, "wrong-piece"],
      [/wrong side/i, "wrong-side"],
      [/opposite|neighbour|next to/i, "opposite-as-neighbour"],
      [/wrong position|swapped places|different face|wrong place/i, "wrong-position"],
      [/turned the wrong way|wrong angle|impossible angle|turned wrongly/i, "wrong-turn"],
      [/cannot fold|cannot make|does not make the cube/i, "impossible-net"],
      /* "tilted by N degrees" beats any size word later in the same note */
      [/tilted by/i, "tilt"],
      [/too big|too small|smaller|bigger|wrong size|size bigger|size smaller/i, "size"],
      [/tilted/i, "tilt"]
    ];
    function noteTag(note) {
      var text = String(note || "").trim();
      if (!text) return "other";
      for (var i = 0; i < NOTE_TAGS.length; i++) if (NOTE_TAGS[i][0].test(text)) return NOTE_TAGS[i][1];
      return "other";
    }
    /* tag -> what the child did, past tense, short enough for one line on a phone */
    var TAG_LABELS = {
      "mirror-image": "picked a mirror image",
      "size": "picked the wrong size",
      "tilt": "picked a tilted copy",
      "look-alike": "picked a look-alike shape",
      "hidden-cube": "missed cubes hidden behind or underneath",
      "top-layer": "forgot the top layer",
      "wrong-view": "took the view from the wrong side",
      "flipped-view": "flipped the view over",
      "one-square": "missed a square that did not match",
      "wrong-crease": "copied the holes across the wrong crease",
      "not-unfolded": "did not unfold every crease",
      "missing-copy": "missed a copy of a hole",
      "extra-hole": "added a hole that is not there",
      "slipped": "let the holes slip sideways",
      "triangle-flip": "forgot the triangle flips over",
      "spun": "spun it round instead of mirroring it",
      "unchanged": "copied the shape without mirroring it",
      "wrong-corners": "put the copies in the wrong corners",
      "moved-cube": "moved one cube",
      "piece-count": "got the cube total wrong",
      "wrong-piece": "picked a piece that does not fit",
      "cut-out": "cut the piece out instead of adding it",
      "wrong-side": "joined the piece on the wrong side",
      "opposite-as-neighbour": "mixed up opposite faces and neighbours",
      "wrong-position": "put the symbol in the wrong place",
      "wrong-turn": "turned the symbol the wrong way",
      "impossible-net": "mixed up which nets make the cube",
      "other": "made a different slip"
    };
    function tagLabel(tag) { return TAG_LABELS[tag] || TAG_LABELS.other; }
    /* Stamp o.tag on every wrong option: from its note, or its noteGroup wording, else "other". */
    function tagOptions(options) {
      options.forEach(function (o) {
        if (!o || o.isCorrect) { if (o) o.tag = null; return; }
        var text = o.note || (o.noteGroup && (o.noteGroup.one || o.noteGroup.many)) || "";
        o.tag = text ? noteTag(text) : "other";
      });
      return options;
    }
    /* Generic finisher: shuffle, then prove N options, exactly one correct, no
       duplicate signatures, nothing empty. Same note grouping as the nets core,
       with letters up to E. Returns null so the caller re-rolls. */
    function finishQ(q) {
      var order = shuffle(q.options.map(function (_, i) { return i; }));
      var options = order.map(function (i) { return q.options[i]; });
      var correctIdx = -1, correctCount = 0, sigs = {};
      for (var i = 0; i < options.length; i++) {
        var o = options[i];
        if (!o || !o.html || !o.sig) return null;
        if (sigs[o.sig]) return null;
        sigs[o.sig] = true;
        if (o.isCorrect) { correctIdx = i; correctCount++; }
      }
      if (options.length < 4 || options.length > 5 || correctCount !== 1) return null;
      var notes = [], groups = {}, groupOrder = [], plain = {}, plainOrder = [];
      options.forEach(function (o, i) {
        if (o.isCorrect) return;
        if (o.noteGroup) {
          var key = o.noteGroup.many;
          if (!groups[key]) { groups[key] = { whos: [], one: o.noteGroup.one, many: o.noteGroup.many }; groupOrder.push(key); }
          groups[key].whos.push(o.noteGroup.who || letterFor(i));
        } else if (o.note) {
          if (!plain[o.note]) { plain[o.note] = []; plainOrder.push(o.note); }
          plain[o.note].push(letterFor(i));
        }
      });
      plainOrder.forEach(function (n) { notes.push(listJoin(plain[n]) + ": " + n); });
      notes = groupOrder.map(function (k) {
        var g = groups[k];
        var line = g.whos.length === 1 ? g.whos[0] + " " + g.one : listJoin(g.whos) + " " + g.many;
        return line.charAt(0).toUpperCase() + line.slice(1);
      }).concat(notes);
      tagOptions(options);
      q.options = options;
      q.correctIdx = correctIdx;
      var ex = q.explanation.charAt(0).toUpperCase() + q.explanation.slice(1);
      q.explanation = ex + (notes.length ? "\n" + notes.join("\n") : "");
      if (q.rule) q.rule = String(q.rule).trim();
      if (q.hint) q.hint = String(q.hint).trim();
      return q;
    }
    /* Try a builder until it converges. */
    function tryBuild(fn, arg, tries) {
      var q = null, n = tries || 40;
      for (var t = 0; t < n && !q; t++) {
        try { q = fn(arg); } catch (e) { q = null; }
      }
      return q;
    }
    var ICO = {
      tick: "<svg viewBox='0 0 24 24' width='12' height='12' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M5 12l5 5L20 7'/></svg>",
      cross: "<svg viewBox='0 0 24 24' width='12' height='12' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' aria-hidden='true'><path d='M6 6l12 12M18 6L6 18'/></svg>",
      rotate: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M20 12a8 8 0 1 1-2.3-5.7'/><path d='M20 4v5h-5'/></svg>",
      layers: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M12 3l9 5-9 5-9-5 9-5z'/><path d='M3 13l9 5 9-5'/><path d='M3 17l9 5 9-5'/></svg>",
      camera: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 8h3l2-3h6l2 3h3v11H4z'/><circle cx='12' cy='13' r='3.5'/></svg>",
      lock: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><rect x='5' y='11' width='14' height='10' rx='2'/><path d='M8 11V7a4 4 0 0 1 8 0v4'/></svg>",
      punch: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><circle cx='12' cy='12' r='4'/><path d='M12 2v3M12 19v3M2 12h3M19 12h3'/></svg>"
    };
    /* ============================================================
       13. VOXEL SOLIDS
       A real orthographic camera (yaw about the vertical, pitch above the
       ground) drawing unit cubes in painter's order, so the same code
       spins a pile, snaps to a front / side / plan elevation, peels
       layers and lights hidden blocks. Cubes are [i, j, k] with +x = i,
       +y = j and +z = k up. FRONT of a pile is its +x side; SIDE is +y.
       ============================================================ */
    var VX_HOME = { yaw: 45, pitch: 30 };
    var VX_VIEWS = { front: { yaw: 0, pitch: 0 }, side: { yaw: 90, pitch: 0 }, plan: { yaw: 0, pitch: 90 } };
    var VX_TINTS = {
      grey:   { dark: "#b9c3d8", edge: SR_NAVY },
      blue:   { dark: "#8fb0e6", edge: SR_NAVY },
      green:  { dark: "#8cc9a6", edge: SR_NAVY },
      orange: { dark: "#f4a660", edge: SR_ORANGE },
      ghost:  { dark: "#c4cbda", edge: "#8f99b0" }
    };
    var VX_LIGHT = (function () { var L = [0.32, 0.62, 0.72], n = Math.sqrt(L[0] * L[0] + L[1] * L[1] + L[2] * L[2]); return [L[0] / n, L[1] / n, L[2] / n]; })();
    function vxCam(yaw, pitch) {
      var t = (yaw * Math.PI) / 180, p = (pitch * Math.PI) / 180;
      var d = [Math.cos(p) * Math.cos(t), Math.cos(p) * Math.sin(t), Math.sin(p)];   /* scene -> camera */
      var r = [-Math.sin(t), Math.cos(t), 0];                                        /* screen right */
      var u = [-Math.sin(p) * Math.cos(t), -Math.sin(p) * Math.sin(t), Math.cos(p)];  /* screen up */
      return { d: d, r: r, u: u, yaw: yaw, pitch: pitch };
    }
    function vxDot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
    function vxProject(cam, p, s) { return [vxDot(p, cam.r) * s, -vxDot(p, cam.u) * s, vxDot(p, cam.d)]; }
    function vxKey(c) { return c[0] + "," + c[1] + "," + c[2]; }
    function vxSetOf(cubes) { var m = {}; cubes.forEach(function (c) { m[vxKey(c)] = true; }); return m; }
    function vxFromHeights(h) {
      var out = [];
      h.forEach(function (row, j) { row.forEach(function (n, i) { for (var k = 0; k < n; k++) out.push([i, j, k]); }); });
      return out;
    }
    function vxNorm(cubes) {
      var mi = [Infinity, Infinity, Infinity];
      cubes.forEach(function (c) { for (var a = 0; a < 3; a++) mi[a] = Math.min(mi[a], c[a]); });
      return cubes.map(function (c) { return [c[0] - mi[0], c[1] - mi[1], c[2] - mi[2]]; })
        .sort(function (p, q) { return p[0] - q[0] || p[1] - q[1] || p[2] - q[2]; });
    }
    function vxBounds(cubes) {
      var I = 0, J = 0, K = 0;
      cubes.forEach(function (c) { I = Math.max(I, c[0] + 1); J = Math.max(J, c[1] + 1); K = Math.max(K, c[2] + 1); });
      return { I: I, J: J, K: K };
    }
    function vxSig(cubes) { return vxNorm(cubes).map(vxKey).join(";"); }
    function vxRot(cubes, axis, times) {
      var out = cubes, n = ((times % 4) + 4) % 4;
      for (var t = 0; t < n; t++) {
        out = out.map(function (c) {
          var i = c[0], j = c[1], k = c[2];
          return axis === "z" ? [-j, i, k] : axis === "x" ? [i, -k, j] : [k, j, -i];
        });
      }
      return vxNorm(out);
    }
    function vxMirror(cubes) { return vxNorm(cubes.map(function (c) { return [-c[0], c[1], c[2]]; })); }
    function vxAllRots(cubes) {
      var seen = {}, out = [];
      for (var x = 0; x < 4; x++) for (var y = 0; y < 4; y++) for (var z = 0; z < 4; z++) {
        var r = vxRot(vxRot(vxRot(cubes, "x", x), "y", y), "z", z);
        var s = vxSig(r);
        if (!seen[s]) { seen[s] = true; out.push(r); }
      }
      return out;
    }
    function vxIsRotOf(a, b) {
      var sb = vxSig(b);
      return vxAllRots(a).some(function (r) { return vxSig(r) === sb; });
    }
    function vxIsChiral(cubes) { return !vxIsRotOf(cubes, vxMirror(cubes)); }
    function vxConnected(cubes) {
      if (!cubes.length) return false;
      var set = vxSetOf(cubes), seen = {}, stack = [cubes[0]], n = 0;
      seen[vxKey(cubes[0])] = true;
      while (stack.length) {
        var c = stack.pop(); n++;
        [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]].forEach(function (d) {
          var nb = [c[0] + d[0], c[1] + d[1], c[2] + d[2]], k = vxKey(nb);
          if (set[k] && !seen[k]) { seen[k] = true; stack.push(nb); }
        });
      }
      return n === cubes.length;
    }
    /* --- invariants: the one feature of a polycube a child can follow through
       a turn, a mirror or a build, so explanations talk about the item itself --- */
    var VX_DIRS = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
    var VX_ARM_WORDS = ["no", "one", "two", "three", "four", "five", "six"];
    function vxParseKey(k) {
      if (Array.isArray(k)) return [k[0], k[1], k[2]];
      var p = String(k).split(",").map(Number);
      return [p[0], p[1], p[2]];
    }
    /* vxInvariant(cubes) -> { kind, keys, text }. kind is "end" (the only cube with
       one neighbour), "elbow" (the only two-neighbour cube whose neighbours are not
       in a line), "branch" (the only cube with three or more neighbours), "run" (the
       only longest straight line of cubes) or "none". keys are cube keys in the frame
       the cubes were given in; text is a noun phrase for the explanation. */
    function vxInvariant(cubes) {
      cubes = cubes || [];
      var set = vxSetOf(cubes), nbs = {};
      cubes.forEach(function (c) {
        nbs[vxKey(c)] = VX_DIRS.map(function (d) { return [c[0] + d[0], c[1] + d[1], c[2] + d[2]]; })
          .filter(function (nb) { return set[vxKey(nb)]; });
      });
      var ends = [], elbows = [], branches = [];
      cubes.forEach(function (c) {
        var n = nbs[vxKey(c)];
        if (n.length === 1) ends.push(c);
        else if (n.length === 2) {
          var a = n[0], b = n[1];
          var straight = a[0] + b[0] === 2 * c[0] && a[1] + b[1] === 2 * c[1] && a[2] + b[2] === 2 * c[2];
          if (!straight) elbows.push(c);
        } else if (n.length >= 3) branches.push(c);
      });
      if (ends.length === 1) return { kind: "end", keys: [vxKey(ends[0])], text: "the single cube that sticks out on its own at one end" };
      if (elbows.length === 1) return { kind: "elbow", keys: [vxKey(elbows[0])], text: "the corner cube where the solid bends" };
      if (branches.length === 1) {
        var arms = nbs[vxKey(branches[0])].length;
        return { kind: "branch", keys: [vxKey(branches[0])], text: "the cube that joins " + (VX_ARM_WORDS[arms] || arms) + " arms" };
      }
      /* every maximal straight run of two or more cubes along an axis */
      var runs = [];
      [[1, 0, 0], [0, 1, 0], [0, 0, 1]].forEach(function (d) {
        cubes.forEach(function (c) {
          if (set[vxKey([c[0] - d[0], c[1] - d[1], c[2] - d[2]])]) return;   /* not the start of a run */
          var run = [c], nx = [c[0] + d[0], c[1] + d[1], c[2] + d[2]];
          while (set[vxKey(nx)]) { run.push(nx); nx = [nx[0] + d[0], nx[1] + d[1], nx[2] + d[2]]; }
          if (run.length >= 2) runs.push(run);
        });
      });
      var best = 0;
      runs.forEach(function (r) { best = Math.max(best, r.length); });
      var longest = runs.filter(function (r) { return r.length === best; });
      if (best >= 2 && longest.length === 1) return { kind: "run", keys: longest[0].map(vxKey), text: "the longest straight run of " + best + " cubes" };
      return { kind: "none", keys: [], text: "" };
    }
    /* One raw rotation step (no normalising), the same maps vxRot applies. */
    function vxRotStep(c, axis) {
      var i = c[0], j = c[1], k = c[2];
      return axis === "z" ? [-j, i, k] : axis === "x" ? [i, -k, j] : [k, j, -i];
    }
    function vxRotRaw(c, x, y, z) {
      var t;
      for (t = 0; t < x; t++) c = vxRotStep(c, "x");
      for (t = 0; t < y; t++) c = vxRotStep(c, "y");
      for (t = 0; t < z; t++) c = vxRotStep(c, "z");
      return c;
    }
    function vxMinCorner(cubes) {
      var mi = [Infinity, Infinity, Infinity];
      cubes.forEach(function (c) { for (var a = 0; a < 3; a++) mi[a] = Math.min(mi[a], c[a]); });
      return mi;
    }
    /* vxRotKeys(keys, cubesBefore, cubesAfter) -> the keys of the same cubes once the
       rotation that carries cubesBefore onto cubesAfter has been applied (the x, y, z
       quarter-turn search vxAllRots runs, normalised the way vxIsRotOf normalises),
       written in cubesAfter's own frame. null when no rotation maps one onto the other. */
    function vxRotKeys(keys, cubesBefore, cubesAfter) {
      if (!keys || !cubesBefore || !cubesAfter || cubesBefore.length !== cubesAfter.length) return null;
      var target = vxSig(cubesAfter), mA = vxMinCorner(cubesAfter);
      var pts = keys.map(vxParseKey);
      for (var x = 0; x < 4; x++) for (var y = 0; y < 4; y++) for (var z = 0; z < 4; z++) {
        var turned = cubesBefore.map(function (c) { return vxRotRaw(c, x, y, z); });
        if (vxSig(turned) !== target) continue;
        var mR = vxMinCorner(turned);
        return pts.map(function (p) {
          var r = vxRotRaw(p, x, y, z);
          return vxKey([r[0] - mR[0] + mA[0], r[1] - mR[1] + mA[1], r[2] - mR[2] + mA[2]]);
        });
      }
      return null;
    }
    /* vxPlacement(T, A, B) -> { aKeys, bKeys }: one way of fitting piece A and piece B
       (any turn, any slide) together so they make exactly T, with the keys in T's frame.
       The search is vxCanBuild's: every turn of A at every offset inside T, then the
       leftover must be a turn of B. null when the pieces cannot make T. */
    function vxPlacement(T, A, B) {
      if (!T || !A || !B || A.length + B.length !== T.length) return null;
      var set = vxSetOf(T), lo = vxMinCorner(T), hi = [-Infinity, -Infinity, -Infinity];
      T.forEach(function (c) { for (var a = 0; a < 3; a++) hi[a] = Math.max(hi[a], c[a]); });
      var rots = vxAllRots(A);
      for (var r = 0; r < rots.length; r++) {
        var pc = rots[r];
        for (var di = lo[0]; di <= hi[0]; di++) for (var dj = lo[1]; dj <= hi[1]; dj++) for (var dk = lo[2]; dk <= hi[2]; dk++) {
          var ok = true, placed = {}, aKeys = [];
          for (var q = 0; q < pc.length && ok; q++) {
            var k = (pc[q][0] + di) + "," + (pc[q][1] + dj) + "," + (pc[q][2] + dk);
            if (!set[k]) ok = false; else { placed[k] = true; aKeys.push(k); }
          }
          if (!ok) continue;
          var rest = T.filter(function (c) { return !placed[vxKey(c)]; });
          if (rest.length !== B.length || !vxIsRotOf(B, rest)) continue;
          return { aKeys: aKeys, bKeys: rest.map(vxKey) };
        }
      }
      return null;
    }
    /* A random connected polycube of n cubes, grown from one cube. */
    function vxRandomPolycube(n, flatBias) {
      var cubes = [[0, 0, 0]], set = { "0,0,0": true };
      var dirs = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
      var guard = 0;
      while (cubes.length < n && guard++ < 500) {
        var base = pick(cubes), d = pick(dirs);
        if (flatBias && d[2] !== 0 && Math.random() < flatBias) continue;
        var nb = [base[0] + d[0], base[1] + d[1], base[2] + d[2]], k = vxKey(nb);
        if (set[k]) continue;
        set[k] = true; cubes.push(nb);
      }
      return vxNorm(cubes);
    }
    /* A pile that stands on the ground: every column is solid from k = 0. */
    function vxRandomPile(nBlocks, maxSide, maxH) {
      var I = Math.min(maxSide, Math.max(2, Math.ceil(Math.sqrt(nBlocks / maxH)) + ri(2)));
      var J = Math.min(maxSide, Math.max(2, Math.ceil(nBlocks / (I * maxH)) + ri(2)));
      var h = [], left = nBlocks;
      for (var j = 0; j < J; j++) { h.push([]); for (var i = 0; i < I; i++) h[j].push(0); }
      var cells = [];
      for (var jj = 0; jj < J; jj++) for (var ii = 0; ii < I; ii++) cells.push([ii, jj]);
      /* seed every column with at least one block where it fits, then pour the rest */
      shuffle(cells);
      var baseCount = Math.min(cells.length, Math.max(2, Math.round(nBlocks / (1 + Math.random() * (maxH - 1)))));
      for (var b = 0; b < baseCount && left > 0; b++) { h[cells[b][1]][cells[b][0]] = 1; left--; }
      var guard = 0;
      while (left > 0 && guard++ < 2000) {
        var c = pick(cells.slice(0, baseCount));
        if (h[c[1]][c[0]] < maxH) { h[c[1]][c[0]]++; left--; }
      }
      if (left > 0) return null;
      return h;
    }
    function vxHeightsOf(cubes) {
      var b = vxBounds(cubes), h = [];
      for (var j = 0; j < b.J; j++) { h.push([]); for (var i = 0; i < b.I; i++) h[j].push(0); }
      cubes.forEach(function (c) { h[c[1]][c[0]] = Math.max(h[c[1]][c[0]], c[2] + 1); });
      return h;
    }
    /* Which cubes can actually be seen from this camera: nine sample points
       per visible face, each marched along the view line through the pile. */
    function vxHiddenKeys(cubes, cam) {
      var set = vxSetOf(cubes), b = vxBounds(cubes), reach = (b.I + b.J + b.K) * 1.2, d = cam.d;
      var faces = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
      var hidden = [];
      cubes.forEach(function (c) {
        var seen = false;
        for (var f = 0; f < faces.length && !seen; f++) {
          var n = faces[f];
          if (vxDot(n, d) <= 0.02) continue;
          for (var a = 0; a < 3 && !seen; a++) for (var bb = 0; bb < 3 && !seen; bb++) {
            var u = 0.2 + a * 0.3, v = 0.2 + bb * 0.3;
            var p;
            if (n[0]) p = [c[0] + (n[0] > 0 ? 1 : 0), c[1] + u, c[2] + v];
            else if (n[1]) p = [c[0] + u, c[1] + (n[1] > 0 ? 1 : 0), c[2] + v];
            else p = [c[0] + u, c[1] + v, c[2] + (n[2] > 0 ? 1 : 0)];
            var blocked = false;
            for (var t = 0.08; t < reach && !blocked; t += 0.12) {
              var q = [p[0] + d[0] * t, p[1] + d[1] * t, p[2] + d[2] * t];
              var key = Math.floor(q[0]) + "," + Math.floor(q[1]) + "," + Math.floor(q[2]);
              if (set[key] && key !== vxKey(c)) blocked = true;
            }
            if (!blocked) seen = true;
          }
        }
        if (!seen) hidden.push(vxKey(c));
      });
      return hidden;
    }
    /* Can the pile be counted from this one view? A pile stands in solid columns,
       so a column's height is known the moment its top cube's top face can be
       seen; the cubes under it are then forced. A column whose top is completely
       hidden behind a taller one cannot be worked out without turning the pile,
       and that is what makes a first view unfair. Returns the hidden tops. */
    function vxHiddenTops(cubes, cam) {
      var set = vxSetOf(cubes), b = vxBounds(cubes), reach = (b.I + b.J + b.K) * 1.2, d = cam.d;
      var tops = {};
      cubes.forEach(function (c) { var k = c[0] + "," + c[1]; if (!tops[k] || c[2] > tops[k][2]) tops[k] = c; });
      var out = [];
      Object.keys(tops).forEach(function (k) {
        var c = tops[k], seen = false;
        for (var a = 0; a < 3 && !seen; a++) for (var bb = 0; bb < 3 && !seen; bb++) {
          var p = [c[0] + 0.2 + a * 0.3, c[1] + 0.2 + bb * 0.3, c[2] + 1];
          var blocked = false;
          for (var t = 0.08; t < reach && !blocked; t += 0.12) {
            var q = [p[0] + d[0] * t, p[1] + d[1] * t, p[2] + d[2] * t];
            if (set[Math.floor(q[0]) + "," + Math.floor(q[1]) + "," + Math.floor(q[2])]) blocked = true;
          }
          if (!blocked) seen = true;
        }
        if (!seen) out.push(vxKey(c));
      });
      return out;
    }
    /* The three views as grids of booleans: rows top to bottom, cells left to right.
       plan: rows i (back at the top, front at the bottom), cols j.
       front (from +x): rows k from the top, cols j.  side (from +y): rows k, cols i reversed. */
    function vxViews(cubes) {
      var b = vxBounds(cubes), set = vxSetOf(cubes);
      var any = function (test) { return cubes.some(test); };
      var plan = [], front = [], side = [];
      for (var i = 0; i < b.I; i++) { var row = []; for (var j = 0; j < b.J; j++) row.push(any(function (c) { return c[0] === i && c[1] === j; })); plan.push(row); }
      for (var kk = b.K - 1; kk >= 0; kk--) {
        var fr = [], sr = [];
        for (var jj = 0; jj < b.J; jj++) fr.push(any(function (c) { return c[1] === jj && c[2] === kk; }));
        for (var ii = b.I - 1; ii >= 0; ii--) sr.push(any(function (c) { return c[0] === ii && c[2] === kk; }));
        front.push(fr); side.push(sr);
      }
      void set;
      return { plan: plan, front: front, side: side };
    }
    function gridSig(g) { return g.map(function (r) { return r.map(function (c) { return c ? "1" : "0"; }).join(""); }).join("/"); }
    function gridFlipH(g) { return g.map(function (r) { return r.slice().reverse(); }); }
    function gridFlipV(g) { return g.slice().reverse(); }
    function gridTrim(g) {
      /* drop empty outer rows and columns so two views compare by shape, not by frame */
      var rows = g.filter(function (r) { return r.some(Boolean); });
      if (!rows.length) return [[false]];
      var cols = rows[0].length, keep = [];
      for (var c = 0; c < cols; c++) if (rows.some(function (r) { return r[c]; })) keep.push(c);
      return rows.map(function (r) { return keep.map(function (c) { return r[c]; }); });
    }
    function gridSvg(grid, o) {
      o = o || {};
      var c = 20, rows = grid.length, cols = 0;
      grid.forEach(function (r) { cols = Math.max(cols, r.length); });
      var W = cols * c, H = rows * c, s = "";
      if (o.faint !== false) for (var r = 0; r < rows; r++) for (var q = 0; q < cols; q++) s += "<rect x='" + (q * c) + "' y='" + (r * c) + "' width='" + c + "' height='" + c + "' fill='none' stroke='" + SR_NAVY + "' stroke-opacity='0.18' stroke-width='1' stroke-dasharray='2 2'/>";
      grid.forEach(function (row, r) { row.forEach(function (on, q) { if (on) s += "<rect x='" + (q * c) + "' y='" + (r * c) + "' width='" + c + "' height='" + c + "' fill='" + (o.fill || SR_PAPER) + "' stroke='" + (o.stroke || SR_NAVY) + "' stroke-width='2.4'/>"; }); });
      var pad = 3, w = o.width || Math.min(84, W + pad * 2);
      return svgBox(s, (-pad) + " " + (-pad) + " " + (W + pad * 2) + " " + (H + pad * 2), w, w * (H + pad * 2) / (W + pad * 2), o.label || "a view of the pile");
    }
    /* Draw-the-view grid: dashed cells, the child's taps filled orange, misses and
       missing cells marked after a check. */
    function drawGridSvg(cols, rows, on, marks, o) {
      o = o || {};
      var c = 20, W = cols * c, H = rows * c, s = "";
      for (var r = 0; r < rows; r++) for (var q = 0; q < cols; q++) {
        var k = q + "," + r, hit = !!on[k], mark = marks && marks[k];
        var fill = hit ? "#ffe6c7" : "#ffffff", stroke = hit ? SR_ORANGE : SR_NAVY, op = hit ? 1 : 0.35, sw = hit ? 2.6 : 1.4;
        if (mark === "wrong") { fill = "#fdecea"; stroke = "#c0392b"; op = 1; sw = 2.6; }
        if (mark === "missing") { fill = "#e7f6ee"; stroke = "#1e7a4f"; op = 1; sw = 2.6; }
        s += "<rect data-cell='" + k + "' x='" + (q * c) + "' y='" + (r * c) + "' width='" + c + "' height='" + c + "' rx='2' fill='" + fill + "' stroke='" + stroke + "' stroke-opacity='" + op + "' stroke-width='" + sw + "'" + (hit || mark ? "" : " stroke-dasharray='3 3'") + "/>";
      }
      var pad = 3, w = o.width || 200;
      return svgBox(s, (-pad) + " " + (-pad) + " " + (W + pad * 2) + " " + (H + pad * 2), w, w * (H + pad * 2) / (W + pad * 2), o.label || "draw the view here");
    }
    /* Draw-the-view grid as real buttons: one toggle button per cell inside a CSS
       grid, so the lab works from the keyboard and reads properly to a screen
       reader. filled and marks use the same "col,row" keys as drawGridSvg (both
       0-based from the top-left); data-r / data-c are those 0-based indices and
       data-cell is the "col,row" key; the labels count rows and columns from 1.
       o: label (grid aria-label), role (default "grid"). */
    function drawGridButtonsHtml(cols, rows, filled, marks, o) {
      o = o || {};
      filled = filled || {};
      var cells = "";
      for (var r = 0; r < rows; r++) for (var q = 0; q < cols; q++) {
        var k = q + "," + r, on = !!filled[k], mark = marks && marks[k];
        var cls = "sr-cell" + (on ? " is-on" : "") + (mark === "wrong" ? " is-wrong" : mark === "missing" ? " is-missing" : "");
        var cellLabel = "Row " + (r + 1) + ", column " + (q + 1) + ", " + (on ? "filled" : "empty") + (mark === "wrong" ? ", should be empty" : mark === "missing" ? ", missing" : "");
        cells += "<button type=\"button\" class=\"" + cls + "\" data-r=\"" + r + "\" data-c=\"" + q + "\" data-cell=\"" + k + "\" aria-pressed=\"" + (on ? "true" : "false") + "\" aria-label=\"" + cellLabel + "\"></button>";
      }
      var gridLabel = o.label || ("Draw the view: " + rows + " rows by " + cols + " columns");
      return "<div class=\"sr-drawgrid\" role=\"" + esc(o.role || "grid") + "\" aria-label=\"" + esc(gridLabel) + "\" style=\"grid-template-columns: repeat(" + cols + ", 1fr); --sr-cols: " + cols + "; --sr-rows: " + rows + ";\">" + cells + "</div>";
    }
    /* The renderer. o: yaw, pitch, size (px per cube), width (scale the svg to),
       tint, hl (map of keys to light orange), layerCap (cubes above are ghosted),
       ghostKeys (map of keys drawn faint), markers (FRONT / SIDE ground arrows),
       fixed (frame from the bounding sphere so a spinning pile never jumps), label */
    function vxSvg(cubes, o) {
      o = o || {};
      var s = o.size || 40, cam = vxCam(o.yaw == null ? VX_HOME.yaw : o.yaw, o.pitch == null ? VX_HOME.pitch : o.pitch);
      var tint = VX_TINTS[o.tint || "grey"], b = vxBounds(cubes);
      var P = function (p) { return vxProject(cam, p, s); };
      var sorted = cubes.map(function (c, idx) { return { c: c, idx: idx, depth: vxDot([c[0] + 0.5, c[1] + 0.5, c[2] + 0.5], cam.d) }; })
        .sort(function (p, q) { return p.depth - q.depth || p.idx - q.idx; });
      var sw = Math.max(1.4, s * 0.055), body = "";
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      var seen = function (pt) { minX = Math.min(minX, pt[0]); maxX = Math.max(maxX, pt[0]); minY = Math.min(minY, pt[1]); maxY = Math.max(maxY, pt[1]); return pt; };
      var faces = [
        { n: [1, 0, 0],  q: function (c) { return [[c[0] + 1, c[1], c[2]], [c[0] + 1, c[1] + 1, c[2]], [c[0] + 1, c[1] + 1, c[2] + 1], [c[0] + 1, c[1], c[2] + 1]]; } },
        { n: [-1, 0, 0], q: function (c) { return [[c[0], c[1], c[2]], [c[0], c[1], c[2] + 1], [c[0], c[1] + 1, c[2] + 1], [c[0], c[1] + 1, c[2]]]; } },
        { n: [0, 1, 0],  q: function (c) { return [[c[0], c[1] + 1, c[2]], [c[0] + 1, c[1] + 1, c[2]], [c[0] + 1, c[1] + 1, c[2] + 1], [c[0], c[1] + 1, c[2] + 1]]; } },
        { n: [0, -1, 0], q: function (c) { return [[c[0], c[1], c[2]], [c[0] + 1, c[1], c[2]], [c[0] + 1, c[1], c[2] + 1], [c[0], c[1], c[2] + 1]]; } },
        { n: [0, 0, 1],  q: function (c) { return [[c[0], c[1], c[2] + 1], [c[0] + 1, c[1], c[2] + 1], [c[0] + 1, c[1] + 1, c[2] + 1], [c[0], c[1] + 1, c[2] + 1]]; } },
        { n: [0, 0, -1], q: function (c) { return [[c[0], c[1], c[2]], [c[0], c[1] + 1, c[2]], [c[0] + 1, c[1] + 1, c[2]], [c[0] + 1, c[1], c[2]]]; } }
      ];
      sorted.forEach(function (e) {
        var c = e.c, key = vxKey(c);
        var hl = o.hl && o.hl[key];
        var ghost = (o.layerCap != null && c[2] >= o.layerCap) || (o.ghostKeys && o.ghostKeys[key]);
        var t = hl ? VX_TINTS.orange : (ghost ? VX_TINTS.ghost : tint);
        var g = "";
        faces.forEach(function (fc) {
          if (vxDot(fc.n, cam.d) <= 0.02) return;
          var shade = 0.55 + 0.45 * Math.max(0, vxDot(fc.n, VX_LIGHT));
          var fill = hexMix(t.dark, "#ffffff", shade);
          var quad = fc.q(c).map(function (p) { return seen(P(p)); });
          g += "<polygon points='" + ptsStr(quad) + "' fill='" + fill + "' stroke='" + t.edge + "' stroke-width='" + fx(sw) + "' stroke-linejoin='round'/>";
        });
        body += "<g" + (ghost ? " opacity='0.3'" : "") + ">" + g + "</g>";
      });
      /* the stable frame: the bounding sphere projects to the same circle at any angle */
      var I = b.I, J = b.J, K = b.K;
      var centre = P([I / 2, J / 2, K / 2]);
      var R = 0.5 * Math.sqrt(I * I + J * J + K * K) * s + sw * 2;
      if (o.markers) {
        var arrow = function (from, to, text) {
          var a = P(from), bb = P(to);
          var dx = bb[0] - a[0], dy = bb[1] - a[1], L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L;
          var headL = s * 0.34, headW = s * 0.2, stemW = Math.max(2.5, s * 0.075);
          var hb = [bb[0] - ux * headL, bb[1] - uy * headL];
          var head = [bb, [hb[0] - uy * headW, hb[1] + ux * headW], [hb[0] + uy * headW, hb[1] - ux * headW]];
          var fs = s * 0.26, hw = (text.length * fs * 0.66 + s * 0.3) / 2, hh = s * 0.24;
          var edge = Math.min(hw / Math.max(Math.abs(ux), 0.01), hh / Math.max(Math.abs(uy), 0.01)) + s * 0.06;
          var st = [a[0] + ux * edge, a[1] + uy * edge];
          seen([a[0] - hw, a[1] - hh]); seen([a[0] + hw, a[1] + hh]);
          return "<line x1='" + fx(st[0]) + "' y1='" + fx(st[1]) + "' x2='" + fx(hb[0]) + "' y2='" + fx(hb[1]) + "' stroke='" + SR_ORANGE + "' stroke-width='" + fx(stemW) + "' stroke-linecap='round'/>" +
            "<polygon points='" + ptsStr(head) + "' fill='" + SR_ORANGE + "' stroke='" + SR_ORANGE + "' stroke-width='" + fx(stemW * 0.6) + "' stroke-linejoin='round'/>" +
            "<rect x='" + fx(a[0] - hw) + "' y='" + fx(a[1] - hh) + "' width='" + fx(hw * 2) + "' height='" + fx(hh * 2) + "' rx='" + fx(hh) + "' fill='#ffffff' stroke='" + SR_ORANGE + "' stroke-width='" + fx(Math.max(1.6, s * 0.05)) + "'/>" +
            "<text x='" + fx(a[0]) + "' y='" + fx(a[1] + fs * 0.05) + "' font-size='" + fx(fs) + "' font-weight='900' font-family='DM Sans, Arial, sans-serif' letter-spacing='0.04em' text-anchor='middle' dominant-baseline='central' fill='" + SR_ORANGE + "'>" + text + "</text>";
        };
        body += arrow([I + 1.55, J / 2, 0], [I + 0.12, J / 2, 0], "FRONT") + arrow([I / 2, J + 1.55, 0], [I / 2, J + 0.12, 0], "SIDE");
        R += s * 1.6;
      }
      var vb;
      if (o.fixed) vb = [centre[0] - R, centre[1] - R, R * 2, R * 2];
      else { var pad = sw * 2; vb = [minX - pad, minY - pad, maxX - minX + pad * 2, maxY - minY + pad * 2]; }
      var w = o.width || vb[2];
      return svgBox(body, vb.map(fx).join(" "), w, w * vb[3] / vb[2], o.label || (cubes.length + " block solid"));
    }
    /* Interactive viewer: drag to spin, animated camera moves, layers, highlights.
       Keyboard: the .sr-viewer root is focusable (tabindex 0) with role application and
       opts.label as its name; ArrowLeft / ArrowRight yaw by 30, ArrowUp / ArrowDown
       pitch by 15, Home returns to the home view. A visually-hidden child
       (.sr-visually-hidden, wired through aria-describedby) reads
       "Drag, or use the arrow keys, to turn". Locked viewers ignore keys and drags.
       opts: yaw, pitch, size, width, tint, markers, locked, onDrag, label, role. */
    var vxViewerSeq = 0;
    var VX_HINT_FREE = "Drag, or use the arrow keys, to turn", VX_HINT_LOCKED = "Locked during the test, it turns in the review";
    function mountVoxelViewer(container, cubes, opts) {
      opts = opts || {};
      var locked = !!opts.locked;
      var v = {
        cubes: cubes, yaw: opts.yaw == null ? VX_HOME.yaw : opts.yaw, pitch: opts.pitch == null ? VX_HOME.pitch : opts.pitch,
        size: opts.size || 40, width: opts.width || null, tint: opts.tint || "grey", markers: !!opts.markers,
        hl: null, layerCap: null, anim: null, dragging: false, lastX: 0, lastY: 0, moved: false, keyTurned: false, turnTarget: null
      };
      var host = document.createElement("div");
      host.className = "sr-viewer";
      host.setAttribute("tabindex", "0");
      host.setAttribute("role", opts.role || "application");
      host.setAttribute("aria-label", opts.label || (cubes.length + " block solid"));
      var hint = document.createElement("span");
      hint.className = "sr-visually-hidden";
      hint.id = "sr-viewer-hint-" + (++vxViewerSeq);
      hint.setAttribute("style", "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0");
      hint.textContent = VX_HINT_FREE;
      host.setAttribute("aria-describedby", hint.id);
      container.innerHTML = "";
      container.appendChild(host);
      v.host = host;
      v.hint = hint;
      /* locked stays a plain read / write property (ui.js assigns v.locked = false
         when the answer is in); the setter also mirrors it to data-locked on the root. */
      Object.defineProperty(v, "locked", {
        enumerable: true,
        get: function () { return locked; },
        set: function (flag) { locked = !!flag; if (locked) host.setAttribute("data-locked", "true"); else host.removeAttribute("data-locked"); hint.textContent = locked ? VX_HINT_LOCKED : VX_HINT_FREE; }
      });
      v.locked = locked;
      v.setLocked = function (flag) { v.locked = flag; };
      v.render = function () {
        host.innerHTML = vxSvg(v.cubes, { yaw: v.yaw, pitch: v.pitch, size: v.size, width: v.width, tint: v.tint, hl: v.hl, layerCap: v.layerCap, markers: v.markers, fixed: true, label: opts.label });
        host.appendChild(hint);
      };
      v.set = function (yaw, pitch) { v.yaw = yaw; v.pitch = clamp(pitch, -5, 90); v.render(); };
      v.stop = function () { if (v.anim) { cancelAnimationFrame(v.anim); v.anim = null; } };
      v.animateTo = function (yaw, pitch, ms, done) {
        v.stop();
        v.turnTarget = null;
        var y0 = v.yaw, p0 = v.pitch, dy = yaw - y0, dp = pitch - p0, t0 = null;
        if (document.hidden || ms <= 0 || window.__srReduceMotion) { v.set(yaw, pitch); if (done) done(); return; }
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var t = clamp((ts - t0) / ms, 0, 1), e = smoother(t);
          v.yaw = y0 + dy * e; v.pitch = p0 + dp * e; v.render();
          if (t < 1) v.anim = requestAnimationFrame(frame); else { v.anim = null; if (done) done(); }
        }
        v.anim = requestAnimationFrame(frame);
      };
      /* Relative, animated turn. Quick repeated turns chain from the pending
         target rather than the half-way camera, so two presses give two steps. */
      v.turn = function (dYaw, dPitch, ms, done) {
        var base = (v.anim && v.turnTarget) ? v.turnTarget : { yaw: v.yaw, pitch: v.pitch };
        var yaw = base.yaw + (dYaw || 0), pitch = clamp(base.pitch + (dPitch || 0), -5, 90);
        v.animateTo(yaw, pitch, ms == null ? 350 : ms, function () { v.turnTarget = null; if (done) done(); });
        if (v.anim) v.turnTarget = { yaw: yaw, pitch: pitch };
      };
      v.spin = function (ms, done) { v.animateTo(v.yaw + 360, v.pitch, ms || 1800, function () { v.yaw = ((v.yaw % 360) + 360) % 360; if (done) done(); }); };
      v.home = function (ms) { v.animateTo(VX_HOME.yaw, VX_HOME.pitch, ms == null ? 500 : ms); };
      v.snap = function (which, ms) { var t = VX_VIEWS[which] || VX_HOME; v.animateTo(t.yaw, t.pitch, ms == null ? 700 : ms); };
      v.setLayerCap = function (k) { v.layerCap = k; v.render(); };
      v.setHl = function (keys) { v.hl = keys ? (Array.isArray(keys) ? keys.reduce(function (m, k) { m[k] = true; return m; }, {}) : keys) : null; v.render(); };
      v.setCubes = function (c) { v.cubes = c; v.render(); };
      function down(e) {
        if (v.locked) return;
        v.dragging = true; v.moved = false; v.lastX = e.clientX; v.lastY = e.clientY;
        v.stop();
        container.classList.add("is-dragging");
        try { container.setPointerCapture(e.pointerId); } catch (err) {}
      }
      function move(e) {
        if (!v.dragging) return;
        var dx = e.clientX - v.lastX, dy = e.clientY - v.lastY;
        if (Math.abs(dx) + Math.abs(dy) > 2 && !v.moved) { v.moved = true; if (opts.onDrag) opts.onDrag(); }
        v.lastX = e.clientX; v.lastY = e.clientY;
        v.yaw += dx * 0.5; v.pitch = clamp(v.pitch + dy * 0.35, -5, 90);
        /* one render per frame while dragging, not one per pointer event */
        if (!v.raf) v.raf = requestAnimationFrame(function () { v.raf = null; v.render(); });
        e.preventDefault();
      }
      function up() { v.dragging = false; container.classList.remove("is-dragging"); }
      /* the first keyboard turn counts as assistance, the same as the first drag */
      function keyAssisted() { if (!v.keyTurned) { v.keyTurned = true; if (opts.onDrag) opts.onDrag(); } }
      function key(e) {
        if (v.locked || e.altKey || e.ctrlKey || e.metaKey) return;
        var k = e.key || "", dYaw = 0, dPitch = 0;
        if (k === "ArrowLeft" || k === "Left") dYaw = -30;
        else if (k === "ArrowRight" || k === "Right") dYaw = 30;
        else if (k === "ArrowUp" || k === "Up") dPitch = 15;
        else if (k === "ArrowDown" || k === "Down") dPitch = -15;
        else if (k === "Home") {
          e.preventDefault();
          if (Math.abs(v.yaw - VX_HOME.yaw) > 0.01 || Math.abs(v.pitch - VX_HOME.pitch) > 0.01) keyAssisted();
          v.home();
          return;
        }
        else return;
        e.preventDefault();
        keyAssisted();
        v.turn(dYaw, dPitch);
      }
      container.addEventListener("pointerdown", down);
      container.addEventListener("pointermove", move);
      container.addEventListener("pointerup", up);
      container.addEventListener("pointercancel", up);
      container.addEventListener("pointerleave", up);
      host.addEventListener("keydown", key);
      v.render();
      return v;
    }
    /* ============================================================
       14. FLAT SHAPES: matching, reflection, combining, jigsaw, hidden shapes
       Polygons live in a 100-unit box. A chiral shape is one whose mirror
       image cannot be reached by spinning it, which is what makes the
       matching and reflection traps honest.
       Every builder takes (rung, plan). The plan is optional: a test hands
       one in to fix the subtype (the rotation band, the mirror axis, the
       combining kind, the hidden target), and practice hands in plan.avoid,
       the variants served recently, so a builder retries its random feature
       choice up to 12 times before giving up gracefully. Every question sets
       q.variant, the subtype plus its key feature, so repeats can be seen.
       ============================================================ */
    function flRotate(pts, deg, cx, cy) {
      cx = cx == null ? 50 : cx; cy = cy == null ? 50 : cy;
      var r = (deg * Math.PI) / 180, cs = Math.cos(r), sn = Math.sin(r);
      return pts.map(function (p) { var dx = p[0] - cx, dy = p[1] - cy; return [cx + dx * cs - dy * sn, cy + dx * sn + dy * cs]; });
    }
    function flMirror(pts, axis) {
      var out = pts.map(function (p) { return axis === "h" ? [p[0], 100 - p[1]] : [100 - p[0], p[1]]; });
      return out.reverse();
    }
    function flMirrorPt(p, axis) { return axis === "h" ? [p[0], 100 - p[1]] : [100 - p[0], p[1]]; }
    function flCentroid(pts) {
      var sx = 0, sy = 0; pts.forEach(function (p) { sx += p[0]; sy += p[1]; });
      return [sx / pts.length, sy / pts.length];
    }
    function flFit(pts, pad) {
      pad = pad == null ? 9 : pad;
      var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      var sc = Math.min((100 - pad * 2) / Math.max(1, maxX - minX), (100 - pad * 2) / Math.max(1, maxY - minY), 1.3);
      var cx = (minX + maxX) / 2, cy = (minY + maxY) / 2;
      return pts.map(function (p) { return [50 + (p[0] - cx) * sc, 50 + (p[1] - cy) * sc]; });
    }
    function flScale(pts, k, cx, cy) {
      var c = cx == null ? flCentroid(pts) : [cx, cy];
      return pts.map(function (p) { return [c[0] + (p[0] - c[0]) * k, c[1] + (p[1] - c[1]) * k]; });
    }
    function flSig(pts) { return flFit(pts).map(function (p) { return Math.round(p[0] * 2) / 2 + "," + Math.round(p[1] * 2) / 2; }).join(" "); }
    /* size matters for jigsaw and combining: a signature that keeps scale, dropping only position */
    function flSigRaw(pts) { var c = flCentroid(pts); return pts.map(function (p) { return Math.round((p[0] - c[0]) * 2) / 2 + "," + Math.round((p[1] - c[1]) * 2) / 2; }).join(" "); }
    function flFitScale(pts, pad) {
      pad = pad == null ? 9 : pad;
      var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
      return Math.min((100 - pad * 2) / Math.max(1, Math.max.apply(null, xs) - Math.min.apply(null, xs)), (100 - pad * 2) / Math.max(1, Math.max.apply(null, ys) - Math.min.apply(null, ys)), 1.3);
    }
    function flPlace(pts, sc) {
      var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
      var cx = (Math.min.apply(null, xs) + Math.max.apply(null, xs)) / 2, cy = (Math.min.apply(null, ys) + Math.max.apply(null, ys)) / 2;
      return pts.map(function (p) { return [50 + (p[0] - cx) * sc, 50 + (p[1] - cy) * sc]; });
    }
    function flSvg(pts, o) {
      o = o || {};
      var w = o.width || 84, vb = o.viewBox || "0 0 100 100";
      var inner = (o.before || "") + "<polygon points='" + ptsStr(pts) + "' fill='" + (o.fill || "none") + "' stroke='" + (o.stroke || SR_NAVY) + "' stroke-width='" + (o.sw || 3) + "' stroke-linejoin='round'/>" + (o.after || "");
      var parts = vb.split(" ").map(Number);
      return svgBox(inner, vb, w, w * parts[3] / parts[2], o.label || "shape");
    }
    /* "an octagon", "an 8-sided shape", "an L-shape", "a hexagon": for accessible names built from generated nouns */
    function flArticle(word) { return (/^([aeiou]|[flmnrsx]-|8|11|18|8\d)/i.test(String(word)) ? "an " : "a ") + word; }
    function flLetter(x, y, ch, size) {
      return "<text x='" + fx(x) + "' y='" + fx(y) + "' font-size='" + (size || 11) + "' font-weight='900' font-family='DM Sans, Arial, sans-serif' text-anchor='middle' dominant-baseline='central' fill='" + SR_NAVY + "'>" + ch + "</text>";
    }
    function flSegsCross(a, b, c, d) {
      function orient(p, q, r) { return (q[0] - p[0]) * (r[1] - p[1]) - (q[1] - p[1]) * (r[0] - p[0]); }
      var o1 = orient(a, b, c), o2 = orient(a, b, d), o3 = orient(c, d, a), o4 = orient(c, d, b);
      return (o1 > 0) !== (o2 > 0) && (o3 > 0) !== (o4 > 0) && o1 !== 0 && o2 !== 0 && o3 !== 0 && o4 !== 0;
    }
    function flSimple(pts) {
      var n = pts.length;
      if (n < 3) return false;
      for (var i = 0; i < n; i++) for (var j = i + 2; j < n; j++) {
        if (i === 0 && j === n - 1) continue;
        if (flSegsCross(pts[i], pts[(i + 1) % n], pts[j], pts[(j + 1) % n])) return false;
      }
      return true;
    }
    /* Is a the same shape as b turned (any angle) and moved? Sizes must match too. */
    function flSameShape(a, b) {
      if (a.length !== b.length) return false;
      var n = a.length;
      function norm(p) {
        var c = flCentroid(p), rms = 0;
        var q = p.map(function (v) { return [v[0] - c[0], v[1] - c[1]]; });
        q.forEach(function (v) { rms += v[0] * v[0] + v[1] * v[1]; });
        return { pts: q, rms: Math.sqrt(rms / n) };
      }
      var na = norm(a), nb = norm(b);
      if (Math.abs(na.rms - nb.rms) > Math.max(0.6, na.rms * 0.04)) return false;
      var tol = Math.max(1.2, na.rms * 0.06);
      for (var shift = 0; shift < n; shift++) {
        var pa = na.pts[0], pb = nb.pts[shift];
        var ang = Math.atan2(pb[1], pb[0]) - Math.atan2(pa[1], pa[0]);
        var cs = Math.cos(ang), sn = Math.sin(ang), ok = true;
        for (var i = 0; i < n && ok; i++) {
          var p = na.pts[i], q = nb.pts[(i + shift) % n];
          var rx = p[0] * cs - p[1] * sn, ry = p[0] * sn + p[1] * cs;
          if (Math.abs(rx - q[0]) > tol || Math.abs(ry - q[1]) > tol) ok = false;
        }
        if (ok) return true;
      }
      return false;
    }
    function flIsChiral(pts) { return !flSameShape(flMirror(pts), pts); }
    function flJitter(pts, amt) {
      if (!amt) return pts;
      for (var t = 0; t < 8; t++) {
        var out = pts.map(function (p) { return [p[0] + (Math.random() * 2 - 1) * amt, p[1] + (Math.random() * 2 - 1) * amt]; });
        if (flSimple(out) && flIsChiral(out)) return out;
      }
      return pts;
    }
    /* Every shape carries a landmark a child can pick out by eye (flLandmarks): a corner clearly
       sharper than the rest, a side clearly longer, or a single notch. The Z has a shorter foot
       than its top bar, the lean is a slanted quadrilateral rather than a parallelogram, and the
       arrowfoot, key and step have one side clearly longer than any other, because a shape with
       two equal candidates (a parallelogram, a symmetric arrowhead) cannot be described that way. */
    var FL_CHIRAL = [
      { id: "L", pts: [[20, 15], [45, 15], [45, 60], [80, 60], [80, 85], [20, 85]] },
      { id: "Z", pts: [[25, 28], [90, 28], [90, 38], [48, 62], [60, 62], [60, 72], [10, 72], [10, 62], [52, 38], [25, 38]] },
      { id: "wedge", pts: [[20, 15], [20, 85], [80, 85]] },
      { id: "lean", pts: [[32, 25], [80, 25], [85, 75], [10, 75]] },
      { id: "arrowfoot", pts: [[38, 10], [85, 45], [65, 45], [65, 75], [80, 75], [80, 90], [35, 90], [35, 45], [15, 45]] },
      { id: "key", pts: [[5, 35], [45, 35], [45, 20], [85, 20], [85, 55], [70, 55], [70, 45], [60, 45], [60, 70], [5, 70]] },
      { id: "blob", pts: [[22, 14], [62, 8], [52, 44], [88, 54], [46, 92], [28, 60]] },
      { id: "flag", pts: [[22, 12], [28, 0], [34, 12], [34, 38], [82, 30], [82, 58], [34, 52], [34, 90], [22, 90]] },
      { id: "step", pts: [[15, 30], [50, 30], [50, 45], [70, 45], [70, 65], [85, 65], [85, 80], [15, 80]] },
      { id: "hook", pts: [[25, 10], [75, 10], [75, 45], [60, 45], [60, 25], [40, 25], [40, 75], [65, 75], [65, 90], [25, 90]] }
    ].filter(function (s) { return flSimple(s.pts) && flIsChiral(s.pts); });
    function flChiralShape(rung) { return flJitter(pick(FL_CHIRAL).pts, rung >= 3 ? 4 : 2); }
    function flAngles(rung) {
      var step = rung <= 2 ? 90 : rung <= 4 ? 45 : 30, out = [];
      for (var a = step; a < 360; a += step) out.push(a);
      return out;
    }

    /* --- plans and variants --- */
    function flAvoids(plan, variant) { return !!(plan && plan.avoid && plan.avoid.length && plan.avoid.indexOf(variant) >= 0); }
    /* pick from choices, retrying up to 12 times while the variant it would make is in plan.avoid */
    function flPickAvoiding(choices, plan, variantOf) {
      var c = pick(choices);
      for (var t = 0; t < 12 && flAvoids(plan, variantOf(c)); t++) c = pick(choices);
      return c;
    }

    /* --- reading a polygon: where things sit, which corner is sharpest, which side is longest --- */
    var FL_DIRS = ["right", "bottom right", "bottom", "bottom left", "left", "top left", "top", "top right"];
    /* compass-style word for a point seen from a centre, in screen coordinates (y runs down) */
    function flDirWord(c, p) {
      var a = (Math.atan2(p[1] - c[1], p[0] - c[0]) * 180) / Math.PI;
      var k = ((Math.round(a / 45) % 8) + 8) % 8;
      return FL_DIRS[k];
    }
    function flSignedArea(p) { var a = 0; for (var i = 0; i < p.length; i++) { var q = p[(i + 1) % p.length]; a += p[i][0] * q[1] - q[0] * p[i][1]; } return a / 2; }
    function flTurnAt(pts, i) {
      var n = pts.length, p = pts[(i + n - 1) % n], q = pts[i], r = pts[(i + 1) % n];
      var ux = q[0] - p[0], uy = q[1] - p[1], vx = r[0] - q[0], vy = r[1] - q[1];
      return (Math.atan2(ux * vy - uy * vx, ux * vx + uy * vy) * 180) / Math.PI;
    }
    /* interior angle in degrees at every corner of a simple polygon (a reflex corner comes out above 180) */
    function flCornerAngles(pts) {
      var s = flSignedArea(pts) >= 0 ? 1 : -1, out = [];
      for (var i = 0; i < pts.length; i++) out.push(180 - s * flTurnAt(pts, i));
      return out;
    }
    /* corners the eye counts: skip any vertex where the outline runs straight on or doubles back */
    function flCornerCount(pts) {
      var cnt = 0;
      for (var i = 0; i < pts.length; i++) { var t = Math.abs(flTurnAt(pts, i)); if (t > 2 && t < 178) cnt++; }
      return cnt;
    }
    /* drop vertices where the outline runs straight on or doubles back on itself (a cut whose
       leg lies along a side of the base leaves such a spike), so the polygon is a clean outline */
    function flTidy(pts) {
      var out = pts.slice(), changed = true, guard = 0;
      while (changed && guard++ < 24 && out.length > 3) {
        changed = false;
        for (var i = 0; i < out.length; i++) {
          var n = out.length, p = out[(i + n - 1) % n], q = out[i], r = out[(i + 1) % n];
          if (Math.hypot(q[0] - p[0], q[1] - p[1]) < 0.05 || Math.hypot(r[0] - q[0], r[1] - q[1]) < 0.05) { out.splice(i, 1); changed = true; break; }
          var t = Math.abs(flTurnAt(out, i));
          if (t < 1 || t > 179) { out.splice(i, 1); changed = true; break; }
        }
      }
      return out;
    }
    /* The landmarks of a polygon a child can pick out by eye, most distinctive first. A landmark is
       only named when it is clearly so: the sharpest corner when it beats the next by 12 degrees, the
       longest side when it beats the next by 12 per cent, the notch when exactly one corner cuts in,
       then the shortest side and the widest corner on the same terms. The clear ones come first
       (lm.clear is true); any that are too close to call follow, so a caller that needs a second
       landmark still has one, and buildMatch and buildReflect prefer the clear ones. */
    function flSideLens(pts) {
      var n = pts.length, lens = [];
      for (var i = 0; i < n; i++) { var q = pts[(i + 1) % n]; lens.push(Math.hypot(q[0] - pts[i][0], q[1] - pts[i][1])); }
      return lens;
    }
    function flLandmarks(pts) {
      var n = pts.length, ang = flCornerAngles(pts), lens = flSideLens(pts);
      var byAng = ang.map(function (_, i) { return i; }).sort(function (a, b) { return ang[a] - ang[b]; });
      var byLen = lens.map(function (_, i) { return i; }).sort(function (a, b) { return lens[b] - lens[a]; });
      /* corners the eye reads as corners: not reflex, not nearly straight */
      var convex = byAng.filter(function (i) { return ang[i] < 165; }), reflex = byAng.filter(function (i) { return ang[i] >= 180; });
      var clear = [], rest = [];
      /* one too close to call is never described as sharpest or longest: it is "the marked corner",
         the orange dot on the stage sheet, which is honest whatever the geometry */
      var put = function (ok, lm) { lm.clear = !!ok; if (!ok) lm.name = lm.kind === "corner" ? "marked corner" : "marked side"; (ok ? clear : rest).push(lm); };
      if (convex.length) put(convex.length === 1 || ang[convex[1]] - ang[convex[0]] >= 12, { kind: "corner", idx: convex[0], name: "sharpest corner" });
      put(n < 2 || lens[byLen[0]] - lens[byLen[1]] >= lens[byLen[0]] * 0.12, { kind: "side", idx: byLen[0], name: "longest side" });
      if (reflex.length === 1) put(true, { kind: "corner", idx: reflex[0], name: "notch" });
      if (n > 1) put(lens[byLen[n - 2]] - lens[byLen[n - 1]] >= lens[byLen[n - 2]] * 0.12, { kind: "side", idx: byLen[n - 1], name: "shortest side" });
      if (convex.length > 1) put(ang[convex[convex.length - 1]] - ang[convex[convex.length - 2]] >= 12, { kind: "corner", idx: convex[convex.length - 1], name: "widest corner" });
      return clear.concat(rest);
    }
    /* The longest side running along the mirror line's own direction, when one clearly is (12 per cent
       longer than the next such side): an upright side for an upright mirror, a flat side for a flat
       one. A reflection carries it straight across, so it is the landmark to follow when the shape's
       other clear features sit in line with the mirror. */
    function flAxisSide(pts, axis) {
      var n = pts.length, lens = flSideLens(pts), cand = [];
      for (var i = 0; i < n; i++) {
        var a = pts[i], b = pts[(i + 1) % n], dx = Math.abs(b[0] - a[0]), dy = Math.abs(b[1] - a[1]);
        if (axis === "v" ? dx <= dy * 0.36 : dy <= dx * 0.36) cand.push(i);
      }
      if (!cand.length) return null;
      cand.sort(function (x, y) { return lens[y] - lens[x]; });
      if (cand.length > 1 && lens[cand[0]] - lens[cand[1]] < lens[cand[0]] * 0.12) return null;
      return { kind: "side", idx: cand[0], name: axis === "v" ? "longest upright side" : "longest flat side", clear: true };
    }
    /* Which way round the outline a landmark's neighbours come, a fact every spin keeps and every
       mirror image reverses, so an explanation can say what really tells the answer from the
       turned-over options. Null when the two neighbours are too alike to tell apart by eye. */
    function flHanded(pts, lm) {
      var n = pts.length, cw = flSignedArea(pts) > 0, ang = flCornerAngles(pts), lens = flSideLens(pts);
      if (lm.kind === "corner") {
        var sideBefore = lens[(lm.idx + n - 1) % n], sideAfter = lens[lm.idx];
        var arrive = cw ? sideBefore : sideAfter, leave = cw ? sideAfter : sideBefore;
        if (Math.abs(arrive - leave) < Math.max(arrive, leave) * 0.12) return null;
        return "Walk round the outline clockwise: at its " + lm.name + " you arrive along the " + (arrive > leave ? "longer" : "shorter") + " side and leave along the " + (arrive > leave ? "shorter" : "longer") + " one.";
      }
      var a0 = ang[lm.idx], a1 = ang[(lm.idx + 1) % n], from = cw ? a0 : a1, to = cw ? a1 : a0;
      if (Math.abs(from - to) < 12) return null;
      var endWord = function (a, other) {
        if (a >= 180 && other < 180) return "the end that cuts in";
        if (a < 180 && other >= 180) return "the end that sticks out";
        return a < other ? "its sharper end" : "its blunter end";
      };
      return "Walk round the outline clockwise: along its " + lm.name + " you go from " + endWord(from, to) + " to " + endWord(to, from) + ".";
    }
    function flLandmarkPt(pts, lm) {
      var n = pts.length;
      if (lm.kind === "corner") return pts[lm.idx];
      return [(pts[lm.idx][0] + pts[(lm.idx + 1) % n][0]) / 2, (pts[lm.idx][1] + pts[(lm.idx + 1) % n][1]) / 2];
    }
    /* where a landmark sits, seen from the middle of the shape */
    function flLandmarkDir(pts, lm) { return flDirWord(flCentroid(pts), flLandmarkPt(pts, lm)); }
    /* the same landmark on the mirror image, whose points come back in reverse order */
    function flLandmarkMirrored(lm, n) { return { kind: lm.kind, idx: lm.kind === "corner" ? n - 1 - lm.idx : (2 * n - 2 - lm.idx) % n, name: lm.name }; }
    function flWhere(lm, dir) {
      if (lm.kind === "corner") return "sits at the " + dir;
      if (dir === "top" || dir === "bottom") return "runs along the " + dir;
      if (dir === "left" || dir === "right") return "runs down the " + dir + "-hand side";
      return "slopes across the " + dir;
    }
    /* orange marker on a landmark, for the little stage sheets under an explanation */
    function flMark(fitted, lm) {
      var n = fitted.length;
      if (lm.kind === "corner") { var p = fitted[lm.idx]; return "<circle cx='" + fx(p[0]) + "' cy='" + fx(p[1]) + "' r='4.5' fill='" + SR_ORANGE + "' stroke='#ffffff' stroke-width='1.5'/>"; }
      var a = fitted[lm.idx], b = fitted[(lm.idx + 1) % n];
      return "<line x1='" + fx(a[0]) + "' y1='" + fx(a[1]) + "' x2='" + fx(b[0]) + "' y2='" + fx(b[1]) + "' stroke='" + SR_ORANGE + "' stroke-width='5.5' stroke-linecap='round'/>";
    }
    function flSheet(parts) { return "<div class='sr-figrow sr-sheet'>" + parts.join("<span class='sr-eq' aria-hidden='true'>&#8594;</span>") + "</div>"; }

    /* --- matching shape: spun (right) or turned over and spun (wrong) --- */
    var FL_BANDS = { quarter: [90, 180, 270], eighth: [45, 135, 225, 315], arbitrary: [30, 60, 120, 150, 210, 240, 300, 330] };
    function flBandsFor(rung) { return rung <= 2 ? ["quarter"] : rung <= 4 ? ["quarter", "eighth"] : ["quarter", "eighth", "arbitrary"]; }
    function flBandRung(band) { return band === "arbitrary" ? 5 : band === "eighth" ? 3 : 1; }
    function buildMatch(rung, plan) {
      var base = flChiralShape(rung);
      var bands = plan && FL_BANDS[plan.band] ? [plan.band] : flBandsFor(rung), pairs = [];
      bands.forEach(function (b) { FL_BANDS[b].forEach(function (r) { pairs.push({ band: b, rot: r }); }); });
      var turn = flPickAvoiding(pairs, plan, function (p) { return "band:" + p.band + "|" + p.rot; });
      var band = turn.band, rot = turn.rot;
      /* the mirror-image traps spin through the finest angle set the rung or the band allows */
      var angles = flAngles(Math.max(rung, flBandRung(band)));
      var correct = flRotate(base, rot);
      var optLabel = flArticle(base.length + "-sided shape");
      var opts = [{ html: flSvg(flFit(correct), { width: 110, label: optLabel }), sig: flSig(correct), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      for (var g = 0; g < 80 && opts.length < 5; g++) {
        var cand = flRotate(flMirror(base), pick([0].concat(angles)));
        var sig = flSig(cand);
        if (used[sig] || flSameShape(cand, base)) continue;
        used[sig] = true;
        opts.push({ html: flSvg(flFit(cand), { width: 110, label: optLabel }), sig: sig, isCorrect: false, noteGroup: { one: "has been turned over, and no spin can undo a flip", many: "have been turned over, and no spin can undo a flip" } });
      }
      if (opts.length < 5) return null;
      /* the explanation follows this shape's own landmark round the turn, then says what really
         tells the answer from the mirror images: the order things come in going round the outline,
         which a spin keeps and a flip reverses (a compass position never can, since the mirror
         images are spun too and can put the same landmark in the same place) */
      var lms = flLandmarks(base), lm = lms[0], before = flLandmarkDir(base, lm), after = flLandmarkDir(correct, lm);
      var move = before === after
        ? "Its " + lm.name + " " + flWhere(lm, before) + ", and after a " + rot + " degree turn it still " + flWhere(lm, after) + ", just turned further round."
        : "Its " + lm.name + " " + flWhere(lm, before) + "; after the turn it " + flWhere(lm, after) + ".";
      var handed = null;
      for (var hi = 0; hi < lms.length && !handed; hi++) if (lms[hi].clear) handed = flHanded(base, lms[hi]);
      var flip = (handed || "Walk round the outline clockwise and its corners come in the same order as in the shape.") + " A mirror image sends you round the other way, and no spin can undo that.";
      var fb = flFit(base), fc = flFit(correct);
      return finishQ({
        typeId: "matching", door: "matching",
        variant: "band:" + band + "|" + rot,
        prompt: "Which option is the same shape after it has been rotated? Do not turn it over.",
        stimulusHtml: figureHtml(flSvg(flFit(base), { width: 110, label: "the shape to match, " + optLabel }), "rotated, not turned over"),
        options: opts,
        rule: "A turn never flips a shape over, so pick a corner you can spot and check what comes next going round clockwise: that never changes.",
        hint: "Find a corner that sticks out or a notch that cuts in, then follow it round in each option.",
        explanation: "The match is the shape turned through " + rot + " degrees. " + move + " " + flip,
        explainHtml: flSheet([
          flSvg(fb, { width: 84, after: flMark(fb, lm), label: "the shape with " + (lm.clear ? "its " + lm.name : "one " + lm.kind) + " marked in orange" }),
          flSvg(fc, { width: 84, after: flMark(fc, lm), label: "the shape after the turn, the same " + lm.kind + " marked" })
        ])
      });
    }

    /* --- reflection: the mirror image in a dashed line --- */
    function buildReflect(rung, plan) {
      var base = flChiralShape(rung);
      var axis = plan && (plan.axis === "v" || plan.axis === "h") ? plan.axis
        : rung >= 4 ? flPickAvoiding(["v", "h"], plan, function (a) { return a; }) : "v";
      var correct = flMirror(base, axis);
      var fitted = flFit(base, 12);
      var line = axis === "v"
        ? "<line x1='108' y1='4' x2='108' y2='96' stroke='" + SR_ORANGE + "' stroke-width='3' stroke-dasharray='7 5' stroke-linecap='round'/>"
        : "<line x1='4' y1='108' x2='96' y2='108' stroke='" + SR_ORANGE + "' stroke-width='3' stroke-dasharray='7 5' stroke-linecap='round'/>";
      var sides = flArticle(base.length + "-sided shape");
      var stim = flSvg(fitted, { width: 120, viewBox: axis === "v" ? "0 0 118 100" : "0 0 100 118", after: line, label: "the shape to reflect, " + sides + ", with a dashed " + (axis === "v" ? "upright" : "flat") + " mirror line beside it" });
      var opts = [{ html: flSvg(flFit(correct), { width: 104, label: sides }), sig: flSig(correct), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      var cands = [0, 90, 180, 270].map(function (a) { return { pts: flRotate(base, a), note: a === 0 ? "the shape as it was, not reflected" : "the shape spun round, not reflected" }; });
      shuffle(cands);
      cands.forEach(function (c) {
        if (opts.length >= 5) return;
        var sig = flSig(c.pts);
        if (used[sig] || flSameShape(c.pts, correct)) return;
        used[sig] = true;
        opts.push({ html: flSvg(flFit(c.pts), { width: 104, label: sides }), sig: sig, isCorrect: false, note: c.note });
      });
      /* a near miss fills any gap: the mirror image with one corner nudged */
      for (var g = 0; g < 20 && opts.length < 5; g++) {
        var nudged = correct.map(function (p) { return p.slice(); });
        var vi = ri(nudged.length);
        nudged[vi] = [nudged[vi][0] + (ri(2) ? 9 : -9), nudged[vi][1] + (ri(2) ? 9 : -9)];
        if (!flSimple(nudged)) continue;
        var s2 = flSig(nudged);
        if (used[s2]) continue;
        used[s2] = true;
        opts.push({ html: flSvg(flFit(nudged), { width: 104, label: sides }), sig: s2, isCorrect: false, note: "nearly the mirror image, but one corner is in the wrong place" });
      }
      if (opts.length < 5) return null;
      var swap = axis === "v" ? "left and right swap" : "top and bottom swap";
      /* the first clear landmark tells the story: one that lands somewhere new moves from side to side;
         one that sits in line with the mirror (the base of a key, the top bar of a Z) is described by
         which way along that line it leans, since that is what the mirror swaps; only a landmark that
         is both in line and central is passed over */
      var lms = flLandmarks(base), c0 = flCentroid(base), lm = null, move = "", axisSide = flAxisSide(base, axis);
      if (axisSide) {
        /* after the shape's own clear landmarks, before any that are too close to call */
        var firstUnclear = lms.length;
        lms.forEach(function (l, k) { if (!l.clear && k < firstUnclear) firstUnclear = k; });
        lms.splice(firstUnclear, 0, axisSide);
      }
      for (var li = 0; li < lms.length && !lm; li++) {
        var p0 = flLandmarkPt(base, lms[li]), b0 = flDirWord(c0, p0), a0 = flDirWord(flMirrorPt(c0, axis), flMirrorPt(p0, axis));
        if (b0 !== a0) { lm = lms[li]; move = "The " + lm.name + " moves from the " + b0 + " to the " + a0 + ", the same distance from the dashed line"; continue; }
        var off = axis === "v" ? p0[0] - c0[0] : p0[1] - c0[1];
        if (!lms[li].clear || Math.abs(off) < 6) continue;
        var lean = axis === "v" ? (off < 0 ? "left" : "right") : (off < 0 ? "top" : "bottom"), leanTo = axis === "v" ? (off < 0 ? "right" : "left") : (off < 0 ? "bottom" : "top");
        lm = lms[li];
        move = "The " + lm.name + " " + flWhere(lm, b0) + ", nearer the " + lean + "; in the mirror image it still " + flWhere(lm, a0) + " but nearer the " + leanTo + ", the same distance from the dashed line";
      }
      if (!lm) move = "The " + lms[0].name + " sits right in line with the middle, so it stays put while the parts either side of it swap over";
      var mark = lm || lms[0], fb = flFit(base), fc = flFit(correct);
      return finishQ({
        typeId: "reflection", door: "reflection",
        variant: axis,
        prompt: "Which option is the mirror image of this shape in the dashed line?",
        stimulusHtml: figureHtml(stim, "reflect it in the dashed line"),
        options: opts,
        rule: "Every corner moves straight across the mirror line and lands the same distance away on the other side.",
        hint: "Take the corner nearest the dashed line and the one furthest from it, and work out where each must land.",
        explanation: "The mirror line is " + (axis === "v" ? "upright" : "flat") + ", so " + swap + ". " + move + ", and nothing has been rotated.",
        explainHtml: flSheet([
          flSvg(fb, { width: 84, after: flMark(fb, mark), label: "the shape with " + (mark.clear ? "its " + mark.name : "one " + mark.kind) + " marked in orange" }),
          flSvg(fc, { width: 84, after: flMark(fc, flLandmarkMirrored(mark, base.length)), label: "the mirror image, the same " + mark.kind + " marked" })
        ])
      });
    }

    /* --- combining shapes: join on the lettered side, or cut out along it --- */
    function flRegular(n, r, start) {
      var out = [];
      for (var k = 0; k < n; k++) { var a = ((start + (360 / n) * k) * Math.PI) / 180; out.push([50 + r * Math.cos(a), 50 + r * Math.sin(a)]); }
      return out;
    }
    var FL_BASES = [
      { id: "square", name: "square", pts: [[30, 30], [70, 30], [70, 70], [30, 70]] },
      { id: "rect", name: "rectangle", pts: [[22, 34], [78, 34], [78, 66], [22, 66]] },
      { id: "tri", name: "triangle", pts: flRegular(3, 32, -90) },
      { id: "pent", name: "pentagon", pts: flRegular(5, 30, -90) },
      { id: "hex", name: "hexagon", pts: flRegular(6, 30, 0) },
      { id: "trap", name: "trapezium", pts: [[36, 30], [64, 30], [80, 70], [20, 70]] }
    ];
    var FL_PIECES = { tri: "triangle", rtri: "right-angled triangle", square: "square", half: "small triangle" };
    function flPieceH(kind, L) { return kind === "tri" ? L * 0.866 : kind === "rtri" ? L * 0.75 : kind === "half" ? L * 0.45 : L; }
    /* piece points along the outside of edge a->b of a polygon with centroid c: the piece stands
       square on the edge (its height runs along the edge's own normal, pointing away from c),
       so a triangle really is that triangle and a square really is a square on a slanted side too */
    function flPieceOn(a, b, kind, c, o) {
      o = o || {};
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
      var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
      var nx = -(b[1] - a[1]) / L, ny = (b[0] - a[0]) / L;
      if (nx * (mx - c[0]) + ny * (my - c[1]) < 0) { nx = -nx; ny = -ny; }
      if (o.inward) { nx = -nx; ny = -ny; }
      var h = flPieceH(kind, L) * (o.scale || 1);
      if (kind === "tri" || kind === "half") return [[mx + nx * h, my + ny * h]];
      if (kind === "rtri") { var e = o.flip ? b : a; return [[e[0] + nx * h, e[1] + ny * h]]; }
      return [[a[0] + nx * h, a[1] + ny * h], [b[0] + nx * h, b[1] + ny * h]];
    }
    function flGlue(base, edge, kind, o) {
      var n = base.length, a = base[edge], b = base[(edge + 1) % n], c = flCentroid(base);
      var ins = flPieceOn(a, b, kind, c, o), out = [];
      for (var i = 0; i < n; i++) { out.push(base[i]); if (i === edge) ins.forEach(function (p) { out.push(p); }); }
      return out;
    }
    /* o.scale shrinks the piece's height (a cut-out piece is flatter than a joined one); o.role names it */
    function flPieceAlone(kind, L, letter, flip, o) {
      o = o || {};
      var half = L / 2, h = flPieceH(kind, L) * (o.scale || 1);
      var y = 50 + h / 2, pts;
      if (kind === "tri" || kind === "half") pts = [[50 - half, y], [50 + half, y], [50, y - h]];
      else if (kind === "rtri") pts = flip ? [[50 - half, y], [50 + half, y], [50 + half, y - h]] : [[50 - half, y], [50 + half, y], [50 - half, y - h]];
      else pts = [[50 - half, y], [50 + half, y], [50 + half, y - h], [50 - half, y - h]];
      /* drawn at the same scale as the base, so the two really do fit */
      var ys = pts.map(function (p) { return p[1]; }), bottom = Math.max.apply(null, ys);
      return flSvg(pts, { width: 84, after: flLetter(50, Math.min(94, bottom + 9), letter), label: (o.role === "cut" ? "the piece to cut out, " : "the piece to add, ") + flArticle(FL_PIECES[kind]) + " with its side " + letter + " marked" });
    }
    function flBaseWithLetter(base, edge, letter, name) {
      var n = base.length, a = base[edge], b = base[(edge + 1) % n], c = flCentroid(base);
      var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2, nx = mx - c[0], ny = my - c[1], nl = Math.hypot(nx, ny) || 1;
      return flSvg(base, { width: 84, after: flLetter(mx + (nx / nl) * 9, my + (ny / nl) * 9, letter), label: "the base shape, " + flArticle(name || "shape") + " with one side marked " + letter });
    }
    /* the side of the base that carries the letter, as a compass word from the middle */
    function flEdgeDir(base, edge) {
      var n = base.length, a = base[edge], b = base[(edge + 1) % n];
      return flDirWord(flCentroid(base), [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]);
    }
    /* map extra points (all inside the base's box) with the same fit the base gets */
    function flFitWith(base, extra) { return flFit(base.concat(extra)).slice(base.length); }
    function buildCombine(rung, plan) {
      var bd = pick(FL_BASES), base = flRotate(bd.pts, rung >= 3 ? pick([0, 30, 60, 90, 120, 150]) : 0);
      var n = base.length, edge = ri(n);
      var kinds = rung <= 2 ? ["tri", "square"] : ["tri", "rtri", "square", "half"];
      var kind = flPickAvoiding(kinds, plan, function (k) { return "join|" + k; }), letter = pick(["X", "Y", "Z"]);
      var correctPts = flGlue(base, edge, kind, {});
      if (!flSimple(correctPts)) return null;
      var rotFor = function () { return rung >= 3 ? pick([0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]) : 0; };
      var correct = flRotate(correctPts, rotFor());
      var cands = [];
      var other = (edge + 1 + ri(n - 1)) % n;
      cands.push({ pts: flGlue(base, other, kind, {}), note: "the piece is on the wrong side" });
      cands.push({ pts: flGlue(base, edge, kind, { inward: true }), note: "the piece has been cut out instead of added on" });
      cands.push({ pts: flGlue(base, edge, kind, { scale: 1.5 }), note: "the piece is too big" });
      if (kind === "rtri") cands.push({ pts: flGlue(base, edge, kind, { flip: true }), note: "the piece is turned over" });
      cands.push({ pts: flGlue(base, edge, kind === "tri" ? "square" : "tri", {}), note: "that is a different piece" });
      cands.push({ pts: flGlue(base, (edge + 2) % n, kind, {}), note: "the piece is on the wrong side" });
      cands.push({ pts: flGlue(base, edge, kind, { scale: 0.6 }), note: "the piece is too small" });
      /* every option shares one scale, so a bigger or smaller piece really looks bigger or smaller */
      var pool = [correct].concat(cands.map(function (cd) { return cd.pts; }));
      var sc = Math.min.apply(null, pool.map(function (p) { return flFitScale(p, 8); }));
      var optLabel = "a joined outline";
      var opts = [{ html: flSvg(flPlace(correct, sc), { width: 104, label: optLabel }), sig: flSigRaw(correct), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      shuffle(cands).forEach(function (cd) {
        if (opts.length >= 5) return;
        if (!flSimple(cd.pts) || flSameShape(cd.pts, correctPts)) return;
        var pts = flRotate(cd.pts, rotFor()), sig = flSigRaw(pts);
        if (used[sig]) return;
        used[sig] = true;
        opts.push({ html: flSvg(flPlace(pts, sc), { width: 104, label: optLabel }), sig: sig, isCorrect: false, note: cd.note });
      });
      if (opts.length < 5) return null;
      var a = base[edge], b = base[(edge + 1) % n];
      var stim = "<div class='sr-figrow'>" + flBaseWithLetter(base, edge, letter, bd.name) + "<span class='sr-eq' aria-hidden='true'>+</span>" +
        flPieceAlone(kind, Math.hypot(b[0] - a[0], b[1] - a[1]), letter) +
        "<span class='sr-eq' aria-hidden='true'>=</span><span class='sr-eq' aria-hidden='true'>?</span></div>";
      /* the explanation names this item's shared edge and counts the corners the eye sees */
      var dir = flEdgeDir(base, edge), corners = flCornerCount(correctPts), piece = FL_PIECES[kind];
      var baseName = (bd.name === piece ? "base " : "") + bd.name, pieceName = (bd.name === piece ? "added " : "") + piece;
      var fj = flFit(correctPts), fe = flFitWith(correctPts, [a, b]);
      var shared = "<line x1='" + fx(fe[0][0]) + "' y1='" + fx(fe[0][1]) + "' x2='" + fx(fe[1][0]) + "' y2='" + fx(fe[1][1]) + "' stroke='" + SR_ORANGE + "' stroke-width='3' stroke-dasharray='5 4' stroke-linecap='round'/>";
      return finishQ({
        typeId: "combining", door: "combining",
        variant: "join|" + kind,
        prompt: "Put the two sides marked " + letter + " together, with the piece on the outside. Which outline do you get?",
        stimulusHtml: stim,
        options: opts,
        rule: "Join the two lettered sides so the piece sits on the outside of the base shape, then read the new outline.",
        hint: "Find the lettered side on the base shape and picture the piece stuck to that side, pointing away from the middle.",
        explanation: "The " + letter + " sides meet: the " + baseName + "'s " + dir + " side and the " + pieceName + "'s marked side become one shared edge inside the new outline, so the " + pieceName + " sticks out to the " + dir + ". The outline has " + corners + " corners" + (rung >= 3 ? ", spun round in the answer." : "."),
        explainHtml: flSheet([flSvg(fj, { width: 84, fill: "#d8e9fd", after: shared, label: "the joined outline, with the shared edge dashed in orange" })])
      });
    }

    /* --- cutting out: the piece is cut into the base along the lettered side, leaving a notch --- */
    var FL_CUT_KINDS = { tri: 0.5, rtri: 0.5, half: 0.3 };
    /* The notch a piece leaves when cut in from edge `edge`, or null when it does not fit.
       Rule: the cut piece is a flatter cousin of the joining piece (a triangle or right-angled
       triangle half the side deep, a small triangle 0.3 of it), shrunk if need be to 55% of the
       distance from that side's middle to the base's centre, the inradius-ish distance, so the
       notch never reaches the middle; a notch under 0.22 of the side deep is too shallow to see,
       so the builder gives up and the door falls back to a join. A right-angled piece is only cut
       where the base's corner at its leg is a right angle (square, rectangle), so it chamfers that
       corner cleanly instead of leaving a needle-thin sliver. o.depth forces a depth (for the too
       big and too small traps) and o.flip cuts a right-angled piece from the other end. */
    function flNotch(base, edge, kind, o) {
      o = o || {};
      var n = base.length, a = base[edge], b = base[(edge + 1) % n], c = flCentroid(base);
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      var mid = [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2], d = Math.hypot(mid[0] - c[0], mid[1] - c[1]);
      var depth = o.depth != null ? o.depth : Math.min(L * FL_CUT_KINDS[kind], d * 0.55);
      if (o.depth == null && depth < L * 0.22) return null;
      if (kind === "rtri") { var legAt = flCornerAngles(base)[o.flip ? (edge + 1) % n : edge]; if (Math.abs(legAt - 90) > 3) return null; }
      var scale = depth / flPieceH(kind, L);
      var ins = flPieceOn(a, b, kind, c, { inward: true, scale: scale, flip: !!o.flip });
      var cut = flTidy(flGlue(base, edge, kind, { inward: true, scale: scale, flip: !!o.flip }));
      var inside = ins.every(function (p) { var dx = c[0] - p[0], dy = c[1] - p[1], dl = Math.hypot(dx, dy) || 1; return ppInPoly([p[0] + (dx / dl) * 0.6, p[1] + (dy / dl) * 0.6], base); });
      if (cut.length < 4 || !inside || !flSimple(cut) || polyAreaAbs(cut) >= polyAreaAbs(base) - 1) return null;
      return { pts: cut, piece: [a].concat(ins, [b]), scale: scale, depth: depth, L: L };
    }
    function buildCutout(rung, plan) {
      var bd = pick(FL_BASES), base = flRotate(bd.pts, rung >= 3 ? pick([0, 30, 60, 90, 120, 150]) : 0);
      var n = base.length, edge = ri(n);
      var kinds = rung <= 2 ? ["tri", "half"] : ["tri", "rtri", "half"];
      var kind = flPickAvoiding(kinds, plan, function (k) { return "cutout|" + k; }), letter = pick(["X", "Y", "Z"]);
      var notch = flNotch(base, edge, kind);
      if (!notch) return null;
      var correctPts = notch.pts;
      var rotFor = function () { return rung >= 3 ? pick([0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]) : 0; };
      var correct = flRotate(correctPts, rotFor());
      var cands = [], other = (edge + 1 + ri(n - 1)) % n, third = (edge + 2) % n;
      var addOn = function (e) { return flTidy(flGlue(base, e, kind, { scale: notch.scale })); };
      cands.push({ pts: addOn(edge), note: "the piece has been added on instead of cut out" });
      var wrongSide = flNotch(base, other, kind, { depth: notch.depth });
      if (wrongSide) cands.push({ pts: wrongSide.pts, note: "the notch is cut on the wrong side" });
      var big = flNotch(base, edge, kind, { depth: notch.depth * 1.6 });
      if (big) cands.push({ pts: big.pts, note: "the notch is too big" });
      var small = flNotch(base, edge, kind, { depth: notch.depth * 0.55 });
      if (small) cands.push({ pts: small.pts, note: "the notch is too small" });
      if (kind === "rtri") {
        var flipped = flNotch(base, edge, kind, { depth: notch.depth, flip: true });
        if (flipped) cands.push({ pts: flipped.pts, note: "the notch is a mirror image: the piece was spun into the shape instead of flipped over the side" });
      }
      /* a look-alike notch: a triangle where the right-angled piece was cut, a right-angled one (where it fits) otherwise */
      var alike = flNotch(base, edge, kind === "rtri" ? "tri" : "rtri", { depth: notch.depth });
      if (alike) cands.push({ pts: alike.pts, note: "a look-alike: the notch is the wrong shape" });
      if (third !== other) {
        var wrongSide2 = flNotch(base, third, kind, { depth: notch.depth });
        if (wrongSide2) cands.push({ pts: wrongSide2.pts, note: "the notch is cut on the wrong side" });
      }
      cands.push({ pts: addOn(other), note: "the piece has been added on instead of cut out" });
      /* one shared scale, so a deeper or shallower notch really looks deeper or shallower */
      var pool = [correct].concat(cands.map(function (cd) { return cd.pts; }));
      var sc = Math.min.apply(null, pool.map(function (p) { return flFitScale(p, 8); }));
      var optLabel = "an outline";
      var opts = [{ html: flSvg(flPlace(correct, sc), { width: 104, label: optLabel }), sig: flSigRaw(correct), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      shuffle(cands).forEach(function (cd) {
        if (opts.length >= 5) return;
        if (!cd.pts || cd.pts.length < 3 || !flSimple(cd.pts) || flSameShape(cd.pts, correctPts)) return;
        var pts = flRotate(cd.pts, rotFor()), sig = flSigRaw(pts);
        if (used[sig]) return;
        used[sig] = true;
        opts.push({ html: flSvg(flPlace(pts, sc), { width: 104, label: optLabel }), sig: sig, isCorrect: false, note: cd.note });
      });
      if (opts.length < 5) return null;
      var stim = "<div class='sr-figrow'>" + flBaseWithLetter(base, edge, letter, bd.name) + "<span class='sr-eq' aria-hidden='true'>&#8722;</span>" +
        flPieceAlone(kind, notch.L, letter, false, { scale: notch.scale, role: "cut" }) +
        "<span class='sr-eq' aria-hidden='true'>=</span><span class='sr-eq' aria-hidden='true'>?</span></div>";
      var dir = flEdgeDir(base, edge), corners = flCornerCount(correctPts), piece = FL_PIECES[kind];
      /* stage sheet: the base in grey, the piece shaded where it is cut away, the outline left in navy */
      var fb = flFit(base), fp = flFitWith(base, notch.piece), fc = flFitWith(base, correctPts);
      var sheet = svgBox("<polygon points='" + ptsStr(fb) + "' fill='none' stroke='" + SR_PAPER + "' stroke-width='3' stroke-linejoin='round'/>" +
        "<polygon points='" + ptsStr(fp) + "' fill='rgba(244,120,32,0.22)' stroke='" + SR_ORANGE + "' stroke-width='2' stroke-dasharray='5 4' stroke-linejoin='round'/>" +
        "<polygon points='" + ptsStr(fc) + "' fill='none' stroke='" + SR_NAVY + "' stroke-width='3' stroke-linejoin='round'/>", "0 0 100 100", 84, 84, "the " + bd.name + " with the " + piece + " shaded where it is cut away, and the outline that is left");
      /* the cut follows the paper's rule: the piece is flipped over its lettered side into the base
         (a reflection across that edge), so a right-angled piece keeps its right angle at the same end */
      var cutLine = kind === "rtri"
        ? "Flip the " + piece + " over that side into the " + bd.name + " and cut it away: its right angle stays at the same end of the side, so that corner of the " + bd.name + " is sliced off on a slant."
        : "Flip the " + piece + " over that side into the " + bd.name + " and cut it away: the side becomes a notch that dips towards the middle. Going round the outline you pass the " + bd.name + "'s own corners, then the notch's point, then the rest of the " + bd.name + ".";
      return finishQ({
        typeId: "cutout", door: "combining",
        variant: "cutout|" + kind,
        prompt: "The piece is cut out of the shape along the sides marked " + letter + ", flipped in over that side. Which outline is left?",
        stimulusHtml: stim,
        options: opts,
        rule: "Flip the piece over its lettered side into the base shape, rub out the part it covers, then read the outline that is left.",
        hint: "Find the lettered side on the base, then flip the piece over that side into the shape in your head: the notch is where it lands.",
        explanation: "Side " + letter + " is the " + bd.name + "'s " + dir + " side. " + cutLine + " The outline has " + corners + " corners in all" + (rung >= 3 ? ", spun round in the answer." : "."),
        explainHtml: flSheet([sheet])
      });
    }

    /* --- jigsaw: which piece completes the shape --- */
    var FL_JIG_BASES = FL_BASES.concat([{ id: "oct", name: "octagon", pts: flRegular(8, 32, 22.5) }]).filter(function (b) { return b.pts.length >= 4; });
    function buildJigsaw(rung, plan) {
      var bd = flPickAvoiding(FL_JIG_BASES, plan, function (b) { return "missing|" + b.name; }), whole = flRotate(bd.pts, pick([0, 15, 30, 45, 60, 90]));
      var n = whole.length;
      var verts = whole.slice();
      if (rung >= 3 && ri(2)) {
        /* cut from a corner to the middle of a side */
        var ei = ri(n), mid = [(verts[ei][0] + verts[(ei + 1) % n][0]) / 2, (verts[ei][1] + verts[(ei + 1) % n][1]) / 2];
        verts.splice(ei + 1, 0, mid);
        n = verts.length;
      }
      var i = ri(n), j = (i + 2 + ri(Math.max(1, n - 3))) % n;
      if (j === i || (j + 1) % n === i || (i + 1) % n === j) return null;
      var A = [], B = [], k;
      for (k = i; k !== j; k = (k + 1) % n) A.push(verts[k]); A.push(verts[j]);
      for (k = j; k !== i; k = (k + 1) % n) B.push(verts[k]); B.push(verts[i]);
      if (A.length < 3 || B.length < 3) return null;
      if (Math.abs(polyAreaAbs(A) - polyAreaAbs(B)) < 1 && flSameShape(A, B)) return null;
      var given = A, missing = B;
      var correct = flRotate(missing, rung >= 2 ? pick([30, 60, 90, 120, 150, 180, 210, 240, 270, 300]) : 0);
      var cands = [];
      if (flIsChiral(missing)) cands.push({ pts: flMirror(missing), note: "a mirror image of the missing piece" });
      var nudged = missing.map(function (p) { return p.slice(); }), vi = ri(nudged.length);
      var cN = flCentroid(nudged), dx = nudged[vi][0] - cN[0], dy = nudged[vi][1] - cN[1], dl = Math.hypot(dx, dy) || 1;
      nudged[vi] = [nudged[vi][0] + (dx / dl) * 11, nudged[vi][1] + (dy / dl) * 11];
      cands.push({ pts: nudged, note: "nearly right, but one corner is in the wrong place" });
      if (!flSameShape(given, missing)) cands.push({ pts: given, note: "that is the piece you already have" });
      cands.push({ pts: flScale(missing, 0.8), note: "the right shape but too small" });
      cands.push({ pts: flScale(missing, 1.2), note: "the right shape but too big" });
      var j2 = (i + 1 + ri(n - 1)) % n;
      if (j2 !== j && j2 !== i && (j2 + 1) % n !== i && (i + 1) % n !== j2) {
        var C = [];
        for (k = j2; k !== i; k = (k + 1) % n) C.push(verts[k]); C.push(verts[i]);
        if (C.length >= 3 && !flSameShape(C, missing)) cands.push({ pts: C, note: "a piece cut along a different line" });
      }
      /* one scale for the whole, the piece you have and every option, so sizes are real */
      var sc = flFitScale(whole, 9);
      cands.forEach(function (cd) { sc = Math.min(sc, flFitScale(cd.pts, 8)); });
      var optLabel = "a piece";
      var opts = [{ html: flSvg(flPlace(correct, sc), { width: 104, label: optLabel }), sig: flSigRaw(correct), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      shuffle(cands).forEach(function (cd) {
        if (opts.length >= 5) return;
        if (!flSimple(cd.pts) || flSameShape(cd.pts, missing)) return;
        var pts = flRotate(cd.pts, pick([0, 45, 90, 135, 180, 225, 270, 315])), sig = flSigRaw(pts);
        if (used[sig]) return;
        used[sig] = true;
        opts.push({ html: flSvg(flPlace(pts, sc), { width: 104, label: optLabel }), sig: sig, isCorrect: false, note: cd.note });
      });
      if (opts.length < 5) return null;
      /* the whole shape with the piece you have shaded in place, so the missing region is plain to see */
      var fw = flPlace(whole, sc), cW = flCentroid(whole), cF = flCentroid(fw);
      var fg = given.map(function (p) { return [cF[0] + (p[0] - cW[0]) * sc, cF[1] + (p[1] - cW[1]) * sc]; });
      var wholeSvg = flSvg(fw, { width: 116, fill: "#ffffff", before: "<polygon points='" + ptsStr(fg) + "' fill='#d8e9fd' stroke='none'/>", after: "<polygon points='" + ptsStr(fg) + "' fill='none' stroke='" + SR_NAVY + "' stroke-width='2' stroke-dasharray='5 4'/>", label: "the whole " + bd.name + ", with the blue piece shaded in place and a white gap left" });
      var stim = "<div class='sr-figrow'>" + wholeSvg + "<span class='sr-eq' aria-hidden='true'>=</span>" +
        flSvg(flPlace(given, sc), { width: 104, fill: "#d8e9fd", label: "the blue piece you already have" }) + "<span class='sr-eq' aria-hidden='true'>+</span><span class='sr-eq' aria-hidden='true'>?</span></div>";
      return finishQ({
        typeId: "jigsaw", door: "combining",
        variant: "missing|" + bd.name,
        prompt: "Two pieces make the whole shape. The blue piece is already in place. Which same-size piece fills the white gap? It may be rotated.",
        stimulusHtml: stim,
        options: opts,
        rule: "Fit the straight cut edge first, then check the corners at each end of it and that the piece is the same size.",
        hint: "Look at the white gap: its long straight edge is the cut, so find the piece with an edge exactly that long.",
        explanation: "The missing piece is the white gap in the " + bd.name + ", turned round to fit. Its cut edge is the same length as the cut edge of the blue piece, and its other corners are the " + bd.name + "'s own corners."
      });
    }
    function polyAreaAbs(p) { var a = 0; for (var i = 0; i < p.length; i++) { var q = p[(i + 1) % p.length]; a += p[i][0] * q[1] - q[0] * p[i][1]; } return Math.abs(a) / 2; }
    /* the combining door: join (rung 1 only in practice), find the missing piece, or cut the piece out.
       plan.kind fixes the kind; otherwise practice mixes join, missing and cutout about 5:3:2 from rung 2,
       skipping any kind whose every variant was served recently. In practice a cutout that will not fit
       falls back to a join; a planned cutout never does (the test's quota counts on it), it returns null
       so the plan builder draws again. */
    var FL_KIND_VARIANTS = {
      join: function (rung) { return (rung <= 2 ? ["tri", "square"] : ["tri", "rtri", "square", "half"]).map(function (k) { return "join|" + k; }); },
      missing: function () { return FL_JIG_BASES.map(function (b) { return "missing|" + b.name; }); },
      cutout: function (rung) { return (rung <= 2 ? ["tri", "half"] : ["tri", "rtri", "half"]).map(function (k) { return "cutout|" + k; }); }
    };
    function buildCombineOrJigsaw(rung, plan) {
      var kind = plan && FL_KIND_VARIANTS[plan.kind] ? plan.kind : null;
      if (!kind) {
        var bag = rung >= 2 ? ["join", "join", "join", "join", "join", "missing", "missing", "missing", "cutout", "cutout"] : ["join"];
        var open = bag.filter(function (k) { return FL_KIND_VARIANTS[k](rung).some(function (v) { return !flAvoids(plan, v); }); });
        kind = pick(open.length ? open : bag);
      }
      var q = null, t, planned = !!(plan && plan.kind === "cutout");
      if (kind === "missing") { for (t = 0; t < 6 && !q; t++) q = buildJigsaw(rung, plan); return q; }
      if (kind === "cutout") { for (t = 0; t < (planned ? 24 : 6) && !q; t++) q = buildCutout(rung, plan); if (q || planned) return q; }
      return buildCombine(rung, plan);
    }

    /* --- hidden shapes: ported from Shape Sleuth (genHidden) --- */
    /* every hidden-shape picture, prompt and option, is drawn at this width so
       "at exactly the size shown" is literally true on screen */
    /* ---- does a hidden-shapes picture really contain the shape, and only once? ----
       Every side of the target has to be drawn as a line of the picture, so a copy can
       only sit with its corners where the picture's lines meet or end. Collect the drawn
       segments, cross them all, then try to land the target on every pair of those points
       that is the right distance apart, and count the placements whose every side is
       covered by a drawn line. The intended copy is one of them; a second one means two
       answers are right, which is the one failure worse than an easy elimination. */
    var HIDE_EPS = 0.7;
    function flSegsFromHtml(html) {
      var segs = [], m;
      var poly = /<polygon points='([^']+)'/g;
      while ((m = poly.exec(html))) {
        var v = m[1].trim().split(/\s+/).map(function (t) { return t.split(",").map(Number); });
        for (var i = 0; i < v.length; i++) {
          var a = v[i], b = v[(i + 1) % v.length];
          segs.push([a[0], a[1], b[0], b[1]]);
        }
      }
      var line = /<line x1='([-\d.]+)' y1='([-\d.]+)' x2='([-\d.]+)' y2='([-\d.]+)'/g;
      while ((m = line.exec(html))) segs.push([+m[1], +m[2], +m[3], +m[4]]);
      return segs.filter(function (g) { return Math.hypot(g[2] - g[0], g[3] - g[1]) > 0.5; });
    }
    function flPointOnSeg(px, py, g, eps) {
      var vx = g[2] - g[0], vy = g[3] - g[1], L2 = vx * vx + vy * vy;
      if (L2 < 1e-9) return false;
      var t = ((px - g[0]) * vx + (py - g[1]) * vy) / L2;
      if (t < -eps / Math.sqrt(L2) || t > 1 + eps / Math.sqrt(L2)) return false;
      t = Math.max(0, Math.min(1, t));
      return Math.hypot(px - (g[0] + vx * t), py - (g[1] + vy * t)) <= eps;
    }
    /* every endpoint, and every place two lines cross */
    function flNodes(segs) {
      var pts = [], seen = {};
      var add = function (x, y) {
        var k = Math.round(x * 4) + "," + Math.round(y * 4);
        if (seen[k]) return;
        seen[k] = true; pts.push([x, y]);
      };
      segs.forEach(function (g) { add(g[0], g[1]); add(g[2], g[3]); });
      for (var i = 0; i < segs.length; i++) for (var j = i + 1; j < segs.length; j++) {
        var a = segs[i], b = segs[j];
        var r1 = a[2] - a[0], r2 = a[3] - a[1], s1 = b[2] - b[0], s2 = b[3] - b[1];
        var den = r1 * s2 - r2 * s1;
        if (Math.abs(den) < 1e-9) continue;
        var t = ((b[0] - a[0]) * s2 - (b[1] - a[1]) * s1) / den;
        var u = ((b[0] - a[0]) * r2 - (b[1] - a[1]) * r1) / den;
        if (t < -0.001 || t > 1.001 || u < -0.001 || u > 1.001) continue;
        add(a[0] + r1 * t, a[1] + r2 * t);
      }
      return pts;
    }
    /* the turns that map a shape onto itself, so a square that is "turned" 90 degrees
       still counts as the same way up */
    /* How many times a shape maps onto itself in a full turn: 8 for an octagon, 4 for a
       square or a cross, 1 for an arrow. Whole degrees will not do - a heptagon repeats
       every 51.43 degrees - so the order is what gets measured, and the angles come from
       it. Memoised by shape name where the caller has one. */
    function flTurnsOntoItself(v, deg) {
      var cx = 0, cy = 0;
      v.forEach(function (q) { cx += q[0]; cy += q[1]; });
      cx /= v.length; cy /= v.length;
      var rad = 0;
      v.forEach(function (q) { rad = Math.max(rad, Math.hypot(q[0] - cx, q[1] - cy)); });
      var tol = Math.max(0.35, rad * 0.02);
      var a = (deg * Math.PI) / 180, c = Math.cos(a), s2 = Math.sin(a);
      return v.every(function (q) {
        var x = cx + (q[0] - cx) * c - (q[1] - cy) * s2, y = cy + (q[0] - cx) * s2 + (q[1] - cy) * c;
        return v.some(function (w) { return Math.hypot(w[0] - x, w[1] - y) < tol; });
      });
    }
    function flRotOrder(v) {
      for (var k = 12; k > 1; k--) if (flTurnsOntoItself(v, 360 / k)) return k;
      return 1;
    }
    function flShapeSymmetry(v) {
      var k = flRotOrder(v), out = [];
      for (var i = 0; i < k; i++) out.push((360 / k) * i);
      return out;
    }
    /* A turn a child would actually see. An octagon looks the same every 45 degrees, so
       "rotated by 45" is not rotated at all; the turn has to sit clear of both ends of the
       shape's own repeat. Returns 0 when the shape repeats so often that no turn shows. */
    function flVisibleTurn(v, minShow) {
      var span = 360 / flRotOrder(v), gap = minShow || 18;
      if (span - gap * 2 < 4) return 0;
      var t = gap + Math.random() * (span - gap * 2);
      return Math.round(t * 2) / 2;
    }
    function flHiddenCopies(segs, shape, allowRot) {
      var nodes = flNodes(segs), n = shape.length;
      var e0 = Math.hypot(shape[1][0] - shape[0][0], shape[1][1] - shape[0][1]);
      var sym = allowRot ? null : flShapeSymmetry(shape);
      var covered = function (a, b) {
        for (var k = 0; k < segs.length; k++) {
          if (flPointOnSeg(a[0], a[1], segs[k], HIDE_EPS) && flPointOnSeg(b[0], b[1], segs[k], HIDE_EPS)) return true;
        }
        return false;
      };
      var hits = [], i, j;
      for (i = 0; i < nodes.length; i++) for (j = 0; j < nodes.length; j++) {
        if (i === j) continue;
        var A = nodes[i], B = nodes[j];
        var d = Math.hypot(B[0] - A[0], B[1] - A[1]);
        if (Math.abs(d - e0) > HIDE_EPS) continue;
        /* the turn and shift that put the shape's first side on this pair */
        var ang = Math.atan2(B[1] - A[1], B[0] - A[0]) - Math.atan2(shape[1][1] - shape[0][1], shape[1][0] - shape[0][0]);
        if (sym) {
          var deg = ((ang * 180) / Math.PI % 360 + 360) % 360;
          var onSym = sym.some(function (t) { var dd = Math.abs(deg - t); return Math.min(dd, 360 - dd) < 3; });
          if (!onSym) continue;
        }
        var c = Math.cos(ang), s2 = Math.sin(ang);
        var put = shape.map(function (q) {
          var dx = q[0] - shape[0][0], dy = q[1] - shape[0][1];
          return [A[0] + dx * c - dy * s2, A[1] + dx * s2 + dy * c];
        });
        var ok = true;
        for (var k2 = 0; k2 < n && ok; k2++) if (!covered(put[k2], put[(k2 + 1) % n])) ok = false;
        if (!ok) continue;
        /* the same copy found from a different starting side is still one copy */
        var mx = 0, my = 0;
        put.forEach(function (q) { mx += q[0]; my += q[1]; });
        mx /= n; my /= n;
        if (!hits.some(function (h) { return Math.hypot(h[0] - mx, h[1] - my) < 1.2; })) hits.push([mx, my]);
      }
      return hits.length;
    }
    /* how often the audit below throws a question away, so a change that starts
       rejecting everything shows up instead of quietly slowing the page down */
    var HIDE_AUDIT = { passed: 0, rejected: 0, ms: 0 };
    function flHiddenAudit(opts, shape, allowRot) {
      var t0 = (typeof performance === "object" && performance.now) ? performance.now() : 0;
      var out = { ok: true, counts: [] };
      for (var i = 0; i < opts.length; i++) {
        var c = flHiddenCopies(flSegsFromHtml(opts[i].html), shape, allowRot);
        out.counts.push(c);
        if (opts[i].isCorrect ? c !== 1 : c !== 0) out.ok = false;
      }
      if (t0) HIDE_AUDIT.ms += (performance.now() - t0);
      return out;
    }
    /* The line through a side of the shape, as far as it can run inside the frame:
       returns the two parameters t (in a -> b units) where it meets the frame, with
       t0 < 0 and t1 > 1. Null if it somehow does not cross the frame twice. */
    function flRunToFrame(a, b, frame) {
      var dx = b[0] - a[0], dy = b[1] - a[1], ts = [];
      for (var i = 0; i < frame.length; i++) {
        var p = frame[i], q = frame[(i + 1) % frame.length];
        var ex = q[0] - p[0], ey = q[1] - p[1];
        var den = dx * ey - dy * ex;
        if (Math.abs(den) < 1e-9) continue;
        var t = ((p[0] - a[0]) * ey - (p[1] - a[1]) * ex) / den;
        var u = ((p[0] - a[0]) * dy - (p[1] - a[1]) * dx) / den;
        if (u < -1e-6 || u > 1 + 1e-6) continue;
        ts.push(t);
      }
      if (ts.length < 2) return null;
      var lo = Math.min.apply(null, ts), hi = Math.max.apply(null, ts);
      if (lo > -0.02 || hi < 1.02) return null;
      return [lo, hi];
    }
    var HIDE_ART = 150;
    /* How far a shape really reaches at radius 1: for a triangle or a hexagon that is 1,
       but an L-shape, a Z-shape or a right-angled triangle put a corner well beyond it.
       Memoised, since it is asked for on every question. */
    var HIDE_REACH = {};
    function flShapeReach(shape) {
      if (HIDE_REACH[shape]) return HIDE_REACH[shape];
      var v = shapeV(shape, 1), cx = 0, cy = 0;
      v.forEach(function (q) { cx += q[0]; cy += q[1]; });
      cx /= v.length; cy /= v.length;
      var m = 1;
      v.forEach(function (q) { m = Math.max(m, Math.hypot(q[0] - cx, q[1] - cy)); });
      HIDE_REACH[shape] = m;
      return m;
    }
    var HIDE_TARGETS = ["triangle", "square", "pentagon", "hexagon", "heptagon", "octagon", "diamond", "cross", "star", "star6", "trapezium", "kite", "parallelogram", "chevron", "tshape", "zshape", "arrow", "rtriangle", "lshape", "house", "bolt"];
    var HIDE_CHIRAL = ["lshape", "rtriangle", "parallelogram", "zshape", "bolt"];
    var SHAPEDESC = { square: "square", triangle: "triangle", pentagon: "pentagon", hexagon: "hexagon", heptagon: "heptagon", octagon: "octagon", star: "five-pointed star", star6: "six-pointed star", diamond: "diamond", cross: "cross", arrow: "arrow", chevron: "chevron", tshape: "T-shape", trapezium: "trapezium", kite: "kite", parallelogram: "parallelogram", zshape: "Z-shape", lshape: "L-shape", rtriangle: "right-angled triangle", house: "house shape", bolt: "lightning bolt" };
    /* the on-demand hint names a feature of the target itself: its corner count, a square corner
       only where it has one, a notch, a parallel pair, so the child hunts for something that is there */
    var HIDE_HINTS = {
      triangle: "Look for three straight lines meeting at three sharp corners, all the same size as the shape shown.",
      square: "Look for four equal sides meeting at four square corners, with every side the length shown.",
      pentagon: "Count sides: you need five equal sides going round, with every corner the same blunt angle.",
      hexagon: "Count sides: six equal sides, with each side parallel to the one straight opposite it.",
      heptagon: "Count sides: seven equal sides make an almost round shape with blunt corners.",
      octagon: "Count sides: eight equal sides, with each side parallel to the one straight opposite it.",
      diamond: "Look for a square standing on one corner, with a point at the top and at the bottom.",
      cross: "Look for four square arms of the same length coming off a square middle.",
      star: "Look for five sharp points with a notch cutting in between each pair of points.",
      star6: "Look for six sharp points with a notch cutting in between each pair of points.",
      trapezium: "Look for two parallel sides of different lengths, joined by two slanted sides.",
      kite: "Look for two short sides meeting at one point and two long sides meeting at the opposite point.",
      parallelogram: "Look for two pairs of parallel sides with no square corner, so the shape leans over.",
      chevron: "Look for a wide V with a second V cut into it from below, like an arrowhead with no stick.",
      tshape: "Look for a wide bar with a stem coming off the middle of it at a square corner.",
      zshape: "Look for two bars joined by a slanted bar, like a letter Z.",
      arrow: "Look for a pointed head on a straight stick, with square corners where the stick meets the head.",
      rtriangle: "Look for one square corner with the longest side running across on a slant.",
      lshape: "Look for one square corner cutting in, with two arms of different lengths.",
      house: "Look for a pointed roof sitting on a box with a square corner at each bottom edge.",
      bolt: "Look for a slanted zig-zag with a sharp point at each end."
    };
    var NEARMISS = { triangle: ["rtriangle", "kite", "diamond"], rtriangle: ["triangle", "trapezium"], square: ["trapezium", "parallelogram", "pentagon"], diamond: ["kite", "triangle", "square"], pentagon: ["hexagon", "heptagon", "square", "house"], hexagon: ["pentagon", "heptagon"], heptagon: ["hexagon", "octagon"], octagon: ["heptagon", "hexagon"], cross: ["tshape", "zshape", "lshape"], lshape: ["zshape", "tshape", "cross"], star: ["star6", "cross"], star6: ["star", "cross"], trapezium: ["parallelogram", "kite", "square"], kite: ["diamond", "trapezium"], parallelogram: ["trapezium", "square"], chevron: ["arrow", "triangle"], tshape: ["cross", "lshape"], zshape: ["lshape", "tshape", "bolt"], arrow: ["chevron", "kite"], house: ["pentagon", "kite"], bolt: ["zshape", "arrow"] };
    function shapeV(shape, r) {
      function pv(n, start) { var p = []; for (var i = 0; i < n; i++) { var a = ((start + (i * 360) / n) * Math.PI) / 180; p.push([r * Math.cos(a), r * Math.sin(a)]); } return p; }
      if (shape === "square") return pv(4, 45);
      if (shape === "triangle") return pv(3, -90);
      if (shape === "pentagon") return pv(5, -90);
      if (shape === "hexagon") return pv(6, 0);
      if (shape === "diamond") return pv(4, -90);
      if (shape === "star") { var p2 = []; for (var i2 = 0; i2 < 10; i2++) { var rr = i2 % 2 === 0 ? r : r * 0.45, a2 = ((-90 + i2 * 36) * Math.PI) / 180; p2.push([rr * Math.cos(a2), rr * Math.sin(a2)]); } return p2; }
      if (shape === "cross") { var w = r * 0.36; return [[-w, -r], [w, -r], [w, -w], [r, -w], [r, w], [w, w], [w, r], [-w, r], [-w, w], [-r, w], [-r, -w], [-w, -w]]; }
      if (shape === "rtriangle") return [[-r, -0.5 * r], [-r, r], [r, r]];
      if (shape === "heptagon") return pv(7, -90);
      if (shape === "octagon") return pv(8, -67.5);
      if (shape === "star6") { var p6 = []; for (var i6 = 0; i6 < 12; i6++) { var r6 = i6 % 2 === 0 ? r : r * 0.55, a6 = ((-90 + i6 * 30) * Math.PI) / 180; p6.push([r6 * Math.cos(a6), r6 * Math.sin(a6)]); } return p6; }
      if (shape === "trapezium") return [[-0.5 * r, -0.72 * r], [0.5 * r, -0.72 * r], [r, 0.72 * r], [-r, 0.72 * r]];
      if (shape === "kite") return [[0, -r], [0.8 * r, -0.34 * r], [0, r], [-0.8 * r, -0.34 * r]];
      if (shape === "parallelogram") return [[-0.55 * r, -0.62 * r], [r, -0.62 * r], [0.55 * r, 0.62 * r], [-r, 0.62 * r]];
      if (shape === "chevron") return [[0, -r], [r, -0.05 * r], [r, 0.5 * r], [0, -0.45 * r], [-r, 0.5 * r], [-r, -0.05 * r]];
      if (shape === "tshape") { var wT = r * 0.34; return [[-r, -r], [r, -r], [r, -r + 2 * wT], [wT, -r + 2 * wT], [wT, r], [-wT, r], [-wT, -r + 2 * wT], [-r, -r + 2 * wT]]; }
      if (shape === "zshape") { var wZ = r * 0.3; return [[-r, -r], [r, -r], [r, -r + wZ], [-0.1 * r, r - wZ], [r, r - wZ], [r, r], [-r, r], [-r, r - wZ], [0.1 * r, -r + wZ], [-r, -r + wZ]]; }
      if (shape === "arrow") return [[0, -r], [0.58 * r, -0.12 * r], [0.24 * r, -0.12 * r], [0.24 * r, r], [-0.24 * r, r], [-0.24 * r, -0.12 * r], [-0.58 * r, -0.12 * r]];
      if (shape === "house") return [[0, -r], [0.85 * r, -0.3 * r], [0.85 * r, r], [-0.85 * r, r], [-0.85 * r, -0.3 * r]];
      if (shape === "bolt") return [[0.25 * r, -r], [-0.6 * r, 0.1 * r], [0.02 * r, 0.1 * r], [-0.25 * r, r], [0.6 * r, -0.1 * r], [-0.02 * r, -0.1 * r]];
      return [[-r, -r], [-0.35 * r, -r], [-0.35 * r, 0.4 * r], [r, 0.4 * r], [r, r], [-r, r]];
    }
    function xformV(pts, rot, flip, cx, cy) {
      var a = (rot * Math.PI) / 180, ca = Math.cos(a), sa = Math.sin(a);
      return pts.map(function (p) { var x = flip ? -p[0] : p[0], y = p[1]; return [cx + x * ca - y * sa, cy + x * sa + y * ca]; });
    }
    /* plan.rotated forces the rotated or the fixed task at any rung (rungs 5 and 6 rotate by default);
       plan.target picks the shape, plan.avoidTargets and plan.avoid steer away from recent ones */
    function buildHidden(rung, plan) {
      var allowRot = plan && plan.rotated != null ? !!plan.rotated : rung >= 5;
      var mode = allowRot ? "rot" : "fixed";
      var pool = HIDE_TARGETS.slice();
      /* a spun square is a diamond, so neither is a fair rotated target */
      if (allowRot) pool = pool.filter(function (s) { return s !== "square" && s !== "diamond"; });
      var avoidT = (plan && plan.avoidTargets) || [], narrowed = pool.filter(function (s) { return avoidT.indexOf(s) < 0; });
      if (narrowed.length) pool = narrowed;
      /* a recent target is avoided whichever way up it was served: "hexagon|fixed" in the history
         rules out "hexagon|rot" too, so a rung change does not bring the same shape straight back */
      var recentT = {};
      ((plan && plan.avoid) || []).forEach(function (v) { recentT[String(v).split("|")[0]] = true; });
      /* plan.target used to bypass the pool, which let a test plan ask for a rotated
         square - and a spun square is a diamond */
      var planned = plan && plan.target && pool.indexOf(plan.target) >= 0 ? plan.target : null;
      var target = planned || flPickAvoiding(pool, { avoid: Object.keys(recentT) }, function (s) { return s; });
      var alias = { square: ["diamond"], diamond: ["square"] };
      /* Clutter for this question: the rung fixes how many lines join the target to the frame and how
         many chords cross the target; the frame polygon and the number of chords across the frame are
         drawn from the rung's band, so one test shows a spread of pictures rather than one look. */
      var rr = clamp(rung, 1, 6) - 1;
      /* The size decoys step by about two fifths of the target, so "a size bigger" reads as a
         different size at option size rather than as a wobble. The bigger one has to fit inside
         the frame with room to spare, or a child can throw it out on the frame alone without ever
         looking at the shape. "Radius" is not the same as reach: an L-shape or a Z-shape puts its
         far corner about 1.4 radii out, so the frame is chosen, and the target drawn, against the
         shape's real reach. A square frame is out entirely: its inradius is only 33. */
      var HIDE_FRAME_R = 46, HIDE_R = 24;
      var frameInradius = function (n) { return HIDE_FRAME_R * Math.cos(Math.PI / n); };
      var reach = flShapeReach(target);
      var bigWant = [10, 10, 10, 10, 10, 9][rr], small = [10, 9, 9, 8, 8, 7][rr], tilt = [35, 30, 25, 20, 20, 15][rr];
      if (allowRot && rung >= 5) { small = 7; bigWant = 9; }
      var frameBand = [5, 6, 8];
      var roomFor = function (n) { return (frameInradius(n) - 2.5) / reach; };
      var frameFits = frameBand.filter(function (n) { return HIDE_R + bigWant <= roomFor(n); });
      var frameN = pick(frameFits.length ? frameFits : [Math.max.apply(null, frameBand)]);
      /* a wide-reaching shape is drawn smaller so the size step survives; the prompt uses the
         same radius, so "at exactly the size shown" still holds */
      var tr = clamp(Math.floor(roomFor(frameN) - bigWant), 14, HIDE_R);
      var big = Math.max(4, Math.min(bigWant, Math.floor(roomFor(frameN) - tr)));
      small = Math.max(4, Math.min(small, tr - 8));
      var frameChords = Math.min(2, [0, 1, 1, 1, 2, 2][clamp(rung, 1, 6) - 1] + (ri(3) === 0 ? 1 : 0));
      var frameName = { 4: "square", 5: "pentagon", 6: "hexagon", 8: "octagon" }[frameN] || "polygon";
      /* A picture like the real paper: the target inside a tidy outer frame (a regular
         polygon), with straight lines joining target corners to frame corners, a few
         chords across the frame and, from rung 3, chords across the target itself.
         Everything stays inside the frame, so it reads as a figure, not a scribble. */
      /* every option is built through this, and it reports whether the shape really
         landed inside its frame; a question that cannot place one is thrown away */
      /* How far each side runs past its own corners, as a fraction of the way to the
         frame: at level 1 a side pokes out a little, by level 5 it runs all the way. */
      var reachOut = [[0.12, 0.3], [0.2, 0.45], [0.3, 0.6], [0.42, 0.72], [0.5, 0.8], [0.55, 0.85]][rr];
      function composite(shape, r, rot, flip, highlight) {
        var frameR = HIDE_FRAME_R, frameStart = pick([0, 15, 30, 45]);
        var frame = [];
        for (var fk = 0; fk < frameN; fk++) { var fa = ((frameStart + (360 / frameN) * fk) * Math.PI) / 180; frame.push([50 + frameR * Math.cos(fa), 50 + frameR * Math.sin(fa)]); }
        var cx = 46 + ri(9), cy = 46 + ri(9);
        var v = xformV(shapeV(shape, r), rot, flip, cx, cy);
        /* keep the target inside the frame: pull it to the middle if a corner pokes out */
        /* a corner is only in if it is a clear margin inside the frame, not just on the line */
        var inside = function (pt) { return ppInPoly(pt, frame) && ppEdgeDist(pt, frame) >= 1.5; };
        for (var guard = 0; guard < 14 && !v.every(inside); guard++) { cx += (50 - cx) * 0.45; cy += (50 - cy) * 0.45; v = xformV(shapeV(shape, r), rot, flip, cx, cy); }
        if (!v.every(inside)) return null;
        var segs = [];
        /* The shape is NOT drawn as an outline. Every side is drawn as part of a longer
           line that runs past both of its corners, so the corners are crossings in the
           picture rather than the ends of a closed figure, and the shape has to be traced
           out of the drawing instead of being spotted as a separate object. */
        var i, sideOk = true;
        for (i = 0; i < v.length; i++) {
          var a = v[i], b2 = v[(i + 1) % v.length];
          var run = flRunToFrame(a, b2, frame);
          if (!run) { sideOk = false; break; }
          var back = reachOut[0] + Math.random() * (reachOut[1] - reachOut[0]);
          var fwd = reachOut[0] + Math.random() * (reachOut[1] - reachOut[0]);
          var t0 = run[0] * back, t1 = 1 + (run[1] - 1) * fwd;
          segs.push([a[0] + (b2[0] - a[0]) * t0, a[1] + (b2[1] - a[1]) * t0,
                     a[0] + (b2[0] - a[0]) * t1, a[1] + (b2[1] - a[1]) * t1]);
        }
        if (!sideOk) return null;
        /* clutter: lines from a corner out to the frame, and chords across the frame */
        /* the top levels get their difficulty from the shape being buried in longer
           lines, not from sheer line count: past about seven extra lines the picture
           turns into a mesh and the shape cannot be traced at all */
        var nConnect = [2, 2, 3, 3, 3, 3][clamp(rung, 1, 6) - 1];
        var usedV = {}, usedF = {};
        for (i = 0; i < nConnect; i++) {
          var vi = ri(v.length), fi = ri(frame.length), tries = 0;
          while ((usedV[vi] || usedF[fi]) && tries++ < 12) { vi = ri(v.length); fi = ri(frame.length); }
          if (usedV[vi] || usedF[fi]) break;
          usedV[vi] = true; usedF[fi] = true;
          segs.push([v[vi][0], v[vi][1], frame[fi][0], frame[fi][1]]);
        }
        var usedC = {};
        for (var c = 0; c < frameChords; c++) {
          var a1 = ri(frame.length), a2 = (a1 + 2 + ri(Math.max(1, frame.length - 3))) % frame.length;
          var ck = Math.min(a1, a2) + "-" + Math.max(a1, a2);
          if (usedC[ck] || a1 === a2) continue;
          usedC[ck] = true;
          segs.push([frame[a1][0], frame[a1][1], frame[a2][0], frame[a2][1]]);
        }
        var d2 = "<polygon points='" + ptsStr(frame) + "' fill='none' stroke='" + SR_NAVY + "' stroke-width='2.8' stroke-linejoin='round'/>";
        for (var s4 = 0; s4 < segs.length; s4++) d2 += "<line x1='" + fx(segs[s4][0]) + "' y1='" + fx(segs[s4][1]) + "' x2='" + fx(segs[s4][2]) + "' y2='" + fx(segs[s4][3]) + "' stroke='" + SR_NAVY + "' stroke-width='2.8' stroke-linecap='round'/>";
        var plain = svgBox(d2, "0 0 100 100", HIDE_ART, HIDE_ART, "a line picture inside " + flArticle(frameName) + " frame");
        var lit = highlight ? svgBox(d2 + "<polygon points='" + ptsStr(v) + "' fill='rgba(244,120,32,0.22)' stroke='" + SR_ORANGE + "' stroke-width='3.6' stroke-linejoin='round'/>", "0 0 100 100", HIDE_ART, HIDE_ART, "the picture with the hidden " + SHAPEDESC[shape] + " shaded orange") : null;
        /* the corners the shape really landed on, so the audit and the tests can see
           what is meant to be in the picture without reading it back out of the SVG */
        return { html: plain, reveal: lit, verts: v };
      }
      var others = HIDE_TARGETS.filter(function (s) { return s !== target && (alias[target] || []).indexOf(s) < 0 && !(allowRot && (s === "square" || s === "diamond")); });
      var chiralT = HIDE_CHIRAL.indexOf(target) >= 0;
      /* a second look-alike must not repeat the first, or two wrong answers carry the
         same reason and the child has one fewer thing to tell apart */
      function near(not) {
        var skip = not ? [].concat(not) : [];
        var free = others.filter(function (sh) { return skip.indexOf(sh) < 0; });
        var n = (NEARMISS[target] || []).filter(function (sh) { return free.indexOf(sh) >= 0; });
        return n.length ? pick(n) : (free.length ? pick(free) : null);
      }
      var decoys, notes;
      var alike = function (s) { return "a look-alike, " + flArticle(SHAPEDESC[s]) + " rather than " + flArticle(SHAPEDESC[target]); };
      if (allowRot) {
        var n1 = near(), n2 = near(n1);
        if (!n1 || (!chiralT && !n2)) return null;
        decoys = [{ s: n1, r: tr, rot: 15 * ri(24), f: false }, { s: target, r: tr - small, rot: 15 * ri(24), f: false }, { s: target, r: tr + big, rot: 15 * ri(24), f: false }, chiralT ? { s: target, r: tr, rot: 15 * ri(24), f: true } : { s: n2, r: tr, rot: 15 * ri(24), f: false }];
        notes = [alike(n1), "the same shape but a size smaller", "the same shape but a size bigger", chiralT ? "a mirror image of the shape" : alike(n2)];
      } else {
        var n0 = near(), flipIt = chiralT && rung >= 3;
        if (!n0) return null;
        decoys = [{ s: n0, r: tr, rot: 0, f: false }, { s: target, r: tr - small, rot: 0, f: false }, { s: target, r: tr + big, rot: 0, f: false }, flipIt ? { s: target, r: tr, rot: 0, f: true } : { s: target, r: tr, rot: tilt, f: false }];
        notes = [alike(n0), "the same shape but a size smaller", "the same shape but a size bigger", flipIt ? "a mirror image of the shape" : "the same shape tilted by " + tilt + " degrees"];
      }
      /* at the rotated levels the answer has to be genuinely turned, or the level's own
         promise ("it may be turned") is empty and the question is a level 4 in disguise */
      var correctRot = allowRot ? flVisibleTurn(shapeV(target, tr)) : 0;
      var right = composite(target, tr, correctRot, false, true);
      if (!right) return null;
      var opts = [{ html: right.html, revealHtml: right.reveal, sig: right.html, isCorrect: true, verts: right.verts }];
      var placed = true;
      decoys.forEach(function (d, di) {
        var c = composite(d.s, d.r, d.rot, d.f, false);
        if (!c) { placed = false; return; }
        opts.push({ html: c.html, sig: c.html, isCorrect: false, note: notes[di], verts: c.verts });
      });
      if (!placed) return null;
      /* the picture as a whole, not just the outline planted in it: exactly one option
         may contain the shape, and the one that does has to be the right one */
      var audit = flHiddenAudit(opts, shapeV(target, tr), allowRot);
      if (!audit.ok) { HIDE_AUDIT.rejected++; return null; }
      HIDE_AUDIT.passed++;
      var promptSvg = svgBox("<polygon points='" + ptsStr(xformV(shapeV(target, tr), 0, false, 50, 50)) + "' fill='none' stroke='" + SR_NAVY + "' stroke-width='2.8' stroke-linejoin='round'/>", "0 0 100 100", HIDE_ART, HIDE_ART, "the shape to find, " + flArticle(SHAPEDESC[target]));
      var prompt = allowRot
        ? "This shape is hidden in one picture. It is the same size but may be rotated. Which picture contains it?"
        : "This shape is hidden in one picture. It is the same size and is not rotated. Which picture contains it?";
      var sideCount = shapeV(target, tr).length;
      var explain = "Only one picture has the " + SHAPEDESC[target] + " at exactly the size shown" + (allowRot ? ", turned round" : ", the same way up") +
        ", with all " + sideCount + " of its sides drawn as lines of the picture inside the " + frameName + " frame.";
      return finishQ({
        typeId: "hidden", door: "hidden",
        variant: target + "|" + mode,
        /* the prompt shape has to render at the same width as an option picture */
        matchArt: true,
        /* the turn the answer was given, so a test can prove a rotated level rotates */
        turn: correctRot,
        prompt: prompt,
        stimulusHtml: figureHtml(promptSvg, "is hiding in one of these, at this size"),
        options: opts,
        rule: "Trace the shape side by side at exactly the size shown: check the size first, then the angle of every side.",
        hint: HIDE_HINTS[target] || ("Look for " + flArticle(SHAPEDESC[target]) + " with all " + sideCount + " of its sides drawn as lines of the picture, at exactly the size shown."),
        explanation: explain
      });
    }
    /* ============================================================
       15. PAPER FOLDING
       One model for the question and the lab. The sheet is the unit square.
       Every piece of paper carries the affine map from sheet coordinates to
       where it lies in the folded layout, plus a layer number. Folding clips
       every piece along the fold line, reflects the moving half and stacks it
       on top. A hole punched through the stack is mapped back through each
       layer's map, which is exactly what the child sees when the paper opens.
       ============================================================ */
    var AF_ID = [1, 0, 0, 1, 0, 0];
    function afApply(m, p) { return [m[0] * p[0] + m[1] * p[1] + m[4], m[2] * p[0] + m[3] * p[1] + m[5]]; }
    function afMul(m2, m1) {
      return [m2[0] * m1[0] + m2[1] * m1[2], m2[0] * m1[1] + m2[1] * m1[3], m2[2] * m1[0] + m2[3] * m1[2], m2[2] * m1[1] + m2[3] * m1[3],
        m2[0] * m1[4] + m2[1] * m1[5] + m2[4], m2[2] * m1[4] + m2[3] * m1[5] + m2[5]];
    }
    function afInv(m) {
      var det = m[0] * m[3] - m[1] * m[2];
      var a = m[3] / det, b = -m[1] / det, c = -m[2] / det, d = m[0] / det;
      return [a, b, c, d, -(a * m[4] + b * m[5]), -(c * m[4] + d * m[5])];
    }
    /* fold: { a, b, side, kind }: the line through a and b; points with cross * side > 0 move */
    function ppCross(fold, p) { return (fold.b[0] - fold.a[0]) * (p[1] - fold.a[1]) - (fold.b[1] - fold.a[1]) * (p[0] - fold.a[0]); }
    function ppDist(fold, p) { return (ppCross(fold, p) * fold.side) / (Math.hypot(fold.b[0] - fold.a[0], fold.b[1] - fold.a[1]) || 1); }
    function ppReflect(fold) {
      var ux = fold.b[0] - fold.a[0], uy = fold.b[1] - fold.a[1], L = Math.hypot(ux, uy) || 1;
      ux /= L; uy /= L;
      var r00 = 2 * ux * ux - 1, r01 = 2 * ux * uy, r10 = r01, r11 = 2 * uy * uy - 1;
      return [r00, r01, r10, r11, fold.a[0] - (r00 * fold.a[0] + r01 * fold.a[1]), fold.a[1] - (r10 * fold.a[0] + r11 * fold.a[1])];
    }
    function ppClip(poly, fold, moving) {
      var out = [];
      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        var fa = ppDist(fold, a) * (moving ? 1 : -1), fb = ppDist(fold, b) * (moving ? 1 : -1);
        if (fa >= -1e-9) out.push(a);
        if ((fa >= -1e-9) !== (fb >= -1e-9)) { var t = fa / (fa - fb); out.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
      }
      return out.length >= 3 ? out : null;
    }
    function ppArea(poly) { return polyAreaAbs(poly); }
    function ppInPoly(pt, poly) {
      var c = false;
      for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
        if (((poly[i][1] > pt[1]) !== (poly[j][1] > pt[1])) && (pt[0] < ((poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1])) / (poly[j][1] - poly[i][1]) + poly[i][0])) c = !c;
      }
      return c;
    }
    function ppEdgeDist(pt, poly) {
      var best = Infinity;
      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        var vx = b[0] - a[0], vy = b[1] - a[1], L2 = vx * vx + vy * vy || 1;
        var t = Math.max(0, Math.min(1, ((pt[0] - a[0]) * vx + (pt[1] - a[1]) * vy) / L2));
        best = Math.min(best, Math.hypot(pt[0] - (a[0] + vx * t), pt[1] - (a[1] + vy * t)));
      }
      return best;
    }
    /* born: the index of the last fold that moved the piece (0 = never moved).
       hist: every fold index that moved it, in order, so the explanation can
       tell which pieces lie flat again once the last few folds are open. */
    function ppStart() { return [{ lp: [[0, 0], [1, 0], [1, 1], [0, 1]], m: AF_ID.slice(), layer: 0, born: 0, hist: [] }]; }
    function ppFold(pieces, fold, idx) {
      var R = ppReflect(fold), M = 0;
      pieces.forEach(function (p) { M = Math.max(M, p.layer); });
      var out = [];
      pieces.forEach(function (p) {
        var stay = ppClip(p.lp, fold, false), move = ppClip(p.lp, fold, true);
        if (stay && ppArea(stay) > 1e-5) out.push({ lp: stay, m: p.m, layer: p.layer, born: p.born, hist: p.hist || [] });
        if (move && ppArea(move) > 1e-5) out.push({ lp: move.map(function (q) { return afApply(R, q); }), m: afMul(R, p.m), layer: 2 * M + 1 - p.layer, born: idx, hist: (p.hist || []).concat([idx]) });
      });
      return out;
    }
    function ppStates(folds) {
      var states = [ppStart()];
      folds.forEach(function (f, i) { states.push(ppFold(states[i], f, i + 1)); });
      return states;
    }
    function ppBBox(pieces) {
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      pieces.forEach(function (p) { p.lp.forEach(function (q) { x0 = Math.min(x0, q[0]); x1 = Math.max(x1, q[0]); y0 = Math.min(y0, q[1]); y1 = Math.max(y1, q[1]); }); });
      return { x0: x0, y0: y0, x1: x1, y1: y1 };
    }
    /* A fold of a given kind laid over the current footprint. */
    function ppMakeFold(pieces, kind, dir) {
      var bb = ppBBox(pieces), w = bb.x1 - bb.x0, h = bb.y1 - bb.y0;
      var f = { kind: kind, dir: dir };
      if (kind === "v" || kind === "vq") {
        var xm = kind === "v" ? bb.x0 + w / 2 : (dir === "r" ? bb.x0 + w * 0.75 : bb.x0 + w * 0.25);
        f.a = [xm, bb.y0 - 1]; f.b = [xm, bb.y1 + 1];
        f.probe = [dir === "r" ? bb.x1 : bb.x0, bb.y0 + h / 2];
        f.text = kind === "v" ? ("Fold the " + (dir === "r" ? "right" : "left") + " half over") : ("Fold the " + (dir === "r" ? "right" : "left") + " quarter over");
      } else if (kind === "h" || kind === "hq") {
        var ym = kind === "h" ? bb.y0 + h / 2 : (dir === "b" ? bb.y0 + h * 0.75 : bb.y0 + h * 0.25);
        f.a = [bb.x0 - 1, ym]; f.b = [bb.x1 + 1, ym];
        f.probe = [bb.x0 + w / 2, dir === "b" ? bb.y1 : bb.y0];
        f.text = kind === "h" ? ("Fold the " + (dir === "b" ? "bottom half up" : "top half down")) : ("Fold the " + (dir === "b" ? "bottom quarter up" : "top quarter down"));
      } else if (kind === "d1") {
        f.a = [bb.x0, bb.y0]; f.b = [bb.x1, bb.y1];
        f.probe = dir === "r" ? [bb.x1, bb.y0] : [bb.x0, bb.y1];
        f.text = "Fold corner to corner, " + (dir === "r" ? "top right" : "bottom left") + " over";
      } else {
        f.a = [bb.x1, bb.y0]; f.b = [bb.x0, bb.y1];
        f.probe = dir === "r" ? [bb.x1, bb.y1] : [bb.x0, bb.y0];
        f.text = "Fold corner to corner, " + (dir === "r" ? "bottom right" : "top left") + " over";
      }
      var c = ppCross(f, f.probe);
      f.side = c > 0 ? 1 : -1;
      return f;
    }
    function ppBuildFolds(kinds) {
      var pieces = ppStart(), folds = [];
      kinds.forEach(function (kd) {
        var f = ppMakeFold(pieces, kd.kind, kd.dir);
        folds.push(f);
        pieces = ppFold(pieces, f, folds.length);
      });
      return folds;
    }
    /* hole shapes as small polygons in layout coordinates, r in sheet units */
    function ppHolePoly(kind, pt, r) {
      if (kind === "tri") return [[pt[0], pt[1] - r * 1.15], [pt[0] + r * 1.1, pt[1] + r * 0.75], [pt[0] - r * 1.1, pt[1] + r * 0.75]];
      if (kind === "square") return [[pt[0] - r * 0.9, pt[1] - r * 0.9], [pt[0] + r * 0.9, pt[1] - r * 0.9], [pt[0] + r * 0.9, pt[1] + r * 0.9], [pt[0] - r * 0.9, pt[1] + r * 0.9]];
      if (kind === "diamond") return [[pt[0], pt[1] - r * 1.15], [pt[0] + r * 1.15, pt[1]], [pt[0], pt[1] + r * 1.15], [pt[0] - r * 1.15, pt[1]]];
      var out = [];
      for (var t = 0; t < 12; t++) { var a = (t / 12) * Math.PI * 2; out.push([pt[0] + r * Math.cos(a), pt[1] + r * Math.sin(a)]); }
      return out;
    }
    var PP_R = 0.065;
    /* Holes shrink with the folded footprint: three folds leave an eighth of the sheet. */
    function ppHoleR(pieces, nHoles) { var bb = ppBBox(pieces); return clamp(Math.min(bb.x1 - bb.x0, bb.y1 - bb.y0) / (nHoles >= 2 ? 10 : 7), 0.03, PP_R); }
    /* Punch at a layout point: one hole through every piece under it, each mapped
       back to the sheet through that layer's map (so a triangle flips when its layer did). */
    function ppPunch(pieces, pt, kind, r) {
      r = r || ppHoleR(pieces);
      var lay = ppHolePoly(kind, pt, r), out = [];
      pieces.forEach(function (p) {
        if (!ppInPoly(pt, p.lp)) return;
        var inv = afInv(p.m);
        out.push({ sheet: lay.map(function (q) { return afApply(inv, q); }), kind: kind, layer: p.layer, born: p.born, hist: p.hist || [], pt: pt, r: r, centre: afApply(inv, pt) });
      });
      return out;
    }
    /* ---- punching by hand ----
       Can a hole go at this layout point? It has to sit on the folded stack, far
       enough in from the edge for a whole hole and clear of the holes already made. */
    function ppTopPieces(pieces) {
      var top = 0; pieces.forEach(function (p) { top = Math.max(top, p.layer); });
      return pieces.filter(function (p) { return p.layer === top; });
    }
    function ppPunchable(pieces, pt, r, avoid) {
      var tops = ppTopPieces(pieces), on = false;
      for (var i = 0; i < tops.length && !on; i++) {
        if (ppInPoly(pt, tops[i].lp) && ppEdgeDist(pt, tops[i].lp) >= r * 1.02) on = true;
      }
      if (!on) return "off";
      /* far enough apart that two holes do not merge into a blob, and no further: the lab
         is for filling a sheet with holes, so the rule is "they must not touch", not
         "leave a polite gap" */
      var clash = (avoid || []).some(function (q) { return Math.hypot(q[0] - pt[0], q[1] - pt[1]) < r * 2.25; });
      return clash ? "close" : "";
    }
    /* A tap lands where a finger lands, so a tap on the paper that is a little too
       near an edge or an old hole slides to the nearest spot that does work rather
       than doing nothing. Returns null only when the tap is nowhere near the paper. */
    function ppNearestPunch(pieces, pt, r, avoid) {
      if (!ppPunchable(pieces, pt, r, avoid)) return pt;
      var tops = ppTopPieces(pieces), near = false;
      for (var i = 0; i < tops.length && !near; i++) {
        if (ppInPoly(pt, tops[i].lp) || ppEdgeDist(pt, tops[i].lp) <= r * 2) near = true;
      }
      if (!near) return null;
      for (var ring = 1; ring <= 14; ring++) {
        var rad = ring * r * 0.35, best = null, bestD = Infinity;
        for (var a = 0; a < 24; a++) {
          var th = (a / 24) * Math.PI * 2;
          var q = [pt[0] + rad * Math.cos(th), pt[1] + rad * Math.sin(th)];
          if (ppPunchable(pieces, q, r, avoid)) continue;
          var d = Math.hypot(q[0] - pt[0], q[1] - pt[1]);
          if (d < bestD) { bestD = d; best = q; }
        }
        if (best) return best;
      }
      return null;
    }
    /* The folded stack seen from straight above, drawn on the sheet it came from:
       the dashed square is the whole sheet, the solid shape is the paper the punch
       would go through, and the marks are the holes already made. */
    function ppFoldedTopSvg(pieces, punchPts, r, o) {
      o = o || {};
      var sc = function (q) { return [q[0] * 100, q[1] * 100]; };
      var body = "<rect x='0' y='0' width='100' height='100' fill='#eceff5' stroke='#9aa8bf' stroke-width='1.2' stroke-dasharray='4 3'/>";
      pieces.forEach(function (p) {
        body += "<polygon points='" + ptsStr(p.lp.map(sc)) + "' fill='" + SR_PAPER + "' stroke='" + SR_NAVY + "' stroke-width='1.6' stroke-linejoin='round'/>";
      });
      (punchPts || []).forEach(function (pt) {
        body += "<circle cx='" + fx(pt[0] * 100) + "' cy='" + fx(pt[1] * 100) + "' r='" + fx((r || 0.05) * 100) + "' fill='#ffffff' stroke='" + SR_ORANGE + "' stroke-width='2.4'/>";
      });
      return svgBox(body, "-1 -1 102 102", o.width || 200, o.width || 200, o.label === undefined ? "the folded paper on the sheet" : o.label);
    }
    function ppRandomPoint(pieces, avoid, r) {
      r = r || ppHoleR(pieces);
      var top = 0; pieces.forEach(function (p) { top = Math.max(top, p.layer); });
      var tops = pieces.filter(function (p) { return p.layer === top; });
      for (var t = 0; t < 200; t++) {
        var piece = pick(tops), bb = ppBBox([piece]);
        var pt = [bb.x0 + Math.random() * (bb.x1 - bb.x0), bb.y0 + Math.random() * (bb.y1 - bb.y0)];
        if (!ppInPoly(pt, piece.lp) || ppEdgeDist(pt, piece.lp) < r * 2.2) continue;
        var clash = (avoid || []).some(function (q) { return Math.hypot(q[0] - pt[0], q[1] - pt[1]) < r * 4.2; });
        if (!clash) return pt;
      }
      return null;
    }
    /* A hole set is drawable when every hole sits inside the sheet and no two
       holes touch, so a wrong option never shows as a smudge of overlapping holes. */
    function ppHoleCentre(h) { return h.centre || flCentroid(h.sheet); }
    function ppHolesOk(hs) {
      if (!hs.length) return false;
      for (var i = 0; i < hs.length; i++) {
        var c = ppHoleCentre(hs[i]), r = hs[i].r || PP_R;
        if (c[0] < r * 1.4 || c[0] > 1 - r * 1.4 || c[1] < r * 1.4 || c[1] > 1 - r * 1.4) return false;
        for (var j = i + 1; j < hs.length; j++) {
          var d = ppHoleCentre(hs[j]);
          /* 3.6 radii between centres leaves a clear gap of 1.6 radii; at 2.4 two holes read as one blob */
          if (Math.hypot(c[0] - d[0], c[1] - d[1]) < Math.max(r, hs[j].r || PP_R) * 3.6) return false;
        }
      }
      return true;
    }
    /* Two options are the same option when they DRAW the same thing, which is not the same
       as carrying the same point list: a triangle mirrored across a vertical crease lands on
       exactly its own three corners in a different order. Sorting the corners inside each
       hole as well as sorting the holes makes those collide, so the duplicate check throws
       the decoy out instead of shipping two identical squares with one marked wrong. */
    function ppHoleSig(holes) {
      return holes.map(function (h) {
        return h.sheet.map(function (p) { return Math.round(p[0] * 100) + "," + Math.round(p[1] * 100); }).sort().join(" ");
      }).sort().join("|");
    }
    /* Fold lines carried back onto the flat sheet: every fold, clipped to every piece then existing.
       minIdx (1-based, optional) keeps only folds from that index on, for the stage sheets. */
    function ppFoldLinesSheet(folds, minIdx) {
      var states = ppStates(folds), segs = [];
      folds.forEach(function (f, i) {
        if (minIdx && i + 1 < minIdx) return;
        states[i].forEach(function (p) {
          var inv = afInv(p.m);
          var dx = f.b[0] - f.a[0], dy = f.b[1] - f.a[1];
          var far = [f.a[0] - dx * 5, f.a[1] - dy * 5], near = [f.b[0] + dx * 5, f.b[1] + dy * 5];
          /* clip the long line to the piece by clipping a thin strip */
          var strip = [far, near, [near[0] + 1e-4, near[1] + 1e-4]];
          var inside = p.lp;
          var pts = [];
          for (var e = 0; e < inside.length; e++) {
            var a = inside[e], b = inside[(e + 1) % inside.length];
            var ca = ppCross(f, a), cb = ppCross(f, b);
            if ((ca > 0) !== (cb > 0) && Math.abs(ca - cb) > 1e-12) { var t = ca / (ca - cb); pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
          }
          void strip;
          if (pts.length >= 2) segs.push([afApply(inv, pts[0]), afApply(inv, pts[pts.length - 1])]);
        });
      });
      return segs;
    }
    function ppSheetSvg(holes, o) {
      o = o || {};
      var s = "<rect x='0' y='0' width='100' height='100' fill='" + SR_PAPER + "' stroke='" + SR_NAVY + "' stroke-width='1.6'/>";
      (o.lines || []).forEach(function (sg) { s += "<line x1='" + fx(sg[0][0] * 100) + "' y1='" + fx(sg[0][1] * 100) + "' x2='" + fx(sg[1][0] * 100) + "' y2='" + fx(sg[1][1] * 100) + "' stroke='#ffffff' stroke-width='2' stroke-dasharray='4 3'/>"; });
      holes.forEach(function (h) { s += "<polygon points='" + ptsStr(h.sheet.map(function (p) { return [p[0] * 100, p[1] * 100]; })) + "' fill='#ffffff' stroke='" + SR_NAVY + "' stroke-width='2.2' stroke-linejoin='round'/>"; });
      return svgBox(s, "-3 -3 106 106", o.width || 84, o.width || 84, o.label || "the paper unfolded");
    }
    /* One step diagram: the stack before fold k (solid), the sheet outline (dashed),
       the fold line and an arrow from the moving side over it. For the final
       diagram (no fold), the holes as punched. */
    function ppStepSvg(pieces, fold, holes, o) {
      o = o || {};
      var s = "<rect x='0' y='0' width='100' height='100' fill='none' stroke='" + SR_NAVY + "' stroke-width='1.8' stroke-dasharray='5 4'/>";
      pieces.forEach(function (p) { s += "<polygon points='" + ptsStr(p.lp.map(function (q) { return [q[0] * 100, q[1] * 100]; })) + "' fill='" + SR_PAPER + "' stroke='" + SR_NAVY + "' stroke-width='1.6' stroke-linejoin='round'/>"; });
      if (fold) {
        var bb = ppBBox(pieces);
        var pts = [];
        var box = [[bb.x0, bb.y0], [bb.x1, bb.y0], [bb.x1, bb.y1], [bb.x0, bb.y1]];
        for (var e = 0; e < 4; e++) {
          var a = box[e], b = box[(e + 1) % 4], ca = ppCross(fold, a), cb = ppCross(fold, b);
          if ((ca > 0) !== (cb > 0) && Math.abs(ca - cb) > 1e-12) { var t = ca / (ca - cb); pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
        }
        if (pts.length >= 2) s += "<line x1='" + fx(pts[0][0] * 100) + "' y1='" + fx(pts[0][1] * 100) + "' x2='" + fx(pts[1][0] * 100) + "' y2='" + fx(pts[1][1] * 100) + "' stroke='#ffffff' stroke-width='3'/>";
        /* arrow: from the moving side's centre over the line to its mirror image */
        var moving = [];
        pieces.forEach(function (p) { var mv = ppClip(p.lp, fold, true); if (mv) mv.forEach(function (q) { moving.push(q); }); });
        if (moving.length) {
          var cx = 0, cy = 0; moving.forEach(function (q) { cx += q[0]; cy += q[1]; }); cx /= moving.length; cy /= moving.length;
          var R = ppReflect(fold), mirror = afApply(R, [cx, cy]);
          var mx = (cx + mirror[0]) / 2, my = (cy + mirror[1]) / 2;
          var dx = mirror[0] - cx, dy = mirror[1] - cy, L = Math.hypot(dx, dy) || 1;
          var lift = 0.34;
          var ctrl = [mx - (dy / L) * lift * (o.liftSign || 1), my + (dx / L) * lift * (o.liftSign || 1)];
          var id = "srah" + Math.floor(Math.random() * 1e9);
          s += "<defs><marker id='" + id + "' viewBox='0 0 10 10' refX='8' refY='5' markerWidth='5' markerHeight='5' orient='auto-start-reverse'><path d='M0 0 L10 5 L0 10 Z' fill='" + SR_NAVY + "'/></marker></defs>";
          s += "<path d='M " + fx(cx * 100) + " " + fx(cy * 100) + " Q " + fx(ctrl[0] * 100) + " " + fx(ctrl[1] * 100) + " " + fx(mirror[0] * 100) + " " + fx(mirror[1] * 100) + "' fill='none' stroke='" + SR_NAVY + "' stroke-width='2.6' stroke-linecap='round' marker-end='url(#" + id + ")'/>";
        }
      }
      (holes || []).forEach(function (h) {
        var top = ppHolePoly(h.kind, h.pt, h.r || PP_R);
        s += "<polygon points='" + ptsStr(top.map(function (q) { return [q[0] * 100, q[1] * 100]; })) + "' fill='#ffffff' stroke='" + SR_NAVY + "' stroke-width='2.2' stroke-linejoin='round'/>";
      });
      var w = o.width || 100;
      return svgBox(s, "-36 -36 172 172", w, w, o.label || "fold step");
    }
    function ppStepsHtml(folds, holes, width) {
      var states = ppStates(folds), out = "";
      var cap = function (svg, text) { return "<div class='sr-stepfig'>" + svg + "<span class='sr-vlabel'>" + text + "</span></div>"; };
      folds.forEach(function (f, i) { out += cap(ppStepSvg(states[i], f, null, { width: width, label: "fold " + (i + 1) + " of " + folds.length + ": " + f.text }), "Fold " + (i + 1)); });
      var uniq = [], seenPt = {};
      holes.forEach(function (h) { var k = Math.round(h.pt[0] * 200) + "," + Math.round(h.pt[1] * 200); if (!seenPt[k]) { seenPt[k] = true; uniq.push(h); } });
      out += cap(ppStepSvg(states[folds.length], null, uniq, { width: width, label: "the paper folded " + ppTimes(folds.length) + ", with " + (uniq.length === 1 ? "one hole" : uniq.length + " holes") + " punched through every layer" }), "Punch");
      return out;
    }
    function ppTimes(n) { return n === 1 ? "once" : n === 2 ? "twice" : n + " times"; }
    /* ---- recipes ----
       The table is keyed by fold count, with straight and diagonal variants at
       every count, so a test plan asking for "2 folds, one diagonal" can be met
       at any rung. Every direction is drawn fresh each time. A rung's family
       (PP_RUNG_FAMILY) is what practice draws from when no plan says otherwise;
       the rung also fixes how many punches and which hole shapes.
       vq+h is the quarter-then-half fold (the mirror twin of hq+v): folding the
       half first and then a quarter of it leaves a strip too thin to hold a hole
       under the clearance rules, so that order never builds and is not listed. */
    var PP_RECIPES = {
      1: { straight: ["v", "h"], diag: ["d1", "d2"] },
      2: { straight: ["v+h", "h+v", "vq+h", "hq+v"], diag: ["d1+v", "v+d2", "h+d1", "d1+d2"] },
      3: { straight: ["v+h+v", "h+v+h"], diag: ["v+h+d1", "d1+d2+v", "v+d2+h"] }
    };
    var PP_RUNG_FAMILY = [
      { ids: ["v", "h"], holes: [1], shapes: ["circle", "square"] },
      { ids: ["v", "h"], holes: [2], shapes: ["circle", "tri", "square"] },
      { ids: ["v+h", "h+v"], holes: [1, 2], shapes: ["circle", "tri", "square"] },
      { ids: ["d1", "vq+h", "hq+v"], holes: [2], shapes: ["circle", "tri", "square", "diamond"] },
      { ids: ["v+h+v", "h+v+h", "d1+d2"], holes: [1, 2], shapes: ["circle", "tri", "square", "diamond"] },
      { ids: ["d1+v", "v+d2+h", "h+d1", "v+h+d1"], holes: [1, 2], shapes: ["circle", "tri", "square", "diamond"] }
    ];
    function ppIsDiag(id) { return /d[12]/.test(id); }
    function ppRecipeKinds(id) {
      return id.split("+").map(function (k) { return { kind: k, dir: k === "h" || k === "hq" ? pick(["t", "b"]) : pick(["l", "r"]) }; });
    }
    /* plan: { folds: 1|2|3, diagonal: bool } picks from the table, preferring the
       rung's own recipes when they fit; no plan means the rung's family as before. */
    /* the recipes a rung and plan may draw from, and the rung's family (punch counts, hole shapes) */
    function ppRecipePool(rung, plan) {
      plan = plan || {};
      var fam = PP_RUNG_FAMILY[clamp(rung || 1, 1, 6) - 1], pool, all;
      var tier = function (n) { var t = PP_RECIPES[n] || PP_RECIPES[2]; return plan.diagonal === true ? t.diag : plan.diagonal === false ? t.straight : t.straight.concat(t.diag); };
      if (plan.folds) {
        all = tier(plan.folds);
        var own = all.filter(function (id) { return fam.ids.indexOf(id) >= 0; });
        pool = own.length ? own : all;
      } else {
        pool = fam.ids.slice();
        if (plan.diagonal != null) {
          var want = !!plan.diagonal, fit = pool.filter(function (id) { return ppIsDiag(id) === want; });
          if (fit.length) pool = fit;
          else {
            var counts = {}; pool.forEach(function (id) { counts[id.split("+").length] = true; });
            pool = []; Object.keys(counts).forEach(function (n) { pool = pool.concat(tier(+n)); });
          }
        }
      }
      return { fam: fam, pool: pool };
    }
    /* plan._id / plan._holes (internal, set by buildFold's avoid retry) fix the recipe and the punch count */
    function ppRecipe(rung, plan) {
      plan = plan || {};
      var rp = ppRecipePool(rung, plan), fam = rp.fam, pool = rp.pool;
      var id = plan._id && pool.indexOf(plan._id) >= 0 ? plan._id : pick(pool);
      var holes = plan._holes && fam.holes.indexOf(plan._holes) >= 0 ? plan._holes : pick(fam.holes);
      return { id: id, kinds: ppRecipeKinds(id), holes: holes, kinds2: fam.shapes.slice(), diag: ppIsDiag(id) };
    }
    /* the fold in words for the explanation: "Folded left over right, then ..." */
    function ppFoldWords(kd) {
      var k = kd.kind, d = kd.dir;
      if (k === "v") return d === "r" ? "right over left" : "left over right";
      if (k === "h") return d === "b" ? "bottom over top" : "top over bottom";
      if (k === "vq") return "the " + (d === "r" ? "right" : "left") + " quarter over";
      if (k === "hq") return "the " + (d === "b" ? "bottom quarter up" : "top quarter down");
      if (k === "d1") return d === "r" ? "the top right corner down to the bottom left" : "the bottom left corner up to the top right";
      return d === "r" ? "the bottom right corner up to the top left" : "the top left corner down to the bottom right";
    }
    /* After opening folds nF down to k, the pieces moved only by folds k or later
       lie flat again, so their holes sit at their true places; the rest of the
       paper is still folded away. A hole with no history falls back to born. */
    function ppHoleOpenAt(h, k) {
      var hist = h.hist || (h.born ? [h.born] : []);
      for (var i = 0; i < hist.length; i++) if (hist[i] < k) return false;
      return true;
    }
    function ppHolesWord(n) { return n === 1 ? "one hole" : n + " holes"; }
    /* The unfolding, one crease at a time, as a row of small sheets: only for 2 or 3 folds. */
    function ppStagesHtml(folds, holes, width) {
      var nF = folds.length;
      if (nF < 2) return "";
      var cap = function (svg, text) { return "<div class='sr-stepfig'>" + svg + "<span class='sr-vlabel'>" + text + "</span></div>"; };
      var out = "";
      for (var k = nF; k >= 2; k--) {
        var open = holes.filter(function (x) { return ppHoleOpenAt(x, k); });
        out += cap(ppSheetSvg(open, { width: width, lines: ppFoldLinesSheet(folds, k), label: "after opening fold " + k + ": " + ppHolesWord(open.length) + " so far" }), "after opening fold " + k);
      }
      out += cap(ppSheetSvg(holes, { width: width, lines: ppFoldLinesSheet(folds), label: "fully open: " + ppHolesWord(holes.length) }), "fully open");
      return "<div class='sr-figrow sr-stages'>" + out + "</div>";
    }
    var PP_WHY = {};
    function ppWhy(k) { PP_WHY[k] = (PP_WHY[k] || 0) + 1; return null; }
    /* One fold-and-punch attempt for a rung and plan: null (counted in PP_WHY) when the
       punches do not fit. plan.maxHoles caps punches x layers, so a 16-hole sheet
       (two punches through three folds) only appears when the plan allows it. */
    function ppAttempt(rung, plan) {
      var rec = ppRecipe(rung, plan);
      var folds = ppBuildFolds(rec.kinds);
      var final = ppStates(folds)[folds.length];
      var deep = 0; final.forEach(function (p) { deep = Math.max(deep, p.layer + 1); });
      var punches = rec.holes;
      if (plan.maxHoles) punches = Math.max(1, Math.min(punches, Math.floor(plan.maxHoles / deep)));
      var holes = [], pts = [], kinds = shuffle(rec.kinds2.slice()), hr = ppHoleR(final, punches);
      if (rung >= 2 && kinds.indexOf("tri") >= 0) { kinds.splice(kinds.indexOf("tri"), 1); kinds.unshift("tri"); }
      for (var h = 0; h < punches; h++) {
        var pt = ppRandomPoint(final, pts, hr);
        if (!pt) return ppWhy("r" + rung + " no point for hole " + (h + 1));
        pts.push(pt);
        holes = holes.concat(ppPunch(final, pt, kinds[h % kinds.length], hr));
      }
      if (holes.length < 2) return ppWhy("r" + rung + " under 2 holes");
      if (plan.maxHoles && holes.length > plan.maxHoles) return ppWhy("r" + rung + " over " + plan.maxHoles + " holes");
      if (!ppHolesOk(holes)) return ppWhy("r" + rung + " holes overlap");
      return {
        rec: rec, folds: folds, holes: holes, pts: pts, kinds: kinds, hr: hr, punches: punches,
        variant: folds.length + "f|" + (rec.diag ? "diag" : "straight") + "|" + holes.length + "h"
      };
    }
    /* build(rung, plan). plan is optional: { folds, diagonal, maxHoles, avoid }.
       Up to 12 successful fold-and-punch draws (a punch that will not fit does
       not use one up; 60 raw tries at most) look for a variant not in plan.avoid,
       the practice history. After that the draw whose variant was served longest
       ago is used, so a rung whose family only makes one variant still serves a
       question and a forced repeat is the oldest one it can be. */
    function buildFold(rung, plan) {
      plan = plan || {};
      var avoid = plan.avoid && plan.avoid.length ? plan.avoid : null, best = null, bestAge = -1, drawn = 0;
      /* with a history to avoid, the retries walk every recipe x punch-count combination the rung
         allows, in a shuffled round, so a rare variant is reached by design rather than by luck */
      var combos = [];
      if (avoid) {
        var rp = ppRecipePool(rung, plan);
        rp.pool.forEach(function (id) { rp.fam.holes.forEach(function (h) { combos.push({ _id: id, _holes: h }); }); });
        combos = shuffle(combos);
      }
      for (var raw = 0; raw < 60 && drawn < 12; raw++) {
        var p2 = plan;
        if (combos.length) { var cb = combos[drawn % combos.length]; p2 = {}; Object.keys(plan).forEach(function (k) { p2[k] = plan[k]; }); p2._id = cb._id; p2._holes = cb._holes; }
        var a = ppAttempt(rung, p2);
        if (!a) continue;
        drawn++;
        if (!avoid || avoid.indexOf(a.variant) < 0) { best = a; break; }
        /* the oldest entry in the history is the most forgivable repeat */
        var age = avoid.length - avoid.lastIndexOf(a.variant);
        if (age > bestAge) { bestAge = age; best = a; }
      }
      if (!best) return null;
      var rec = best.rec, folds = best.folds, holes = best.holes, pts = best.pts, kinds = best.kinds, hr = best.hr;
      var nF = folds.length, last = nF;
      var correctSig = ppHoleSig(holes);
      var cands = [];
      var dropLast = holes.filter(function (x) { return x.born !== last; });
      if (dropLast.length && dropLast.length < holes.length) cands.push({ holes: dropLast, note: "the last fold has not been opened, so the holes on that side are missing" });
      /* wrong mirror line: the last fold across the other way */
      (function () {
        var alt = rec.kinds.slice(0, -1).concat([{ kind: { v: "h", h: "v", vq: "hq", hq: "vq", d1: "d2", d2: "d1" }[rec.kinds[nF - 1].kind], dir: pick(["l", "r", "t", "b"]) }]);
        var f2 = ppBuildFolds(alt), st2 = ppStates(f2)[nF], hs = [];
        pts.forEach(function (p, i) { hs = hs.concat(ppPunch(st2, p, kinds[i % kinds.length], hr)); });
        if (hs.length >= 2) cands.push({ holes: hs, note: "the copies are mirrored across the wrong line, so they sit on the wrong side" });
      })();
      /* the first fold mirrored the wrong way too, for two-fold recipes: a row instead of a square, or a column */
      if (nF >= 2) (function () {
        var alt = [{ kind: { v: "h", h: "v", vq: "hq", hq: "vq", d1: "d2", d2: "d1" }[rec.kinds[0].kind], dir: pick(["l", "r", "t", "b"]) }].concat(rec.kinds.slice(1));
        var f2 = ppBuildFolds(alt), st2 = ppStates(f2)[nF], hs = [];
        pts.forEach(function (p, i) { hs = hs.concat(ppPunch(st2, p, kinds[i % kinds.length], hr)); });
        if (hs.length >= 2) cands.push({ holes: hs, note: "the first fold has been mirrored across the wrong line" });
      })();
      /* not unfolded at all: only the punched holes, no copies */
      if (nF >= 2) {
        var born0 = holes.filter(function (x) { return x.born === 0; });
        if (born0.length && born0.length < holes.length) cands.push({ holes: born0, note: "the paper has not been unfolded: every fold adds copies" });
      }
      /* copies in the wrong corners: the last fold's copies swapped across the sheet's diagonal */
      (function () {
        var hs = holes.map(function (x) {
          if (x.born !== last) return x;
          return { sheet: x.sheet.map(function (p) { return [p[1], p[0]]; }), kind: x.kind, born: x.born, layer: x.layer, pt: x.pt, r: x.r };
        });
        cands.push({ holes: hs, note: "the copies are in the wrong corners" });
      })();
      /* spun instead of mirrored: the last fold's copies turned through 180 degrees about the middle of the sheet */
      (function () {
        var hs = holes.map(function (x) {
          if (x.born !== last) return x;
          return { sheet: x.sheet.map(function (p) { return [1 - p[0], 1 - p[1]]; }), kind: x.kind, born: x.born, layer: x.layer, pt: x.pt, r: x.r };
        });
        cands.push({ holes: hs, note: "the copies have been spun round the middle of the sheet instead of mirrored across the fold" });
      })();
      /* the asymmetric holes not flipped */
      if (holes.some(function (x) { return x.kind === "tri" && x.born > 0; })) {
        cands.push({ holes: holes.map(function (x) { if (x.kind !== "tri" || x.born === 0) return x; var c = x.centre; return { sheet: ppHolePoly("tri", c, x.r || PP_R), kind: x.kind, born: x.born, layer: x.layer, pt: x.pt, r: x.r }; }), note: "the copied triangle should point the other way: a reflection turns it over" });
      }
      cands.push({ holes: holes.slice(0, -1), note: "one hole is missing" });
      /* one hole too many: a copy reflected in whichever line keeps it clear of the others */
      [[1, 0], [0, 1], [1, 1]].some(function (ax) {
        var extra = { sheet: holes[0].sheet.map(function (p) { return [ax[0] ? 1 - p[0] : p[0], ax[1] ? 1 - p[1] : p[1]]; }), kind: holes[0].kind, born: 9, layer: 0, pt: holes[0].pt, r: holes[0].r };
        extra.centre = flCentroid(extra.sheet);
        var set = holes.concat([extra]);
        if (!ppHolesOk(set)) return false;
        cands.push({ holes: set, note: "one hole too many" });
        return true;
      });
      cands.push({ holes: holes.map(function (x) { var dx = ppHoleCentre(x)[0] > 0.5 ? -0.24 : 0.24; return { sheet: x.sheet.map(function (p) { return [p[0] + dx, p[1]]; }), kind: x.kind, born: x.born, layer: x.layer, pt: x.pt, r: x.r }; }), note: "the holes have slipped sideways" });
      cands.push({ holes: holes.map(function (x) { var dy = ppHoleCentre(x)[1] > 0.5 ? -0.24 : 0.24; return { sheet: x.sheet.map(function (p) { return [p[0], p[1] + dy]; }), kind: x.kind, born: x.born, layer: x.layer, pt: x.pt, r: x.r }; }), note: "the holes have slipped up or down" });
      /* the classic mistakes first, then whichever of the rest fit */
      cands = cands.slice(0, 2).concat(shuffle(cands.slice(2)));
      var optLabel = "an unfolded sheet of paper with holes in it";
      var opts = [{ html: ppSheetSvg(holes, { width: 132, label: optLabel }), sig: correctSig, isCorrect: true }];
      var used = {}; used[correctSig] = true;
      cands.forEach(function (cd) {
        if (opts.length >= 5) return;
        if (!ppHolesOk(cd.holes)) return;
        var sig = ppHoleSig(cd.holes);
        if (used[sig]) return;
        used[sig] = true;
        opts.push({ html: ppSheetSvg(cd.holes, { width: 132, label: optLabel }), sig: sig, isCorrect: false, note: cd.note });
      });
      if (opts.length < 5) return ppWhy("r" + rung + " only " + opts.length + " options");
      var triFlip = holes.some(function (x) { return x.kind === "tri" && x.born > 0; });
      /* the hole arithmetic from this sheet's own punches: layers under each punch point */
      var perPunch = [], seenPunch = {};
      holes.forEach(function (x) { var k = Math.round(x.pt[0] * 200) + "," + Math.round(x.pt[1] * 200); if (seenPunch[k] == null) { seenPunch[k] = perPunch.length; perPunch.push(0); } perPunch[seenPunch[k]]++; });
      var total = holes.length, sameDepth = perPunch.every(function (n) { return n === perPunch[0]; }), arith;
      if (perPunch.length === 1) arith = "The punch went through " + perPunch[0] + " layers, so the open sheet has " + total + " holes in all.";
      else if (sameDepth) arith = "Each punch went through " + perPunch[0] + " layers: " + perPunch.length + " punches times " + perPunch[0] + " layers makes " + total + " holes on the open sheet.";
      else if (perPunch.length === 2) arith = "One punch went through " + perPunch[0] + " layers and the other through " + perPunch[1] + ", so the open sheet has " + total + " holes in all.";
      else arith = "The punches went through " + listJoin(perPunch.map(String)) + " layers, so the open sheet has " + total + " holes in all.";
      var explain = "Folded " + rec.kinds.map(ppFoldWords).join(", then ") + ", then punched " + ppTimes(perPunch.length) + ". " + arith + (triFlip ? " The triangle flips over each time it crosses a crease, so its point swaps direction." : "");
      var q = {
        typeId: "folding", door: "folding",
        variant: best.variant,
        prompt: "The paper is folded as shown and holes are punched through every layer. Which square shows the paper after it is fully unfolded?",
        stimulusHtml: "<div class='sr-figrow sr-foldsteps'>" + ppStepsHtml(folds, holes, 196) + "</div>",
        options: opts,
        rule: "Open one crease at a time, last fold first: each crease is a mirror, so every hole gets a copy the same distance away across it.",
        hint: "Count how many layers the punch goes through, then unfold one crease at a time.",
        explanation: explain,
        review: { kind: "fold", folds: folds, holes: holes }
      };
      var stages = ppStagesHtml(folds, holes, 92);
      if (stages) q.explainHtml = stages;
      return finishQ(q);
    }
    /* ---- the 3D scene for the lab and the replay ---- */
    var PP_EPS = 0.012;
    /* label: the svg's accessible name; pass false when a focusable wrapper carries the name */
    /* One point of a turning flap: the sheet point p on its layer, swung phi about the crease. */
    function ppLift(p, z0, fold, phi, zT) {
      var ux = fold.b[0] - fold.a[0], uy = fold.b[1] - fold.a[1], L = Math.hypot(ux, uy) || 1; ux /= L; uy /= L;
      var nx = -uy * fold.side, ny = ux * fold.side;
      var rel = [p[0] - fold.a[0], p[1] - fold.a[1]];
      var along = rel[0] * ux + rel[1] * uy, dist = rel[0] * nx + rel[1] * ny;
      var foot = [fold.a[0] + ux * along, fold.a[1] + uy * along];
      var dn = dist * Math.cos(phi) - (z0 - zT) * Math.sin(phi);
      var dz = zT + dist * Math.sin(phi) + (z0 - zT) * Math.cos(phi);
      return [foot[0] + nx * dn, foot[1] + ny * dn, dz];
    }
    /* The box the paper needs at this camera, over EVERY stage of the fold and
       the flap mid-swing, so the frame is the same from flat to folded and the
       shape never grows out of its picture. Cached per folds + camera. */
    var PP_FRAMES = {}, PP_FRAME_KEYS = [];
    function ppFrame(folds, cam, s) {
      var key = folds.map(function (f) { return f.kind + f.dir + fx(f.a[0]) + fx(f.a[1]) + fx(f.b[0]) + fx(f.b[1]) + f.side; }).join("|") +
        "@" + Math.round((cam.yaw || 0) / 2) + "," + Math.round((cam.pitch || 0) / 2) + "," + s;
      if (PP_FRAMES[key]) return PP_FRAMES[key];
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      function add(p3) {
        var q = vxProject(cam, p3, s);
        if (q[0] < x0) x0 = q[0]; if (q[0] > x1) x1 = q[0];
        if (q[1] < y0) y0 = q[1]; if (q[1] > y1) y1 = q[1];
      }
      ppStates(folds).forEach(function (pieces, k) {
        var M = 0; pieces.forEach(function (p) { M = Math.max(M, p.layer); });
        pieces.forEach(function (p) { p.lp.forEach(function (q) { add([q[0], q[1], p.layer * PP_EPS]); }); });
        var fold = folds[k];
        if (!fold) return;
        var zT = (M + 1) * PP_EPS;
        [0.3, 0.5, 0.7].forEach(function (fr) {
          var phi = fr * Math.PI;
          pieces.forEach(function (p) {
            var moving = ppClip(p.lp, fold, true);
            if (!moving) return;
            moving.forEach(function (q) { add(ppLift(q, p.layer * PP_EPS, fold, phi, zT)); });
          });
        });
      });
      if (!isFinite(x0)) { x0 = -s; y0 = -s; x1 = s; y1 = s; }
      var pad = Math.max(x1 - x0, y1 - y0) * 0.06 + 3;
      var frame = { x: x0 - pad, y: y0 - pad, w: (x1 - x0) + pad * 2, h: (y1 - y0) + pad * 2 };
      PP_FRAMES[key] = frame;
      PP_FRAME_KEYS.push(key);
      if (PP_FRAME_KEYS.length > 60) delete PP_FRAMES[PP_FRAME_KEYS.shift()];
      return frame;
    }
    function ppScene(folds, t, holes, cam, s, label) {
      var states = ppStates(folds);
      var nF = folds.length, k = Math.min(nF, Math.floor(t + 1e-9)), frac = k < nF ? t - k : 0;
      var pieces = states[k], polys = [];
      var M = 0; pieces.forEach(function (p) { M = Math.max(M, p.layer); });
      var zT = (M + 1) * PP_EPS;
      var fold = k < nF && frac > 0 ? folds[k] : null;
      var phi = frac * Math.PI;
      var lift = function (p, layer, moving) {
        var z0 = layer * PP_EPS;
        if (!moving) return [p[0], p[1], z0];
        return ppLift(p, z0, fold, phi, zT);
      };
      pieces.forEach(function (p) {
        var parts = fold ? [[ppClip(p.lp, fold, false), false], [ppClip(p.lp, fold, true), true]] : [[p.lp, false]];
        parts.forEach(function (pr) {
          if (!pr[0]) return;
          var poly3 = pr[0].map(function (q) { return lift(q, p.layer, pr[1]); });
          var depth = 0; poly3.forEach(function (q) { depth += vxDot(q, cam.d); }); depth /= poly3.length;
          polys.push({ pts: poly3, depth: depth, fill: pr[1] && phi > Math.PI / 2 ? "#cdd6e6" : SR_PAPER, stroke: SR_NAVY, sw: 1.6 });
          (holes || []).forEach(function (h) {
            var inv = afInv(p.m), c = afApply(inv, afApply(p.m, [0, 0]));
            void c;
            var centreSheet = h.centre || flCentroid(h.sheet);
            var lay = afApply(p.m, centreSheet);
            if (!ppInPoly(lay, pr[0])) return;
            var hp = h.sheet.map(function (q) { return lift(afApply(p.m, q), p.layer, pr[1]); });
            polys.push({ pts: hp, depth: depth + 1e-4, fill: "#ffffff", stroke: SR_NAVY, sw: 1.4 });
          });
        });
      });
      polys.sort(function (a, b) { return a.depth - b.depth; });
      var body = "";
      polys.forEach(function (pg) {
        var pr = pg.pts.map(function (q) { return vxProject(cam, q, s); });
        body += "<polygon points='" + ptsStr(pr) + "' fill='" + pg.fill + "' stroke='" + pg.stroke + "' stroke-width='" + pg.sw + "' stroke-linejoin='round'/>";
      });
      /* the picture is drawn to the paper's own box, so it fills the space it is given */
      var fr = ppFrame(folds, cam, s), big = Math.max(fr.w, fr.h) || 1;
      return svgBox(body, fx(fr.x) + " " + fx(fr.y) + " " + fx(fr.w) + " " + fx(fr.h),
        Math.round((400 * fr.w) / big), Math.round((400 * fr.h) / big), label === undefined ? "the paper folding" : label);
    }
    /* Interactive fold viewer: slider over t, drag to look around, punch and unfold.
       Same camera API as mountVoxelViewer (set, animateTo, turn, home, stop, locked)
       so ui.js can treat both viewers the same. The root is focusable: arrow keys
       yaw by 30 and pitch by 15, Home returns to the home view. */
    var PP_HOME = { yaw: 40, pitch: 38 };
    var PP_KEY_YAW = 30, PP_KEY_PITCH = 15;
    var SR_VIEWER_HINT = "<span class='cnt-sr-only sr-viewer-hint'>Drag, or use the arrow keys, to turn</span>";
    var SR_VIEWER_HINT_LOCKED = "<span class='cnt-sr-only sr-viewer-hint'>Locked during the test, it turns in the review</span>";
    function ppViewerLabel(folds, holes) {
      return "the sheet of paper, folded " + ppTimes(folds.length) + (holes && holes.length ? ", with the holes punched" : "");
    }
    function mountPaperViewer(container, folds, holes, opts) {
      opts = opts || {};
      var v = {
        folds: folds, holes: holes || [], t: opts.t == null ? folds.length : opts.t,
        yaw: opts.yaw == null ? PP_HOME.yaw : opts.yaw, pitch: opts.pitch == null ? PP_HOME.pitch : opts.pitch,
        anim: null, camAnim: null, dragging: false, lastX: 0, lastY: 0, locked: !!opts.locked, moved: false
      };
      var host = document.createElement("div");
      host.className = "sr-viewer";
      host.setAttribute("tabindex", "0");
      host.setAttribute("role", "application");
      host.setAttribute("aria-label", opts.label || ppViewerLabel(v.folds, v.holes));
      container.innerHTML = "";
      container.appendChild(host);
      v.host = host;
      v.render = function () {
        host.innerHTML = ppScene(v.folds, v.t, v.holes, vxCam(v.yaw, v.pitch), 150, false) + (v.locked ? SR_VIEWER_HINT_LOCKED : SR_VIEWER_HINT);
        if (opts.onChange) opts.onChange(v);
      };
      v.setT = function (t) { v.t = clamp(t, 0, v.folds.length); v.render(); };
      v.stop = function () {
        if (v.anim) { cancelAnimationFrame(v.anim); v.anim = null; }
        if (v.camAnim) { cancelAnimationFrame(v.camAnim); v.camAnim = null; }
      };
      v.animateT = function (target, ms, done) {
        if (v.anim) { cancelAnimationFrame(v.anim); v.anim = null; }
        var t0 = null, from = v.t, diff = target - from;
        if (document.hidden || ms <= 0 || window.__srReduceMotion) { v.setT(target); if (done) done(); return; }
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var p = clamp((ts - t0) / ms, 0, 1);
          v.setT(from + diff * smoother(p));
          if (p < 1) v.anim = requestAnimationFrame(frame); else { v.anim = null; if (done) done(); }
        }
        v.anim = requestAnimationFrame(frame);
      };
      /* camera: absolute, relative and home moves, all animated unless motion is reduced */
      v.set = function (yaw, pitch) { v.yaw = yaw; v.pitch = clamp(pitch, 8, 88); v.render(); };
      v.animateTo = function (yaw, pitch, ms, done) {
        if (v.camAnim) { cancelAnimationFrame(v.camAnim); v.camAnim = null; }
        var y0 = v.yaw, p0 = v.pitch, dy = yaw - y0, dp = clamp(pitch, 8, 88) - p0, t0 = null;
        if (document.hidden || ms <= 0 || window.__srReduceMotion) { v.set(yaw, pitch); if (done) done(); return; }
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var t = clamp((ts - t0) / ms, 0, 1), e = smoother(t);
          v.yaw = y0 + dy * e; v.pitch = p0 + dp * e; v.render();
          if (t < 1) v.camAnim = requestAnimationFrame(frame); else { v.camAnim = null; if (done) done(); }
        }
        v.camAnim = requestAnimationFrame(frame);
      };
      v.turn = function (dYaw, dPitch, ms) { v.animateTo(v.yaw + (dYaw || 0), v.pitch + (dPitch || 0), ms == null ? 260 : ms); };
      v.home = function (ms) { v.animateTo(PP_HOME.yaw, PP_HOME.pitch, ms == null ? 500 : ms); };
      v.setHoles = function (h) { v.holes = h; if (!opts.label) host.setAttribute("aria-label", ppViewerLabel(v.folds, v.holes)); v.render(); };
      v.setFolds = function (f, h) { v.folds = f; v.holes = h || []; v.t = f.length; if (!opts.label) host.setAttribute("aria-label", ppViewerLabel(v.folds, v.holes)); v.render(); };
      function noteTurn() { if (!v.moved) { v.moved = true; if (opts.onDrag) opts.onDrag(); } }
      function down(e) {
        if (v.locked) return;
        v.dragging = true; v.lastX = e.clientX; v.lastY = e.clientY;
        if (v.camAnim) { cancelAnimationFrame(v.camAnim); v.camAnim = null; }
        container.classList.add("is-dragging");
        try { container.setPointerCapture(e.pointerId); } catch (err) {}
      }
      function move(e) {
        if (!v.dragging) return;
        var dx = e.clientX - v.lastX, dy = e.clientY - v.lastY;
        if (Math.abs(dx) + Math.abs(dy) > 2) noteTurn();
        v.lastX = e.clientX; v.lastY = e.clientY;
        v.yaw += dx * 0.5; v.pitch = clamp(v.pitch + dy * 0.35, 8, 88);
        if (!v.raf) v.raf = requestAnimationFrame(function () { v.raf = null; v.render(); });
        e.preventDefault();
      }
      function up() { v.dragging = false; container.classList.remove("is-dragging"); }
      function key(e) {
        if (v.locked) return;
        var k = e.key;
        if (k === "Home") { e.preventDefault(); noteTurn(); v.home(); return; }
        var dy = k === "ArrowLeft" ? -PP_KEY_YAW : k === "ArrowRight" ? PP_KEY_YAW : 0;
        var dp = k === "ArrowUp" ? PP_KEY_PITCH : k === "ArrowDown" ? -PP_KEY_PITCH : 0;
        if (!dy && !dp) return;
        e.preventDefault();
        noteTurn();
        v.turn(dy, dp);
      }
      container.addEventListener("pointerdown", down);
      container.addEventListener("pointermove", move);
      container.addEventListener("pointerup", up);
      container.addEventListener("pointercancel", up);
      container.addEventListener("pointerleave", up);
      host.addEventListener("keydown", key);
      v.render();
      return v;
    }
    var PP_LAB_RECIPES = [
      { id: "one", label: "1 fold", kinds: [{ kind: "v", dir: "r" }] },
      { id: "two", label: "2 folds", kinds: [{ kind: "v", dir: "r" }, { kind: "h", dir: "t" }] },
      { id: "quarter", label: "Quarter fold", kinds: [{ kind: "v", dir: "r" }, { kind: "vq", dir: "r" }] },
      { id: "diag", label: "Diagonal", kinds: [{ kind: "d1", dir: "r" }] },
      { id: "diag2", label: "Two diagonals", kinds: [{ kind: "d1", dir: "r" }, { kind: "d2", dir: "r" }] },
      { id: "mixed", label: "Mixed", kinds: [{ kind: "v", dir: "l" }, { kind: "d1", dir: "r" }] }
    ];
    function ppRecipeIcon(rec) {
      var folds = ppBuildFolds(rec.kinds), states = ppStates(folds), s = "<rect x='4' y='4' width='36' height='36' fill='" + SR_PAPER + "' stroke='" + SR_NAVY + "' stroke-width='2'/>";
      folds.forEach(function (f, i) {
        var bb = ppBBox(states[i]), box = [[bb.x0, bb.y0], [bb.x1, bb.y0], [bb.x1, bb.y1], [bb.x0, bb.y1]], pts = [];
        for (var e = 0; e < 4; e++) { var a = box[e], b = box[(e + 1) % 4], ca = ppCross(f, a), cb = ppCross(f, b); if ((ca > 0) !== (cb > 0) && Math.abs(ca - cb) > 1e-12) { var t = ca / (ca - cb); pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); } }
        if (pts.length >= 2) s += "<line x1='" + fx(4 + pts[0][0] * 36) + "' y1='" + fx(4 + pts[0][1] * 36) + "' x2='" + fx(4 + pts[1][0] * 36) + "' y2='" + fx(4 + pts[1][1] * 36) + "' stroke='" + SR_NAVY + "' stroke-width='2' stroke-dasharray='3 3'/>";
      });
      return svgBox(s, "0 0 44 44", 40, 40, rec.label + " recipe");
    }
    /* ============================================================
       16. SOLID QUESTIONS, THE TEN DOORS, RUNGS, SMART MIX AND PLANS
       Every builder is build(rung, plan). plan is optional: without one
       the builder picks its own features (steering away from plan.avoid,
       the practice history, when that is given); with one it uses the
       fields listed in PLAN_SPECS. Every builder sets q.variant, a short
       string naming the substantive subtype, so repeats can be detected.
       ============================================================ */
    function vxLayerCounts(cubes) {
      var K = vxBounds(cubes).K, out = [];
      for (var k = 0; k < K; k++) out.push(cubes.filter(function (c) { return c[2] === k; }).length);
      return out;
    }
    function ordinalWord(n) { return ["", "first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth"][n] || (n + "th"); }
    /* every layer named on its own: "6 on the ground, 6 on the second layer, 5 on the third layer and 3 on top" */
    function layerSentence(layers) {
      var L = layers.length;
      if (L === 1) return "all " + layers[0] + " on the ground";
      if (L === 2) return layers[0] + " on the ground and " + layers[1] + " on top";
      if (L === 3) return layers[0] + " on the ground, " + layers[1] + " in the middle and " + layers[2] + " on top";
      var parts = [layers[0] + " on the ground"];
      for (var i = 1; i < L - 1; i++) parts.push(layers[i] + " on the " + ordinalWord(i + 1) + " layer");
      parts.push(layers[L - 1] + " on top");
      return listJoin(parts);
    }
    function numOpt(n, isCorrect, note) { return { html: "<span class='sr-num'>" + n + "</span>", sig: "n:" + n, isCorrect: !!isCorrect, note: note || null }; }
    /* the papers stop around twenty cubes, so the piles here do too */
    var BLOCKS_MAX = 20;
    function srBlocksRange() {
      var v = (el && el.blocksSelect && el.blocksSelect.value) || ("5-" + BLOCKS_MAX);
      var parts = v.split("-").map(Number);
      return [clamp(parts[0] || 5, 4, BLOCKS_MAX), clamp(parts[1] || BLOCKS_MAX, 5, BLOCKS_MAX)];
    }
    /* which third of the selected blocks range a pile size falls in */
    function sizeBandOf(n, lo, hi) {
      var span = hi - lo;
      return n <= Math.round(lo + span / 3) ? "S" : n <= Math.round(lo + (span * 2) / 3) ? "M" : "L";
    }
    function keyMap(keys) { var m = {}; (keys || []).forEach(function (k) { m[k] = true; }); return m; }
    /* A small pile (up to 8 cubes, two layers) drawn evenly over its shapes: a 2 by 2 to 3 by 3 base,
       the number of columns picked evenly across everything that fits, every row and column of the
       base used, then the spare cubes stacked one high. vxRandomPile seeds a few columns and stacks the
       rest, which at this size kept serving the same handful of walls and blocks. */
    function vxSmallPile(n) {
      var I = pick([2, 3, 3]), J = pick([2, 3, 3]), cells = [];
      for (var j = 0; j < J; j++) for (var i = 0; i < I; i++) cells.push([i, j]);
      for (var t = 0; t < 40; t++) {
        var k = rnd(Math.max(2, Math.ceil(n / 2)), Math.min(n, cells.length));
        if (k > cells.length || k * 2 < n) continue;
        var base = shuffle(cells.slice()).slice(0, k), h = [], left = n - k, guard = 0;
        for (var jj = 0; jj < J; jj++) { h.push([]); for (var ii = 0; ii < I; ii++) h[jj].push(0); }
        base.forEach(function (c) { h[c[1]][c[0]] = 1; });
        while (left > 0 && guard++ < 200) { var c = pick(base); if (h[c[1]][c[0]] < 2) { h[c[1]][c[0]]++; left--; } }
        if (left > 0) continue;
        var rowsUsed = h.every(function (row) { return row.some(Boolean); });
        var colsUsed = h[0].every(function (_, i) { return h.some(function (row) { return row[i]; }); });
        if (rowsUsed && colsUsed) return h;
      }
      return null;
    }
    /* --- block counting --- */
    function buildCount(rung, plan) {
      plan = plan || {};
      var range = srBlocksRange(), lo = range[0], hi = range[1], span = hi - lo, avoid = plan.avoid || [];
      var a, b;
      if (plan.size === "S" || plan.size === "M" || plan.size === "L") {
        /* the plan's size band: thirds of the selected range */
        var third = { S: 0, M: 1, L: 2 }[plan.size];
        a = Math.round(lo + (span * third) / 3) + (third > 0 ? 1 : 0);
        b = Math.round(lo + (span * (third + 1)) / 3);
      } else {
        a = Math.round(lo + (span * (rung - 1)) / 6);
        b = Math.round(lo + (span * rung) / 6);
      }
      a = Math.min(hi, Math.max(lo, a)); b = Math.max(a, Math.min(hi, b));
      var wantK = clamp(parseInt(plan.layers, 10) || 1, 1, 4);
      var n = 0, heights = null, cubes = null, variant = "";
      /* the features first (size band and layer count), then the diagram; a variant
         in the practice history is redrawn, up to twelve times */
      var homeCam = vxCam(VX_HOME.yaw, VX_HOME.pitch);
      for (var attempt = 0; attempt < 12; attempt++) {
        n = clamp(rnd(a, b), 5, BLOCKS_MAX);
        var maxH = n <= 8 ? 2 : n <= 14 ? 3 : 4, maxSide = n <= 8 ? 3 : 4;
        if (wantK > maxH && n >= wantK + 1) maxH = wantK;
        var best = null;
        for (var t = 0; t < 40; t++) {
          var h = n <= 8 && wantK <= 2 ? vxSmallPile(n) : vxRandomPile(n, maxSide, maxH);
          if (!h) continue;
          /* every column has to show its top from the first view, or the pile
             cannot be counted without turning it */
          if (vxHiddenTops(vxFromHeights(h), homeCam).length) continue;
          if (!best || vxBounds(vxFromHeights(h)).K > vxBounds(vxFromHeights(best)).K) best = h;
          if (vxBounds(vxFromHeights(h)).K >= wantK) { best = h; break; }
        }
        if (!best) continue;
        heights = best;
        cubes = vxFromHeights(heights);
        variant = sizeBandOf(n, lo, hi) + "|" + vxBounds(cubes).K + "L";
        if (avoid.indexOf(variant) < 0) break;
      }
      if (!heights) return null;
      var hidden = vxHiddenKeys(cubes, homeCam);
      var visible = n - hidden.length;
      var layersEarly = vxLayerCounts(cubes);
      var pool = [visible, n - layersEarly[layersEarly.length - 1], n - 1, n + 1, n + 2, n - 2, n + 3, visible + 1, visible - 1];
      var opts = [numOpt(n, true)], seen = {}; seen[n] = true;
      pool.forEach(function (x) {
        if (opts.length >= 5 || seen[x] || x < 1) return;
        seen[x] = true;
        opts.push(numOpt(x, false, x === visible && visible !== n ? "that is only the cubes you can see, the hidden ones are missing" : (x === n - layersEarly[layersEarly.length - 1] && layersEarly.length > 1 ? "that misses out the top layer" : (x < n ? "too few cubes: some have been missed" : "too many cubes: one has been counted twice"))));
      });
      if (opts.length < 5) return null;
      var layers = vxLayerCounts(cubes);
      /* "holding up the cubes above" only when a hidden cube really has one on top of it */
      var cubeSet = vxSetOf(cubes), holding = hidden.some(function (k) { var c = k.split(",").map(Number); return !!cubeSet[vxKey([c[0], c[1], c[2] + 1])]; });
      var explain = hidden.length
        ? n + " cubes. You can see " + visible + ", so " + hidden.length + (hidden.length === 1 ? " is" : " are") + " underneath or behind the ones you can see" + (holding ? ", holding up the cubes above." : ".") + "\nBy layers: " + layerSentence(layers) + "."
        : n + " cubes, and every one of them can be seen from here.\nBy layers: " + layerSentence(layers) + ".";
      return finishQ({
        typeId: "blocks", door: "blocks", variant: variant,
        prompt: "How many cubes are in the pile? Count the cubes underneath the ones you can see as well.",
        stimulusHtml: figureHtml(vxSvg(cubes, { size: 34, fixed: true, width: 260, label: "the pile of cubes to count" }), "spin it to see the back"),
        viewer: { cubes: cubes, tint: "grey", markers: false },
        options: opts,
        rule: "Count the pile layer by layer, and remember a cube up in the air needs cubes underneath to hold it up.",
        hint: "Count the ground layer first, then ask how many cubes each higher cube must be resting on.",
        explanation: explain,
        review: { kind: "pile", cubes: cubes, hidden: hidden }
      });
    }
    /* --- views: pick the view --- */
    function gridAlt(grid) {
      var rows = grid.length, cols = grid[0].length, out = grid.map(function (r) { return r.slice(); });
      for (var t = 0; t < 40; t++) {
        var r = ri(rows), c = ri(cols);
        var nb = [[r - 1, c], [r + 1, c], [r, c - 1], [r, c + 1]].some(function (p) { return p[0] >= 0 && p[0] < rows && p[1] >= 0 && p[1] < cols && grid[p[0]][p[1]]; });
        if (!grid[r][c] && !nb) continue;
        out[r][c] = !out[r][c];
        if (out.some(function (row) { return row.some(Boolean); })) return out;
        out[r][c] = !out[r][c];
      }
      return null;
    }
    function gridColumnHeights(g) { return g[0].map(function (_, q) { return g.filter(function (r) { return r[q]; }).length; }); }
    /* The cubes that actually show in a view: from the FRONT (+x) one sight-line per
       column j, and the tallest stack along it shows (the nearest of equals); from the
       SIDE (+y) one per row i. From above, the top cube of every stack. */
    function vxShowingKeys(cubes, which) {
      var h = vxHeightsOf(cubes), J = h.length, I = J ? h[0].length : 0, out = [], i, j, k;
      if (which === "front") {
        for (j = 0; j < J; j++) {
          var best = 0, bi = -1;
          for (i = 0; i < I; i++) if (h[j][i] > 0 && h[j][i] >= best) { best = h[j][i]; bi = i; }
          for (k = 0; k < best; k++) out.push(bi + "," + j + "," + k);
        }
      } else if (which === "side") {
        for (i = 0; i < I; i++) {
          var best2 = 0, bj = -1;
          for (j = 0; j < J; j++) if (h[j][i] > 0 && h[j][i] >= best2) { best2 = h[j][i]; bj = j; }
          for (k = 0; k < best2; k++) out.push(i + "," + bj + "," + k);
        }
      } else {
        for (j = 0; j < J; j++) for (i = 0; i < I; i++) if (h[j][i] > 0) out.push(i + "," + j + "," + (h[j][i] - 1));
      }
      return out;
    }
    function buildPickView(rung, plan) {
      plan = plan || {};
      var which = (plan.which === "front" || plan.which === "side" || plan.which === "plan") ? plan.which : null;
      if (!which) {
        var avoid = plan.avoid || [], poolW = rung <= 2 ? ["front", "plan"] : ["front", "side", "plan"];
        for (var w = 0; w < 12; w++) { which = pick(poolW); if (avoid.indexOf(which) < 0) break; }
      }
      var n = clamp(rnd(5 + rung, 8 + rung * 2), 5, 20);
      var heights = null;
      for (var t = 0; t < 30 && !heights; t++) heights = vxRandomPile(n, rung <= 2 ? 3 : 4, rung <= 2 ? 2 : 3);
      if (!heights) return null;
      var cubes = vxFromHeights(heights), views = vxViews(cubes);
      var right = views[which];
      var others = ["front", "side", "plan"].filter(function (x) { return x !== which; });
      var cands = [
        { g: gridFlipH(right), note: "that is the view flipped left to right" },
        { g: views[others[0]], note: "that is the view from the " + (others[0] === "plan" ? "top" : others[0]) },
        { g: views[others[1]], note: "that is the view from the " + (others[1] === "plan" ? "top" : others[1]) },
        { g: gridAlt(right), note: "one square is wrong: check each column" },
        { g: gridFlipV(right), note: "that is the view upside down" },
        { g: gridAlt(gridFlipH(right)), note: "flipped, and one square wrong" }
      ];
      var gridLabel = which === "plan" ? "a grid of squares seen from above" : "a grid of squares seen from the " + which;
      var opts = [{ html: gridSvg(right, { width: 88, label: gridLabel }), sig: gridSig(gridTrim(right)), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      cands.forEach(function (cd) {
        if (opts.length >= 5 || !cd.g) return;
        var sig = gridSig(gridTrim(cd.g));
        if (used[sig]) return;
        used[sig] = true;
        opts.push({ html: gridSvg(cd.g, { width: 88, label: gridLabel }), sig: sig, isCorrect: false, note: cd.note });
      });
      if (opts.length < 5) return null;
      var explain, rule, hint, hlCaption;
      if (which === "plan") {
        var covered = 0; right.forEach(function (row) { row.forEach(function (on) { if (on) covered++; }); });
        rule = "Looking straight down, every stack shows as one square however tall it is, with the FRONT arrow at the bottom.";
        hint = "Think about which squares on the ground have at least one cube standing on them, whatever their height.";
        explain = "The pile stands on " + covered + " squares of the ground, so the plan has " + covered + " filled squares in that same pattern, tall stacks and short stacks alike. The FRONT arrow is at the bottom of the plan.";
        hlCaption = "The top cube of every stack is lit orange";
      } else {
        var hs = gridColumnHeights(right);
        rule = "Stand at the arrow and look straight on: only the tallest stack in each line shows, left to right as you see it.";
        hint = "Work along the pile from your left to your right as you stand at the arrow, and find the tallest stack in each line.";
        explain = "From the " + which.toUpperCase() + " arrow you see " + hs.length + " stacks, " + listJoin(hs.map(String)) + " cubes high, left to right.\nCubes hidden behind a taller stack never change the view.";
        hlCaption = "The stacks you can see from the " + which.toUpperCase() + " are lit orange";
      }
      return finishQ({
        typeId: "views", door: "views", variant: which,
        prompt: which === "plan" ? "Look straight down from above, with the FRONT arrow at the bottom. Which squares are covered by at least one cube?" : "Stand at the orange " + which.toUpperCase() + " arrow and look straight at the pile. Which grid would you see? Left in the grid is your left.",
        stimulusHtml: figureHtml(vxSvg(cubes, { size: 34, fixed: true, markers: true, width: 300, label: "the pile of cubes, with the FRONT and SIDE arrows" }), "the arrows show where to look from"),
        viewer: { cubes: cubes, tint: "grey", markers: true },
        options: opts,
        rule: rule,
        hint: hint,
        explanation: explain,
        hlKeys: vxShowingKeys(cubes, which),
        hlCaption: hlCaption,
        review: { kind: "view", cubes: cubes, which: which }
      });
    }
    function viewsSigOf(cubes) { var v = vxViews(cubes); return gridSig(v.plan) + "|" + gridSig(v.front) + "|" + gridSig(v.side); }
    function buildPickPile(rung, plan) {
      void plan;
      var n = clamp(rnd(6, 6 + rung), 6, 12);
      var heights = null;
      for (var t = 0; t < 30 && !heights; t++) heights = vxRandomPile(n, 3, 3);
      if (!heights) return null;
      var cubes = vxFromHeights(heights), v = vxViews(cubes), sig0 = viewsSigOf(cubes);
      var opts = [{ html: vxSvg(cubes, { size: 15, width: 104, label: "a pile of cubes" }), sig: "p:" + vxSig(cubes), isCorrect: true }];
      var used = {}; used[sig0] = true;
      for (var g = 0; g < 160 && opts.length < 5; g++) {
        var h2 = heights.map(function (r) { return r.slice(); });
        var moves = rnd(1, 2);
        for (var m = 0; m < moves; m++) { var j = ri(h2.length), i = ri(h2[0].length); h2[j][i] = clamp(h2[j][i] + (ri(2) ? 1 : -1), 0, 3); }
        var c2 = vxFromHeights(h2);
        if (c2.length < 3) continue;
        var s2 = viewsSigOf(c2);
        if (used[s2]) continue;
        used[s2] = true;
        var v2 = vxViews(c2), why = gridSig(v2.plan) !== gridSig(v.plan) ? "the plan is different" : gridSig(v2.front) !== gridSig(v.front) ? "the front view is different" : "the side view is different";
        opts.push({ html: vxSvg(c2, { size: 15, width: 104, label: "a pile of cubes" }), sig: "p:" + vxSig(c2), isCorrect: false, note: why });
      }
      if (opts.length < 5) return null;
      var trio = "<div class='sr-vtrio'>" + ["plan", "front", "side"].map(function (k) { return "<div><span class='sr-vlabel'>" + k + "</span>" + gridSvg(v[k], { width: 60, label: "the " + k + " view of the pile" }) + "</div>"; }).join("") + "</div>";
      var planCount = 0; v.plan.forEach(function (row) { row.forEach(function (on) { if (on) planCount++; }); });
      var fh = gridColumnHeights(v.front), sh = gridColumnHeights(v.side);
      return finishQ({
        typeId: "pickpile", door: "views", variant: "pickpile",
        prompt: "Here are the plan, the front view and the side view of one pile. Which pile makes all three?",
        stimulusHtml: trio,
        options: opts,
        rule: "Check the plan first for which stacks exist, then the heights from the front, then from the side: the pile must pass all three.",
        hint: "Start with the plan and rule out any pile whose footprint is wrong, then test the heights from the front.",
        explanation: "Only one pile passes all three checks: " + planCount + " stacks in the plan, stacks " + listJoin(fh.map(String)) + " high from the front, and " + listJoin(sh.map(String)) + " high from the side.",
        review: { kind: "pile", cubes: cubes, hidden: [] }
      });
    }
    function buildViews(rung, plan) {
      plan = plan || {};
      if (plan.which === "pickpile") return buildPickPile(rung, plan);
      if (plan.which === "front" || plan.which === "side" || plan.which === "plan") return buildPickView(rung, plan);
      /* no plan: the mix as before, steered away from the recent variants */
      var avoid = plan.avoid || [], which = null, pile = false;
      for (var t = 0; t < 12; t++) {
        pile = rung >= 5 && !!ri(2);
        which = pile ? "pickpile" : pick(rung <= 2 ? ["front", "plan"] : ["front", "side", "plan"]);
        if (avoid.indexOf(which) < 0) break;
      }
      return pile ? buildPickPile(rung, plan) : buildPickView(rung, { which: which, avoid: avoid });
    }
    /* --- 3D rotation --- */
    function vxNearMiss(cubes) {
      for (var t = 0; t < 40; t++) {
        var idx = ri(cubes.length), rest = cubes.filter(function (_, i) { return i !== idx; });
        if (!vxConnected(rest)) continue;
        var base = pick(rest), d = pick([[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]]);
        var nb = [base[0] + d[0], base[1] + d[1], base[2] + d[2]];
        if (vxSetOf(rest)[vxKey(nb)]) continue;
        var cand = vxNorm(rest.concat([nb]));
        if (vxIsRotOf(cubes, cand)) continue;
        return cand;
      }
      return null;
    }
    /* Two joined cubes lifted off together and put back somewhere else as a pair:
       still a connected solid, not a turn of the original and not its mirror image. */
    function vxPairMove(cubes) {
      var n = cubes.length;
      if (n < 4) return null;
      var set = vxSetOf(cubes), dirs = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]], mirror = vxMirror(cubes);
      for (var t = 0; t < 60; t++) {
        var a = pick(cubes), d = pick(dirs), bC = [a[0] + d[0], a[1] + d[1], a[2] + d[2]];
        var ka = vxKey(a), kb = vxKey(bC);
        if (!set[kb]) continue;
        var rest = cubes.filter(function (c) { var k = vxKey(c); return k !== ka && k !== kb; });
        if (rest.length < 2 || !vxConnected(rest)) continue;
        var rset = vxSetOf(rest);
        var base = pick(rest), d1 = pick(dirs), p1 = [base[0] + d1[0], base[1] + d1[1], base[2] + d1[2]], k1 = vxKey(p1);
        if (rset[k1] || k1 === ka || k1 === kb) continue;
        var d2 = pick(dirs), p2 = [p1[0] + d2[0], p1[1] + d2[1], p1[2] + d2[2]], k2 = vxKey(p2);
        if (rset[k2] || k2 === k1 || k2 === ka || k2 === kb) continue;
        var cand = vxNorm(rest.concat([p1, p2]));
        if (vxIsRotOf(cubes, cand) || vxIsRotOf(mirror, cand)) continue;
        return cand;
      }
      return null;
    }
    /* The method, the nudge and the explanation tail for each kind of invariant
       vxInvariant (voxel.js) can pick out; "none" is the generic wording. */
    var ROT_GUIDE = {
      end: {
        feat: "the cube on its own",
        rule: "A turn keeps every cube joined to the same neighbours, so follow the cube that sticks out on its own: it must still come off the same end.",
        hint: "Pick out the cube that sticks out on its own and notice where it joins the rest, then look for that same join in each option.",
        tail: "in the answer it still hangs off the same cube of the rest of the solid, on the same side. A mirror image looks right until you check where that cube joins on.",
        mirror: "the cube on its own sticks out the other way"
      },
      elbow: {
        feat: "the corner",
        rule: "A turn keeps every cube joined to the same neighbours, so follow the corner: it must still bend the same way between the same two arms.",
        hint: "Pick out the corner where the solid bends and notice what sits on each side of it, then look for that same bend in each option.",
        tail: "in the answer it still bends the same way, with the same arms on each side. A mirror image looks right until you check which way it bends.",
        mirror: "the corner bends the other way"
      },
      branch: {
        feat: "the junction",
        rule: "A turn keeps every cube joined to the same neighbours, so follow the junction cube: the same arms must still come off it.",
        hint: "Pick out the cube where the arms meet and notice which arms come off it, then look for that same junction in each option.",
        tail: "in the answer the same arms still come off it, in the same order. A mirror image looks right until you check that junction.",
        mirror: "the arms come off the junction the other way round"
      },
      run: {
        feat: "the long run",
        rule: "A turn keeps every cube joined to the same neighbours, so follow the longest straight run: the same cubes must still hang off its ends.",
        hint: "Pick out the longest straight run and notice what hangs off each end, then look for that same run in each option.",
        tail: "in the answer the same cubes still hang off the same ends of it. A mirror image looks right until you check those ends.",
        mirror: "the cubes hang off the long run on the other side"
      },
      /* the one chiral solid of four cubes: a zig-zag of three pairs whose two bends turn different ways */
      zigzag: {
        feat: "the zig-zag",
        rule: "A turn keeps every cube joined to the same neighbours, so follow the zig-zag from one end: it must still bend the same way at each of its two bends.",
        hint: "Start at one end cube and follow the path: it bends once, then bends again in a new direction. Look for that same path in each option.",
        tail: "This solid is a zig-zag: from one end it bends once, then bends again in a new direction. In the answer it still bends the same way at both bends, only seen from a new angle. A mirror image is the zig-zag bending the other way, and no turn can fix that.",
        mirror: "the zig-zag bends the other way"
      },
      /* a solid with no single stand-out feature: the wording stays generic and true */
      none: {
        feat: "the path from one end",
        rule: "A turn keeps every cube joined to the same neighbours, so start at one end and follow the path: every bend must still turn the same way.",
        hint: "Pick one end cube and follow the path from it, noticing which way each bend turns, then look for that same path in each option.",
        tail: "In the answer every cube still sits next to the same neighbours, only seen from a new angle. A mirror image looks right until you follow the path from one end and find it bends the other way.",
        mirror: "the path bends the other way"
      }
    };
    var ROT_MOVE_NOTE = { one: "has one cube moved to a different place, so it is a different stack", many: "have one cube moved to a different place, so they are different stacks" };
    var ROT_PAIR_NOTE = { one: "has a cube moved with its neighbour: two cubes have moved together, so it is a different solid", many: "have a cube moved with its neighbour: two cubes have moved together, so they are different solids" };
    var rotTrapTurn = 0;
    function buildRotation(rung, plan) {
      plan = plan || {};
      var rr6 = clamp(rung, 1, 6) - 1, n = [4, 5, 5, 6, 6, 7][rr6], bias = [0.6, 0.45, 0.35, 0.3, 0.2, 0.1][rr6], S = null;
      if (plan.n === 4 || plan.n === 5 || plan.n === 6 || plan.n === 7) n = plan.n;
      /* the item's own invariant: the most distinctive unique feature of this solid. A chiral
         solid with one is preferred (the explanation is built on it); any chiral solid will do. */
      var invOf = function (cubes) {
        var out = null;
        try { if (typeof vxInvariant === "function") out = vxInvariant(cubes); } catch (e) { out = null; }
        if (!out || !out.keys || !out.keys.length || !out.text || !ROT_GUIDE[out.kind] || out.kind === "none") out = null;
        return out;
      };
      var inv = null, firstChiral = null;
      for (var t = 0; t < 60 && !S; t++) {
        var c = vxRandomPolycube(n, bias);
        if (c.length !== n || !vxIsChiral(c)) continue;
        if (!firstChiral) firstChiral = c;
        var ci = invOf(c);
        if (ci) { S = c; inv = ci; }
      }
      if (!S && firstChiral) S = firstChiral;
      if (!S) return null;
      var sigS = vxSig(S), mirrorS = vxMirror(S);
      var rots = vxAllRots(S).filter(function (r) { return vxSig(r) !== sigS; });
      if (!rots.length) return null;
      var correct = pick(rots);
      var guide = ROT_GUIDE[inv ? inv.kind : (n === 4 ? "zigzag" : "none")];
      var optLabel = "a solid made of " + n + " blue cubes";
      var correctOpt = { html: vxSvg(correct, { size: 24, width: 124, tint: "blue", label: optLabel }), sig: vxSig(correct), isCorrect: true };
      if (inv) {
        var mapped = null;
        try { if (typeof vxRotKeys === "function") mapped = vxRotKeys(inv.keys, S, correct); } catch (e2) { mapped = null; }
        if (mapped && mapped.length) correctOpt.htmlReveal = vxSvg(correct, { size: 24, width: 124, tint: "blue", hl: keyMap(mapped), label: optLabel + ", with " + guide.feat + " lit orange" });
      }
      var opts = [correctOpt];
      var used = {}; used[opts[0].sig] = true; used[sigS] = true;
      var mirrors = shuffle(vxAllRots(mirrorS));
      var mirrorNote = { one: "is a mirror image: " + guide.mirror + ", and no turn can fix that", many: "are mirror images: " + guide.mirror + ", and no turn can fix that" };
      mirrors.forEach(function (m) {
        if (opts.length >= 3) return;
        var s = vxSig(m);
        if (used[s]) return;
        used[s] = true;
        opts.push({ html: vxSvg(m, { size: 24, width: 124, tint: "blue", label: optLabel }), sig: s, isCorrect: false, noteGroup: mirrorNote });
      });
      /* two structural traps fill the rest: one cube moved, or a joined pair moved
         together; which is tried first alternates question by question */
      var addTrap = function (kind) {
        for (var g = 0; g < 30; g++) {
          var nm = kind === "pair" ? vxPairMove(S) : vxNearMiss(S);
          if (!nm) continue;
          if (kind !== "pair" && vxIsRotOf(mirrorS, nm)) continue;
          var rr = pick(vxAllRots(nm)), s2 = vxSig(rr);
          if (used[s2] || vxIsRotOf(S, rr)) continue;
          used[s2] = true;
          opts.push({ html: vxSvg(rr, { size: 24, width: 124, tint: "blue", label: optLabel }), sig: s2, isCorrect: false, noteGroup: kind === "pair" ? ROT_PAIR_NOTE : ROT_MOVE_NOTE });
          return true;
        }
        return false;
      };
      var order = (rotTrapTurn++ % 2) ? ["pair", "move"] : ["move", "pair"];
      for (var slot = 0; opts.length < 5 && slot < 4; slot++) { if (!addTrap(order[slot % 2])) addTrap(order[(slot + 1) % 2]); }
      if (opts.length < 5) return null;
      var explain = inv ? "Follow " + inv.text + ": " + guide.tail : guide.tail;
      return finishQ({
        typeId: "rotation", door: "rotation", variant: "n" + n,
        prompt: "Which option is the same solid after it has been turned in your hands? It has not been flipped over or reflected.",
        stimulusHtml: figureHtml(vxSvg(S, { size: 30, width: 220, tint: "blue", fixed: true, label: "the solid to turn, " + n + " blue cubes joined together" }), "spin it round"),
        viewer: { cubes: S, tint: "blue", markers: false },
        options: opts,
        rule: guide.rule,
        hint: guide.hint,
        explanation: explain,
        hlKeys: inv ? inv.keys.slice() : undefined,
        hlCaption: inv ? "The cubes to follow are lit orange" : undefined,
        review: { kind: "solid", cubes: S, target: correct }
      });
    }
    /* --- building blocks --- */
    /* Split a solid into two connected pieces, [big, small]; smallWant fixes the small piece's size. */
    function vxSplit(cubes, smallWant) {
      var n = cubes.length;
      for (var t = 0; t < 60; t++) {
        var a = smallWant ? smallWant : rnd(2, n - 2), start = pick(cubes), set = vxSetOf(cubes), got = [start], seen = {}; seen[vxKey(start)] = true;
        var guard = 0;
        while (got.length < a && guard++ < 200) {
          var base = pick(got), d = pick([[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]]);
          var nb = [base[0] + d[0], base[1] + d[1], base[2] + d[2]], k = vxKey(nb);
          if (set[k] && !seen[k]) { seen[k] = true; got.push(nb); }
        }
        if (got.length !== a) continue;
        var rest = cubes.filter(function (c) { return !seen[vxKey(c)]; });
        if (vxConnected(got) && vxConnected(rest)) {
          var A = vxNorm(got), B = vxNorm(rest);
          return A.length >= B.length ? [A, B] : [B, A];
        }
      }
      return null;
    }
    function vxCanBuild(target, p1, p2) {
      if (p1.length + p2.length !== target.length) return false;
      var T = vxSetOf(target), b = vxBounds(target);
      var rots = vxAllRots(p1);
      for (var r = 0; r < rots.length; r++) {
        var pc = rots[r];
        for (var di = 0; di < b.I; di++) for (var dj = 0; dj < b.J; dj++) for (var dk = 0; dk < b.K; dk++) {
          var ok = true, placed = {};
          for (var q = 0; q < pc.length && ok; q++) { var k = (pc[q][0] + di) + "," + (pc[q][1] + dj) + "," + (pc[q][2] + dk); if (!T[k]) ok = false; placed[k] = true; }
          if (!ok) continue;
          var rest = target.filter(function (c) { return !placed[vxKey(c)]; });
          if (rest.length === p2.length && vxIsRotOf(p2, rest)) return true;
        }
      }
      return false;
    }
    function pairHtml(p1, p2) {
      return "<span class='sr-pair'>" + vxSvg(p1, { size: 18, width: 60, tint: "blue", label: "a blue piece of " + p1.length + " cubes" }) + "<b aria-hidden='true'>+</b>" + vxSvg(p2, { size: 18, width: 60, tint: "green", label: "a green piece of " + p2.length + " cubes" }) + "</span>";
    }
    /* Where a piece sits in the solid, in plain words, as the picture shows it from the
       home camera: right is larger j minus i, the front is larger i plus j, up is k. */
    function vxPiecePhrase(keys, T) {
      var cubes = keys.map(function (k) { return k.split(",").map(Number); }), count = cubes.length, b = vxBounds(T);
      var nb = vxBounds(vxNorm(cubes));
      var shape = count === 2 ? "pair" : count === 3 ? ((nb.I === 3 || nb.J === 3 || nb.K === 3) ? "row of three" : "L-shape") : "piece";
      var vertical = cubes.every(function (c) { return c[0] === cubes[0][0] && c[1] === cubes[0][1]; });
      var flat = cubes.every(function (c) { return c[2] === cubes[0][2]; });
      var pose = vertical ? "standing up" : flat ? "lying flat" : "climbing up";
      var sx = 0, sy = 0;
      cubes.forEach(function (c) { sx += c[0]; sy += c[1]; });
      var cx = sx / count - (b.I - 1) / 2, cy = sy / count - (b.J - 1) / 2;
      var side = cy - cx, depth = cx + cy;
      var words = [];
      if (side > 0.5) words.push("on the right"); else if (side < -0.5) words.push("on the left");
      if (depth > 0.5) words.push("at the front"); else if (depth < -0.5) words.push("at the back");
      if (b.K > 1) {
        if (cubes.every(function (c) { return c[2] === 0; })) words.push("on the ground");
        else if (cubes.every(function (c) { return c[2] === b.K - 1; })) words.push("on top");
        else if (!vertical) words.push("half way up");
      }
      if (!words.length) words.push("in the middle");
      return count + "-cube piece is the " + shape + " " + pose + " " + words.slice(0, 2).join(" ");
    }
    function buildBuild(rung, plan) {
      plan = plan || {};
      var n = [5, 5, 6, 6, 7, 7][clamp(rung, 1, 6) - 1];
      if (plan.n === 5 || plan.n === 6 || plan.n === 7) n = plan.n;
      var maxSmall = Math.floor(n / 2), avoid = plan.avoid || [];
      var small = (plan.small === 2 || plan.small === 3) ? Math.min(plan.small, maxSmall) : 0;
      if (!small) {
        /* no plan: the small piece's size, steered away from the recent variants */
        var choices = maxSmall >= 3 ? [2, 3] : [2];
        for (var s = 0; s < 12; s++) { small = pick(choices); if (avoid.indexOf(n + "|" + small) < 0) break; }
      }
      var T = null;
      for (var t = 0; t < 40 && !T; t++) { var c = vxRandomPolycube(n, 0.45); if (c.length === n) T = c; }
      if (!T) return null;
      var split = vxSplit(T, small);
      if (!split) return null;
      var p1 = split[0], p2 = split[1];
      var opts = [{ html: pairHtml(p1, p2), sig: vxSig(p1) + "+" + vxSig(p2), isCorrect: true }];
      var used = {}; used[opts[0].sig] = true;
      var bar = function (len) { var o = []; for (var i = 0; i < len; i++) o.push([i, 0, 0]); return o; };
      var tower = function (len) { var o = []; for (var i = 0; i < len; i++) o.push([0, 0, i]); return o; };
      var cands = [], mirrorCand = null;
      /* the mirror trap: the small piece turned over when it is chiral, else the big one */
      if (vxIsChiral(p2)) mirrorCand = [p1, vxMirror(p2), "that is a mirror image of the small piece: it only fits if you turn it over"];
      else if (vxIsChiral(p1)) mirrorCand = [vxMirror(p1), p2, "that is a mirror image of the big piece: it only fits if you turn it over"];
      var m2 = vxNearMiss(p2); if (m2) cands.push([p1, m2, "these do not fit together to make the solid"]);
      var m1 = vxNearMiss(p1); if (m1) cands.push([m1, p2, "these do not fit together to make the solid"]);
      cands.push([p1, bar(p2.length), "these do not fit together to make the solid"]);
      cands.push([p1, tower(p2.length), "these do not fit together to make the solid"]);
      var countTraps = [
        [p1, bar(p2.length + 1), "too many cubes: the pieces must add up to " + n],
        [p1, p2.length > 2 ? bar(p2.length - 1) : bar(1), "too few cubes: the pieces must add up to " + n]
      ];
      if (rung <= 2) cands = cands.concat(countTraps);
      var m3 = vxNearMiss(p2); if (m3) cands.push([p1, m3, "these do not fit together to make the solid"]);
      var m4 = vxNearMiss(p1); if (m4) cands.push([m4, p2, "these do not fit together to make the solid"]);
      var m5 = vxNearMiss(p1); if (m5) cands.push([m5, p2, "these do not fit together to make the solid"]);
      /* the mirror trap goes first so it is never squeezed out; the count traps are the last resort above rung 2 */
      var ordered = (mirrorCand ? [mirrorCand] : []).concat(shuffle(cands), rung <= 2 ? [] : countTraps);
      ordered.forEach(function (cd) {
        if (opts.length >= 5) return;
        var sg = vxSig(cd[0]) + "+" + vxSig(cd[1]), sg2 = vxSig(cd[1]) + "+" + vxSig(cd[0]);
        if (used[sg] || used[sg2]) return;
        if (vxCanBuild(T, cd[0], cd[1])) return;
        used[sg] = true;
        opts.push({ html: pairHtml(cd[0], cd[1]), sig: sg, isCorrect: false, note: cd[2] });
      });
      if (opts.length < 5) return null;
      /* where the small piece sits, from the placement that tiles the solid */
      var place = null;
      try { if (typeof vxPlacement === "function") place = vxPlacement(T, p1, p2); } catch (e) { place = null; }
      if (!place || !place.bKeys || !place.bKeys.length) place = null;
      var explain = place
        ? "The two pieces add up to " + n + " cubes. The " + vxPiecePhrase(place.bKeys, T) + ", and the rest is the " + p1.length + "-cube piece, turned round to fit."
        : "The two pieces add up to " + n + " cubes. The " + p1.length + "-cube piece sits inside the solid, and what is left over is the " + p2.length + "-cube piece, turned round to fit.";
      return finishQ({
        typeId: "building", door: "building", variant: n + "|" + p2.length,
        prompt: "Which two pieces can be put together to make exactly this solid? You may turn the pieces round.",
        stimulusHtml: figureHtml(vxSvg(T, { size: 30, width: 220, tint: "green", fixed: true, label: "the solid to build, " + n + " green cubes joined together" }), "made from which two pieces?"),
        viewer: { cubes: T, tint: "green", markers: false },
        options: opts,
        rule: "Count first: the two pieces must add up to " + n + " cubes. Then find where the small piece sits and check the rest is the other piece, turned round if it needs to be.",
        hint: "Add up the cubes in each pair first, then see whether the leftover shape could be the second piece turned round.",
        explanation: explain,
        hlKeys: place ? place.bKeys.slice() : undefined,
        hlCaption: place ? "The small piece is lit orange" : undefined,
        review: { kind: "solid", cubes: T, target: T }
      });
    }
    /* --- cube nets: the live engine, one door --- */
    var NETS_RUNGS = [["opposite"], ["cannotTouch", "canTouch"], ["missingFace", "hiddenFace"], ["cubeCanMake"], ["cubeCannot", "netCanMake"], ["netCannot", "cubeCannot"]];
    var NETS_THEMES = [["numbers", "letters", "dice"], ["numbers", "letters", "dice"], ["shapes", "arrows", "squares"], ["shapes", "arrows", "squares"], ["mixed"], ["mixed"]];
    var NETS_ALL_THEMES = ["numbers", "letters", "squares", "shapes", "arrows", "dots", "shaded", "dice", "lines"];
    /* The reusable method and the nudge for each nets question type. The nets
       core's explanations are already the worked application, so they stay. */
    var NETS_GUIDE = {
      opposite: {
        rule: "On a net, two squares one square apart in a straight line end up opposite each other on the cube.",
        hint: "Look along the rows and columns of the net for the square that is exactly one square away from the orange one."
      },
      cannotTouch: {
        rule: "A face touches its four neighbours but never its opposite, and opposites sit one square apart in a straight line.",
        hint: "Find the opposite of the orange face first: it is the only face that can never meet it."
      },
      canTouch: {
        rule: "Squares one square apart in a straight line on the net are opposite and never meet, so any other pair of faces touches.",
        hint: "Rule out every pair that sits one square apart in a straight line on the net, then look at what is left."
      },
      missingFace: {
        rule: "The two faces you can see fix the whole cube, so the net tells you which symbol is missing and which way it turns.",
        hint: "Use the two visible faces to work out which net square is missing, then check which way that symbol should point."
      },
      hiddenFace: {
        rule: "The face behind the ringed one is its opposite: one square apart in a straight line on the net.",
        hint: "Find the ringed symbol on the net, then look one square along in a straight line."
      },
      cubeCanMake: {
        rule: "Check three things on each cube: the symbols at the corner, the way each one is turned, and that no opposite pair touches.",
        hint: "Start by checking whether any two faces that touch on a cube are opposite each other on the net."
      },
      cubeCannot: {
        rule: "Check three things on each cube: the symbols at the corner, the way each one is turned, and that no opposite pair touches.",
        hint: "Three cubes are the same cube seen from different sides, so look for the one that breaks a rule about opposites, turns or mirrors."
      },
      netCanMake: {
        rule: "For each net, check every visible symbol: its neighbours and its turn must both match the cube.",
        hint: "Pick one symbol on the cube, find it on each net, and check which symbols sit next to it there."
      },
      netCannot: {
        rule: "Three nets fold into the same cube, so find the one where a symbol has the wrong neighbour, the wrong turn or the wrong spot.",
        hint: "Pick one symbol on the cube and check its neighbours and its turn on each net, one net at a time."
      }
    };
    /* Wrong options the nets core leaves without a note: the mistake is fixed by the question type
       (canTouch's wrong pairs are all opposite pairs; netCannot's wrong nets all make the cube).
       cubeCannot's wrong cubes are the real cube from other angles, which no tag names, so they stay "other". */
    var NETS_SILENT_TAG = { canTouch: "opposite-as-neighbour", netCannot: "impossible-net" };
    /* The nets core's first explanation line restates the method for these two; the worked line goes here. */
    var NETS_EXPLAIN_FIRST = {
      cubeCanMake: "Only one drawing passes all three checks; each of the other three breaks one of them.",
      netCanMake: "Only one net passes; each of the other three breaks one of the checks."
    };
    /* the question types a rung may draw on: its own list and its neighbours' */
    function netsTypesNear(rr) {
      var out = NETS_RUNGS[rr].slice();
      if (rr > 0) out = out.concat(NETS_RUNGS[rr - 1]);
      if (rr < NETS_RUNGS.length - 1) out = out.concat(NETS_RUNGS[rr + 1]);
      return out;
    }
    function buildNets(rung, plan) {
      plan = plan || {};
      var rr = clamp(rung || 1, 1, 6) - 1, avoid = plan.avoid || [];
      var chosen = (el && el.themeSelect && el.themeSelect.value) || "mixed";
      var fixedType = plan.typeId && netsTypesNear(rr).indexOf(plan.typeId) > -1 ? plan.typeId : null;
      var fixedTheme = typeof plan.theme === "string" && plan.theme ? plan.theme : null;
      var poolT = NETS_RUNGS[rr].filter(function (t) { return t !== lastTypeId; });
      if (!poolT.length) poolT = NETS_RUNGS[rr];
      var typeId, theme;
      for (var t = 0; t < 12; t++) {
        typeId = fixedType || pick(poolT);
        theme = fixedTheme || (chosen === "mixed" ? pick(NETS_THEMES[rr]) : chosen);
        if (avoid.indexOf(typeId + "|" + theme) < 0) break;
      }
      var q = makeQuestion(typeId, theme);
      if (!q) return null;
      lastTypeId = q.typeId;
      q.door = "nets";
      q.variant = q.typeId + "|" + theme;
      q.subLabel = typeLabel(q.typeId);
      q.review = { kind: "nets", netIdx: q.review.netIdx, prints: q.review.prints };
      var guide = NETS_GUIDE[q.typeId] || NETS_GUIDE.opposite;
      q.rule = guide.rule;
      q.hint = guide.hint;
      if (NETS_EXPLAIN_FIRST[q.typeId]) {
        var nl = q.explanation.indexOf("\n");
        q.explanation = NETS_EXPLAIN_FIRST[q.typeId] + (nl >= 0 ? q.explanation.slice(nl) : "");
      }
      /* cannotTouch's second sentence restates the Method line word for word, so it goes */
      if (q.typeId === "cannotTouch") q.explanation = q.explanation.replace(" A face touches its four neighbours but never its opposite.", "");
      /* the nets core finishes its own questions, so tag them here */
      tagOptions(q.options);
      q.options.forEach(function (o) { if (!o.isCorrect && o.tag === "other" && NETS_SILENT_TAG[q.typeId]) o.tag = NETS_SILENT_TAG[q.typeId]; });
      return q;
    }
    /* --- the doors --- */
    var DOORS = [
      { id: "hidden", group: "flat", label: "Hidden shapes", sub: "Find the shape inside", build: buildHidden, lab: null, watch: null, tools: null, rungs: ["Simple pictures", "More lines", "Busy pictures", "Chords cross it", "Any way up", "Any way up, busy"] },
      { id: "folding", group: "flat", label: "Paper folding", sub: "Fold, punch, unfold", build: buildFold, lab: "fold", watch: "Watch it unfold", tools: null, rungs: ["1 fold", "1 fold, 2 holes", "2 folds", "Quarter and corner folds", "3 folds", "Diagonals mixed in"] },
      { id: "matching", group: "flat", label: "Matching shape", sub: "Spun, not flipped", build: buildMatch, lab: null, watch: null, tools: null, rungs: ["Quarter turns", "Quarter turns, wobbly", "Eighth turns", "Eighth turns, wobbly", "Any angle", "Any angle, wobbly"] },
      { id: "reflection", group: "flat", label: "Reflection", sub: "The mirror image", build: buildReflect, lab: null, watch: null, tools: null, rungs: ["Vertical mirror", "Vertical, wobbly", "Vertical, tricky", "Either mirror", "Either, wobbly", "Either, tricky"] },
      { id: "combining", group: "flat", label: "Combining shapes", sub: "Join on the lettered side", build: buildCombineOrJigsaw, lab: null, watch: null, tools: null, rungs: ["Join two shapes", "Join, or find the piece", "Spun round", "Odd pieces", "Cut to the middle", "Every trap"] },
      { id: "blocks", group: "solid", label: "Block counting", sub: "5 to 20 blocks", build: buildCount, lab: "solids", watch: "Watch it turn", tools: ["spin", "peel", "reset"], rungs: ["Small piles", "Some underneath", "Bigger piles", "Three layers", "Four layers", "The biggest piles"] },
      { id: "views", group: "solid", label: "Views", sub: "Plan, front and side", build: buildViews, lab: "solids", watch: "Watch it turn", tools: ["spin", "snap", "reset"], rungs: ["Front and plan", "Front and plan, bigger", "Side too", "Three layers", "Pick the pile", "Pick the pile, bigger"] },
      { id: "rotation", group: "solid", label: "3D rotation", sub: "Same solid, turned", build: buildRotation, lab: "solids", watch: "Watch it turn", tools: ["spin", "reset"], rungs: ["The 4-block zig-zag", "5 blocks", "5 blocks, tricky", "6 blocks", "6 blocks, tricky", "7 blocks"] },
      { id: "building", group: "solid", label: "Building blocks", sub: "Which pieces make it", build: buildBuild, lab: "solids", watch: "Watch it turn", tools: ["spin", "reset"], rungs: ["5 blocks", "5 blocks, tricky", "6 blocks", "6 blocks, tricky", "7 blocks", "7 blocks, tricky"] },
      { id: "nets", group: "solid", label: "Cube nets", sub: "11 nets, fold them", build: buildNets, lab: "nets", watch: "Watch it fold", tools: null, rungs: ["Opposite faces", "Neighbours", "Missing and hidden faces", "Which cube", "Which net", "Impossible ones"] }
    ];
    var DOOR_BY_ID = {};
    DOORS.forEach(function (d) { DOOR_BY_ID[d.id] = d; });
    var RUNG_MAX = 6, RUNG_UP = 3, RUNG_DOWN = 4;
    function doorLabel(id) { return DOOR_BY_ID[id] ? DOOR_BY_ID[id].label : id; }
    /* Build with a plan: the builder gets (rung, plan); a null build is retried up to
       `tries` times, and a build whose variant sits in plan.avoid is redrawn up to
       twelve times before one is accepted anyway. A builder that keeps offering the
       same one or two variants (a rung with nothing else to give) stops early, and the
       build it falls back on is the one whose variant was served longest ago, so a
       two-variant rung alternates instead of serving the same variant five times over. */
    function planBuild(fn, rung, plan, tries) {
      var q = null, fallback = null, fallbackAge = -1, nulls = 0, repeats = 0, n = tries || 40, rejected = {}, distinct = 0;
      var avoid = plan && plan.avoid && plan.avoid.length ? plan.avoid : null;
      while (!q && nulls < n) {
        var cand = null;
        try { cand = fn(rung, plan || undefined); } catch (e) { cand = null; }
        if (!cand) { nulls++; continue; }
        if (avoid && typeof cand.variant === "string" && avoid.indexOf(cand.variant) > -1 && repeats < 12) {
          repeats++;
          var age = avoid.length - avoid.lastIndexOf(cand.variant);
          if (age > fallbackAge) { fallbackAge = age; fallback = cand; }
          if (!rejected[cand.variant]) { rejected[cand.variant] = true; distinct++; }
          if (repeats >= 4 && repeats >= 3 * distinct) break;
          continue;
        }
        q = cand;
      }
      return q || fallback;
    }
    function makeQ(doorId, rung, plan) {
      var door = DOOR_BY_ID[doorId];
      if (!door) return null;
      plan = plan && typeof plan === "object" ? plan : null;
      /* step down the ladder until a rung generates; the question keeps the rung it really came from */
      var q = null, r = clamp(rung, 1, RUNG_MAX);
      while (!q && r >= 1) { q = planBuild(door.build, r, plan, 40); if (!q) r--; }
      if (q) {
        q.door = q.door || doorId; q.rung = r; q.askedRung = rung;
        if (typeof q.variant !== "string" || !q.variant) q.variant = q.typeId || doorId;
        if (plan) q.plan = plan;
      }
      return q;
    }
    /* ---- plans: the meaningful subtypes a test schedules before any diagram is drawn.
       Weights are per 10 questions and scale to the test length; caps are per 10 too. ---- */
    var PLAN_SPECS = {
      hidden:     { rotated: [[false, 1], [true, 1]], targetCap: 2 },
      folding:    { folds: [[1, 3], [2, 4], [3, 3]], diagonalMin: 2, maxHoles: 8, lateHoles: 16 },
      matching:   { band: [["quarter", 3], ["eighth", 3], ["arbitrary", 4]] },
      reflection: { axis: [["v", 1], ["h", 1]] },
      combining:  { kind: [["join", 5], ["missing", 3], ["cutout", 2]] },
      blocks:     { size: [["S", 3], ["M", 4], ["L", 3]], tallMin: 2, tallLayers: 4 },
      views:      { which: [["front", 3], ["side", 2], ["plan", 3], ["pickpile", 2]], direct: ["front", "side", "plan"] },
      rotation:   { n: [[4, 1], [5, 1], [6, 1], [7, 1]] },
      building:   { n: [[5, 3], [6, 4], [7, 3]], small: [[2, 1], [3, 1]] },
      nets:       { typeCap: 2, themeCap: 3 }
    };
    var RECENT_WINDOW = 5;
    function historyKey(q) { return q && typeof q.variant === "string" ? q.variant : ""; }
    /* len values from weighted pairs [value, weight]: the whole shares first, the remainder
       to the largest fractional parts (ties at random), then shuffled */
    function planQuota(pairs, len) {
      var total = 0, out = [], fracs = [];
      pairs.forEach(function (p) { total += p[1]; });
      pairs.forEach(function (p, i) {
        var exact = (len * p[1]) / total, base = Math.floor(exact);
        for (var k = 0; k < base; k++) out.push(p[0]);
        fracs.push({ i: i, f: exact - base });
      });
      fracs = shuffle(fracs).sort(function (x, y) { return y.f - x.f; });
      for (var r = 0; out.length < len && fracs.length; r++) out.push(pairs[fracs[r % fracs.length].i][0]);
      return shuffle(out);
    }
    function planCap(per10, len) { return Math.max(1, Math.ceil((per10 * len) / 10)); }
    function planLeastUsed(pool, used) {
      var best = null, bestN = Infinity;
      shuffle(pool).forEach(function (t) { var n = used[t] || 0; if (n < bestN) { bestN = n; best = t; } });
      return best;
    }
    var viewsExtraTurn = 0;
    /* testPlanFor(doorId, len, rungs): len plan objects for one door. rungs (optional) is the
       rung each slot will be asked at; without it the test ladder (testRungFor) is assumed. */
    function testPlanFor(doorId, len, rungs) {
      len = Math.max(0, parseInt(len, 10) || 0);
      var plans = [], spec = PLAN_SPECS[doorId], k;
      for (k = 0; k < len; k++) plans.push({});
      if (!spec || !len) return plans;
      var rungAt = function (i) { var r = rungs && rungs[i]; return clamp(parseInt(r, 10) || testRungFor(i, len), 1, RUNG_MAX); };
      var idx = plans.map(function (_, i) { return i; });
      if (doorId === "hidden") {
        var rot = planQuota(spec.rotated, len), cap = planCap(spec.targetCap, len), tUsed = {};
        var targets = typeof HIDE_TARGETS !== "undefined" && HIDE_TARGETS && HIDE_TARGETS.length ? HIDE_TARGETS.slice() : null;
        plans.forEach(function (p, i) {
          p.rotated = !!rot[i];
          /* avoidTargets carries the plan's own earlier picks that have reached the cap */
          p.avoidTargets = targets ? targets.filter(function (t) { return (tUsed[t] || 0) >= cap; }) : [];
          if (targets) {
            /* a square or a diamond turned through 45 degrees is the other one, so neither is a rotated target */
            var pool = targets.filter(function (t) { return (tUsed[t] || 0) < cap && !(p.rotated && (t === "square" || t === "diamond")); });
            if (pool.length) { p.target = pick(pool); tUsed[p.target] = (tUsed[p.target] || 0) + 1; }
          }
        });
      } else if (doorId === "folding") {
        var folds = planQuota(spec.folds, len), diagMin = planCap(spec.diagonalMin, len), lateFrom = Math.floor((len * 2) / 3);
        plans.forEach(function (p, i) { p.folds = folds[i]; p.diagonal = false; p.maxHoles = i >= lateFrom ? spec.lateHoles : spec.maxHoles; });
        /* at least two diagonal creases per 10, a few more at random */
        shuffle(idx).forEach(function (i, order) { if (order < diagMin || ri(5) === 0) plans[i].diagonal = true; });
      } else if (doorId === "matching") {
        var bands = planQuota(spec.band, len);
        plans.forEach(function (p, i) { p.band = bands[i]; });
      } else if (doorId === "reflection") {
        var axes = planQuota(spec.axis, len);
        plans.forEach(function (p, i) { p.axis = axes[i]; });
      } else if (doorId === "combining") {
        var kinds = planQuota(spec.kind, len);
        plans.forEach(function (p, i) { p.kind = kinds[i]; });
      } else if (doorId === "blocks") {
        var sizes = planQuota(spec.size, len), tall = planCap(spec.tallMin, len), rank = { S: 0, M: 1, L: 2 };
        plans.forEach(function (p, i) { p.size = sizes[i]; p.layers = 1; });
        /* the four-layer piles go on the biggest bands first: a small pile cannot stand four high */
        var byBand = shuffle(idx).sort(function (x, y) { return rank[plans[y].size] - rank[plans[x].size]; });
        byBand.forEach(function (i, order) { plans[i].layers = order < tall ? spec.tallLayers : pick([1, 2, 2, 3]); });
      } else if (doorId === "views") {
        /* 3/2/3/2 per 10; the remainder rotates round the three direct views, test by test */
        var total = 0, base = [], sum = 0;
        spec.which.forEach(function (p) { total += p[1]; });
        spec.which.forEach(function (p) { var b = Math.floor((len * p[1]) / total); base.push([p[0], b]); sum += b; });
        var list = [];
        base.forEach(function (p) { for (var j = 0; j < p[1]; j++) list.push(p[0]); });
        var extras = spec.direct.slice(viewsExtraTurn % 3).concat(spec.direct.slice(0, viewsExtraTurn % 3)).concat(["pickpile"]);
        /* fewer slots than kinds (a door's share of a Smart mix): rotate through all four, so the
           pick-the-pile task gets its turn rather than always being the fourth in line */
        if (len < 4) { var all4 = ["front", "plan", "side", "pickpile"], from = viewsExtraTurn % 4; extras = all4.slice(from).concat(all4.slice(0, from)); }
        viewsExtraTurn++;
        for (var e = 0; list.length < len; e++) list.push(extras[e % extras.length]);
        list = shuffle(list);
        plans.forEach(function (p, i) { p.which = list[i]; });
      } else if (doorId === "rotation") {
        var ns = planQuota(spec.n, len);
        plans.forEach(function (p, i) { p.n = ns[i]; });
      } else if (doorId === "building") {
        var bn = planQuota(spec.n, len), sm = planQuota(spec.small, len);
        plans.forEach(function (p, i) { p.n = bn[i]; p.small = sm[i]; });
        /* a 5-cube solid splits 2 + 3, so its small piece is always 2: swap any 3 onto a bigger solid */
        plans.forEach(function (p) {
          if (p.n !== 5 || p.small !== 3) return;
          var swap = null;
          plans.forEach(function (o) { if (!swap && o.n !== 5 && o.small === 2) swap = o; });
          if (swap) { swap.small = 3; p.small = 2; }
        });
      } else if (doorId === "nets") {
        var tcap = planCap(spec.typeCap, len), thcap = planCap(spec.themeCap, len), tyUsed = {}, thUsed = {};
        var chosen = (el && el.themeSelect && el.themeSelect.value) || "mixed";
        plans.forEach(function (p, i) {
          var rr = rungAt(i) - 1, typeId = null;
          /* the rung's own types first, then the neighbouring rungs, then further out */
          for (var step = 0; step < NETS_RUNGS.length && !typeId; step++) {
            [rr - step, rr + step].forEach(function (r2) {
              if (typeId || r2 < 0 || r2 >= NETS_RUNGS.length) return;
              var pool = NETS_RUNGS[r2].filter(function (t) { return (tyUsed[t] || 0) < tcap; });
              if (pool.length) typeId = pick(pool);
            });
          }
          if (!typeId) typeId = pick(NETS_RUNGS[rr]);
          tyUsed[typeId] = (tyUsed[typeId] || 0) + 1;
          p.typeId = typeId;
          if (chosen === "mixed") {
            var tp = NETS_THEMES[rr].filter(function (t) { return (thUsed[t] || 0) < thcap; });
            if (!tp.length) tp = NETS_ALL_THEMES.filter(function (t) { return (thUsed[t] || 0) < thcap; });
            var theme = tp.length ? planLeastUsed(tp, thUsed) : pick(NETS_THEMES[rr]);
            thUsed[theme] = (thUsed[theme] || 0) + 1;
            p.theme = theme;
          } else p.theme = chosen;
        });
      }
      return plans;
    }
    /* rungs per door, remembered */
    function rungState(doorId) {
      store.rungs = store.rungs || {};
      if (!store.rungs[doorId]) store.rungs[doorId] = { r: 1, recent: [] };
      return store.rungs[doorId];
    }
    /* Three right at this level, in any order and with no waiting for a full set of
       five, UNLOCKS the next one: the child then decides whether to take it or stay
       and practise here. Four wrong at the same level drops back one, and clears any
       unlocked move. Returns 1 when the next level has just unlocked, -1 on a drop. */
    function rungRecord(doorId, right) {
      var rs = rungState(doorId), moved = 0;
      rs.recent.push(!!right);
      if (rs.recent.length > 12) rs.recent = rs.recent.slice(-12);
      var ok = 0, bad = 0;
      rs.recent.forEach(function (b) { if (b) ok++; else bad++; });
      if (ok >= RUNG_UP) {
        if (rs.r < RUNG_MAX && !rs.ready) { rs.ready = true; moved = 1; }
        rs.recent = [];
      } else if (bad >= RUNG_DOWN) {
        if (rs.r > 1) { rs.r--; moved = -1; }
        rs.recent = [];
        rs.ready = false;
      }
      saveStore();
      return moved;
    }
    /* the child taking the offer: the only thing that moves a level up */
    function rungClimb(doorId) {
      var rs = rungState(doorId);
      if (!rs.ready || rs.r >= RUNG_MAX) return 0;
      rs.r++;
      rs.recent = [];
      rs.ready = false;
      saveStore();
      return 1;
    }
    /* how many right at a level count as secure, and how many wrong send the child back */
    function rungProgress(doorId) {
      var rs = rungState(doorId), ok = 0, bad = 0;
      rs.recent.forEach(function (b) { if (b) ok++; else bad++; });
      return { r: rs.r, ok: ok, bad: bad, need: RUNG_UP, ready: !!rs.ready && rs.r < RUNG_MAX };
    }
    /* accuracy history per door feeds the smart mix */
    function accRecord(doorId, right) {
      store.acc = store.acc || {};
      var a = store.acc[doorId] || { n: 0, ok: 0 };
      a.n++; if (right) a.ok++;
      store.acc[doorId] = a;
    }
    function accOf(doorId) {
      var a = store.acc && store.acc[doorId];
      return a && a.n >= 4 ? a.ok / a.n : 0.65;
    }
    var mix = { queue: [], last: [] };
    function nextDoorId(selected) {
      if (selected !== "mixed") return selected;
      if (!mix.queue.length) {
        if (!mix.seeded) { mix.queue = shuffle(DOORS.map(function (d) { return d.id; })); mix.seeded = true; }
        else {
          /* weighted by how much each door still needs: 1 + 2.2 * (1 - accuracy) */
          var bag = [];
          DOORS.forEach(function (d) { var w = Math.max(1, Math.round((1 + 2.2 * (1 - accOf(d.id))) * 10)); for (var i = 0; i < w; i++) bag.push(d.id); });
          mix.queue = [pick(bag)];
        }
      }
      var id = mix.queue.shift();
      if (mix.last.length >= 2 && mix.last[0] === id && mix.last[1] === id) {
        var alt = DOORS.map(function (d) { return d.id; }).filter(function (x) { return x !== id; });
        id = pick(alt);
      }
      mix.last.push(id); if (mix.last.length > 2) mix.last.shift();
      return id;
    }
    /* The doors of a Smart mix test: every door gets the same share (one tenth of the test, rounded
       down), the remainder goes to the doors that need it most (weighted as the practice mix is,
       each door at most once), and the order is shuffled so no door comes twice in a row where the
       length allows. A 24-question test gives every door 2 or 3 questions; 40 gives every door 4. */
    function testDoorsFor(len) {
      len = Math.max(0, parseInt(len, 10) || 0);
      var ids = DOORS.map(function (d) { return d.id; }), base = Math.floor(len / ids.length), extra = len - base * ids.length, list = [];
      ids.forEach(function (id) { for (var i = 0; i < base; i++) list.push(id); });
      var bag = ids.slice();
      while (extra > 0 && bag.length) {
        var wts = bag.map(function (id) { return 1 + 2.2 * (1 - accOf(id)); }), total = 0, k = 0;
        wts.forEach(function (w) { total += w; });
        var r = Math.random() * total;
        while (k < bag.length - 1 && (r -= wts[k]) > 0) k++;
        list.push(bag[k]); bag.splice(k, 1); extra--;
      }
      var adjacent = function (xs) { var c = 0; for (var i = 1; i < xs.length; i++) if (xs[i] === xs[i - 1]) c++; return c; };
      var best = shuffle(list), bestBad = adjacent(best);
      for (var t = 0; t < 60 && bestBad > 0; t++) { var s = shuffle(list), bad = adjacent(s); if (bad < bestBad) { best = s; bestBad = bad; } }
      return best;
    }
    function testRungFor(qIndex, len) {
      var ladder = len <= 10 ? [2, 3, 3, 4, 5] : [2, 3, 3, 4, 4, 5, 5, 6];
      return ladder[qIndex % ladder.length];
    }
    /* door icons for the launcher */
    /* The launcher card picture: a real drawing from the same generators the questions
       use, at card size, so a parent can see what each puzzle looks like before opening
       anything. doorIconSvg stays as the small version for anywhere that wants a chip. */
    function doorArtSvg(id) {
      var W = 150;
      try {
        if (id === "hidden") {
          var hv = xformV(shapeV("trapezium", 24), 0, false, 50, 52);
          return svgBox("<polygon points='50,6 92,29 92,73 50,96 8,73 8,29' fill='none' stroke='" + SR_NAVY + "' stroke-width='2.6'/>" +
            "<polygon points='" + ptsStr(hv) + "' fill='#FFC21A' stroke='" + SR_NAVY + "' stroke-width='3.4'/>" +
            "<line x1='8' y1='29' x2='74' y2='40' stroke='" + SR_NAVY + "' stroke-width='2.4'/>" +
            "<line x1='92' y1='73' x2='26' y2='44' stroke='" + SR_NAVY + "' stroke-width='2.4'/>" +
            "<line x1='50' y1='6' x2='38' y2='76' stroke='" + SR_NAVY + "' stroke-width='2.4'/>", "0 0 100 100", 104, 104, "hidden shapes");
        }
        if (id === "folding") {
          var fst = ppStates(ppBuildFolds([{ kind: "v", dir: "r" }]));
          return "<span class='sr-art-pair'>" +
            ppStepSvg(fst[0], ppBuildFolds([{ kind: "v", dir: "r" }])[0], null, { width: 84, label: false }) +
            ppStepSvg(fst[1], null, [{ kind: "circle", pt: [0.26, 0.3], r: 0.06 }, { kind: "circle", pt: [0.26, 0.7], r: 0.06 }], { width: 84, label: false }) +
            "</span>";
        }
        if (id === "matching") return flSvg(flFit(FL_CHIRAL[0].pts), { width: W, fill: "#5EC8E5", label: "matching shape" });
        if (id === "reflection") return flSvg(flFit(FL_CHIRAL[2].pts, 14), { width: W, viewBox: "0 0 118 100", after: "<line x1='108' y1='6' x2='108' y2='94' stroke='" + SR_ORANGE + "' stroke-width='4' stroke-dasharray='7 5' stroke-linecap='round'/>", label: "reflection" });
        if (id === "combining") return flSvg(flFit(flGlue(FL_BASES[3].pts, 4, "tri", {})), { width: W, fill: "#6FA0F0", label: "combining shapes" });
        if (id === "blocks") return vxSvg(vxFromHeights([[2, 1, 1], [1, 2, 1], [1, 1, 3]]), { size: 19, width: W, label: "block counting" });
        if (id === "views") {
          return "<span class='sr-art-pair'>" +
            vxSvg(vxFromHeights([[1, 2], [2, 1]]), { size: 20, width: 84, label: false }) +
            gridSvg([[false, true, false], [true, true, true]], { width: 78, fill: "#82D8D5", label: false }) +
            "</span>";
        }
        if (id === "rotation") return vxSvg(vxNorm([[0, 0, 0], [1, 0, 0], [1, 1, 0], [1, 1, 1], [2, 1, 1]]), { size: 17, width: W, tint: "blue", label: "3D rotation" });
        if (id === "building") {
          return "<span class='sr-art-pair'>" +
            vxSvg(vxFromHeights([[2, 1], [1, 2]]), { size: 19, width: 84, tint: "green", label: false }) +
            vxSvg(vxNorm([[0, 0, 0], [1, 0, 0], [1, 0, 1]]), { size: 19, width: 72, label: false }) +
            "</span>";
        }
        if (id === "nets") return netSvg(0, [], { width: W, maxH: 96, label: "cube nets" });
      } catch (e) {}
      return doorIconSvg(id);
    }
    function doorIconSvg(id) {
      try {
        if (id === "hidden") { var v = xformV(shapeV("trapezium", 17), 0, false, 50, 50); return svgBox("<polygon points='50,5 92,28 92,72 50,95 8,72 8,28' fill='none' stroke='" + SR_NAVY + "' stroke-width='3'/><line x1='50' y1='5' x2='50' y2='95' stroke='" + SR_NAVY + "' stroke-width='3'/><polygon points='" + ptsStr(v) + "' fill='rgba(244,120,32,0.22)' stroke='" + SR_ORANGE + "' stroke-width='4'/>", "0 0 100 100", 44, 44, "hidden shapes"); }
        if (id === "folding") { var st = ppStates(ppBuildFolds([{ kind: "v", dir: "r" }])); return ppStepSvg(st[1], null, [{ kind: "circle", pt: [0.3, 0.3] }, { kind: "tri", pt: [0.3, 0.7] }], { width: 44, label: "paper folding" }); }
        if (id === "matching") return flSvg(flFit(FL_CHIRAL[0].pts), { width: 44, fill: "#fdeccc", label: "matching shape" });
        if (id === "reflection") return flSvg(flFit(FL_CHIRAL[2].pts, 14), { width: 44, viewBox: "0 0 118 100", after: "<line x1='108' y1='6' x2='108' y2='94' stroke='" + SR_ORANGE + "' stroke-width='4' stroke-dasharray='7 5' stroke-linecap='round'/>", label: "reflection" });
        if (id === "combining") return flSvg(flFit(flGlue(FL_BASES[3].pts, 4, "tri", {})), { width: 44, fill: "#d8e9fd", label: "combining shapes" });
        if (id === "blocks") return vxSvg(vxFromHeights([[1, 1], [1, 2]]), { size: 12, width: 44, label: "block counting" });
        if (id === "views") return gridSvg([[false, true, false], [true, true, true]], { width: 44, fill: "#d8e9fd", label: "views" });
        if (id === "rotation") return vxSvg(vxNorm([[0, 0, 0], [1, 0, 0], [1, 1, 0], [1, 1, 1], [2, 1, 1]]), { size: 10, width: 44, tint: "blue", label: "3D rotation" });
        if (id === "building") return vxSvg(vxFromHeights([[2, 1], [1, 2]]), { size: 11, width: 44, tint: "green", label: "building blocks" });
        if (id === "nets") return netSvg(0, [], { width: 40, maxH: 40, label: "cube nets" });
      } catch (e) {}
      return "";
    }
    /* ============================================================
       17. UI STATE MACHINE
       Launcher with ten doors -> full-screen shell with three tabs:
       Practice (untimed drill with a rung ladder), Lab (nets, paper,
       solids) and Test (the mock, timer optional), then a summary.
       ============================================================ */
    var NETLIST = typeof NETS !== "undefined" ? NETS : NET_DEFS;
    var el = {
      shell: root.querySelector("[data-shell]"),
      tabs: root.querySelectorAll("[data-mode-tab]"),
      labTab: root.querySelector("[data-mode-tab='lab']"),
      themeSelect: root.querySelector("[data-theme-select]"),
      qtypeSelect: root.querySelector("[data-qtype-select]"),
      blocksSelect: root.querySelector("[data-blocks-select]"),
      testlenSelect: root.querySelector("[data-testlen-select]"),
      paceSelect: root.querySelector("[data-pace-select]"),
      doorRows: { flat: root.querySelector("[data-door-row='flat']"), solid: root.querySelector("[data-door-row='solid']") },
      panel: root.querySelector("[data-question-panel]"),
      labPanel: root.querySelector("[data-lab-panel]"),
      labNets: root.querySelector("[data-lab-nets]"),
      labFold: root.querySelector("[data-lab-fold]"),
      labSolids: root.querySelector("[data-lab-solids]"),
      practiceStrip: root.querySelector("[data-practice-strip]"),
      rungs: root.querySelector("[data-rungs]"),
      climbText: root.querySelector("[data-climb-text]"),
      levelUp: root.querySelector("[data-level-up]"),
      openLabBtn: root.querySelector("[data-open-lab]"),
      scorePill: root.querySelector("[data-score-pill]"),
      scoreNum: root.querySelector("[data-score-num]"),
      progressPill: root.querySelector("[data-progress-pill]"),
      progressNum: root.querySelector("[data-progress-num]"),
      progressWrap: root.querySelector("[data-progress-wrap]"),
      progressBar: root.querySelector("[data-progress-bar]"),
      timerPill: root.querySelector("[data-timer-pill]"),
      timerNum: root.querySelector("[data-timer-num]"),
      promptText: root.querySelector("[data-prompt-text]"),
      stimulus: root.querySelector("[data-stimulus]"),
      tools: root.querySelector("[data-tools]"),
      options: root.querySelector("[data-options]"),
      feedback: root.querySelector("[data-feedback]"),
      explain: root.querySelector("[data-explain]"),
      nextBtn: root.querySelector("[data-next-btn]"),
      endTestBtn: root.querySelector("[data-end-test-btn]"),
      endPracticeBtn: root.querySelector("[data-end-practice-btn]"),
      testIntro: root.querySelector("[data-test-intro]"),
      introTitle: root.querySelector("[data-intro-title]"),
      introTimerNote: root.querySelector("[data-intro-timer-note]"),
      introBest: root.querySelector("[data-intro-best]"),
      introStartBtn: root.querySelector("[data-intro-start-btn]"),
      streakPill: root.querySelector("[data-streak-pill]"),
      streakNum: root.querySelector("[data-streak-num]"),
      keysHint: root.querySelector("[data-keys-hint]"),
      muteBtn: root.querySelector("[data-mute-btn]"),
      scorebig: root.querySelector("[data-scorebig]"),
      newBest: root.querySelector("[data-new-best]"),
      replayPanel: root.querySelector("[data-replay-panel]"),
      replayBody: root.querySelector("[data-replay-body]"),
      replayToggle: root.querySelector("[data-replay-toggle]"),
      summary: root.querySelector("[data-summary]"),
      finalScore: root.querySelector("[data-final-score]"),
      finalMessage: root.querySelector("[data-final-message]"),
      typeTable: root.querySelector("[data-type-table]"),
      reviewList: root.querySelector("[data-review-list]"),
      backPracticeBtn: root.querySelector("[data-back-practice-btn]"),
      retakeBtn: root.querySelector("[data-retake-btn]"),
      settingsChip: root.querySelector("[data-settings-chip]"),
      scroller: root.querySelector("[data-scroller]"),
      closeBtn: root.querySelector("[data-close-btn]"),
      /* the sprint launcher (2026-10-03) has no Practise button: its Start button is the opener the shell falls back to */
      openPracticeBtn: root.querySelector("[data-open-practice]") || root.querySelector("[data-sp-go]"),
      openTestBtn: root.querySelector("[data-open-test]"),
      /* nets lab */
      pgPicker: root.querySelector("[data-pg-picker]"),
      pgFlat: root.querySelector("[data-pg-flat]"),
      pgStage: root.querySelector("[data-pg-stage]"),
      pgModel: root.querySelector("[data-pg-model]"),
      pgSlider: root.querySelector("[data-pg-slider]"),
      pgFoldBtn: root.querySelector("[data-pg-fold]"),
      pgPairsBtn: root.querySelector("[data-pg-pairs]"),
      pgRandomBtn: root.querySelector("[data-pg-random]"),
      pgResetBtn: root.querySelector("[data-pg-reset]"),
      pgLegend: root.querySelector("[data-pg-pairs-legend]"),
      pgNetName: root.querySelector("[data-pg-netname]"),
      /* fold lab */
      foldRecipes: root.querySelector("[data-fold-recipes]"),
      foldStage: root.querySelector("[data-fold-stage]"),
      foldSvg: root.querySelector("[data-fold-svg]"),
      foldTitle: root.querySelector("[data-fold-title]"),
      foldSteps: root.querySelector("[data-fold-steps]"),
      foldFlat: root.querySelector("[data-fold-flat]"),
      foldSlider: root.querySelector("[data-fold-slider]"),
      foldPunch: root.querySelector("[data-fold-punch]"),
      foldUnfold: root.querySelector("[data-fold-unfold]"),
      foldNew: root.querySelector("[data-fold-new]"),
      foldReset: root.querySelector("[data-fold-reset]"),
      punchRead: root.querySelector("[data-punch-read]"),
      punchArt: root.querySelector("[data-punch-art]"),
      punchWrap: root.querySelector("[data-punch-wrap]"),
      /* solids lab */
      solidPiles: root.querySelector("[data-solid-piles]"),
      solidStage: root.querySelector("[data-solid-stage]"),
      solidSvg: root.querySelector("[data-solid-svg]"),
      solidCount: root.querySelector("[data-solid-count]"),
      solidLayer: root.querySelector("[data-solid-layer]"),
      solidSnaps: root.querySelectorAll("[data-solid-snap]"),
      solidNew: root.querySelector("[data-solid-new]"),
      drawTitle: root.querySelector("[data-draw-title]"),
      drawWhich: root.querySelector("[data-draw-which]"),
      drawGrid: root.querySelector("[data-draw-grid]"),
      drawFeedback: root.querySelector("[data-draw-feedback]"),
      drawCheck: root.querySelector("[data-draw-check]"),
      drawClear: root.querySelector("[data-draw-clear]"),
      drawShow: root.querySelector("[data-draw-show]"),
      /* markup hooks added with the navigator; every one is optional, so guard each use */
      scorebar: root.querySelector("[data-scorebar]"),
      launcher: root.querySelector("[data-launcher]"),
      slips: root.querySelector("[data-slips]"),
      settingBlocks: root.querySelector("[data-setting='blocks']"),
      settingTheme: root.querySelector("[data-setting='theme']"),
      openLabLaunch: root.querySelector("[data-open-lab-launch]"),
      stickyBar: root.querySelector(".sr-sticky-start"),
      stickyStart: root.querySelector("[data-sticky-start]"),
      palette: null, navRow: null, navBack: null, navFlag: null, navFlagText: null, navNext: null, hint: null
    };
    var state = {
      mode: "practice", door: "mixed", testActive: false, practiceActive: false, sessionKind: "test",
      testLen: 24, qIndex: 0, log: [], current: null, streak: 0, bestStreak: 0,
      timer: null, deadline: 0, remaining: 0, paused: false, viewer: null, replayViewer: null, answeredCount: 0, lab: "solids",
      /* the test navigator: every question drawn up front, picks kept until the end */
      testQs: null, testEnd: null,
      /* practice history per door: the last RECENT_WINDOW variants served, so the next draw avoids them */
      history: {}
    };
    store.rungs = store.rungs || {};
    store.acc = store.acc || {};
    var UI_ICO = {
      left: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M15 5l-7 7 7 7'/></svg>",
      right: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M9 5l7 7-7 7'/></svg>",
      up: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M5 15l7-7 7 7'/></svg>",
      down: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M5 9l7 7 7-7'/></svg>",
      flag: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M5 21V4'/><path d='M5 4h12l-2.5 4L17 12H5'/></svg>",
      bulb: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M9 18h6'/><path d='M10 22h4'/><path d='M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.3h6c0-1 .4-1.8 1-2.3A7 7 0 0 0 12 2z'/></svg>"
    };

    /* ---- the test navigator's own elements: palette + Back / Flag under the scorebar, the hint under the
       prompt. The orange dock button (data-next-btn) is the one Next / Finish test control in a test. ---- */
    (function () {
      var bar = el.scorebar;
      el.palette = root.querySelector("[data-palette]");
      if (!el.palette && bar) {
        el.palette = document.createElement("div");
        el.palette.className = "sr-palette";
        el.palette.setAttribute("data-palette", "");
        el.palette.setAttribute("role", "group");
        el.palette.setAttribute("aria-label", "Question navigator");
        el.palette.hidden = true;
        bar.insertAdjacentElement("afterend", el.palette);
      }
      el.navRow = root.querySelector("[data-nav-row]");
      if (!el.navRow && el.palette) {
        el.navRow = document.createElement("div");
        el.navRow.className = "sr-nav-row";
        el.navRow.setAttribute("data-nav-row", "");
        el.navRow.hidden = true;
        el.navRow.innerHTML = "<button type='button' class='sr-chip' data-nav-back>" + UI_ICO.left + "Back</button>" +
          "<button type='button' class='sr-chip sr-chip-flag' data-nav-flag aria-pressed='false'>" + UI_ICO.flag + "<span data-nav-flag-text>Flag for review</span></button>";
        el.palette.insertAdjacentElement("afterend", el.navRow);
      }
      if (el.navRow) {
        el.navBack = el.navRow.querySelector("[data-nav-back]");
        el.navFlag = el.navRow.querySelector("[data-nav-flag]");
        el.navFlagText = el.navRow.querySelector("[data-nav-flag-text]");
        el.navNext = el.navRow.querySelector("[data-nav-next]");
      }
      if (el.promptText) {
        el.hint = document.createElement("div");
        el.hint.className = "sr-hint";
        el.hint.setAttribute("data-hint", "");
        el.hint.setAttribute("aria-live", "polite");
        el.hint.setAttribute("tabindex", "-1");
        el.hint.hidden = true;
        el.promptText.insertAdjacentElement("afterend", el.hint);
      }
      /* accessible names and roles the markup does not carry: the palette is
         labelled above, the feedback element is the only live region in the
         question panel (markup), the clock is a timer that stays quiet, the
         prompt can take the focus when a question renders, the drawing grid's
         verdict reads out in the solids lab. */
      if (el.palette) el.palette.setAttribute("aria-label", "Question navigator");
      if (el.timerPill) { el.timerPill.setAttribute("role", "timer"); el.timerPill.setAttribute("aria-live", "off"); }
      if (el.promptText) el.promptText.setAttribute("tabindex", "-1");
      /* the summary score takes the focus when a session ends, so the result is read out */
      if (el.scorebig) el.scorebig.setAttribute("tabindex", "-1");
      if (el.drawFeedback) el.drawFeedback.setAttribute("aria-live", "polite");
    })();

    /* ---- the exercise-book layout (2026-09-14): a rail beside the picture carries the level row, the test
       navigator, the hint, the marks, the explanation, the tools and Next; the answers run along the bottom.
       Every element keeps its data hook and its listeners, only its parent changes. Below 1100px book.css
       dissolves the rail (display: contents) and orders the parts in one column. ---- */
    (function () {
      var qbody = el.promptText ? el.promptText.closest(".cnt-qbody") : null;
      if (!qbody) return;
      /* the picture and the answers share a left column, so a long explanation in the rail never pushes the
         answers down */
      var main = document.createElement("div");
      main.className = "sr-main";
      var stimwrap = qbody.querySelector(".cnt-stimwrap"), dock = qbody.querySelector(".cnt-test-dock");
      if (stimwrap) { stimwrap.insertAdjacentElement("beforebegin", main); main.appendChild(stimwrap); } else qbody.appendChild(main);
      if (dock) main.appendChild(dock);
      var rail = document.createElement("div");
      rail.className = "sr-rail";
      rail.setAttribute("data-rail", "");
      main.insertAdjacentElement("afterend", rail);
      /* the marks and Next come before the explanation, so Next never drops out of view after an answer */
      [el.practiceStrip, el.palette, el.navRow, el.hint, el.feedback, el.replayToggle, el.nextBtn, el.explain, el.tools].forEach(function (node) {
        if (node) rail.appendChild(node);
      });
      el.rail = rail;
      /* the level-up card lives beside the settings sheet, a direct child of the shell and outside the
         feedback's live region, so its buttons are not read out as status text */
      var host = document.createElement("div");
      host.className = "sr-level-host";
      host.setAttribute("data-level-host", "");
      if (el.shell) el.shell.appendChild(host);
      el.levelHost = host;
    })();

    /* ---- the shell as a dialog: the page outside goes inert while it is open,
       focus lands on the question, and goes back to the opener on close. The
       lifted shell (build_template.py) calls srShellOpening() first thing in
       openShell, srShellOpened() last, and srShellClosed() last in closeShell. ---- */
    var srInertLog = [], srOpener = null;
    /* Walk from rootEl up to body; at every level, each other child (not the
       ancestor on the path, not script / style) gets inert and aria-hidden.
       Every change is recorded, so switching off puts back exactly what was there. */
    function srInertOutside(rootEl, on) {
      if (on) {
        if (srInertLog.length) srInertOutside(rootEl, false);
        var node = rootEl;
        while (node && node !== document.body && node.parentElement) {
          var parent = node.parentElement;
          Array.prototype.forEach.call(parent.children, function (sib) {
            if (sib === node) return;
            var tag = (sib.tagName || "").toUpperCase();
            if (tag === "SCRIPT" || tag === "STYLE" || tag === "LINK" || tag === "TEMPLATE" || tag === "NOSCRIPT" || tag === "META") return;
            srInertLog.push({ el: sib, inert: sib.hasAttribute("inert"), hidden: sib.getAttribute("aria-hidden") });
            sib.setAttribute("inert", "");
            sib.setAttribute("aria-hidden", "true");
          });
          node = parent;
        }
        return;
      }
      srInertLog.forEach(function (r) {
        if (!r.inert) r.el.removeAttribute("inert");
        if (r.hidden === null) r.el.removeAttribute("aria-hidden"); else r.el.setAttribute("aria-hidden", r.hidden);
      });
      srInertLog = [];
    }
    function srVisible(node) {
      if (!node || !document.body.contains(node) || node.hidden || node.disabled) return false;
      var r = node.getBoundingClientRect ? node.getBoundingClientRect() : null;
      return !r || (r.width > 0 && r.height > 0);
    }
    function srShellOpening() {
      var a = document.activeElement;
      if (a && a !== document.body && a !== document.documentElement && !(el.shell && el.shell.contains(a))) srOpener = a;
      if (el.shell) srInertOutside(el.shell, true);
    }
    function srShellOpened() {
      if (focusPrompt()) return;
      try { el.closeBtn.focus({ preventScroll: true }); } catch (e) {}
    }
    function srShellClosed() {
      if (typeof spShellClosed === "function") spShellClosed();
      var sheet = root.querySelector("[data-settings-sheet]");
      if (sheet) sheet.hidden = true;
      clearLevelCard();
      syncShellModal();
      srInertOutside(el.shell, false);
      var target = srVisible(srOpener) ? srOpener : el.openPracticeBtn;
      srOpener = null;
      try { target.focus({ preventScroll: true }); } catch (e) {}
    }
    /* A freshly rendered question lands the focus on its prompt, so a screen
       reader hears the question first. Never while a text field or a select
       has the focus. Returns true when the prompt took it. */
    function focusPrompt() {
      var p = el.promptText;
      if (!p || p.hidden || el.panel.hidden || !state.current) return false;
      var a = document.activeElement;
      if (a && (a.tagName === "INPUT" || a.tagName === "SELECT" || a.tagName === "TEXTAREA" || a.isContentEditable)) return false;
      try { p.focus({ preventScroll: true }); } catch (e) { return false; }
      return document.activeElement === p;
    }

    /* ---- turn chips: the same four moves for every 3D viewer (voxel and paper
       share v.turn(dYaw, dPitch)). turnChipSpecs feeds the question tools row
       through toolChips; mountTurnChips builds a standalone group for the labs
       and the replay. ---- */
    var TURN_STEPS = [
      { key: "turn-left", text: "Turn left", ico: UI_ICO.left, dYaw: -30, dPitch: 0 },
      { key: "turn-right", text: "Turn right", ico: UI_ICO.right, dYaw: 30, dPitch: 0 },
      { key: "tilt-up", text: "Tilt up", ico: UI_ICO.up, dYaw: 0, dPitch: 15 },
      { key: "tilt-down", text: "Tilt down", ico: UI_ICO.down, dYaw: 0, dPitch: -15 }
    ];
    function turnChipSpecs(v, unlocked, helped, lockTitle) {
      return TURN_STEPS.map(function (st) {
        return {
          key: st.key, html: st.ico + "<span>" + st.text + "</span>", className: "sr-chip-turn", ariaLabel: st.text,
          disabled: !unlocked, title: unlocked ? "" : lockTitle,
          onClick: function () { if (!v || v.locked || typeof v.turn !== "function") return; helped(); SFX.swish(st.dYaw < 0 || st.dPitch < 0 ? "down" : "up"); v.turn(st.dYaw, st.dPitch); }
        };
      });
    }
    function mountTurnChips(host, getViewer, opts) {
      opts = opts || {};
      if (!host) return null;
      var group = document.createElement("div");
      group.className = "sr-turn-chips" + (opts.className ? " " + opts.className : "");
      group.setAttribute("role", "group");
      group.setAttribute("aria-label", opts.label || "Turn the shape");
      /* the replay mounts these inside the viewer's drag surface: a press on a chip must not start a drag */
      group.addEventListener("pointerdown", function (e) { e.stopPropagation(); });
      TURN_STEPS.forEach(function (st) {
        var b = document.createElement("button");
        b.type = "button";
        b.dataset.turn = st.key;
        b.setAttribute("aria-label", st.text);
        b.innerHTML = st.ico + "<span>" + st.text + "</span>";
        b.addEventListener("click", function () {
          var v = getViewer();
          if (!v || v.locked || typeof v.turn !== "function") return;
          if (opts.onTurn) opts.onTurn();
          /* a turn right or up swishes rising, left or down falling */
          SFX.swish(st.dYaw < 0 || st.dPitch < 0 ? "down" : "up");
          v.turn(st.dYaw, st.dPitch);
        });
        group.appendChild(b);
      });
      host.appendChild(group);
      return group;
    }

    /* ---- launcher: doors and settings ---- */
    DOORS.forEach(function (d) {
      var opt = document.createElement("option");
      opt.value = d.id; opt.textContent = d.label;
      el.qtypeSelect.appendChild(opt);
    });
    function renderDoors() {
      ["flat", "solid"].forEach(function (g) {
        var row = el.doorRows[g];
        /* the sprint launcher (2026-10-03) shows a sticker wall instead of the door rows (sprint.js) */
        if (!row) return;
        row.innerHTML = "";
        DOORS.filter(function (d) { return d.group === g; }).forEach(function (d) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "sr-door" + (state.door === d.id ? " is-on" : "");
          btn.setAttribute("aria-pressed", state.door === d.id ? "true" : "false");
          btn.dataset.door = d.id;
          btn.innerHTML = "<span class='sr-door-ic' aria-hidden='true'>" + doorArtSvg(d.id) + "</span>" +
            "<span class='sr-door-say'><span class='sr-door-name'>" + esc(d.label) + "</span><span class='sr-door-sub'>" + esc(d.sub) + "</span></span>" +
            "<span class='sr-door-flag' aria-hidden='true'>" + ICO.tick + "Picked</span>";
          btn.addEventListener("click", function () { SFX.ui("level", DOORS.indexOf(d) + 1); selectDoor(state.door === d.id ? "mixed" : d.id); });
          row.appendChild(btn);
        });
      });
    }
    function selectDoor(id) {
      state.door = id;
      el.qtypeSelect.value = id;
      Array.prototype.forEach.call(root.querySelectorAll(".sr-door"), function (b) {
        var on = b.dataset.door === id;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var mixBtn = root.querySelector("[data-mix-toggle]");
      if (mixBtn) mixBtn.setAttribute("data-on", id === "mixed" ? "true" : "false");
      renderIntroBest();
      updateChip();
      syncSettingRows();
      savePrefs();
      /* changed from the settings sheet with the app open: the setup card's title and the Lab tab follow at once */
      if (el.shell && el.shell.classList.contains("is-open") && !state.testActive) applyModeVisibility();
      /* the saved sprint round follows the picked puzzle (sprint.js) */
      if (typeof spDoorChanged === "function") spDoorChanged(id);
    }
    /* the blocks setting only matters to the solid doors, the symbols setting only to cube nets */
    var BLOCKS_DOORS = { mixed: true, blocks: true, views: true, rotation: true, building: true };
    var THEME_DOORS = { mixed: true, nets: true };
    function syncSettingRows() {
      var v = el.qtypeSelect.value || state.door;
      if (el.settingBlocks) el.settingBlocks.hidden = !BLOCKS_DOORS[v];
      if (el.settingTheme) el.settingTheme.hidden = !THEME_DOORS[v];
    }
    function doorName() { return state.door === "mixed" ? "Smart mix" : doorLabel(state.door); }
    function updateChip() {
      if (!el.settingsChip) return;
      var txt = doorName();
      if (state.mode === "test") txt += " · " + el.testlenSelect.value + " questions" + (el.paceSelect.value === "exam" ? " · timed" : "");
      if (state.mode === "practice" && state.current && state.current.q) txt = doorLabel(state.current.q.door) + " · level " + rungState(state.current.q.door).r;
      if (state.mode === "lab") txt = state.lab === "nets" ? "Cube nets lab" : state.lab === "fold" ? "Fold lab" : "Solids lab";
      el.settingsChip.textContent = txt;
    }
    function labFor(doorId) {
      if (doorId === "mixed") return state.lab || "solids";
      var d = DOOR_BY_ID[doorId];
      return d ? d.lab : null;
    }

    /* ---- nets lab (as on the Cube Nets page) ---- */
    var pg = { netIdx: 0, prints: null, showPairs: false, fold: 0, rotX: -26, rotY: 36, dragging: false, lastX: 0, lastY: 0 };
    function pgPairsMap() {
      if (!pg.showPairs) return null;
      var info = foldNet(pg.netIdx), map = {}, seen = {}, next = 0;
      for (var i = 0; i < 6; i++) {
        var o = info.opposite[i], k = Math.min(i, o) + "-" + Math.max(i, o);
        if (typeof seen[k] === "undefined") { seen[k] = next; next++; }
        map[i] = seen[k];
      }
      return map;
    }
    function renderPgPicker() {
      el.pgPicker.innerHTML = "";
      NETLIST.forEach(function (net, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cnt-pg-net" + (i === pg.netIdx ? " is-active" : "");
        btn.setAttribute("aria-pressed", i === pg.netIdx ? "true" : "false");
        var b = netBounds(i), side = 92, w = b.cols >= b.rows ? side : Math.round((side * b.cols) / b.rows);
        btn.title = net.id + " · " + net.label;
        btn.setAttribute("aria-label", "Net " + net.id + ", " + net.label);
        btn.innerHTML = "<span class='cnt-pg-net-name'><strong>" + esc(net.id) + "</strong><em> &middot; " + esc(net.label) + "</em></span>" +
          "<span class='cnt-pg-thumb'>" + netSvg(i, [], { width: w, maxH: 40, label: "net " + net.id + ", " + net.label }) + "</span>";
        btn.addEventListener("click", function () { SFX.ui("level", i + 1); pg.netIdx = i; renderPlayground(); });
        el.pgPicker.appendChild(btn);
      });
    }
    function renderPgLegend() {
      if (el.pgNetName) el.pgNetName.textContent = NETLIST[pg.netIdx].id + " · " + NETLIST[pg.netIdx].label;
      var pairs = pgPairsMap();
      if (!pairs) { el.pgLegend.hidden = true; el.pgLegend.innerHTML = ""; return; }
      var info = foldNet(pg.netIdx), seen = {}, rows = "";
      for (var i = 0; i < 6; i++) {
        var k = pairs[i];
        if (typeof seen[k] !== "undefined") continue;
        seen[k] = true;
        var j = info.opposite[i], pc = PAIR_COLOURS[k % 3];
        rows += "<span class='cnt-pair'><i style='color:" + pc + "'>" + (k + 1) + "</i>" +
          faceCardSvg({ g: pg.prints[i].g, rot: pg.prints[i].rho, col: pg.prints[i].col, row: pg.prints[i].row }, { width: 28, label: glyphName(pg.prints[i].g) }) +
          "<b>opposite</b>" +
          faceCardSvg({ g: pg.prints[j].g, rot: pg.prints[j].rho, col: pg.prints[j].col, row: pg.prints[j].row }, { width: 28, label: glyphName(pg.prints[j].g) }) + "</span>";
      }
      el.pgLegend.innerHTML = rows;
      el.pgLegend.hidden = false;
    }
    function renderPgFlat() {
      el.pgFlat.innerHTML = netSvg(pg.netIdx, pg.prints, { width: 260, pairs: pgPairsMap(), label: "the flat net" });
      renderPgLegend();
    }
    function pgApplyNodeFold(node) {
      if (node.dataset.dx !== undefined) {
        var dx = Number(node.dataset.dx), dy = Number(node.dataset.dy), depth = Number(node.dataset.depth || 0);
        var delay = Math.min(0.38, depth * 0.075), t = smoother(clamp((pg.fold / 100 - delay) / (1 - delay), 0, 1)), tf = "";
        if (dx === 1) tf = "rotateY(" + (90 * t) + "deg)";
        if (dx === -1) tf = "rotateY(" + (-90 * t) + "deg)";
        if (dy === 1) tf = "rotateX(" + (-90 * t) + "deg)";
        if (dy === -1) tf = "rotateX(" + (90 * t) + "deg)";
        node.style.transform = tf;
      }
      Array.prototype.forEach.call(node.children, function (child) { if (child.classList && child.classList.contains("cnt-node")) pgApplyNodeFold(child); });
    }
    function pgApplyAll() {
      el.pgModel.style.transform = "rotateX(" + pg.rotX + "deg) rotateY(" + pg.rotY + "deg)";
      var rootNode = el.pgModel.querySelector(".cnt-node-root");
      if (rootNode) pgApplyNodeFold(rootNode);
      el.pgSlider.value = String(Math.round(pg.fold));
      el.pgFoldBtn.textContent = pg.fold < 50 ? "Close cube" : "Open net";
    }
    function pgFaceSize() {
      var r = el.pgStage.getBoundingClientRect(), w = r.width || 600, h = r.height || 400;
      var f = Math.round(Math.max(56, Math.min(w * 0.16, h * 0.22, 220)));
      el.pgStage.style.setProperty("--cnt-face3d", f + "px");
      return f;
    }
    function renderPgModel() {
      var info = foldNet(pg.netIdx), pairs = pgPairsMap(), F = pgFaceSize();
      el.pgModel.innerHTML = "";
      function makeNode(faceIdx) {
        var node = document.createElement("div");
        node.className = "cnt-node";
        var parent = info.parents[faceIdx];
        if (!parent) node.classList.add("cnt-node-root");
        else {
          node.dataset.dx = String(parent.dx); node.dataset.dy = String(parent.dy); node.dataset.depth = String(parent.depth);
          if (parent.dx === 1) { node.style.left = F + "px"; node.style.top = "0px"; node.style.transformOrigin = "left center"; }
          if (parent.dx === -1) { node.style.left = -F + "px"; node.style.top = "0px"; node.style.transformOrigin = "right center"; }
          if (parent.dy === 1) { node.style.left = "0px"; node.style.top = F + "px"; node.style.transformOrigin = "center top"; }
          if (parent.dy === -1) { node.style.left = "0px"; node.style.top = -F + "px"; node.style.transformOrigin = "center bottom"; }
        }
        var face = document.createElement("div");
        face.className = "cnt-3dface";
        face.innerHTML = face3dSvg(pg.prints[faceIdx], pairs ? pairs[faceIdx] : undefined);
        node.appendChild(face);
        info.children[faceIdx].forEach(function (childIdx) { node.appendChild(makeNode(childIdx)); });
        return node;
      }
      el.pgModel.appendChild(makeNode(info.rootIdx));
      pgApplyAll();
    }
    function renderPlayground() { renderPgPicker(); renderPgFlat(); renderPgModel(); }
    function pgSetFold(v) { pg.fold = clamp(Number(v), 0, 100); pgApplyAll(); }
    function pgAnimateFold(target) {
      var start = pg.fold, diff = target - start, t0 = null;
      if (document.hidden) { pgSetFold(target); return; }
      function frame(ts) { if (t0 === null) t0 = ts; var p = clamp((ts - t0) / 2400, 0, 1); pgSetFold(start + diff * smoother(p)); if (p < 1) requestAnimationFrame(frame); }
      requestAnimationFrame(frame);
    }
    /* a note each time the fold crosses a tenth, never one per input event */
    el.pgSlider.addEventListener("input", function () { var was = Math.round(pg.fold / 10); pgSetFold(el.pgSlider.value); if (Math.round(pg.fold / 10) !== was) SFX.ui("slide", Math.round(pg.fold / 10) / 10); });
    /* Close cube folds the net shut, Open net lays it flat again */
    el.pgFoldBtn.addEventListener("click", function () { if (pg.fold < 50) SFX.fold(); else SFX.fold("open"); pgAnimateFold(pg.fold < 50 ? 100 : 0); });
    el.pgPairsBtn.addEventListener("click", function () {
      pg.showPairs = !pg.showPairs;
      SFX.ui(pg.showPairs ? "on" : "off");
      el.pgPairsBtn.textContent = pg.showPairs ? "Hide opposite pairs" : "Show opposite pairs";
      renderPgFlat(); renderPgModel();
    });
    el.pgRandomBtn.addEventListener("click", function () { SFX.shuffle(); pg.prints = randomPrints(el.themeSelect.value); renderPgFlat(); renderPgModel(); });
    el.pgResetBtn.addEventListener("click", function () { SFX.ui("restart"); pg.rotX = -26; pg.rotY = 36; pgApplyAll(); });
    (function () {
      var stage = el.pgStage, downX = 0, downY = 0;
      function down(e) { pg.dragging = true; pg.lastX = downX = e.clientX; pg.lastY = downY = e.clientY; try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
      function move(e) { if (!pg.dragging) return; pg.rotY += (e.clientX - pg.lastX) * 0.5; pg.rotX = clamp(pg.rotX - (e.clientY - pg.lastY) * 0.5, -89, 89); pg.lastX = e.clientX; pg.lastY = e.clientY; pgApplyAll(); e.preventDefault(); }
      function up() { pg.dragging = false; }
      /* silent while it turns, one swish as it lets go (rising for a drag right or up, falling for left or down); a tap is not a drag */
      function release(e) {
        var dx = e.clientX - downX, dy = e.clientY - downY;
        if (pg.dragging && Math.abs(dx) + Math.abs(dy) >= 6) SFX.swish((Math.abs(dx) >= Math.abs(dy) ? dx : -dy) < 0 ? "down" : "up");
        up();
      }
      stage.addEventListener("pointerdown", down); stage.addEventListener("pointermove", move); stage.addEventListener("pointerup", release); stage.addEventListener("pointercancel", up); stage.addEventListener("pointerleave", up);
    })();

    /* ---- fold lab ---- */
    var fl = { recipe: PP_LAB_RECIPES[0], folds: null, holes: [], viewer: null, kinds: ["circle", "tri", "square", "diamond"], ki: 0, punchPts: [] };
    /* the hole the lab punches: small enough that most of the 64 squares are open */
    function flHoleR() { return Math.min(ppHoleR(ppStates(fl.folds)[fl.folds.length], 2), 0.05); }
    function flSetRecipe(rec) {
      fl.recipe = rec;
      fl.folds = ppBuildFolds(rec.kinds);
      fl.holes = []; fl.punchPts = []; fl.ki = 0;
      Array.prototype.forEach.call(el.foldRecipes.querySelectorAll(".sr-recipe"), function (b) { b.classList.toggle("is-active", b.dataset.recipe === rec.id); });
      if (fl.viewer) fl.viewer.setFolds(fl.folds, fl.holes); else fl.viewer = mountPaperViewer(el.foldSvg, fl.folds, fl.holes, { onChange: flSync });
      fl.viewer.setT(0);
      flSync(fl.viewer);
      flRenderPunch();
      flReadOut("");
      el.foldTitle.textContent = rec.label;
    }
    function flSync(v) {
      var nF = fl.folds.length, t = v.t;
      el.foldSlider.value = String(Math.round((t / Math.max(1, nF)) * 100));
      var folded = t >= nF - 1e-6;
      el.foldPunch.disabled = false;
      el.foldPunch.textContent = folded ? "Punch anywhere" : "Fold it and punch anywhere";
      el.foldUnfold.textContent = t <= 1e-6 ? "Fold it up" : "Unfold";
      var steps = "";
      fl.folds.forEach(function (f, i) {
        var cls = t >= i + 1 - 1e-6 ? "" : (t > i ? " is-now" : " is-todo");
        steps += "<div class='sr-step" + cls + "'><i>" + (t >= i + 1 - 1e-6 ? ICO.tick : (i + 1)) + "</i>" + esc(f.text) + "</div>";
      });
      var punched = fl.holes.length > 0;
      steps += "<div class='sr-step" + (punched ? "" : (folded ? " is-now" : " is-todo")) + "'><i>" + (punched ? ICO.tick : (nF + 1)) + "</i>Punch a hole or two</div>";
      steps += "<div class='sr-step" + (punched && t < nF - 1e-6 ? (t <= 1e-6 ? "" : " is-now") : " is-todo") + "'><i>" + (punched && t <= 1e-6 ? ICO.tick : (nF + 2)) + "</i>Unfold and check the mirrors</div>";
      el.foldSteps.innerHTML = steps;
      el.foldFlat.innerHTML = ppSheetSvg(fl.holes, { width: 150, lines: ppFoldLinesSheet(fl.folds), label: "the sheet unfolded" });
    }
    function flRenderRecipes() {
      el.foldRecipes.innerHTML = "";
      PP_LAB_RECIPES.forEach(function (rec, ri) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "sr-recipe";
        btn.dataset.recipe = rec.id;
        btn.innerHTML = ppRecipeIcon(rec) + "<span>" + esc(rec.label) + "</span>";
        btn.addEventListener("click", function () { SFX.ui("select", ri); flSetRecipe(rec); });
        el.foldRecipes.appendChild(btn);
      });
    }
    /* ---- punching by hand ----
       The card shows the folded stack drawn on the sheet it came from, so tapping
       it is tapping the paper: the tap point maps straight through the picture's
       own box to a point on the sheet, and the hole is punched there. */
    function flPunchAt(pt) {
      if (!fl.viewer) return;
      var nF = fl.folds.length;
      var doPunch = function () {
        var final = ppStates(fl.folds)[nF], hr = flHoleR();
        fl.punchPts.push(pt);
        fl.holes = fl.holes.concat(ppPunch(final, pt, fl.kinds[fl.ki++ % fl.kinds.length], hr));
        fl.viewer.setHoles(fl.holes);
        flRenderPunch();
        flReadOut("done");
        /* each hole climbs a note, up to nine; taking one out steps back down */
        SFX.place(Math.min(1, fl.punchPts.length / 9));
      };
      if (fl.viewer.t < nF - 1e-6) fl.viewer.animateT(nF, 900, doPunch); else doPunch();
    }
    function flRenderPunch() {
      if (!el.punchArt || !fl.folds) return;
      var final = ppStates(fl.folds)[fl.folds.length];
      el.punchArt.innerHTML = ppFoldedTopSvg(final, fl.punchPts, flHoleR(), { width: 208, label: false });
    }
    var FL_READ = { "": "tap the paper", off: "that spot is off the folded paper",
      close: "no room for a hole there", done: "hole punched", gone: "hole taken out" };
    function flReadOut(kind) {
      if (el.punchRead) el.punchRead.textContent = FL_READ[kind] || FL_READ[""];
    }
    /* the picture is drawn on a -1 -1 102 102 box over the unit sheet, so a tap
       maps back through that box whatever size the card ends up */
    function flPointFromEvent(e) {
      var svg = el.punchArt.querySelector("svg");
      if (!svg) return null;
      var r = svg.getBoundingClientRect();
      if (!r.width || !r.height) return null;
      return [(-1 + ((e.clientX - r.left) / r.width) * 102) / 100, (-1 + ((e.clientY - r.top) / r.height) * 102) / 100];
    }
    /* Tapping a hole takes it out again, with every copy it made: punching is a toggle, so
       a child can change their mind without starting the recipe over. */
    function flHoleAt(pt) {
      var r = flHoleR(), best = -1, bestD = r * 1.6;
      fl.punchPts.forEach(function (q, i) {
        var dd = Math.hypot(q[0] - pt[0], q[1] - pt[1]);
        if (dd < bestD) { bestD = dd; best = i; }
      });
      return best;
    }
    function flRemovePunch(i) {
      var gone = fl.punchPts[i];
      fl.punchPts = fl.punchPts.filter(function (_, k) { return k !== i; });
      fl.holes = fl.holes.filter(function (h) {
        return !(h.pt && Math.abs(h.pt[0] - gone[0]) < 1e-9 && Math.abs(h.pt[1] - gone[1]) < 1e-9);
      });
      if (fl.viewer) fl.viewer.setHoles(fl.holes);
      flRenderPunch();
      flReadOut("gone");
      SFX.remove(Math.min(1, fl.punchPts.length / 9));
    }
    if (el.punchWrap) {
      el.punchWrap.addEventListener("click", function (e) {
        if (!fl.folds) return;
        var pt = flPointFromEvent(e);
        if (!pt) return;
        var hit = flHoleAt(pt);
        if (hit >= 0) { flRemovePunch(hit); return; }
        var final = ppStates(fl.folds)[fl.folds.length];
        var hr = flHoleR();
        var spot = ppNearestPunch(final, pt, hr, fl.punchPts);
        if (!spot) { flReadOut(ppPunchable(final, pt, hr, []) ? "off" : "close"); SFX.ui("denied"); return; }
        flPunchAt(spot);
      });
      el.punchWrap.addEventListener("keydown", function (e) {
        /* Enter or Space on the card punches somewhere free, the way the dock button does */
        if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
        e.preventDefault();
        if (!fl.folds) return;
        var pt = ppRandomPoint(ppStates(fl.folds)[fl.folds.length], fl.punchPts, flHoleR());
        if (pt) flPunchAt(pt); else { flReadOut("close"); SFX.ui("denied"); }
      });
    }
    /* a note each time the fold crosses a tenth, never one per input event */
    el.foldSlider.addEventListener("input", function () { if (fl.viewer) { var nF = Math.max(1, fl.folds.length), was = Math.round((fl.viewer.t / nF) * 10); fl.viewer.stop(); fl.viewer.setT((Number(el.foldSlider.value) / 100) * fl.folds.length); if (Math.round((fl.viewer.t / nF) * 10) !== was) SFX.ui("slide", Math.round((fl.viewer.t / nF) * 10) / 10); } });
    el.foldPunch.addEventListener("click", function () {
      if (!fl.viewer) return;
      var pt = ppRandomPoint(ppStates(fl.folds)[fl.folds.length], fl.punchPts, flHoleR());
      if (pt) flPunchAt(pt); else SFX.ui("denied");
    });
    el.foldUnfold.addEventListener("click", function () { if (!fl.viewer) return; if (fl.viewer.t <= 1e-6) SFX.fold(); else SFX.fold("open"); fl.viewer.animateT(fl.viewer.t <= 1e-6 ? fl.folds.length : 0, 700 + 900 * fl.folds.length); });
    el.foldNew.addEventListener("click", function () { SFX.shuffle(); var i = PP_LAB_RECIPES.indexOf(fl.recipe); flSetRecipe(PP_LAB_RECIPES[(i + 1) % PP_LAB_RECIPES.length]); });
    el.foldReset.addEventListener("click", function () { if (fl.viewer) { SFX.ui("restart"); fl.viewer.yaw = 40; fl.viewer.pitch = 38; fl.viewer.render(); } });

    /* ---- solids lab: spin, peel, snap, draw the view ---- */
    var sl = { cubes: null, viewer: null, which: "front", taps: {}, marks: null, pileSizes: [6, 10, 14, 17, 20] };
    function slNewPile(n) {
      var heights = null;
      for (var t = 0; t < 30 && !heights; t++) heights = vxRandomPile(n, n <= 8 ? 3 : 4, n <= 8 ? 2 : n <= 16 ? 3 : 4);
      if (!heights) return;
      sl.cubes = vxFromHeights(heights);
      sl.taps = {}; sl.marks = null;
      var K = vxBounds(sl.cubes).K;
      el.solidLayer.max = String(K); el.solidLayer.value = String(K);
      if (sl.viewer) { sl.viewer.setCubes(sl.cubes); sl.viewer.layerCap = null; sl.viewer.setHl(null); sl.viewer.home(0); }
      else sl.viewer = mountVoxelViewer(el.solidSvg, sl.cubes, { size: 60, markers: true, label: "a pile of blocks" });
      el.solidCount.innerHTML = "<strong>" + n + "</strong> blocks";
      Array.prototype.forEach.call(el.solidPiles.querySelectorAll(".sr-recipe"), function (b) { b.classList.toggle("is-active", Number(b.dataset.n) === n); });
      slRenderDraw();
    }
    function slRenderPiles() {
      el.solidPiles.innerHTML = "";
      sl.pileSizes.forEach(function (n, ni) {
        var btn = document.createElement("button");
        btn.type = "button"; btn.className = "sr-recipe"; btn.dataset.n = String(n);
        btn.innerHTML = vxSvg(vxFromHeights(n <= 6 ? [[1, 1], [1, 2]] : n <= 10 ? [[2, 1], [1, 2]] : n <= 15 ? [[2, 2], [2, 1], [1, 1]] : [[3, 2], [2, 2], [2, 1]]), { size: 9, width: 40, label: n + " blocks" }) + "<span>" + n + " blocks</span>";
        /* the piles pluck an octave above the view chips beside them, climbing with the pile */
        btn.addEventListener("click", function () { SFX.ui("select", 5 + ni); slNewPile(n); });
        el.solidPiles.appendChild(btn);
      });
    }
    function slTarget() { return vxViews(sl.cubes)[sl.which]; }
    function slViewName() { return sl.which === "plan" ? "plan view" : sl.which + " view"; }
    function slGridDims() {
      var b = vxBounds(sl.cubes);
      var cols = sl.which === "plan" ? b.J : sl.which === "front" ? b.J : b.I, rows = sl.which === "plan" ? b.I : b.K;
      return { cols: Math.max(cols + 1, 3), rows: Math.max(rows + 1, 3) };
    }
    function slCellLabel(r, c, on, mark) {
      return "Row " + (r + 1) + ", column " + (c + 1) + ", " + (on ? "filled" : "empty") + (mark === "wrong" ? ", should be empty" : mark === "missing" ? ", missing" : "");
    }
    /* The drawing grid is a block of real buttons (drawGridButtonsHtml, voxel.js)
       dropped straight into [data-draw-grid] as .sr-cells, so spatial.css sizes
       the tracks from --sr-cols. sl.taps stays the source of truth: a repaint
       updates the cells in place (the focused square keeps its focus) and only
       rebuilds when the footprint changes. */
    function slPaintGrid() {
      var d = slGridDims(), grid = el.drawGrid, cells = grid.querySelectorAll(".sr-cell");
      var label = "Draw the " + slViewName() + ": " + d.rows + " rows by " + d.cols + " columns. Arrow keys move between the squares, Space fills or clears one";
      grid.setAttribute("role", "group");
      grid.setAttribute("aria-label", label);
      if (cells.length !== d.cols * d.rows || grid.dataset.cols !== String(d.cols)) {
        var tmp = document.createElement("div");
        tmp.innerHTML = drawGridButtonsHtml(d.cols, d.rows, sl.taps, sl.marks, { role: "group", label: label });
        var wrap = tmp.firstElementChild;
        grid.innerHTML = wrap ? wrap.innerHTML : "";
        grid.classList.add("sr-cells");
        grid.dataset.cols = String(d.cols); grid.dataset.rows = String(d.rows);
        grid.style.setProperty("--sr-cols", String(d.cols));
        grid.style.setProperty("--sr-rows", String(d.rows));
        return;
      }
      Array.prototype.forEach.call(cells, function (cell) {
        var k = cell.dataset.cell, on = !!sl.taps[k], mark = sl.marks && sl.marks[k];
        cell.classList.toggle("is-on", on);
        cell.classList.toggle("is-wrong", mark === "wrong");
        cell.classList.toggle("is-missing", mark === "missing");
        cell.setAttribute("aria-pressed", on ? "true" : "false");
        cell.setAttribute("aria-label", slCellLabel(Number(cell.dataset.r), Number(cell.dataset.c), on, mark));
      });
    }
    function slRenderDraw() {
      slPaintGrid();
      el.drawTitle.textContent = sl.which === "plan" ? "from the top" : "from the " + sl.which;
      el.drawWhich.innerHTML = ["front", "side", "plan"].map(function (w) { return "<button type='button' class='sr-chip sr-chip-light" + (w === sl.which ? " is-on" : "") + "' data-draw-view='" + w + "'>" + (w === "plan" ? "Plan (top)" : w.charAt(0).toUpperCase() + w.slice(1)) + "</button>"; }).join("");
      Array.prototype.forEach.call(el.drawWhich.querySelectorAll("[data-draw-view]"), function (btn) {
        btn.addEventListener("click", function () { SFX.ui("select", ["front", "side", "plan"].indexOf(btn.dataset.drawView)); sl.which = btn.dataset.drawView; sl.taps = {}; sl.marks = null; el.drawFeedback.textContent = "Tap the squares, then Check."; el.drawFeedback.className = "sr-draw-fb"; slRenderDraw(); });
      });
    }
    /* a tap, a click, Space or Enter toggles a square (the cells are buttons); the arrow keys walk the grid */
    el.drawGrid.addEventListener("click", function (e) {
      var cell = e.target && e.target.closest ? e.target.closest(".sr-cell") : null;
      if (!cell || !sl.cubes) return;
      var k = cell.dataset.cell;
      if (sl.taps[k]) delete sl.taps[k]; else sl.taps[k] = true;
      /* a square in climbs with how full the grid is (never with the answer), a square out drops */
      var dims = slGridDims(), full = Object.keys(sl.taps).length / Math.max(1, dims.cols * dims.rows);
      if (sl.taps[k]) SFX.place(full); else SFX.remove(full);
      sl.marks = null;
      slPaintGrid();
    });
    el.drawGrid.addEventListener("keydown", function (e) {
      var cell = e.target && e.target.closest ? e.target.closest(".sr-cell") : null;
      if (!cell || e.altKey || e.ctrlKey || e.metaKey) return;
      var k = e.key, dr = 0, dc = 0;
      if (k === "ArrowLeft" || k === "Left") dc = -1;
      else if (k === "ArrowRight" || k === "Right") dc = 1;
      else if (k === "ArrowUp" || k === "Up") dr = -1;
      else if (k === "ArrowDown" || k === "Down") dr = 1;
      else return;
      e.preventDefault();
      var next = el.drawGrid.querySelector(".sr-cell[data-r='" + (Number(cell.dataset.r) + dr) + "'][data-c='" + (Number(cell.dataset.c) + dc) + "']");
      if (next) next.focus();
    });
    /* the target grid drawn into the tap grid's frame: align the view's bottom-left to the frame's bottom-left */
    function slTargetCells() {
      var g = slTarget(), b = vxBounds(sl.cubes);
      var rows = sl.which === "plan" ? b.I : b.K;
      var frameRows = Math.max(rows + 1, 3), out = {};
      var offR = sl.which === "plan" ? 0 : frameRows - rows;
      g.forEach(function (row, r) { row.forEach(function (on, c) { if (on) out[c + "," + (r + offR)] = true; }); });
      return out;
    }
    el.drawCheck.addEventListener("click", function () {
      var target = slTargetCells(), marks = {}, wrong = 0, missing = 0;
      Object.keys(sl.taps).forEach(function (k) { if (!target[k]) { marks[k] = "wrong"; wrong++; } });
      Object.keys(target).forEach(function (k) { if (!sl.taps[k]) { marks[k] = "missing"; missing++; } });
      sl.marks = marks;
      slRenderDraw();
      if (!wrong && !missing) { el.drawFeedback.textContent = "Spot on. That is the " + (sl.which === "plan" ? "plan" : sl.which + " view") + "."; el.drawFeedback.className = "sr-draw-fb is-good"; SFX.right(); }
      else { el.drawFeedback.textContent = (wrong ? wrong + " square" + (wrong === 1 ? "" : "s") + " should not be there" : "") + (wrong && missing ? ", " : "") + (missing ? missing + " missing (shown in green)" : "") + "."; el.drawFeedback.className = "sr-draw-fb is-bad"; SFX.wrong(); }
    });
    el.drawClear.addEventListener("click", function () { SFX.ui("restart"); sl.taps = {}; sl.marks = null; el.drawFeedback.textContent = "Tap the squares, then Check."; el.drawFeedback.className = "sr-draw-fb"; slRenderDraw(); });
    el.drawShow.addEventListener("click", function () { SFX.reveal(); sl.taps = slTargetCells(); sl.marks = null; el.drawFeedback.textContent = "That is the " + (sl.which === "plan" ? "plan" : sl.which + " view") + ". Watch the pile turn to it."; el.drawFeedback.className = "sr-draw-fb"; slRenderDraw(); if (sl.viewer) sl.viewer.snap(sl.which, 900); });
    /* one note for each layer the slider moves to, low at the ground, high at the top */
    el.solidLayer.addEventListener("input", function () { if (!sl.viewer) return; var K = vxBounds(sl.cubes).K, v = Number(el.solidLayer.value), was = sl.viewer.layerCap == null ? K : sl.viewer.layerCap; sl.viewer.setLayerCap(v >= K ? null : v); if (Math.min(v, K) !== was) SFX.ui("slide", K > 1 ? (Math.min(v, K) - 1) / (K - 1) : 1); });
    Array.prototype.forEach.call(el.solidSnaps, function (btn) {
      btn.addEventListener("click", function () { if (!sl.viewer) return; var w = btn.dataset.solidSnap; if (w === "reset") { sl.viewer.layerCap = null; el.solidLayer.value = el.solidLayer.max; sl.viewer.home(500); } else sl.viewer.snap(w, 800); });
    });
    el.solidNew.addEventListener("click", function () { SFX.shuffle(); slNewPile(pick(sl.pileSizes)); });
    /* turn chips beside the lab controls: the pile and the paper answer to the same four moves */
    mountTurnChips(el.labSolids ? el.labSolids.querySelector(".cnt-pg-dock") : null, function () { return sl.viewer; }, { label: "Turn the pile" });
    mountTurnChips(el.labFold ? el.labFold.querySelector(".cnt-pg-dock") : null, function () { return fl.viewer; }, { label: "Turn the paper" });

    /* ---- labs: which one shows ---- */
    var labSwitch = document.createElement("div");
    labSwitch.className = "sr-tools";
    labSwitch.style.padding = "12px 12px 0";
    labSwitch.innerHTML = ["fold", "nets", "solids"].map(function (k) { return "<button type='button' class='sr-chip' data-lab-switch='" + k + "'>" + (k === "fold" ? "Fold lab" : k === "nets" ? "Cube nets lab" : "Solids lab") + "</button>"; }).join("");
    el.labPanel.insertBefore(labSwitch, el.labPanel.firstChild);
    /* the lab chips knock three notes above the shell's own tabs, so the two rows never share a sound */
    Array.prototype.forEach.call(labSwitch.querySelectorAll("[data-lab-switch]"), function (b, bi) { b.addEventListener("click", function () { SFX.ui("tab", bi + 3); showLab(b.dataset.labSwitch); }); });
    function showLab(which) {
      state.lab = which;
      el.labNets.hidden = which !== "nets";
      el.labFold.hidden = which !== "fold";
      el.labSolids.hidden = which !== "solids";
      Array.prototype.forEach.call(labSwitch.querySelectorAll("[data-lab-switch]"), function (b) { b.classList.toggle("is-on", b.dataset.labSwitch === which); });
      if (which === "nets") { if (!pg.prints) pg.prints = randomPrints(el.themeSelect.value); renderPlayground(); }
      if (which === "fold") { if (!fl.folds) { flRenderRecipes(); flSetRecipe(PP_LAB_RECIPES[0]); } else fl.viewer.render(); }
      if (which === "solids") { if (!sl.cubes) { slRenderPiles(); slNewPile(10); } else sl.viewer.render(); }
      updateChip();
    }

    /* ---- question flow ---- */
    function setControlsLocked(locked) {
      el.themeSelect.disabled = locked; el.qtypeSelect.disabled = locked; el.testlenSelect.disabled = locked; el.paceSelect.disabled = locked; el.blocksSelect.disabled = locked;
      Array.prototype.forEach.call(el.tabs, function (tab) { tab.disabled = locked; });
      /* nothing in Settings can change during a test, so it does not open */
      Array.prototype.forEach.call(root.querySelectorAll("[data-settings-open]"), function (b) { b.disabled = locked; });
      if (el.settingsChip) el.settingsChip.setAttribute("aria-disabled", locked ? "true" : "false");
      if (typeof segSyncers !== "undefined" && segSyncers) segSyncers.forEach(function (f) { f(); });
    }
    function updatePills() {
      var answered = state.log.length, right = state.log.filter(function (e) { return e.isCorrect; }).length;
      var live = state.testActive || state.practiceActive;
      el.scorePill.hidden = !state.practiceActive;
      el.progressPill.hidden = !state.testActive;
      el.progressWrap.hidden = !state.testActive;
      el.streakPill.hidden = !(state.practiceActive && state.streak >= 2);
      var bar = el.scorebar || root.querySelector("[data-scorebar]");
      if (bar) bar.classList.toggle("sr-sticky", !!state.testActive);
      el.timerPill.hidden = !(state.testActive && state.deadline > 0);
      if (live) {
        el.scoreNum.textContent = right + " / " + answered;
        el.streakNum.textContent = String(state.streak);
      }
      if (state.testActive) {
        var n = state.testQs ? state.testQs.length : state.testLen, done = testAnsweredCount();
        el.progressNum.textContent = Math.min(state.qIndex + 1, n) + " / " + n;
        el.progressBar.style.width = Math.round((done / Math.max(1, n)) * 100) + "%";
      }
    }
    function renderRungs(doorId) {
      if (!state.practiceActive) { el.practiceStrip.hidden = true; return; }
      el.practiceStrip.hidden = false;
      var d = DOOR_BY_ID[doorId], rs = rungState(doorId), html = "";
      /* "Level 3 of 6", one dot per right answer at this level (three, in any order, opens the next), then the
         next level as a lock that opens once they are in */
      var prog = rungProgress(doorId);
      el.rungs.innerHTML = "<span class='sr-lvl-name'>Level <b class='sr-lvl-n'>" + rs.r + "</b></span><span class='sr-lvl-of'>of <span class='sr-lvl-n'>" + RUNG_MAX + "</span></span>" +
        levelDotsHtml(prog.ready ? prog.need : prog.ok, prog.need) +
        (rs.r < RUNG_MAX ? "<span class='sr-lock" + (prog.ready ? " is-open" : "") + "' aria-hidden='true'>" + (prog.ready ? ICO.tick : ICO.lock) + "<b>" + (rs.r + 1) + "</b></span>" : "");
      el.rungs.setAttribute("title", d.rungs[rs.r - 1] || "");
      /* the whole sentence (and the level's name, which the dots cannot say) stays for screen readers */
      el.climbText.className = "sr-climb cnt-sr-only";
      el.climbText.textContent = d.label + ", level " + rs.r + " of " + RUNG_MAX + ", " + (d.rungs[rs.r - 1] || "") +
        (rs.r >= RUNG_MAX ? ". Top level" : prog.ready ? ". Level " + (rs.r + 1) + " is open, move up when you want to"
          : ". " + prog.ok + " of " + prog.need + " right opens level " + (rs.r + 1));
      if (el.levelUp) {
        el.levelUp.hidden = !prog.ready;
        if (prog.ready) el.levelUp.textContent = "Try level " + (rs.r + 1);
      }
      var lab = d.lab;
      el.openLabBtn.hidden = !lab;
      if (lab) el.openLabBtn.textContent = lab === "nets" ? "Open the nets lab" : lab === "fold" ? "Open the fold lab" : "Open the solids lab";
    }
    function takeLevelUp() {
      var doorId = state.current && state.current.q ? state.current.q.door : state.door;
      if (!rungClimb(doorId)) return;
      renderRungs(doorId);
      updateChip();
      SFX.ui("level", rungState(doorId).r);
      /* a level change only shows in the next question, so bring one straight away */
      if (state.practiceActive && state.current && state.current.answered) newQuestion();
    }
    function levelDotsHtml(ok, need) {
      var h = "<span class='sr-dots' aria-hidden='true'>";
      for (var i = 0; i < need; i++) h += "<span class='sr-dot" + (i < ok ? "" : " is-todo") + "'>" + (i < ok ? ICO.tick : "") + "</span>";
      return h + "</span>";
    }
    /* A card or the settings sheet over the question: the top bar and the scroller go inert, so Tab and a
       click stay inside it (the shell is already the dialog; the answer keys are stopped in the keydown handler) */
    function levelCardOpen() { return !!(el.levelHost && el.levelHost.querySelector(".sr-levelup-bar")); }
    function syncShellModal() {
      var sheet = root.querySelector("[data-settings-sheet]");
      var on = levelCardOpen() || !!(sheet && !sheet.hidden);
      [root.querySelector(".cnt-topbar"), el.scroller, el.progressWrap].forEach(function (n) {
        if (!n) return;
        if (on) n.setAttribute("inert", ""); else n.removeAttribute("inert");
      });
    }
    function clearLevelCard() {
      if (!el.levelHost || !el.levelHost.firstChild) return false;
      el.levelHost.innerHTML = "";
      syncShellModal();
      return true;
    }
    /* the level-up card closes on Stay (or Escape) and the level waits in the rail as "Try level N" */
    function dismissLevelCard() {
      if (!clearLevelCard()) return false;
      SFX.ui("back");
      if (srVisible(el.nextBtn)) { try { el.nextBtn.focus({ preventScroll: true }); } catch (err) {} }
      return true;
    }
    if (el.levelUp) el.levelUp.addEventListener("click", takeLevelUp);
    if (el.levelHost) el.levelHost.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-level-up-now]") : null;
      if (btn) { clearLevelCard(); takeLevelUp(); return; }
      var stay = e.target && e.target.closest ? e.target.closest("[data-level-stay]") : null;
      if (stay) dismissLevelCard();
    });
    function clearFeedback() {
      clearLevelCard();
      el.feedback.textContent = "";
      el.feedback.classList.remove("is-good", "is-bad");
      el.explain.classList.remove("is-open");
      el.explain.textContent = "";
      hideHint();
      setReplayOpen(false);
      el.replayToggle.hidden = true;
      el.replayToggle.classList.remove("is-pulse");
    }
    /* The option art names itself (svgBox writes role img + aria-label); a plain
       option (a number) reads as its text. Feeds the button's own aria-label. */
    function optionArtLabel(opt) {
      var html = String((opt && opt.html) || ""), d = document.createElement("div");
      var m = /aria-label=(["'])([\s\S]*?)\1/.exec(html);
      d.innerHTML = m ? m[2] : html;
      return (d.textContent || "").replace(/\s+/g, " ").trim();
    }
    function renderOptionButtons(q) {
      el.options.innerHTML = "";
      el.options.classList.toggle("sr-opts-5", q.options.length === 5);
      q.options.forEach(function (opt, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cnt-opt";
        btn.innerHTML = "<span class='cnt-sr-only'>Option " + letterFor(i) + ":</span><span class='cnt-opt-badge' aria-hidden='true'>" + letterFor(i) + "</span>" + opt.html + "<span class='cnt-opt-flag' data-opt-flag></span>";
        var art = optionArtLabel(opt);
        btn.setAttribute("aria-label", "Option " + letterFor(i) + (art ? ", " + art : ""));
        if (state.testActive) btn.setAttribute("aria-pressed", "false");
        btn.addEventListener("click", function () { onPick(i); });
        el.options.appendChild(btn);
      });
      el.keysHint.textContent = "Keyboard: A to " + letterFor(q.options.length - 1) + " to answer, Enter for next" + (state.testActive ? ", F to flag" : "") + (q.viewer && !state.testActive ? ", arrow keys turn the shape" : "");
    }
    function optionButtons() { return Array.prototype.slice.call(el.options.querySelectorAll(".cnt-opt")); }
    /* "at exactly the size shown" has to survive the option grid: after the options
       are laid out, the shape in the prompt is drawn at the width an option picture
       actually ended up at, so the two can be compared by eye on any screen. */
    function syncArtScale(q) {
      if (!el.stimulus) return;
      var on = !!(q && q.matchArt);
      el.stimulus.classList.toggle("sr-matchart", on);
      if (!on) { el.stimulus.style.removeProperty("--sr-artw"); return; }
      var first = el.options.querySelector(".cnt-opt svg");
      if (!first) return;
      var w = Math.round(first.getBoundingClientRect().width);
      if (w > 20) el.stimulus.style.setProperty("--sr-artw", w + "px");
    }
    /* ---- full screen (2026-09-15): the prompt, the picture and the answers fit the window without scrolling.
       The picture box takes the height left above the answers and its drawing is zoomed to fit it: up to 1.25x
       on a big screen, never below half size. The rail scrolls inside itself on a wide screen. A shape the
       prompt calls "at exactly the size shown" (q.matchArt) is never zoomed. On a phone the box only shrinks,
       and while a replay covers it the box keeps its own height. ---- */
    function fitQuestion() {
      var st = el.stimulus, sc = el.scroller;
      if (!st || !sc || !el.panel || el.panel.hidden || st.hidden || !sc.clientHeight || !st.getClientRects().length) return;
      var kids = Array.prototype.filter.call(st.children, function (c) { return !c.classList.contains("cnt-fold-pill") && !c.classList.contains("sr-visually-hidden"); });
      var row = kids.length === 1 && kids[0].classList.contains("sr-figrow") ? kids[0] : null;
      /* every measurement is taken unzoomed: a zoomed box does not report its drawn size the same way in every browser */
      var reset = function (z) {
        kids.forEach(function (k) { k.style.zoom = ""; });
        if (row) { row.style.flexWrap = ""; row.style.width = ""; }
        if (z === 1) st.style.removeProperty("--sr-zoom"); else st.style.setProperty("--sr-zoom", String(z));
        st.style.height = "";
      };
      reset(1);
      if (el.rail) el.rail.style.maxHeight = "";
      var wide = window.innerWidth >= 1100, replay = !!(el.replayPanel && !el.replayPanel.hidden);
      if (replay && !wide) { st.classList.remove("sr-fit"); return; }
      st.classList.add("sr-fit");
      var scb = sc.getBoundingClientRect(), y0 = scb.top - sc.scrollTop;
      if (wide && el.rail && el.rail.getClientRects().length) {
        el.rail.style.maxHeight = Math.max(240, Math.floor(sc.clientHeight - (el.rail.getBoundingClientRect().top - y0) - 12)) + "px";
      }
      if (!el.options || !el.options.getClientRects().length) return;
      var cs = getComputedStyle(st), px = function (v) { return parseFloat(v) || 0; };
      var padY = px(cs.paddingTop) + px(cs.paddingBottom) + px(cs.borderTopWidth) + px(cs.borderBottomWidth);
      var availW = st.clientWidth - px(cs.paddingLeft) - px(cs.paddingRight);
      var q = state.current && state.current.q, exact = !!(q && q.matchArt);
      var z = 1, layout = null, natH = 0, targetH = 0, boxH = 0;
      /* two passes: captions are drawn at 15px divided by the zoom (book.css), so the natural size depends on the zoom chosen */
      for (var pass = 0; pass < 2; pass++) {
        if (pass) reset(z);
        var top = Infinity, bottom = -Infinity, left = Infinity, right = -Infinity;
        kids.forEach(function (k) {
          var r = k.getBoundingClientRect();
          if (!r.width && !r.height) return;
          top = Math.min(top, r.top); bottom = Math.max(bottom, r.bottom); left = Math.min(left, r.left); right = Math.max(right, r.right);
        });
        if (!(bottom > top) || !(right > left)) { reset(1); return; }
        natH = bottom - top; boxH = st.offsetHeight;
        var natW = right - left;
        /* a sprint keeps its teach card and streak row above the fold too (sprint.js) */
        var spEnd = typeof spFitEnd === "function" ? spFitEnd() : 0;
        var answersEnd = Math.max(el.options.getBoundingClientRect().bottom, spEnd) - y0 + 18;
        var room = boxH - (answersEnd - sc.clientHeight);
        targetH = Math.max(wide ? 200 : 140, Math.min(room, wide ? 640 : boxH));
        layout = null;
        /* fold steps in a narrow box (the replay beside them): one, two or three rows, whichever draws them biggest */
        if (row && wide && row.children.length >= 3) {
          var cells = Array.prototype.filter.call(row.children, function (c) { return c.getClientRects().length; });
          var cw = 0, ch = 0;
          cells.forEach(function (c) { var r = c.getBoundingClientRect(); cw = Math.max(cw, r.width); ch = Math.max(ch, r.height); });
          var rcs = getComputedStyle(row), gx = px(rcs.columnGap) || 14, gy = px(rcs.rowGap) || 14;
          for (var rows = 1; rows <= cells.length; rows++) {
            var cols = Math.ceil(cells.length / rows), w = cols * cw + (cols - 1) * gx, h = rows * ch + (rows - 1) * gy;
            var fitS = Math.min((targetH - padY) / h, availW / w);
            if (!layout || fitS > layout.s + 0.01) layout = { s: fitS, w: w, h: h, rows: rows };
          }
          natW = layout.w; natH = layout.h;
        }
        var s = Math.min((targetH - padY) / natH, availW / natW);
        s = Math.max(0.5, Math.min(s, wide ? 1.25 : 1));
        if (exact || Math.abs(s - 1) <= 0.02) s = 1;
        z = Math.round(s * 1000) / 1000;
        if (z === 1) break;
      }
      if (layout && layout.rows > 1) { row.style.flexWrap = "wrap"; row.style.width = Math.ceil(layout.w + 1) + "px"; }
      if (z !== 1) {
        kids.forEach(function (k) { k.style.zoom = String(z); });
        st.style.setProperty("--sr-zoom", String(z));
      }
      var drawn = Math.ceil(natH * z + padY);
      st.style.height = (wide ? Math.max(Math.round(targetH), drawn) : Math.max(drawn, Math.min(Math.round(targetH), boxH))) + "px";
      /* a sprint checks the drawing really fits its box (sprint.js) */
      if (typeof spAfterFit === "function") spAfterFit();
    }
    if (window.ResizeObserver && el.scroller) {
      var fitFrame = 0;
      new ResizeObserver(function () {
        if (fitFrame) cancelAnimationFrame(fitFrame);
        fitFrame = requestAnimationFrame(function () { fitFrame = 0; fitQuestion(); });
      }).observe(el.scroller);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitQuestion(); });
    var artScaleTimer = null;
    window.addEventListener("resize", function () {
      if (artScaleTimer) clearTimeout(artScaleTimer);
      artScaleTimer = setTimeout(function () { if (state.current && state.current.q) syncArtScale(state.current.q); }, 150);
    });
    /* Tool chips under the picture. toolChips returns an array of chip specs
       { key, html, title, disabled, on, className, ariaLabel, onClick(btn) } and
       renderTools draws them, so other parts (turn chips, grid buttons) can push
       their own specs onto the array without touching the drawing code. */
    function toolChips(q, unlocked) {
      var chips = [], cur = state.current;
      var helped = function () { if (cur && !cur.answered) cur.assisted = true; };
      if (state.practiceActive && typeof q.hint === "string" && q.hint) {
        chips.push({
          key: "hint", html: UI_ICO.bulb + "Hint", title: "A nudge, without giving the answer away",
          disabled: !!(cur && (cur.answered || cur.hinted)), on: !!(cur && cur.hinted), onClick: function () { showHint(); }
        });
      }
      var d = DOOR_BY_ID[q.door], v = state.viewer;
      var lockTitle = state.testActive ? "Locked during the test" : "Unlocks after you answer";
      if (d && d.tools && v) {
        var peel = { cap: null }, K = vxBounds(v.cubes).K;
        d.tools.forEach(function (t) {
          if (t === "snap") {
            ["front", "side", "plan"].forEach(function (w, wi) {
              chips.push({ key: "snap-" + w, html: ICO.camera + (w === "plan" ? "Plan" : w.charAt(0).toUpperCase() + w.slice(1)), disabled: !unlocked, title: unlocked ? "Swing the camera to this view" : lockTitle, onClick: function () { helped(); SFX.ui("select", wi); v.snap(w, 800); } });
            });
            return;
          }
          if (t === "spin") chips.push({ key: "spin", html: ICO.rotate + "Spin", disabled: !unlocked, title: unlocked ? "" : lockTitle, onClick: function () { helped(); SFX.swish("up"); v.spin(1600); } });
          if (t === "peel") chips.push({ key: "peel", html: ICO.layers + "Peel a layer", disabled: !unlocked, title: unlocked ? "" : lockTitle, onClick: function (b) { helped(); peel.cap = peel.cap === null ? K - 1 : peel.cap - 1; if (peel.cap < 1) peel.cap = null; if (K < 2) SFX.ui("denied"); else if (peel.cap === null) SFX.fold(); else SFX.fold("open"); v.setLayerCap(peel.cap); b.classList.toggle("is-on", peel.cap !== null); } });
          if (t === "reset") chips.push({ key: "reset", html: "Reset", disabled: !unlocked, title: unlocked ? "" : lockTitle, onClick: function () { SFX.ui("restart"); peel.cap = null; v.setLayerCap(null); v.setHl(null); v.home(500); Array.prototype.forEach.call(el.tools.querySelectorAll(".sr-chip:not([data-tool='hint'])"), function (c) { c.classList.remove("is-on"); }); } });
        });
      }
      /* every mounted 3D viewer gets the four turn chips, locked exactly as Spin is;
         they come last and renderTools starts a new row before the first of them */
      if (v && typeof v.turn === "function") chips = chips.concat(turnChipSpecs(v, unlocked, helped, lockTitle));
      return chips;
    }
    function renderTools(q, unlocked) {
      var chips = toolChips(q, unlocked);
      el.tools.innerHTML = "";
      el.tools.hidden = !chips.length;
      var broke = false;
      chips.forEach(function (c) {
        if (!broke && c.className && c.className.indexOf("sr-chip-turn") > -1) {
          /* the camera chips sit on their own row under the action chips */
          var br = document.createElement("span");
          br.className = "sr-tools-break";
          br.setAttribute("aria-hidden", "true");
          el.tools.appendChild(br);
          broke = true;
        }
        var b = document.createElement("button");
        b.type = "button";
        b.className = "sr-chip" + (c.className ? " " + c.className : "") + (c.on ? " is-on" : "");
        b.dataset.tool = c.key;
        b.innerHTML = c.html;
        b.disabled = !!c.disabled;
        if (c.title) b.title = c.title;
        if (c.ariaLabel) b.setAttribute("aria-label", c.ariaLabel);
        b.addEventListener("click", function () { c.onClick(b); });
        el.tools.appendChild(b);
      });
    }
    /* the staged hint: one nudge under the prompt, counts as help */
    function showHint() {
      var cur = state.current;
      if (!cur || !cur.q || !state.practiceActive || cur.answered || !el.hint || typeof cur.q.hint !== "string" || !cur.q.hint) return;
      /* the sparkle brightens with each hint already used this session */
      SFX.ui("hint", state.log.filter(function (e) { return e.hinted; }).length);
      cur.assisted = true;
      cur.hinted = true;
      /* unhide first so the live region is in the tree when the text lands */
      el.hint.hidden = false;
      el.hint.textContent = cur.q.hint;
      /* the chip is about to be disabled: move the focus to the hint before it drops to body */
      try { el.hint.focus({ preventScroll: true }); } catch (e) {}
      var chip = el.tools.querySelector("[data-tool='hint']");
      if (chip) { chip.disabled = true; chip.classList.add("is-on"); }
    }
    function hideHint() {
      if (!el.hint) return;
      el.hint.hidden = true;
      el.hint.textContent = "";
    }
    function mountStimulus(q, unlocked) {
      if (state.viewer) { state.viewer.stop(); state.viewer = null; }
      el.stimulus.classList.remove("sr-live", "is-under");
      el.stimulus.classList.toggle("sr-flatq", !q.viewer);
      if (q.viewer) {
        var live = q.viewer;
        /* the engine names the still picture ("the solid to turn, 6 blue cubes joined together"); the live viewer takes the same name */
        var liveLabel = optionArtLabel({ html: q.stimulusHtml }) || (q.door === "views" ? "a pile of blocks with front and side arrows" : "the solid");
        el.stimulus.innerHTML = "";
        state.viewer = mountVoxelViewer(el.stimulus, live.cubes, { size: 44, width: 340, tint: live.tint, markers: live.markers, locked: !unlocked, onDrag: function () { if (state.current && !state.current.answered) state.current.assisted = true; }, label: liveLabel });
        el.stimulus.classList.add("sr-live");
        var pill = document.createElement("div");
        pill.className = "cnt-fold-pill";
        pill.innerHTML = unlocked ? "&#8635; Drag to spin" : ICO.lock + (state.testActive ? " Spins in the review" : " Spins after you answer");
        el.stimulus.appendChild(pill);
      } else {
        el.stimulus.innerHTML = q.stimulusHtml;
      }
      renderTools(q, unlocked);
    }
    function unlockStimulus() {
      if (!state.current || !state.current.q) return;
      if (state.viewer) {
        state.viewer.locked = false;
        var pill = el.stimulus.querySelector(".cnt-fold-pill");
        if (pill) pill.innerHTML = "&#8635; Drag to spin";
      }
      renderTools(state.current.q, true);
    }
    /* ---- practice: one fresh question at a time ---- */
    function currentRung(doorId) { return rungState(doorId).r; }
    /* the last RECENT_WINDOW variants served for a door in practice; the next draw avoids them */
    function practiceHistory(doorId) {
      state.history = state.history || {};
      return state.history[doorId] || [];
    }
    function recordVariant(doorId, q) {
      var key = typeof historyKey === "function" ? historyKey(q) : (q && q.variant);
      if (!key) return;
      var win = typeof RECENT_WINDOW === "number" ? RECENT_WINDOW : 5;
      var hist = practiceHistory(doorId).concat([key]);
      if (hist.length > win) hist = hist.slice(-win);
      state.history[doorId] = hist;
    }
    /* The variant history keeps the task fresh; this keeps the picture fresh too. A rung with a
       small draw space (small block piles) can hand back the very same pile with the very same
       numbers, so the last SCENE_MEMORY scenes served for a door are remembered and a draw whose
       whole scene is among them is redrawn, up to twelve times. */
    var SCENE_MEMORY = 60;
    function recentScenes(doorId) {
      state.scenes = state.scenes || {};
      return state.scenes[doorId] || [];
    }
    function newQuestion() {
      var doorId = nextDoorId(state.door), rung = currentRung(doorId), scenes = recentScenes(doorId), q = null, first = null;
      for (var t = 0; t < 12 && !q; t++) {
        var cand = makeQ(doorId, rung, { avoid: practiceHistory(doorId).slice() });
        if (!cand) continue;
        if (!first) first = cand;
        if (scenes.indexOf(sceneKey(cand)) < 0) q = cand;
      }
      q = q || first;
      if (!q) { finishSession(); return; }
      recordVariant(doorId, q);
      state.scenes[doorId] = scenes.concat([sceneKey(q)]).slice(-SCENE_MEMORY);
      state.current = { q: q, picked: null, answered: false, assisted: false, hinted: false, shownAt: Date.now() };
      el.promptText.innerHTML = "<span class='cnt-qnum'>Q" + (state.answeredCount + 1) + "</span>" + esc(q.prompt);
      mountStimulus(q, true);
      renderOptionButtons(q);
      syncArtScale(q);
      fitQuestion();
      clearFeedback();
      el.nextBtn.hidden = false;
      el.nextBtn.disabled = true;
      el.nextBtn.textContent = "Next";
      renderRungs(q.door);
      updateChip();
      updatePills();
      if (el.scroller) el.scroller.scrollTop = 0;
      focusPrompt();
    }
    function pushLog(userIdx, wasCorrect) {
      var cur = state.current, q = cur.q;
      state.log.push({ questionIndex: state.log.length, door: q.door, type: q.typeId, promptText: q.prompt, userSelectedIdx: userIdx, correctIdx: q.correctIdx, isCorrect: wasCorrect, explanationText: q.explanation, q: q, ms: Math.min(120000, Date.now() - cur.shownAt), hinted: !!cur.hinted, assisted: !!cur.assisted });
    }
    /* The wrong-option notes are baked onto the end of q.explanation by finishQ
       and finishQuestion (one line each, after a newline). Rebuild them from the
       options the same way and peel them off, so the method, the explanation
       and the notes can be laid out separately. If the tail does not match,
       nothing is split and the whole text shows as it always has. */
    function optionNoteRows(q) {
      var rows = [], groups = {}, groupOrder = [], plain = {}, plainOrder = [];
      (q.options || []).forEach(function (o, i) {
        if (!o || o.isCorrect) return;
        if (o.noteGroup) {
          var key = o.noteGroup.many;
          if (!groups[key]) { groups[key] = { whos: [], one: o.noteGroup.one, many: o.noteGroup.many }; groupOrder.push(key); }
          groups[key].whos.push(o.noteGroup.who || letterFor(i));
        } else if (o.note) {
          if (!plain[o.note]) { plain[o.note] = []; plainOrder.push(o.note); }
          plain[o.note].push(letterFor(i));
        }
      });
      groupOrder.forEach(function (k) {
        var g = groups[k], one = g.whos.length === 1;
        rows.push({ who: one ? g.whos[0] : listJoin(g.whos), text: one ? g.one : g.many, joined: true });
      });
      plainOrder.forEach(function (n) { rows.push({ who: listJoin(plain[n]), text: n, joined: false }); });
      return rows;
    }
    /* the same rows as the lines finishQ bakes onto the end of q.explanation */
    function optionNotes(q) {
      return optionNoteRows(q).map(function (row) {
        if (!row.joined) return row.who + ": " + row.text;
        var line = row.who + " " + row.text;
        return line.charAt(0).toUpperCase() + line.slice(1);
      });
    }
    /* Trim a wrong-answer note to the short form the feedback list shows: the
       clause before the colon or the "so ..." tail, minus the stock openings.
       The full wording still goes to the tags and the end-of-test summary. */
    function splitExplanation(q) {
      var text = String(q.explanation || ""), notes = [];
      try { notes = optionNotes(q); } catch (e) { notes = []; }
      if (notes.length) {
        var tail = "\n" + notes.join("\n");
        if (text.length > tail.length && text.slice(-tail.length) === tail) text = text.slice(0, -tail.length);
        else notes = [];
      }
      return { main: text, notes: notes };
    }
    /* q.explainHtml (optional): small stage sheets or diagrams that go with the explanation text */
    function explainArtHtml(q) {
      return q && typeof q.explainHtml === "string" && q.explainHtml
        ? "<div class='sr-explain-art' style='display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:8px 0 0;white-space:normal'>" + q.explainHtml + "</div>"
        : "";
    }
    /* the correct option's reveal art (htmlReveal, or the older revealHtml) replaces its picture once answered */
    function revealArt(opt) {
      if (!opt) return "";
      return typeof opt.htmlReveal === "string" && opt.htmlReveal ? opt.htmlReveal : (typeof opt.revealHtml === "string" && opt.revealHtml ? opt.revealHtml : "");
    }
    /* Whole-note rewrites, tried on the note as it stands: these are the wordings
       that stay long after the tail is cut off. */
    var WHY_RAW = [
      [/^too (few|many) cubes: the pieces must add up to (\d+)$/i, "too $1 cubes, it needs $2"],
      [/^it shows .+ touching, but they are opposite faces$/i, "shows two opposite faces touching"],
      [/^are neighbours of .+, not the face behind it$/i, "are neighbours, not the face behind"],
      [/^the copies have been spun round .+$/i, "spun round, not mirrored"],
      [/^(that is )?only the cubes you can see, .+$/i, "only the cubes you can see"],
      [/^the first fold has been mirrored across the wrong line$/i, "the first fold went the wrong way"]
    ];
    /* Openings and endings that add nothing once the letter is in front of the line. */
    var WHY_TRIM = [
      [/^that is (a |an |the |only )?/i, "$1"],
      [/^the same shape (but )?/i, ""],
      [/^a look-alike, ?/i, ""],
      [/^nearly [a-z ]+, but /i, ""],
      [/ rather than /i, ", not "],
      [/ (sits|is) in the wrong position on its (face|square)$/i, " is in the wrong place"],
      [/ is twisted to an impossible angle$/i, " is at an impossible angle"],
      [/ is printed at the wrong angle$/i, " is at the wrong angle"]
    ];
    /* Last resort for a line that is still too long: the cube-net symbol names run
       to five words each, so the line drops the names and leans on the picture. */
    var WHY_LONG = 62;
    var WHY_LAST = [
      [/ is opposite /i, "those two are opposite faces"],
      [/ is at an impossible angle$/i, "that symbol is at an impossible angle"],
      [/ is at the wrong angle$/i, "that symbol is at the wrong angle"],
      [/ is in the wrong place$/i, "that symbol is in the wrong place"]
    ];
    function whyShort(text) {
      var raw = String(text || "").trim().replace(/\.$/, ""), t = null;
      for (var r = 0; r < WHY_RAW.length && t === null; r++) if (WHY_RAW[r][0].test(raw)) t = raw.replace(WHY_RAW[r][0], WHY_RAW[r][1]);
      if (t === null) t = raw.split(": ")[0].split(", so ")[0].split(", and ")[0];
      for (var i = 0; i < WHY_TRIM.length; i++) t = t.replace(WHY_TRIM[i][0], WHY_TRIM[i][1]);
      t = t.replace(/\s+/g, " ").trim();
      if (t.length > WHY_LONG) {
        for (var j = 0; j < WHY_LAST.length; j++) if (WHY_LAST[j][0].test(t)) { t = WHY_LAST[j][1]; break; }
      }
      return t || raw;
    }
    /* One short line per wrong answer, letter first, two to a row on a wide screen. */
    function whyListHtml(q, open) {
      var rows = [];
      try { rows = optionNoteRows(q); } catch (e) { rows = []; }
      if (!rows.length) return "";
      var items = rows.map(function (row) {
        var who = String(row.who);
        if (/^[A-E](?:(?:, | and )[A-E])*$/.test(who)) return "<li><b>" + esc(who) + "</b><span>" + esc(whyShort(row.text)) + "</span></li>";
        /* the cube nets name faces, not letters ("the row of three dots, the two dots and the six dots"): one sentence */
        var line = who + " " + whyShort(row.text);
        return "<li class='sr-why-line'><span>" + esc(line.charAt(0).toUpperCase() + line.slice(1)) + "</span></li>";
      }).join("");
      return "<details class='sr-why'" + (open ? " open" : "") +
        "><summary>Why the others are wrong</summary><ul class='sr-whylist'>" + items + "</ul></details>";
    }
    function renderExplain(q) {
      var rule = typeof q.rule === "string" ? q.rule.trim() : "";
      el.explain.innerHTML = "";
      if (!rule) { el.explain.textContent = q.explanation; el.explain.innerHTML += explainArtHtml(q); el.explain.classList.add("is-open"); return; }
      var parts = splitExplanation(q);
      var html = "<p class='sr-rule'><b class='sr-rule-tag'>Method</b>" + esc(rule) + "</p><p class='sr-explain-text'>" + esc(parts.main) + "</p>" + explainArtHtml(q);
      if (parts.notes.length) html += whyListHtml(q, window.innerWidth >= 700);
      el.explain.innerHTML = html;
      el.explain.classList.add("is-open");
    }
    var PRAISE = ["Correct.", "Spot on.", "That is the one.", "Exactly right."];
    var MISS = ["Not this one.", "Not yet."];
    function onPick(i) {
      if (state.sprintActive) { spPick(i); return; }
      var cur = state.current;
      if (!cur || !(state.testActive || state.practiceActive)) return;
      if (state.testActive) { testPick(i); return; }
      if (cur.answered) return;
      cur.answered = true;
      cur.picked = i;
      state.answeredCount++;
      var q = cur.q, right = i === q.correctIdx;
      optionButtons().forEach(function (btn, bi) {
        btn.disabled = true;
        var flag = btn.querySelector("[data-opt-flag]");
        var name = btn.getAttribute("aria-label") || ("Option " + letterFor(bi));
        if (bi === q.correctIdx) {
          btn.classList.add("is-correct");
          var reveal = revealArt(q.options[bi]);
          if (reveal) btn.innerHTML = "<span class='cnt-opt-badge' aria-hidden='true'>" + letterFor(bi) + "</span>" + reveal + "<span class='cnt-opt-flag' data-opt-flag></span>";
          btn.querySelector("[data-opt-flag]").innerHTML = ICO.tick + "Right answer";
          btn.setAttribute("aria-label", name + (bi === i ? ", your answer, correct" : ", the correct answer"));
        } else if (bi === i) {
          btn.classList.add("is-wrong");
          flag.innerHTML = ICO.cross + "Your pick";
          btn.setAttribute("aria-label", name + ", your answer, not correct");
        }
      });
      if (right) {
        state.streak++;
        if (state.streak > state.bestStreak) state.bestStreak = state.streak;
        el.feedback.innerHTML = ICO.tick + (state.streak >= 3 ? "Correct, " + state.streak + " in a row." : choice(PRAISE));
        SFX.right(state.streak);
      } else {
        state.streak = 0;
        el.feedback.innerHTML = ICO.cross + choice(MISS);
        SFX.wrong();
      }
      el.feedback.classList.add(right ? "is-good" : "is-bad");
      renderExplain(q);
      pushLog(i, right);
      accRecord(q.door, right);
      if (state.practiceActive) {
        if (cur.assisted) {
          el.feedback.innerHTML += " <span>" + (cur.hinted ? "(with a hint, so the level stays)" : "(with help, so the level stays)") + "</span>";
        } else {
          var moved = rungRecord(q.door, right);
          if (moved === -1) el.feedback.innerHTML += " <span>Down a level, keep going.</span>";
          /* the offer sits in the feedback, where the child is already looking, and
             stays there on every answer until it is taken */
          var prog = rungProgress(q.door);
          /* the moment three are in, a card takes the screen and the child chooses; after Stay the offer
             waits in the rail as "Try level N" (renderRungs), so it never nags on every answer */
          if (prog.ready && moved === 1) {
            var d2 = DOOR_BY_ID[q.door];
            var nextName = d2 && d2.rungs[prog.r] ? d2.rungs[prog.r] : "";
            el.levelHost.innerHTML =
              "<div class='sr-levelup-bar' data-fresh>" +
                "<div class='sr-levelup-card' role='dialog' aria-modal='true' aria-label='Level " + (prog.r + 1) + " unlocked'>" +
                  levelDotsHtml(prog.need, prog.need) +
                  "<span class='sr-levelup-say'><b>Level " + (prog.r + 1) + " unlocked</b>" + (nextName ? "<em>" + esc(nextName) + "</em>" : "") + "</span>" +
                  "<button type='button' class='cnt-btn cnt-orange cnt-big sr-levelup-now' data-level-up-now>Try level " + (prog.r + 1) + "</button>" +
                  "<button type='button' class='cnt-btn sr-stayhere' data-level-stay>Stay on level " + prog.r + "</button>" +
                "</div>" +
              "</div>";
            syncShellModal();
            /* the right answer first, then the medal as the card lands */
            SFX.after(120, function () { SFX.medal(2); });
          }
        }
        renderRungs(q.door);
      }
      saveStore();
      unlockStimulus();
      /* the item's own invariant (the cubes to follow, the small piece, the stacks that show) lights up on the live viewer */
      if (q.hlKeys && q.hlKeys.length && state.viewer && typeof state.viewer.setHl === "function") { try { state.viewer.setHl(q.hlKeys); } catch (e) {} }
      var d = DOOR_BY_ID[q.door];
      if (d && d.watch && q.review) { el.replayToggle.hidden = false; el.replayToggle.textContent = d.watch; el.replayToggle.classList.add("is-pulse"); }
      el.nextBtn.disabled = false;
      /* ten questions from the round sheet: the last one leads to the marks */
      if (state.practiceCap && state.answeredCount >= state.practiceCap) el.nextBtn.textContent = "See results";
      updatePills();
      try { el.nextBtn.focus({ preventScroll: true }); } catch (e) { el.nextBtn.focus(); }
      var tryLevel = el.levelHost ? el.levelHost.querySelector("[data-level-up-now]") : null;
      if (tryLevel) { try { tryLevel.focus({ preventScroll: true }); } catch (e) {} }
      fitQuestion();
      revealFeedback();
    }
    /* Once the answer is in, the method and the short list matter more than the
       picture, so the panel slides them into view when they do not already fit
       above the options. */
    function revealFeedback() {
      var sc = el.scroller;
      if (!sc || !el.explain || !el.feedback) return;
      /* the answers no longer pin to the bottom (book.css), so nothing covers the scroller. In one column
         (below 1100px) keep the answers, their marks and Next in view together; beside the rail, the marks
         down to the end of the explanation. offsetTop is measured from the shell, so boxes are used. */
      var room = Math.max(120, sc.clientHeight - 16);
      var narrow = window.innerWidth < 1100;
      /* beside the rail everything already fits the window (fitQuestion) and the rail scrolls itself */
      if (!narrow) return;
      var topEl = narrow && el.options ? el.options : el.feedback;
      var bottomEl = narrow && el.nextBtn && !el.nextBtn.hidden ? el.nextBtn : el.explain;
      var scb = sc.getBoundingClientRect();
      var top = topEl.getBoundingClientRect().top - scb.top + sc.scrollTop;
      var bottom = bottomEl.getBoundingClientRect().bottom - scb.top + sc.scrollTop;
      if (bottom - sc.scrollTop <= room) return;
      var want = Math.max(0, Math.min(top - 12, bottom - room));
      if (want <= sc.scrollTop + 4) return;
      if (window.__srReduceMotion || document.hidden || !sc.scrollTo) sc.scrollTop = want;
      else sc.scrollTo({ top: want, behavior: "smooth" });
    }
    function onNext() {
      if (state.testActive) { testNext(); return; }
      var cur = state.current;
      if (!cur || !cur.answered) return;
      SFX.ui("next");
      if (state.practiceCap && state.answeredCount >= state.practiceCap) { finishSession(); return; }
      newQuestion();
    }

    /* ---- the test navigator: every question drawn at the start, marked at the end ---- */
    /* the whole scene of a question, order of the options aside: two questions with the same key look the same */
    function sceneKey(q) {
      var opts = (q.options || []).map(function (o) { return String((o && o.html) || ""); }).sort();
      return String(q.stimulusHtml || "") + "\n" + opts.join("\n");
    }
    /* The doors and rungs are fixed slot by slot first (Smart mix: testDoorsFor shares the test
       out evenly, 2 or 3 per door at 24 and 4 per door at 40), then every door gets its plans from
       testPlanFor for exactly the number of questions it has, so the quotas (the late 16-hole
       folds, the four-layer piles, the diagonal creases) are scaled to that door's own slots and
       its subtypes come out distinct; each slot builds with its plan in order. A scene that
       duplicates an earlier question in the same test is redrawn, up to eight times. */
    function buildTestQs(len) {
      var out = [], seen = {}, slots = [], counts = {}, plans = {}, cursor = {}, i;
      var doorList = state.door === "mixed" && typeof testDoorsFor === "function" ? testDoorsFor(len) : null;
      for (i = 0; i < len; i++) {
        var did = doorList && doorList[i] ? doorList[i] : nextDoorId(state.door);
        slots.push({ door: did, rung: testRungFor(i, len) });
        counts[did] = (counts[did] || 0) + 1;
      }
      Object.keys(counts).forEach(function (d) {
        var rungs = slots.filter(function (s) { return s.door === d; }).map(function (s) { return s.rung; });
        var list = [];
        try { list = typeof testPlanFor === "function" ? testPlanFor(d, counts[d], rungs) : []; } catch (e) { list = []; }
        plans[d] = list || []; cursor[d] = 0;
      });
      slots.forEach(function (slot) {
        var plan = plans[slot.door][cursor[slot.door]++] || null;
        var q = null, dup = null, t;
        for (t = 0; t < 8 && !q; t++) {
          var cand = makeQ(slot.door, slot.rung, plan);
          if (!cand) continue;
          var key = sceneKey(cand);
          if (seen[key]) { dup = cand; continue; }
          seen[key] = true;
          q = cand;
        }
        /* eight draws all matched an earlier scene: keep the last rather than lose the question */
        if (!q && dup) q = dup;
        /* the planned door would not build at all: another door, no plan, as the mix used to do */
        for (t = 0; t < 3 && !q; t++) q = makeQ(nextDoorId(state.door), slot.rung);
        if (q) out.push({ q: q, picked: null, flagged: false, ms: 0, shownAt: null });
      });
      return out;
    }
    function testAnsweredCount() {
      if (!state.testQs) return 0;
      return state.testQs.filter(function (t) { return t.picked != null; }).length;
    }
    function leaveTestQuestion() {
      var t = state.current && state.current.test;
      if (!t || !t.shownAt) return;
      t.ms = Math.min(120000, t.ms + (Date.now() - t.shownAt));
      t.shownAt = null;
    }
    function showTestQuestion(i) {
      if (!state.testActive || !state.testQs || !state.testQs.length) return;
      leaveTestQuestion();
      i = clamp(i, 0, state.testQs.length - 1);
      state.qIndex = i;
      var t = state.testQs[i], q = t.q;
      t.shownAt = Date.now();
      state.current = { q: q, picked: t.picked, answered: t.picked != null, assisted: false, hinted: false, shownAt: t.shownAt, test: t };
      el.promptText.innerHTML = "<span class='cnt-qnum'>Q" + (i + 1) + "</span>" + esc(q.prompt);
      mountStimulus(q, false);
      renderOptionButtons(q);
      syncArtScale(q);
      fitQuestion();
      if (t.picked != null) markPicked(t.picked);
      clearFeedback();
      el.nextBtn.hidden = false;
      el.nextBtn.disabled = false;
      renderPalette();
      syncTestNav();
      updateChip();
      updatePills();
      if (el.scroller) el.scroller.scrollTop = 0;
      focusPrompt();
    }
    function markPicked(i) {
      optionButtons().forEach(function (btn, bi) {
        btn.classList.toggle("is-picked", bi === i);
        btn.setAttribute("aria-pressed", bi === i ? "true" : "false");
      });
    }
    function testPick(i) {
      var cur = state.current, t = cur && cur.test;
      if (!t) return;
      t.picked = i;
      cur.picked = i;
      cur.answered = true;
      markPicked(i);
      SFX.option(i);
      renderPalette();
      syncTestNav();
      updatePills();
      el.nextBtn.focus();
    }
    function testNext() {
      if (!state.testActive || !state.testQs) return;
      if (state.qIndex + 1 >= state.testQs.length) {
        var left = state.testQs.length - testAnsweredCount();
        if (left > 0) {
          SFX.ui("ask");
          if (!window.confirm("You have " + left + " question" + (left === 1 ? "" : "s") + " still to answer. Finish the test now?")) return;
        }
        state.testEnd = "finish";
        finishSession();
        return;
      }
      SFX.ui("next");
      showTestQuestion(state.qIndex + 1);
    }
    function testBack() {
      if (!state.testActive || state.qIndex <= 0) return;
      SFX.ui("back");
      showTestQuestion(state.qIndex - 1);
    }
    function toggleTestFlag() {
      var t = state.current && state.current.test;
      if (!state.testActive || !t) return;
      t.flagged = !t.flagged;
      SFX.ui(t.flagged ? "on" : "off");
      renderPalette();
      syncTestNav();
    }
    function renderPalette() {
      if (!el.palette || !state.testQs) return;
      var html = "";
      state.testQs.forEach(function (t, i) {
        var answered = t.picked != null;
        var label = "Question " + (i + 1) + ", " + (answered ? "answered" : "not answered") + (t.flagged ? ", flagged" : "");
        html += "<button type='button' class='sr-pal-btn" + (answered ? " is-answered" : "") + (t.flagged ? " is-flagged" : "") + (i === state.qIndex ? " is-current" : "") +
          "' data-pal-idx='" + i + "' aria-label='" + label + "'" + (i === state.qIndex ? " aria-current='true'" : "") + ">" + (i + 1) + "</button>";
      });
      html += "<span class='sr-pal-key' aria-hidden='true'><i class='is-answered'></i>answered <i class='is-flagged'></i>flagged</span>";
      /* F on a focused palette button rebuilds the palette: put the focus back on the same number */
      var focusedIdx = document.activeElement && el.palette.contains(document.activeElement) && document.activeElement.dataset ? document.activeElement.dataset.palIdx : null;
      el.palette.classList.toggle("sr-palette-many", state.testQs.length > 24);
      el.palette.innerHTML = html;
      if (focusedIdx != null) { var fb = el.palette.querySelector("[data-pal-idx='" + focusedIdx + "']"); if (fb) { try { fb.focus({ preventScroll: true }); } catch (e) {} } }
      /* the phone palette for 40 questions scrolls sideways: keep the current number in view */
      var curBtn = el.palette.querySelector(".is-current");
      if (curBtn && el.palette.scrollWidth > el.palette.clientWidth + 1) el.palette.scrollLeft = Math.max(0, curBtn.offsetLeft - el.palette.clientWidth / 2 + curBtn.offsetWidth / 2);
    }
    function syncTestNav() {
      if (!state.testQs) return;
      var i = state.qIndex, n = state.testQs.length, t = state.testQs[i], last = i + 1 >= n;
      el.nextBtn.textContent = last ? "Finish test" : "Next";
      if (!el.navRow) return;
      if (el.navBack) el.navBack.disabled = i <= 0;
      if (el.navFlag) {
        el.navFlag.classList.toggle("is-on", !!(t && t.flagged));
        el.navFlag.setAttribute("aria-pressed", t && t.flagged ? "true" : "false");
        if (el.navFlagText) el.navFlagText.textContent = t && t.flagged ? "Flagged" : "Flag for review";
      }
      if (el.navNext) {
        var txt = el.navNext.querySelector("[data-nav-next-text]");
        if (txt) txt.textContent = last ? "Finish test" : "Next"; else el.navNext.textContent = last ? "Finish test" : "Next";
      }
    }
    if (el.palette) {
      el.palette.addEventListener("click", function (e) {
        var b = e.target && e.target.closest ? e.target.closest("[data-pal-idx]") : null;
        if (!b || !state.testActive) return;
        SFX.ui("select", Number(b.dataset.palIdx));
        showTestQuestion(Number(b.dataset.palIdx));
      });
    }
    if (el.navBack) el.navBack.addEventListener("click", testBack);
    if (el.navFlag) el.navFlag.addEventListener("click", toggleTestFlag);
    if (el.navNext) el.navNext.addEventListener("click", testNext);
    /* the log the summary and replay read, built in question order when the test ends */
    function buildTestLog() {
      leaveTestQuestion();
      state.log = []; state.streak = 0; state.bestStreak = 0; state.answeredCount = 0;
      var run = 0;
      (state.testQs || []).forEach(function (t, i) {
        var q = t.q, picked = t.picked == null ? null : t.picked, right = picked != null && picked === q.correctIdx;
        state.log.push({ questionIndex: i, door: q.door, type: q.typeId, promptText: q.prompt, userSelectedIdx: picked, correctIdx: q.correctIdx, isCorrect: right, explanationText: q.explanation, q: q, ms: t.ms || 0, flagged: !!t.flagged, hinted: false, assisted: false });
        if (picked != null) { state.answeredCount++; accRecord(q.door, right); }
        if (right) { run++; if (run > state.bestStreak) state.bestStreak = run; } else run = 0;
      });
    }
    /* the replay: the paper unfolding, the pile turning with the hidden blocks lit, the net folding.
       q (optional) carries hlKeys / hlCaption: the item's own invariant lights up on the turning solid. */
    function mountReplay(container, review, inline, q) {
      var hl = q && q.hlKeys && q.hlKeys.length ? q.hlKeys : null;
      var hlCap = q && typeof q.hlCaption === "string" && q.hlCaption ? q.hlCaption : null;
      var wrap = document.createElement("div");
      wrap.className = "sr-replay";
      container.innerHTML = "";
      container.appendChild(wrap);
      if (review.kind === "nets") { container.innerHTML = ""; delete container.dataset.foldMounted; mountFoldViewer(container, review.netIdx, review.prints); growFoldCube(container); return null; }
      if (review.kind === "fold") {
        var pv = mountPaperViewer(wrap, review.folds, review.holes, { t: review.folds.length });
        var cap = document.createElement("span"); cap.className = "sr-replay-cap"; cap.textContent = "Every fold line is a mirror"; wrap.appendChild(cap);
        mountTurnChips(wrap, function () { return pv; }, { label: "Turn the paper", className: "sr-on-light" });
        /* One crease at a time with a beat between, the way the cube net unfolds: the child
           has to see WHICH crease opened and where its copies landed, and a single sweep from
           folded to flat is over before any of that registers. */
        var nF = review.folds.length, at = nF;
        var stepOpen = function () {
          if (at <= 0) { cap.textContent = "Fully open. Every fold line is a mirror"; return; }
          cap.textContent = nF === 1 ? "Opening the fold" : "Opening fold " + at + " of " + nF;
          at--;
          pv.animateT(at, 900, function () { setTimeout(stepOpen, at > 0 ? 700 : 400); });
        };
        if (window.__srReduceMotion) { pv.setT(0); cap.textContent = "Fully open. Every fold line is a mirror"; }
        else setTimeout(stepOpen, inline ? 300 : 500);
        return pv;
      }
      var v = mountVoxelViewer(wrap, review.cubes, { size: 44, width: 340, tint: review.kind === "solid" ? "blue" : "grey", markers: review.kind === "view", label: "the solid turning" });
      var cap2 = document.createElement("span"); cap2.className = "sr-replay-cap"; wrap.appendChild(cap2);
      mountTurnChips(wrap, function () { return v; }, { label: "Turn the solid", className: "sr-on-light" });
      if (review.kind === "pile") {
        cap2.textContent = review.hidden && review.hidden.length ? "The hidden blocks are lit orange" : "Every block can be seen from the front";
        v.setHl(review.hidden || []);
        setTimeout(function () { v.spin(2400); }, 300);
      } else if (review.kind === "view") {
        cap2.textContent = "The camera swings to the " + (review.which === "plan" ? "plan" : review.which + " view") + (hl && hlCap ? ". " + hlCap : "");
        if (hl) v.setHl(hl);
        setTimeout(function () { v.snap(review.which, 1100, function () {}); setTimeout(function () { v.home(900); }, 2600); }, 400);
      } else {
        cap2.textContent = hl && hlCap ? "The same solid, turning. " + hlCap : "The same solid, turning";
        if (hl) v.setHl(hl);
        setTimeout(function () { v.spin(2400); }, 300);
      }
      return v;
    }
    /* The Cube Nets viewer sizes a face so the FLAT net fits, which leaves the closed cube small. The scene
       scales up as the slider (or the welcome animation) closes the cube, so the finished cube reads at a glance. */
    function growFoldCube(container) {
      var scene = container.querySelector(".cnt-fold-scene"), range = container.querySelector(".cnt-fold-range");
      if (!scene || !range) return;
      var last = -1, stage = container.querySelector(".cnt-fold-stage");
      (function tick() {
        if (!range.isConnected) return;
        var v = Number(range.value) || 0;
        if (v !== last) {
          last = v;
          /* a closed cube stands about two faces tall; leave room for the pill above and the slider below */
          var F = parseFloat(stage ? stage.style.getPropertyValue("--cnt-face3d") : "") || 54;
          var H = stage ? stage.clientHeight : 300;
          var grow = Math.max(1, Math.min(2.2, (H - 130) / (2 * F)));
          var t = v / 100;
          scene.style.transform = "scale(" + (1 + (grow - 1) * t * t).toFixed(3) + ")";
        }
        requestAnimationFrame(tick);
      })();
    }
    function setReplayOpen(open) {
      var cur = state.current;
      el.replayPanel.hidden = !open;
      el.stimulus.classList.toggle("is-under", open);
      if (el.stimulus.parentNode) el.stimulus.parentNode.classList.toggle("sr-replay-on", open);
      if (el.tools) el.tools.hidden = open || !el.tools.children.length;
      var d = cur && cur.q ? DOOR_BY_ID[cur.q.door] : null;
      el.replayToggle.textContent = open ? "Back to the question" : (d && d.watch ? d.watch : "Watch it");
      el.replayToggle.classList.remove("is-pulse");
      if (state.replayViewer && state.replayViewer.stop) state.replayViewer.stop();
      state.replayViewer = null;
      el.replayBody.innerHTML = "";
      delete el.replayBody.dataset.foldMounted;
      fitQuestion();
      if (open && cur && cur.q && cur.q.review) state.replayViewer = mountReplay(el.replayBody, cur.q.review, false, cur.q);
    }
    el.replayToggle.addEventListener("click", function () { if (el.replayPanel.hidden) SFX.fold(); else SFX.ui("back"); setReplayOpen(el.replayPanel.hidden); });

    /* ---- modes, sessions, timer ---- */
    function renderIntroBest() {
      var b = store.best[bestKey(state.door + "|" + el.paceSelect.value, el.testlenSelect.value)];
      /* the old launcher's mock best line; the sprint launcher shows the round's best instead (sprint.js) */
      if (!el.introBest) return;
      el.introBest.hidden = !b;
      if (b) el.introBest.textContent = "Your best on these settings: " + b.right + " / " + b.total + " (" + b.pct + "%)";
    }
    function applyModeVisibility() {
      if (state.mode !== "practice" || !state.practiceActive) clearLevelCard();
      /* a sprint draws its own screen (sprint.js) */
      if (state.mode === "sprint" && typeof spApplyVisibility === "function") { spApplyVisibility(); fitQuestion(); return; }
      var mode = state.mode, questions = mode === "practice" || mode === "test";
      var intro = mode === "test" && !state.testActive;
      el.panel.hidden = !questions;
      el.labPanel.hidden = mode !== "lab";
      el.testIntro.hidden = !intro;
      el.promptText.hidden = intro || (mode === "practice" && !state.practiceActive);
      el.stimulus.hidden = el.promptText.hidden;
      el.options.hidden = el.promptText.hidden;
      el.keysHint.hidden = el.promptText.hidden;
      el.feedback.hidden = el.promptText.hidden;
      el.explain.hidden = el.promptText.hidden;
      el.tools.hidden = el.promptText.hidden || !el.tools.children.length;
      if (el.hint && el.promptText.hidden) hideHint();
      el.nextBtn.hidden = el.promptText.hidden;
      el.endTestBtn.hidden = !state.testActive;
      el.endPracticeBtn.hidden = !state.practiceActive;
      el.practiceStrip.hidden = !state.practiceActive;
      var testLive = mode === "test" && state.testActive;
      if (el.palette) el.palette.hidden = !testLive;
      if (el.navRow) el.navRow.hidden = !testLive;
      var lab = labFor(state.door);
      el.labTab.hidden = !lab;
      Array.prototype.forEach.call(el.tabs, function (tab) {
        var active = tab.dataset.modeTab === mode;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
      if (intro) {
        el.introTitle.textContent = state.door === "mixed" ? "Mock test" : "Mock test: " + doorLabel(state.door);
        el.introTimerNote.textContent = (el.paceSelect.value === "exam"
          ? el.testlenSelect.value + " questions in " + Math.round((Number(el.testlenSelect.value) * 30) / 60) + " minutes. "
          : "No clock. ") + "Marked at the end, then every question is explained.";
        if (typeof segSyncers !== "undefined" && segSyncers) segSyncers.forEach(function (f) { f(); });
      }
      updateChip();
      updatePills();
      fitQuestion();
    }
    function setMode(mode) {
      if (state.testActive || state.sprintActive) return;
      if (typeof spLeaveMode === "function") spLeaveMode();
      if (mode === "lab" && !labFor(state.door)) mode = "practice";
      state.mode = mode;
      el.summary.classList.remove("is-open");
      if (mode === "lab") { applyModeVisibility(); showLab(labFor(state.door)); return; }
      if (mode === "practice") {
        if (!state.practiceActive) startPractice(); else applyModeVisibility();
      } else {
        stopPractice();
        el.options.innerHTML = "";
        clearFeedback();
        renderIntroBest();
        applyModeVisibility();
      }
    }
    function startPractice() {
      /* "10 questions" in the sprint round sheet asks for a capped drill; every other way in is endless */
      state.practiceCap = state.practiceCapNext || 0; state.practiceCapNext = 0;
      state.practiceActive = true; state.sessionKind = "practice";
      state.log = []; state.streak = 0; state.bestStreak = 0; state.answeredCount = 0; state.qIndex = 0;
      applyModeVisibility();
      newQuestion();
    }
    function stopPractice() {
      state.practiceActive = false;
      state.current = null;
      if (state.viewer) { state.viewer.stop(); state.viewer = null; }
    }
    function startTest() {
      state.testActive = true; state.sessionKind = "test"; state.testEnd = null;
      state.testLen = parseInt(el.testlenSelect.value, 10) || 24;
      state.qIndex = 0; state.log = []; state.streak = 0; state.bestStreak = 0; state.answeredCount = 0;
      mix.queue = []; mix.seeded = false; mix.last = [];
      state.testQs = buildTestQs(state.testLen);
      if (!state.testQs.length) { state.testQs = null; finishSession(); return; }
      state.testLen = state.testQs.length;
      setControlsLocked(true);
      if (el.paceSelect.value === "exam") startTimer(state.testLen * 30 * 1000); else stopTimer();
      applyModeVisibility();
      showTestQuestion(0);
    }
    /* the clock ticks once a second in its last five seconds only, as the number changes */
    var clockTick = 0;
    function startTimer(ms) {
      stopTimer();
      clockTick = 0;
      state.deadline = Date.now() + ms;
      state.remaining = ms;
      state.timer = setInterval(tickTimer, 200);
      tickTimer();
    }
    function stopTimer() {
      if (state.timer) clearInterval(state.timer);
      state.timer = null; state.deadline = 0; state.paused = false;
      el.timerPill.hidden = true;
      el.timerPill.classList.remove("is-low");
    }
    function tickTimer() {
      if (!state.testActive || !state.deadline) return;
      var left = Math.max(0, state.deadline - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      el.timerNum.textContent = m + ":" + (s < 10 ? "0" : "") + s;
      el.timerPill.hidden = false;
      el.timerPill.classList.toggle("is-low", left < 60000);
      var shown = Math.floor(left / 1000);
      if (left > 0 && shown >= 1 && shown <= 5 && shown !== clockTick) { clockTick = shown; SFX.tick(shown); }
      if (left <= 0) {
        stopTimer();
        SFX.timeUp();
        finishSession(true);
      }
    }
    document.addEventListener("visibilitychange", function () {
      if (!state.testActive) return;
      /* the per-question stopwatch pauses with the tab, whether or not the shared clock is running */
      var t = state.current && state.current.test;
      if (t) { if (document.hidden) leaveTestQuestion(); else if (!t.shownAt) t.shownAt = Date.now(); }
      if (!state.deadline) return;
      if (document.hidden) { state.remaining = Math.max(0, state.deadline - Date.now()); state.paused = true; clearInterval(state.timer); state.timer = null; }
      else if (state.paused) { state.paused = false; state.deadline = Date.now() + state.remaining; state.timer = setInterval(tickTimer, 200); }
    });
    function confetti() {
      var host = el.scorebig, frag = document.createDocumentFragment(), cols = ["#FFC21A", "#FF8E91", "#5EC8E5", "#C9DE4B", "#6FA0F0", "#B9A6EE"];
      for (var i = 0; i < 60; i++) {
        var s = document.createElement("span");
        s.className = "cnt-confetti";
        s.style.left = (Math.random() * 100) + "%";
        s.style.background = cols[Math.floor(Math.random() * cols.length)];
        s.style.animationDelay = (Math.random() * 0.9) + "s";
        s.style.animationDuration = (2.2 + Math.random() * 1.6) + "s";
        frag.appendChild(s);
      }
      host.appendChild(frag);
      setTimeout(function () { var cs = host.querySelectorAll(".cnt-confetti"); for (var k = 0; k < cs.length; k++) if (cs[k].parentNode) cs[k].parentNode.removeChild(cs[k]); }, 5200);
    }
    function finishSession(timedOut) {
      clearLevelCard();
      var wasTest = state.testActive;
      /* how the test ended: the last Next, the clock, or End test early / the close button */
      var ended = timedOut ? "time" : (state.testEnd || (wasTest ? "early" : "done"));
      if (wasTest && state.testQs) buildTestLog();
      state.testActive = false;
      state.practiceActive = false;
      state.testEnd = null;
      stopTimer();
      setControlsLocked(false);
      if (state.viewer) { state.viewer.stop(); state.viewer = null; }
      state.current = null;
      el.panel.hidden = true;
      el.labPanel.hidden = true;
      if (el.palette) el.palette.hidden = true;
      if (el.navRow) el.navRow.hidden = true;
      el.summary.classList.add("is-open");
      var total = state.log.length, right = state.log.filter(function (e) { return e.isCorrect; }).length;
      var answeredEntries = state.log.filter(function (e) { return e.userSelectedIdx != null && e.userSelectedIdx >= 0; }), answered = answeredEntries.length;
      el.finalScore.textContent = right + " / " + total;
      var pct = total ? Math.round((right / total) * 100) : 0;
      var msg = !answered ? (wasTest ? "Test ended before any questions were answered. Press New test to have a proper go." : "No questions answered yet. Back to practice to have a go.")
        : pct >= 90 ? "Outstanding, " + pct + "%."
        : pct >= 70 ? "Strong work: " + pct + "%. Check the misses below."
        : pct >= 50 ? pct + "%. Work through the review below."
        : pct + "%. Study each review card, then try again.";
      if (wasTest && answered) {
        if (ended === "time") msg = "Time is up. " + answered + " of " + total + " answered. " + msg;
        else if (ended === "early") msg = "Ended early: " + answered + " of " + total + " answered. " + msg;
        else if (answered < total) msg = answered + " of " + total + " answered. " + msg;
      } else if (ended === "time") msg = "Time is up. " + msg;
      if (answered && state.bestStreak >= 3) msg += " Longest streak: " + state.bestStreak + " in a row.";
      var ms = answeredEntries.reduce(function (a, e) { return a + (e.ms || 0); }, 0);
      if (answered >= 3) msg += " About " + (Math.round(ms / answered / 1000) || 1) + "s a question.";
      if (!wasTest && answered) {
        var hintedRight = state.log.filter(function (e) { return e.isCorrect && e.hinted; }).length;
        msg += " " + (right - hintedRight) + " solved on your own" + (hintedRight ? ", " + hintedRight + " with a hint." : ".");
      }
      el.finalMessage.textContent = msg;
      if (el.settingsChip) el.settingsChip.textContent = doorName() + " · " + (wasTest ? answered + " of " + total : total + " of " + total) + " answered";
      el.newBest.hidden = true;
      if (wasTest && ended !== "early" && total > 0 && answered > 0) {
        var bk = bestKey(state.door + "|" + el.paceSelect.value, el.testlenSelect.value), prev = store.best[bk];
        if (!prev || pct > prev.pct) { store.best[bk] = { right: right, total: total, pct: pct }; if (prev) el.newBest.hidden = false; }
        store.hist.push({ t: Date.now(), door: state.door, len: state.testLen, right: right, total: total, pace: el.paceSelect.value });
        if (store.hist.length > 30) store.hist = store.hist.slice(-30);
      }
      saveStore();
      /* scored against the whole paper in a test (right / questions), so ending early never earns a fanfare, and
         nothing answered stays quiet. After time up the finish waits for the time-up sound; a new best sparkles
         about 900 ms after the finish. */
      if (answered) {
        var endAt = timedOut ? 700 : 0, endPct = right / total;
        if (endAt) SFX.after(endAt, function () { SFX.finish(endPct); }); else SFX.finish(endPct);
        if (!el.newBest.hidden) SFX.after(endAt + 900, function () { SFX.best(); });
      }
      if (total && pct === 100) confetti();
      renderSlips();
      /* "Try next": one row per puzzle type answered, weakest first (ties keep the launcher order) */
      el.typeTable.innerHTML = "";
      var typeRows = [];
      DOORS.forEach(function (d) {
        var entries = answeredEntries.filter(function (e) { return e.door === d.id; });
        if (!entries.length) return;
        var ok = entries.filter(function (e) { return e.isCorrect; }).length;
        typeRows.push({ d: d, ok: ok, n: entries.length, share: ok / entries.length, order: typeRows.length });
      });
      typeRows.sort(function (a, b) { return a.share - b.share || a.order - b.order; });
      typeRows.forEach(function (r) {
        var tr = document.createElement("tr");
        tr.setAttribute("data-door", r.d.id);
        tr.innerHTML = "<td><span class='sr-tt-name'><i class='sr-tt-sw' aria-hidden='true'></i>" + esc(r.d.label) + "</span></td>" +
          "<td><span class='sr-tt-bar' aria-hidden='true'><i style='width:" + Math.round(r.share * 100) + "%'></i></span></td>" +
          "<td class='sr-tt-n'>" + r.ok + "/" + r.n + "</td>";
        el.typeTable.appendChild(tr);
      });
      var tryNext = root.querySelector(".sr-trynext");
      if (tryNext) tryNext.hidden = !typeRows.length;
      var wrongOnlyBtn = root.querySelector("[data-wrong-only]");
      if (wrongOnlyBtn) { wrongOnlyBtn.setAttribute("aria-pressed", "false"); el.summary.classList.remove("sr-wrong-only"); }
      el.reviewList.innerHTML = "";
      state.log.forEach(function (entry, idx) {
        var item = document.createElement("div");
        item.className = "cnt-review-item " + (entry.isCorrect ? "is-right" : "is-miss");
        var unanswered = entry.userSelectedIdx == null || entry.userSelectedIdx === -1;
        var head = "<div class='cnt-review-head'><span class='cnt-rv-badge " + (entry.isCorrect ? "is-right'>" + ICO.tick + "Correct" : "is-miss'>" + ICO.cross + (unanswered ? "Not answered" : "Incorrect")) + "</span>" +
          "<span class='cnt-rv-type'>Q" + (idx + 1) + " · " + esc(doorLabel(entry.door)) + (entry.q.subLabel ? " · " + esc(entry.q.subLabel) : "") + "</span>" +
          (entry.flagged ? "<span class='cnt-rv-type sr-rv-flag'>" + UI_ICO.flag + "Flagged</span>" : "") + "</div>";
        var opts = "<div class='cnt-review-opts" + (entry.q.options.length === 5 ? " sr-opts-5" : "") + "'>";
        entry.q.options.forEach(function (o, oi) {
          var cls = "", flag = "";
          if (oi === entry.correctIdx) { cls = " is-correct"; flag = ICO.tick + "Right answer"; }
          if (oi === entry.userSelectedIdx && oi !== entry.correctIdx) { cls = " is-wrong"; flag = ICO.cross + "Your pick"; }
          opts += "<div class='cnt-review-opt" + cls + "'><span class='cnt-opt-badge' aria-hidden='true'>" + letterFor(oi) + "</span>" + (oi === entry.correctIdx && revealArt(o) ? revealArt(o) : o.html) + "<span class='cnt-opt-flag'>" + flag + "</span></div>";
        });
        opts += "</div>";
        var d = DOOR_BY_ID[entry.door];
        var rule = typeof entry.q.rule === "string" ? entry.q.rule.trim() : "";
        item.innerHTML = head + "<p class='cnt-review-prompt'>" + esc(entry.promptText) + "</p><div class='cnt-review-stim'>" + entry.q.stimulusHtml + "</div>" + opts +
          "<div class='cnt-review-explain'>" + (rule ? "<p class='sr-rule'><b class='sr-rule-tag'>Method</b>" + esc(rule) + "</p>" : "") +
            "<p class='sr-explain-text'>" + esc(splitExplanation(entry.q).main) + "</p>" + explainArtHtml(entry.q) + whyListHtml(entry.q) + "</div>" +
          (entry.q.review && d && d.watch ? "<details class='cnt-folddetails'><summary>" + esc(d.watch) + "</summary><div class='cnt-foldbody'></div></details>" : "");
        var details = item.querySelector("details.cnt-folddetails");
        if (details) details.addEventListener("toggle", function () { if (details.open) mountReplay(details.querySelector(".cnt-foldbody"), entry.q.review, true, entry.q); });
        /* the Watch it card folds open and closes; found by its class, because a card's first details can be the why list */
        var watchCard = item.querySelector("details.cnt-folddetails");
        if (watchCard) watchCard.addEventListener("toggle", function () { if (watchCard.open) SFX.fold(); else SFX.ui("close"); });
        el.reviewList.appendChild(item);
      });
      if (el.scroller) el.scroller.scrollTop = 0;
      focusSummary();
    }
    /* the score block takes the focus when a session ends (Finish, End early, time up, the close confirm),
       so a screen reader hears the result instead of losing its place on a button that just disappeared */
    function focusSummary() {
      var target = el.scorebig || el.finalScore;
      if (!target || !el.summary.classList.contains("is-open")) return false;
      try { target.focus({ preventScroll: true }); } catch (e) { return false; }
      return document.activeElement === target;
    }
    /* "Watch out for": the slips behind the wrong picks, counted by o.tag and
       named by TAG_LABELS (util.js). Up to three, most frequent first. */
    function renderSlips() {
      var box = el.slips || root.querySelector("[data-slips]");
      if (!box) return;
      var labels = typeof TAG_LABELS !== "undefined" ? TAG_LABELS : null;
      var counts = {}, order = [];
      state.log.forEach(function (e) {
        if (e.isCorrect || e.userSelectedIdx == null || e.userSelectedIdx < 0) return;
        var o = e.q && e.q.options ? e.q.options[e.userSelectedIdx] : null;
        var tag = o && typeof o.tag === "string" ? o.tag : "";
        if (!tag || tag === "other") return;
        if (!counts[tag]) { counts[tag] = 0; order.push(tag); }
        counts[tag]++;
      });
      var seen = order.slice();
      order.sort(function (a, b) { return counts[b] - counts[a] || seen.indexOf(a) - seen.indexOf(b); });
      var top = order.slice(0, 3);
      var ul = box.querySelector("[data-slips-list]") || box.querySelector("ul");
      if (!ul) { ul = document.createElement("ul"); ul.setAttribute("data-slips-list", ""); box.appendChild(ul); }
      ul.innerHTML = top.map(function (tag) {
        var label = labels && labels[tag] ? labels[tag] : tag.replace(/-/g, " ");
        var n = counts[tag];
        return "<li><strong>" + esc(label) + "</strong> (" + n + (n === 1 ? " time" : " times") + ")</li>";
      }).join("");
      box.hidden = !top.length;
    }
    /* ---- events ---- */
    Array.prototype.forEach.call(el.tabs, function (tab, ti) { tab.addEventListener("click", function () { SFX.ui("tab", ti); setMode(tab.dataset.modeTab); }); });
    function savePrefs() {
      store.prefs.theme = el.themeSelect.value; store.prefs.door = state.door; store.prefs.len = el.testlenSelect.value;
      store.prefs.pace = el.paceSelect.value; store.prefs.blocks = el.blocksSelect.value; store.prefs.muted = muted;
      saveStore();
    }
    /* a select, and the segmented buttons that drive one (they fire its change), pluck the picked option's own note */
    el.themeSelect.addEventListener("change", function () { SFX.ui("select", el.themeSelect.selectedIndex); if (state.mode === "lab" && state.lab === "nets") { pg.prints = randomPrints(el.themeSelect.value); renderPgFlat(); renderPgModel(); } savePrefs(); });
    el.qtypeSelect.addEventListener("change", function () { SFX.ui("select", el.qtypeSelect.selectedIndex); selectDoor(el.qtypeSelect.value); });
    el.testlenSelect.addEventListener("change", function () { SFX.ui("select", el.testlenSelect.selectedIndex); renderIntroBest(); savePrefs(); if (state.mode === "test") applyModeVisibility(); });
    el.paceSelect.addEventListener("change", function () { SFX.ui("select", el.paceSelect.selectedIndex); renderIntroBest(); savePrefs(); if (state.mode === "test") applyModeVisibility(); });
    el.blocksSelect.addEventListener("change", function () { SFX.ui("select", el.blocksSelect.selectedIndex); savePrefs(); });
    /* currentColor: the button is white now, so a white speaker was invisible */
    var SPEAKER_ON = "<svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M11 5 6.5 8.5H3.5v7h3L11 19z' fill='currentColor' stroke='none'/><path d='M15 9.5a4 4 0 0 1 0 5'/><path d='M17.5 7a7.5 7.5 0 0 1 0 10'/></svg>";
    var SPEAKER_OFF = "<svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true' opacity='0.6'><path d='M11 5 6.5 8.5H3.5v7h3L11 19z' fill='currentColor' stroke='none'/><line x1='15' y1='9.5' x2='20' y2='14.5'/><line x1='20' y1='9.5' x2='15' y2='14.5'/></svg>";
    function renderMuteBtn() {
      el.muteBtn.innerHTML = muted ? SPEAKER_OFF : SPEAKER_ON;
      el.muteBtn.setAttribute("aria-pressed", muted ? "true" : "false");
      el.muteBtn.setAttribute("aria-label", muted ? "Unmute sound effects" : "Mute sound effects");
    }
    /* unmuting clears the flag then plays on; muting plays off then sets the flag */
    el.muteBtn.addEventListener("click", function () { if (muted) { muted = false; SFX.ui("on"); } else { SFX.ui("off"); muted = true; } renderMuteBtn(); savePrefs(); });
    el.nextBtn.addEventListener("click", onNext);
    el.introStartBtn.addEventListener("click", function () { SFX.ui("play"); startTest(); });
    el.endTestBtn.addEventListener("click", function () {
      if (!state.testActive) return;
      if (testAnsweredCount()) {
        SFX.ui("ask");
        if (!window.confirm("End the test now? You will see your marks for the questions answered so far.")) return;
      }
      finishSession();
    });
    el.endPracticeBtn.addEventListener("click", function () { if (state.practiceActive) finishSession(); });
    el.openLabBtn.addEventListener("click", function () { SFX.ui("open"); var q = state.current && state.current.q; state.lab = labFor(q ? q.door : state.door) || state.lab; state.practiceActive = false; state.mode = "lab"; applyModeVisibility(); showLab(state.lab); });
    /* leaving the marks cancels a finish or a best still waiting to play */
    el.backPracticeBtn.addEventListener("click", function () { SFX.hush(); SFX.ui("back"); el.summary.classList.remove("is-open"); state.mode = "practice"; startPractice(); if (el.scroller) el.scroller.scrollTop = 0; });
    el.retakeBtn.addEventListener("click", function () { SFX.hush(); SFX.ui("restart"); el.summary.classList.remove("is-open"); setMode("test"); if (el.scroller) el.scroller.scrollTop = 0; try { el.introStartBtn.focus({ preventScroll: true }); } catch (e) {} });
    document.addEventListener("keydown", function (e) {
      if (!(state.testActive || state.practiceActive) || (state.mode !== "test" && state.mode !== "practice")) return;
      /* the answer, next and flag keys wait while the level card or the settings sheet is over the question */
      var sheetEl = root.querySelector("[data-settings-sheet]");
      if (levelCardOpen() || (sheetEl && !sheetEl.hidden)) return;
      var t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "SELECT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
      var cur = state.current, k = e.key.toLowerCase();
      if (!cur) return;
      /* anything that activates natively keeps Enter and Space for itself: a button (the palette, Flag, Back,
         an option in the test), a details summary (Why the others are wrong), a link; the 3D viewer
         keeps Space so a press while turning the shape never skips the question */
      if (t && (k === "enter" || k === " ")) {
        var tag = t.tagName;
        if (tag === "BUTTON" || tag === "SUMMARY" || tag === "A" || t.getAttribute("role") === "button") return;
        if (k === " " && t.classList && t.classList.contains("sr-viewer")) return;
      }
      var idx = ["a", "b", "c", "d", "e"].indexOf(k);
      if (idx === -1 && k >= "1" && k <= "5") idx = Number(k) - 1;
      if (idx > -1 && idx < cur.q.options.length) {
        /* practice locks the pick once answered; the test lets it change until the end */
        if (state.testActive || !cur.answered) { e.preventDefault(); onPick(idx); }
        return;
      }
      if (state.testActive && k === "f") { e.preventDefault(); toggleTestFlag(); return; }
      if ((state.testActive || cur.answered) && (k === "enter" || k === " " || k === "n")) { e.preventDefault(); onNext(); }
    });
    /* ---- launcher extras: lab button, phone sticky start, conditional settings ---- */
    if (el.openLabLaunch) {
      el.openLabLaunch.addEventListener("click", function () {
        SFX.ui("open");
        if (!labFor(state.door)) selectDoor("nets");
        if (typeof openShell === "function") openShell("lab", false);
      });
    }
    if (el.stickyStart) el.stickyStart.addEventListener("click", function () { el.openPracticeBtn.click(); });
    function watchLauncher() {
      var card = el.launcher, row = root.querySelector("[data-start-row]") || (el.openPracticeBtn ? (el.openPracticeBtn.closest(".cnt-launch-btns") || el.openPracticeBtn.parentNode) : null);
      if (!card || !row || typeof IntersectionObserver === "undefined") return;
      try {
        new IntersectionObserver(function (entries) {
          var x = entries[entries.length - 1];
          document.body.classList.toggle("sr-launcher-in-view", !!x && x.isIntersecting);
        }, { threshold: 0 }).observe(card);
        /* watch the Start practice button itself (threshold 0): the bar goes the moment any of the real
           button is on screen, so the two never stack; the whole row is the fallback */
        new IntersectionObserver(function (entries) {
          var x = entries[entries.length - 1];
          document.body.classList.toggle("sr-start-in-view", !!x && x.isIntersecting);
        }, { threshold: 0 }).observe(el.openPracticeBtn || row);
      } catch (err) { return; }
      if (el.stickyBar) el.stickyBar.hidden = false;
    }
    /* ---- boot ---- */
    function applyPref(sel, val) { if (!val) return; for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === val) { sel.value = val; return; } }
    applyPref(el.themeSelect, store.prefs.theme);
    applyPref(el.testlenSelect, store.prefs.len);
    applyPref(el.paceSelect, store.prefs.pace);
    applyPref(el.blocksSelect, store.prefs.blocks);
    state.door = store.prefs.door && (store.prefs.door === "mixed" || DOOR_BY_ID[store.prefs.door]) ? store.prefs.door : "mixed";
    renderDoors();
    el.qtypeSelect.value = state.door;
    syncSettingRows();

    /* ---- exercise-book launcher and shell extras (2026-09-14) ---- */
    /* All puzzles: the smart mix, the same as picking no door */
    var mixToggle = root.querySelector("[data-mix-toggle]");
    if (mixToggle) {
      mixToggle.setAttribute("data-on", state.door === "mixed" ? "true" : "false");
      /* the All puzzles tick box switches the mix on (Labs beside it has the open sound) */
      mixToggle.addEventListener("click", function () { SFX.ui("on"); selectDoor("mixed"); });
    }
    /* the demo card: a real pile from the same voxel renderer the questions use */
    var demoArt = root.querySelector("[data-demo-art]");
    if (demoArt) { try { demoArt.innerHTML = vxSvg(vxFromHeights([[3, 1, 2], [2, 1, 1], [2, 1, 1]]), { size: 34, width: 300, label: "a pile of blocks to count" }); } catch (e) {} }
    /* the mock test's own choices live on its setup card, not in the practice settings */
    var setupSlot = root.querySelector("[data-setup-slot]");
    if (setupSlot) {
      [el.testlenSelect, el.paceSelect].forEach(function (sel) { var f = sel && sel.closest(".cnt-field"); if (f) setupSlot.appendChild(f); });
    }
    /* segmented choices drive the real selects, so every listener and saved preference keeps working */
    var segSyncers = [];
    function segmentSelect(sel, labelFor) {
      var field = sel && sel.closest(".cnt-field");
      if (!field || field.querySelector(".sr-seg")) return;
      var seg = document.createElement("div");
      seg.className = "sr-seg";
      seg.setAttribute("role", "group");
      var lab = field.querySelector("label");
      if (lab) {
        /* the label names the buttons now; pointing it at the hidden select would focus nothing a child can see */
        if (!lab.id) lab.id = (sel.id || "sr-seg") + "-label";
        lab.removeAttribute("for");
        seg.setAttribute("aria-labelledby", lab.id);
      }
      Array.prototype.forEach.call(sel.options, function (o) {
        var b = document.createElement("button");
        b.type = "button";
        b.dataset.segValue = o.value;
        b.textContent = labelFor ? labelFor(o) : o.textContent;
        b.addEventListener("click", function () {
          if (sel.disabled || sel.value === o.value) return;
          sel.value = o.value;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
          sync();
        });
        seg.appendChild(b);
      });
      function sync() {
        Array.prototype.forEach.call(seg.children, function (b) {
          b.setAttribute("aria-pressed", b.dataset.segValue === sel.value ? "true" : "false");
          b.disabled = !!sel.disabled;
        });
      }
      sel.addEventListener("change", sync);
      field.classList.add("has-seg");
      sel.setAttribute("tabindex", "-1");
      sel.setAttribute("aria-hidden", "true");
      field.appendChild(seg);
      segSyncers.push(sync);
      sync();
    }
    segmentSelect(el.testlenSelect, function (o) { return o.textContent.split("·")[0].trim(); });
    segmentSelect(el.paceSelect, function (o) { return o.value === "exam" ? "Timer on" : "No timer"; });
    segmentSelect(el.blocksSelect);
    /* the settings sheet: practice choices, opened from the top bar */
    var settingsSheet = root.querySelector("[data-settings-sheet]"), settingsOpener = null;
    function openSettings() {
      if (!settingsSheet || state.testActive || levelCardOpen()) return;
      SFX.ui("open");
      settingsOpener = document.activeElement;
      settingsSheet.hidden = false;
      syncShellModal();
      /* one lookup at a time: a combined selector returns the backdrop span first (it carries data-settings-close
         too and comes first in the markup), and a span cannot take the focus */
      var first = settingsSheet.querySelector(".cnt-settings select:not([aria-hidden]):not(:disabled)") ||
        settingsSheet.querySelector(".cnt-settings button:not(:disabled)") || settingsSheet.querySelector("button[data-settings-close]");
      try { first.focus({ preventScroll: true }); } catch (e) {}
    }
    function closeSettings() {
      if (!settingsSheet || settingsSheet.hidden) return;
      SFX.ui("close");
      settingsSheet.hidden = true;
      syncShellModal();
      try { (settingsOpener && document.body.contains(settingsOpener) ? settingsOpener : root.querySelector("[data-settings-open]")).focus({ preventScroll: true }); } catch (e) {}
      settingsOpener = null;
    }
    Array.prototype.forEach.call(root.querySelectorAll("[data-settings-open]"), function (b) { b.addEventListener("click", openSettings); });
    Array.prototype.forEach.call(root.querySelectorAll("[data-settings-close]"), function (b) { b.addEventListener("click", closeSettings); });
    if (el.settingsChip) {
      el.settingsChip.setAttribute("role", "button");
      el.settingsChip.setAttribute("tabindex", "0");
      el.settingsChip.addEventListener("click", openSettings);
      el.settingsChip.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openSettings(); } });
    }
    /* Escape closes the level card, then the sheet, before the shell's own Escape closes the app */
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" && e.key !== "Esc") return;
      if (dismissLevelCard()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (settingsSheet && !settingsSheet.hidden) { e.preventDefault(); e.stopImmediatePropagation(); closeSettings(); }
    }, true);
    /* results: See answers jumps to the answers; Wrong ones only hides the right ones */
    var seeAnswers = root.querySelector("[data-see-answers]"), reviewAnchor = root.querySelector("[data-review-anchor]"), wrongOnly = root.querySelector("[data-wrong-only]");
    if (seeAnswers && reviewAnchor) {
      seeAnswers.addEventListener("click", function () {
        SFX.ui("open");
        var sc = el.scroller;
        if (sc) {
          var top = reviewAnchor.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 16;
          if (window.__srReduceMotion || !sc.scrollTo) sc.scrollTop = top; else sc.scrollTo({ top: top, behavior: "smooth" });
        }
        try { reviewAnchor.focus({ preventScroll: true }); } catch (e) {}
      });
    }
    if (wrongOnly) {
      wrongOnly.addEventListener("click", function () {
        var on = wrongOnly.getAttribute("aria-pressed") !== "true";
        SFX.ui("select", on ? 1 : 0);
        wrongOnly.setAttribute("aria-pressed", on ? "true" : "false");
        el.summary.classList.toggle("sr-wrong-only", on);
      });
    }
    watchLauncher();
    renderMuteBtn();
    renderIntroBest();
    updateChip();
    var reduceMotion = false;
    try { reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
    window.__srReduceMotion = reduceMotion;
    window.__shlcSpatialDebug = {
      ppWhy: function () { return PP_WHY; },
      make: makeQ, doors: DOORS.map(function (d) { return d.id; }), state: state, el: el, store: store,
      showTestQuestion: showTestQuestion, toggleTestFlag: toggleTestFlag, testAnsweredCount: testAnsweredCount, showHint: showHint, renderSlips: renderSlips, syncSettingRows: syncSettingRows, splitExplanation: splitExplanation, optionNoteRows: optionNoteRows, whyShort: whyShort,
      srInertOutside: srInertOutside, focusPrompt: focusPrompt, focusSummary: focusSummary, mountTurnChips: mountTurnChips, slPaintGrid: slPaintGrid, optionArtLabel: optionArtLabel,
      /* the plans: subtypes scheduled before any diagram is drawn, and the practice history that avoids repeats */
      testPlanFor: testPlanFor, PLAN_SPECS: PLAN_SPECS, historyKey: historyKey, RECENT_WINDOW: RECENT_WINDOW, sceneKey: sceneKey, buildTestQs: buildTestQs, practiceHistory: practiceHistory,
      vx: { svg: vxSvg, views: vxViews, hidden: vxHiddenKeys, hiddenTops: vxHiddenTops, cam: vxCam, home: VX_HOME, rots: vxAllRots, chiral: vxIsChiral, canBuild: vxCanBuild, showing: vxShowingKeys, pairMove: vxPairMove,
        invariant: typeof vxInvariant === "function" ? vxInvariant : null, rotKeys: typeof vxRotKeys === "function" ? vxRotKeys : null, placement: typeof vxPlacement === "function" ? vxPlacement : null },
      HIDE_TARGETS: typeof HIDE_TARGETS !== "undefined" ? HIDE_TARGETS : null,
      hiddenAudit: typeof flHiddenAudit === "function" ? flHiddenAudit : null,
      hiddenCopies: typeof flHiddenCopies === "function" ? flHiddenCopies : null,
      hiddenSegs: typeof flSegsFromHtml === "function" ? flSegsFromHtml : null,
      rotOrder: typeof flRotOrder === "function" ? flRotOrder : null,
      visibleTurn: typeof flVisibleTurn === "function" ? flVisibleTurn : null,
      hiddenStats: function () { return typeof HIDE_AUDIT === "object" ? HIDE_AUDIT : null; },
      shapeV: typeof shapeV === "function" ? shapeV : null,
      pp: { build: buildFold, states: ppStates, folds: ppBuildFolds, punchable: ppPunchable, nearest: ppNearestPunch, holeR: function () { return flHoleR(); } },
      fl: fl
    };
    /* ============================================================
       19. SPRINT (2026-10-03): the 11+ Verbal Reasoning Game's round loop, in the exercise book.
       A timed round (3 or 5 minutes) of fresh questions: 100 points a right answer times the streak
       multiplier (x2 at 2 in a row, x3 at 4, x4 at 6), a teach card with one line after a wrong pick
       (the clock waits), Skip, the round's misses kept between visits, a round sheet on the launcher
       and a circled score at the end. "10 questions" in the sheet runs the practice drill as before.
       Spec: vocab-features-port/SPEC.md. Shares ui.js's scope (built straight after it).
       ============================================================ */
    var SP_KEYS = { round: "shlc_spatial_round_v1", misses: "shlc_spatial_misses_v1", best: "shlc_spatial_best_v1" };
    var SP_LENS = { "180": "3 minutes", "300": "5 minutes", "10q": "10 questions" };
    var SP_LEVELS = { my: "My level", easy: "Easy", medium: "Medium", hard: "Hard" };
    var SP_LEVEL_RUNGS = { easy: [1, 2], medium: [3, 4], hard: [5, 6] };
    var SP_LEDE = { "180": "How many can you solve in ~@3@ minutes~?", "300": "How many can you solve in ~@5@ minutes~?", "10q": "Ten questions, with levels and hints." };
    var SP_GO = { "180": "Start a ~@3@-minute~ round", "300": "Start a ~@5@-minute~ round", "10q": "Start ~@10@ questions~" };
    var SP_MISS_CAP = 30, SP_MISSBAR_AT = 3, SP_SHOW_MISSED = 6, SP_RIGHT_MS = 600, SP_PIPS = 6;
    state.sprintActive = false;

    /* ---- storage: every call wrapped, garbage dropped on read ---- */
    function spRead(key) { try { var raw = window.localStorage.getItem(key); return raw ? JSON.parse(raw) : null; } catch (e) { return null; } }
    function spWrite(key, val) { try { window.localStorage.setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; } }
    function spDrop(key) { try { window.localStorage.removeItem(key); } catch (e) {} }
    function spIsObj(v) { return !!v && typeof v === "object" && !Array.isArray(v); }
    function spValidType(t) { return t === "mixed" || (typeof t === "string" && !!DOOR_BY_ID[t]); }
    /* the saved round: { type: "mixed" or a door, len: 180 | 300 | "10q", level: "my" | "easy" | "medium" | "hard" } */
    function spGetRound() {
      var r = spRead(SP_KEYS.round), out = { type: "mixed", len: "180", level: "my" };
      if (spIsObj(r)) {
        if (spValidType(r.type)) out.type = r.type;
        if (r.len != null && SP_LENS.hasOwnProperty(String(r.len))) out.len = String(r.len);
        if (typeof r.level === "string" && SP_LEVELS.hasOwnProperty(r.level)) out.level = r.level;
      }
      return out;
    }
    function spSaveRound(r) {
      spWrite(SP_KEYS.round, { type: r.type, len: r.len === "10q" ? "10q" : Number(r.len), level: r.level });
      /* the round's type is the picked puzzle everywhere else too: the settings sheet, the mock test, the labs */
      if (state.door !== r.type) selectDoor(r.type);
    }
    /* the first sentence of the worked answer: the teach card's one line */
    function spTeachLine(q) {
      var text = String((q && q.explanation) || "").split("\n")[0].replace(/\s+/g, " ").trim();
      var m = /^(.+?[.!?])(\s|$)/.exec(text);
      return m ? m[1] : text;
    }
    /* a missed question keeps only what it needs to be drawn and marked again (4 to 25 KB live; the 3D
       viewer, the replay and the reveal art stay behind, so a stored question shows its still picture) */
    function spTrimQ(q) {
      if (!q || typeof q !== "object" || !Array.isArray(q.options) || !DOOR_BY_ID[q.door]) return null;
      var opts = q.options.map(function (o) { return { html: String((o && o.html) || ""), isCorrect: !!(o && o.isCorrect) }; });
      var c = q.correctIdx;
      if (typeof c !== "number" || c < 0 || c >= opts.length) return null;
      return { typeId: String(q.typeId || ""), door: q.door, rung: Number(q.rung) || 1, prompt: String(q.prompt || ""), stimulusHtml: String(q.stimulusHtml || ""),
        options: opts, correctIdx: c, line: typeof q.line === "string" ? q.line : spTeachLine(q), matchArt: !!q.matchArt };
    }
    function spValidQ(q) {
      return spIsObj(q) && typeof q.prompt === "string" && !!q.prompt && typeof q.stimulusHtml === "string" && !!DOOR_BY_ID[q.door] &&
        Array.isArray(q.options) && q.options.length >= 2 && q.options.length <= 6 &&
        q.options.every(function (o) { return spIsObj(o) && typeof o.html === "string"; }) &&
        typeof q.correctIdx === "number" && q.correctIdx === Math.floor(q.correctIdx) && q.correctIdx >= 0 && q.correctIdx < q.options.length;
    }
    /* misses: newest first, at most 30, each { t: door, l: level, at: ms, q: question } */
    function spGetMisses() {
      var a = spRead(SP_KEYS.misses);
      if (!Array.isArray(a)) return [];
      return a.filter(function (m) {
        return spIsObj(m) && typeof m.t === "string" && !!DOOR_BY_ID[m.t] && typeof m.at === "number" && isFinite(m.at) && spValidQ(m.q) && m.q.door === m.t;
      }).slice(0, SP_MISS_CAP);
    }
    function spPutMisses(list) {
      list = list.slice(0, SP_MISS_CAP);
      if (!list.length) { spDrop(SP_KEYS.misses); return true; }
      if (spWrite(SP_KEYS.misses, list)) return true;
      /* the storage is shared by every SHLC tool on the site: when it is full, keep the newer half and try once more */
      return spWrite(SP_KEYS.misses, list.slice(0, Math.ceil(list.length / 2)));
    }
    function spAddMisses(entries) {
      var have = spGetMisses(), seen = {}, out = [];
      entries.slice().reverse().concat(have).forEach(function (m) {
        if (!m || seen[m.at]) return;
        var q = spTrimQ(m.q);
        if (!q || !spValidQ(q)) return;
        seen[m.at] = true;
        out.push({ t: q.door, l: q.rung || 1, at: m.at, q: q });
      });
      spPutMisses(out);
    }
    function spRemoveMiss(at) {
      if (typeof at !== "number") return;
      var have = spGetMisses(), left = have.filter(function (m) { return m.at !== at; });
      if (left.length !== have.length) spPutMisses(left);
    }
    /* best scores per type, length and level: { "folding|180|my": 2700 } */
    function spBestKey(r) { return r.type + "|" + r.len + "|" + r.level; }
    function spBests() { var b = spRead(SP_KEYS.best); return spIsObj(b) ? b : {}; }
    function spBestOf(r) { var v = spBests()[spBestKey(r)]; return typeof v === "number" && isFinite(v) && v > 0 ? Math.floor(v) : 0; }
    function spSetBest(r, score) { var b = spBests(); b[spBestKey(r)] = score; spWrite(SP_KEYS.best, b); }

    /* ---- elements (markup.liquid) ---- */
    function spQ(sel) { return root.querySelector(sel); }
    var spEl = {
      go: spQ("[data-sp-go]"), goLabel: spQ("[data-sp-go-label]"), lede: spQ("[data-sp-lede]"), choose: spQ("[data-sp-choose]"),
      pill: spQ("[data-sp-pill]"), pillLen: spQ("[data-sp-pill-len]"), pillStk: spQ("[data-sp-pill-stk]"), pillType: spQ("[data-sp-pill-type]"),
      missbar: spQ("[data-sp-missbar]"), missN: spQ("[data-sp-miss-n]"), missGo: spQ("[data-sp-miss-go]"), missClear: spQ("[data-sp-miss-clear]"),
      best: spQ("[data-sp-best]"), bestN: spQ("[data-sp-best-n]"), demo: spQ("[data-sp-demo]"), wallSec: spQ("[data-sp-wall-sec]"), wall: spQ("[data-sp-wall]"),
      sheet: spQ("[data-sp-sheet]"), sheetStk: spQ("[data-sp-sheet-stk]"), sheetName: spQ("[data-sp-sheet-name]"), sheetDesc: spQ("[data-sp-sheet-desc]"),
      len: spQ("[data-sp-len]"), level: spQ("[data-sp-level]"), levelRow: spQ("[data-sp-level-row]"), myLvl: spQ("[data-sp-mylvl]"), q10Note: spQ("[data-sp-q10-note]"),
      play: spQ("[data-sp-play]"), sheetBest: spQ("[data-sp-sheet-best]"), sheetBestN: spQ("[data-sp-sheet-best-n]"),
      chip: spQ("[data-sp-chip]"), chipStk: spQ("[data-sp-chip-stk]"), chipName: spQ("[data-sp-chip-name]"),
      scorebox: spQ("[data-sp-scorebox]"), score: spQ("[data-sp-score]"), plus: spQ("[data-sp-plus]"), clock: spQ("[data-sp-clock]"), clockNum: spQ("[data-sp-clock-num]"),
      bar: spQ("[data-sp-bar]"), barFill: spQ("[data-sp-bar-fill]"),
      teach: spQ("[data-sp-teach]"), teachLine: spQ("[data-sp-teach-line]"), next: spQ("[data-sp-next]"),
      foot: spQ("[data-sp-foot]"), streak: spQ("[data-sp-streak]"), mult: spQ("[data-sp-mult]"), pips: spQ("[data-sp-pips]"), streakSay: spQ("[data-sp-streak-say]"),
      watch: spQ("[data-sp-watch]"), skip: spQ("[data-sp-skip]"), say: spQ("[data-sp-say]"),
      results: spQ("[data-sp-results]"), resTitle: spQ("[data-sp-res-title]"), resHead: spQ("[data-sp-res-head]"), resScore: spQ("[data-sp-res-score]"),
      resMeta: spQ("[data-sp-res-meta]"), resRight: spQ("[data-sp-res-right]"), resStreak: spQ("[data-sp-res-streak]"), resMiss: spQ("[data-sp-res-miss]"),
      resList: spQ("[data-sp-res-list]"), resMore: spQ("[data-sp-res-more]"), resReview: spQ("[data-sp-res-review]"), resReviewLabel: spQ("[data-sp-res-review-label]"),
      resAgain: spQ("[data-sp-res-again]"), resChange: spQ("[data-sp-res-change]")
    };
    var spOk = !!(spEl.go && spEl.sheet && spEl.teach && spEl.foot && spEl.results && spEl.wall);

    function spFmt(n) { return String(Math.max(0, Math.round(n || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    /* copy with @n@ marks: the marked numbers are set in Atkinson Hyperlegible; ~...~ never breaks ("3 minutes") */
    function spNums(text) { return esc(text).replace(/~([^~]+)~/g, "<span class='sr-nw'>$1</span>").replace(/@([^@]+)@/g, "<span class='sr-n'>$1</span>"); }
    function spTypeName(t) { return t === "mixed" ? "Smart mix" : doorLabel(t); }
    function spSetStk(node, key) { if (node) node.setAttribute("data-k", key); }
    function spSay(msg) {
      if (!spEl.say) return;
      spEl.say.textContent = "";
      setTimeout(function () { spEl.say.textContent = msg; }, 30);
    }
    /* every 3D question carries random marker ids; a second copy on the page gets its own */
    function spUniq(html, tag) { return String(html || "").replace(/srah(\d+)/g, "srah" + tag + "$1"); }

    /* ---- the launcher: start button, lede, round pill, best, misses bar, sticker levels ---- */
    function spRefreshLauncher() {
      if (!spOk) return;
      var r = spGetRound();
      spEl.lede.innerHTML = spNums(SP_LEDE[r.len]);
      spEl.goLabel.innerHTML = spNums(SP_GO[r.len]);
      if (el.stickyStart) el.stickyStart.textContent = SP_GO[r.len].replace(/[@~]/g, "");
      /* the pill says "3 min" on a phone (sprint.css), as the board does */
      var mins = r.len === "300" ? 5 : 3;
      spEl.pillLen.innerHTML = r.len === "10q" ? spNums("~@10@ questions~")
        : "<span class='sr-rpill-long'>" + spNums("~@" + mins + "@ minutes~") + "</span><span class='sr-rpill-short'>" + spNums("~@" + mins + "@ min~") + "</span>";
      spSetStk(spEl.pillStk, r.type);
      spEl.pillType.textContent = spTypeName(r.type);
      spEl.pill.setAttribute("aria-label", "Round: " + SP_LENS[r.len] + ", " + spTypeName(r.type) + (r.len !== "10q" ? ", " + SP_LEVELS[r.level] : "") + ". Change it");
      var b = r.len === "10q" ? 0 : spBestOf(r);
      spEl.best.hidden = !b;
      if (b) spEl.bestN.textContent = spFmt(b);
      var n = spGetMisses().length;
      spEl.missbar.hidden = n < SP_MISSBAR_AT;
      spEl.missN.textContent = String(n);
      Array.prototype.forEach.call(spEl.wall.querySelectorAll(".sr-stile[data-door]"), function (t) {
        var d = DOOR_BY_ID[t.getAttribute("data-door")], foot = t.querySelector("[data-sp-lvl]");
        if (!d || !foot) return;
        var lv = rungState(d.id).r;
        foot.innerHTML = spNums("Level @" + lv + "@ of @" + RUNG_MAX + "@");
        t.setAttribute("aria-label", d.label + ", level " + lv + " of " + RUNG_MAX);
      });
    }
    /* the settings sheet picked another puzzle: the round follows */
    function spDoorChanged(id) {
      if (!spOk || !spValidType(id)) return;
      var r = spGetRound();
      if (r.type === id) return;
      r.type = id;
      spWrite(SP_KEYS.round, { type: r.type, len: r.len === "10q" ? "10q" : Number(r.len), level: r.level });
      spRefreshLauncher();
    }
    /* the demo card: three real small questions, looped by CSS alone (aria-hidden; reduced motion shows the first, answered) */
    function spFillDemo() {
      if (!spEl.demo) return;
      var fill = function (i, art, opts, right) {
        var a = spEl.demo.querySelector("[data-sp-demo-art='" + i + "']"), o = spEl.demo.querySelector("[data-sp-demo-opts='" + i + "']");
        if (!a || !o) return;
        a.innerHTML = spUniq(art, "d" + i);
        o.innerHTML = opts.map(function (h, k) {
          return "<div class='sr-dm-opt" + (k === right ? " is-right" : "") + "'><i class='sr-n'>" + letterFor(k) + "</i>" + spUniq(h, "d" + i + k) + "</div>";
        }).join("");
      };
      try {
        fill(0, vxSvg(vxFromHeights([[3, 1, 2], [2, 1, 1], [2, 1, 1]]), { size: 22, width: 200, label: false }),
          ["13", "15", "14", "12", "16"].map(function (v) { return "<b class='sr-n'>" + v + "</b>"; }), 2);
      } catch (e) {}
      [["folding", 1], ["reflection", 2]].forEach(function (p) {
        try {
          var q = makeQ(p[0], 1);
          if (q) fill(p[1], q.stimulusHtml, q.options.map(function (o) { return o.html; }), q.correctIdx);
        } catch (e) {}
      });
    }

    /* ---- the round sheet: how long and how hard, for one type; a sticker or the round pill opens it ---- */
    var spSheet = { r: null, from: null, open: false };
    function spSheetPaint() {
      var r = spSheet.r, d = DOOR_BY_ID[r.type];
      spSetStk(spEl.sheetStk, r.type);
      spEl.sheetName.textContent = spTypeName(r.type);
      spEl.sheetDesc.textContent = d ? d.sub + "." : "Every type, mixed.";
      Array.prototype.forEach.call(spEl.len.querySelectorAll("button"), function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === r.len ? "true" : "false"); });
      Array.prototype.forEach.call(spEl.level.querySelectorAll("button"), function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === r.level ? "true" : "false"); });
      /* "My level 3" for one type; a smart mix asks each type at its own level */
      spEl.myLvl.innerHTML = d ? " <span class='sr-n'>" + rungState(d.id).r + "</span>" : "";
      /* ten questions run the practice drill, which climbs its own levels */
      var q10 = r.len === "10q";
      spEl.levelRow.hidden = q10;
      spEl.q10Note.hidden = !q10;
      var b = q10 ? 0 : spBestOf(r);
      spEl.sheetBest.hidden = !b;
      if (b) spEl.sheetBestN.textContent = spFmt(b);
    }
    function spOpenSheet(type) {
      if (!spOk || spSheet.open || (typeof shellOpen === "function" && shellOpen())) return;
      spSheet.r = spGetRound();
      /* a sticker picks its type at once, as a VR Game tile does: the launcher, the settings and the mock follow */
      if (type && spValidType(type) && type !== spSheet.r.type) { spSheet.r.type = type; spSaveRound(spSheet.r); }
      spSheet.from = document.activeElement;
      spSheet.open = true;
      spSheetPaint();
      spEl.sheet.hidden = false;
      root.classList.add("sr-rsheet-open");
      srInertOutside(spEl.sheet, true);
      lockScroll();
      try { spEl.play.focus({ preventScroll: true }); } catch (e) {}
    }
    /* closing saves the round, as the VR Game does; keepLock: straight into a round, the shell takes the scroll lock over */
    function spCloseSheet(keepLock) {
      if (!spSheet.open) return;
      spSheet.open = false;
      spEl.sheet.hidden = true;
      root.classList.remove("sr-rsheet-open");
      srInertOutside(spEl.sheet, false);
      spSaveRound(spSheet.r);
      spRefreshLauncher();
      if (keepLock) return;
      SFX.ui("close");
      unlockScroll();
      var back = spSheet.from && document.body.contains(spSheet.from) ? spSheet.from : spEl.go;
      spSheet.from = null;
      try { back.focus({ preventScroll: true }); } catch (e) {}
    }
    function spSegClick(group, key) {
      group.addEventListener("click", function (e) {
        var b = e.target && e.target.closest ? e.target.closest("button[data-v]") : null;
        if (!b || !spSheet.open) return;
        var v = b.getAttribute("data-v");
        if (spSheet.r[key] === v) return;
        SFX.ui("select", Array.prototype.indexOf.call(group.querySelectorAll("button[data-v]"), b));
        spSheet.r[key] = v;
        spSaveRound(spSheet.r);
        spSheetPaint();
        /* the row that held the focus can hide (How hard, for ten questions): keep the focus on the pressed button */
        try { b.focus({ preventScroll: true }); } catch (err) {}
      });
    }
    function spSheetFocusables() {
      return Array.prototype.filter.call(spEl.sheet.querySelectorAll("button"), function (b) { return !b.disabled && b.getClientRects().length > 0; });
    }
    /* Tab stays inside the sheet; Escape closes it before anything else hears the key */
    document.addEventListener("keydown", function (e) {
      if (!spSheet.open) return;
      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); e.stopImmediatePropagation(); spCloseSheet(false); return; }
      if (e.key !== "Tab") return;
      var f = spSheetFocusables();
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
    }, true);

    /* ---- the round ---- */
    var sp = {
      on: false, kind: "sprint", round: null, list: null, li: 0, timed: false, total: 0,
      score: 0, streak: 0, bestStreak: 0, right: 0, wrong: 0, skipped: 0, misses: [], minRung: 0, maxRung: 0, lastAt: 0,
      q: null, next: null, locked: true, teach: false, teachAt: 0,
      deadline: 0, left: 0, paused: false, hidPause: false, hidLeft: null, tick: null, tickSec: 0,
      advance: null, prebuild: null, run: 0
    };
    /* x2 at 2 in a row, x3 at 4, x4 at 6 (the VR Game steps at 3, 6 and 10; picture questions take longer) */
    function spMult(streak) { return streak >= 6 ? 4 : streak >= 4 ? 3 : streak >= 2 ? 2 : 1; }
    /* the launcher's Start, the sheet's Play and the sticky bar: play the saved round */
    function spStartFromRound() {
      var r = spGetRound();
      spSaveRound(r);
      if (r.len === "10q") {
        /* ten questions: the practice drill as it always was, with its levels, hints and worked answers */
        state.practiceCapNext = 10;
        if (typeof openShell === "function") openShell("practice", false);
        return;
      }
      spStart({ kind: "sprint", round: r });
    }
    function spStart(cfg) {
      if (!spOk) return;
      sp.cfg = cfg;
      if (typeof shellOpen === "function" && shellOpen()) spBeginInShell(); else openShell("sprint", true);
    }
    /* called by openShell("sprint") (build_template.py) or straight from the results screen */
    function spBeginInShell() {
      var cfg = sp.cfg || { kind: "sprint", round: spGetRound() };
      spStopAll();
      if (state.practiceActive) stopPractice();
      clearLevelCard();
      el.summary.classList.remove("is-open");
      spEl.results.hidden = true;
      sp.run++;
      sp.kind = cfg.kind;
      sp.round = cfg.round || spGetRound();
      sp.list = cfg.list ? cfg.list.slice() : null;
      sp.li = 0;
      sp.timed = sp.kind === "sprint";
      sp.total = sp.timed ? Number(sp.round.len) * 1000 : (sp.list ? sp.list.length : 0);
      sp.score = 0; sp.streak = 0; sp.bestStreak = 0; sp.right = 0; sp.wrong = 0; sp.skipped = 0; sp.misses = []; sp.minRung = 0; sp.maxRung = 0;
      sp.q = null; sp.next = null; sp.locked = false; sp.teach = false; sp.paused = false; sp.hidPause = false; sp.hidLeft = null; sp.tickSec = 0;
      if (sp.kind === "sprint" && sp.round.type === "mixed") { mix.queue = []; mix.seeded = false; mix.last = []; }
      state.mode = "sprint";
      state.sprintActive = true;
      sp.on = true;
      el.shell.classList.add("sr-sp-on");
      spSetStk(spEl.chipStk, sp.kind === "sprint" ? sp.round.type : "mixed");
      spEl.chipName.textContent = sp.kind === "misses" ? "Your misses" : sp.kind === "review" ? "Wrong ones" : spTypeName(sp.round.type);
      spEl.score.textContent = "0";
      spEl.clock.classList.remove("is-low", "is-paused");
      /* no clock in a practice round: the pill counts the questions, without the clock face */
      spEl.clock.classList.toggle("is-count", !sp.timed);
      spPaintStreak(false);
      applyModeVisibility();
      if (sp.timed) { sp.deadline = Date.now() + sp.total; spPaintTime(sp.total); spStartClock(); }
      else spPaintProgress();
      spServe();
    }
    /* what the shell shows while the mode is "sprint" (applyModeVisibility hands over here) */
    function spApplyVisibility() {
      var live = !!state.sprintActive;
      el.shell.classList.add("sr-sp-on");
      el.panel.hidden = !live;
      el.labPanel.hidden = true;
      el.testIntro.hidden = true;
      el.promptText.hidden = !live; el.stimulus.hidden = !live; el.options.hidden = !live;
      [el.keysHint, el.feedback, el.explain, el.tools, el.nextBtn, el.endTestBtn, el.endPracticeBtn, el.practiceStrip, el.palette, el.navRow, el.progressWrap, el.replayToggle].forEach(function (n) { if (n) n.hidden = true; });
      if (el.hint) hideHint();
      spEl.chip.hidden = false;
      spEl.scorebox.hidden = !live; spEl.clock.hidden = !live; spEl.bar.hidden = !live; spEl.foot.hidden = !live;
      Array.prototype.forEach.call(el.tabs, function (tab) { tab.classList.remove("is-active"); tab.setAttribute("aria-selected", "false"); });
      updatePills();
    }
    /* the level a question is asked at: the type's own level, or Easy / Medium / Hard as two levels each */
    function spRungFor(door) {
      var lv = SP_LEVEL_RUNGS[sp.round.level];
      return lv ? pick(lv) : rungState(door).r;
    }
    /* a fresh question, avoiding the variants and scenes served lately (as practice does, fewer redraws) */
    function spBuild() {
      var door = nextDoorId(sp.round.type), rung = spRungFor(door), scenes = recentScenes(door), q = null, first = null;
      for (var t = 0; t < 4 && !q; t++) {
        var cand = null;
        try { cand = makeQ(door, rung, { avoid: practiceHistory(door).slice() }); } catch (e) { cand = null; }
        if (!cand) continue;
        if (!first) first = cand;
        if (scenes.indexOf(sceneKey(cand)) < 0) q = cand;
      }
      q = q || first;
      if (!q) return null;
      recordVariant(door, q);
      state.scenes[door] = scenes.concat([sceneKey(q)]).slice(-SCENE_MEMORY);
      return q;
    }
    function spTake() {
      if (sp.list) return sp.li < sp.list.length ? sp.list[sp.li++] : null;
      var q = sp.next || spBuild();
      sp.next = null;
      return q;
    }
    /* the next question is drawn while the child works on this one (a pile or a turned solid can take 200 ms) */
    function spSchedulePrebuild() {
      if (sp.list || sp.next || sp.prebuild || !sp.on) return;
      var run = sp.run;
      var go = function () { sp.prebuild = null; if (sp.on && sp.run === run && !sp.next && !sp.list) sp.next = spBuild(); };
      if (window.requestIdleCallback) sp.prebuild = { idle: window.requestIdleCallback(go, { timeout: 900 }) };
      else sp.prebuild = { t: setTimeout(go, 200) };
    }
    function spCancelPrebuild() {
      if (!sp.prebuild) return;
      if (sp.prebuild.idle && window.cancelIdleCallback) window.cancelIdleCallback(sp.prebuild.idle);
      if (sp.prebuild.t) clearTimeout(sp.prebuild.t);
      sp.prebuild = null;
    }

    function spServe() {
      if (!sp.on) return;
      var q = spTake();
      if (!q) { spFinish(sp.list ? "All done!" : "Time!"); return; }
      sp.q = q; sp.locked = false; sp.teach = false;
      state.current = { q: q, picked: null, answered: false, assisted: false, hinted: false, shownAt: Date.now() };
      clearFeedback();
      spEl.teach.hidden = true; spEl.watch.hidden = true; spEl.skip.hidden = false;
      el.shell.classList.remove("sr-sp-teaching");
      spUnreveal();
      spEl.plus.classList.remove("is-on");
      el.promptText.textContent = q.prompt;
      if (sp.kind !== "sprint" || sp.round.type === "mixed") { spSetStk(spEl.chipStk, q.door); spEl.chipName.textContent = doorLabel(q.door); }
      /* locked, as in a mock test: the 3D viewer unlocks after a wrong pick (spAfterFit keeps it inside its box) */
      mountStimulus(q, false);
      renderOptionButtons(q);
      syncArtScale(q);
      if (el.scroller) el.scroller.scrollTop = 0;
      fitQuestion();
      focusPrompt();
      spSchedulePrebuild();
    }
    /* the marks on the cards, as practice draws them: lime tick on the answer, red cross on a wrong pick */
    function spMark(q, i, reveal) {
      optionButtons().forEach(function (btn, bi) {
        btn.disabled = true;
        var name = btn.getAttribute("aria-label") || ("Option " + letterFor(bi));
        if (bi === q.correctIdx) {
          btn.classList.add("is-correct");
          var art = reveal ? revealArt(q.options[bi]) : "";
          if (art) btn.innerHTML = "<span class='cnt-opt-badge' aria-hidden='true'>" + letterFor(bi) + "</span>" + art + "<span class='cnt-opt-flag' data-opt-flag></span>";
          var f = btn.querySelector("[data-opt-flag]");
          if (f) f.innerHTML = ICO.tick + "Right answer";
          btn.setAttribute("aria-label", name + (bi === i ? ", your answer, correct" : ", the correct answer"));
        } else if (bi === i) {
          btn.classList.add("is-wrong");
          var f2 = btn.querySelector("[data-opt-flag]");
          if (f2) f2.innerHTML = ICO.cross + "Your pick";
          btn.setAttribute("aria-label", name + ", your answer, not correct");
        }
      });
    }
    function spPaintStreak(stepped) {
      var m = spMult(sp.streak), lit = Math.min(sp.streak, SP_PIPS);
      spEl.mult.textContent = "×" + m;
      spEl.streak.classList.toggle("is-x1", m === 1);
      Array.prototype.forEach.call(spEl.pips.querySelectorAll("i"), function (p, k) { p.classList.toggle("on", k < lit); });
      spEl.streakSay.textContent = sp.streak ? sp.streak + " in a row, points times " + m : "No streak yet";
      if (stepped) spBump(spEl.streak, "is-step");
    }
    function spBump(node, cls) {
      if (!node) return;
      node.classList.remove(cls);
      void node.offsetWidth;
      node.classList.add(cls);
    }
    /* the levels the round's answered and skipped questions came from (the results line names them) */
    function spNoteRung(q) {
      var r = Number(q && q.rung) || 0;
      if (!r) return;
      if (!sp.minRung || r < sp.minRung) sp.minRung = r;
      if (r > sp.maxRung) sp.maxRung = r;
    }
    function spMiss(q, picked) {
      sp.lastAt = Math.max(Date.now(), sp.lastAt + 1);
      sp.misses.push({ q: q, picked: picked, skipped: picked == null, at: q.at || sp.lastAt });
    }
    function spPick(i) {
      if (!sp.on || sp.locked || !sp.q || sp.teach) return;
      var q = sp.q, run = sp.run;
      if (!(i >= 0 && i < q.options.length)) return;
      sp.locked = true;
      spNoteRung(q);
      var right = i === q.correctIdx;
      state.current.answered = true; state.current.picked = i;
      spMark(q, i, !right);
      if (DOOR_BY_ID[q.door]) { accRecord(q.door, right); saveStore(); }
      if (right) {
        var before = spMult(sp.streak);
        sp.right++; sp.streak++;
        if (sp.streak > sp.bestStreak) sp.bestStreak = sp.streak;
        var m = spMult(sp.streak), pts = 100 * m;
        sp.score += pts;
        spEl.score.textContent = spFmt(sp.score);
        spEl.plus.textContent = "+" + pts;
        spBump(spEl.plus, "is-on");
        spBump(spEl.score, "is-bump");
        spPaintStreak(m > before || sp.streak === 1);
        /* a step up to x2, x3 or x4 plays the combo in place of the right sound; the kit's own every-fifth combo is
           kept out of the round (this instance is shared with practice, where it stays on) */
        if (m > before) SFX.combo(m - 1); else SFX.right(sp.streak % 5 === 0 ? sp.streak - 1 : sp.streak);
        spSay("Right. " + pts + " points.");
        if (sp.kind !== "sprint" && typeof q.at === "number") spRemoveMiss(q.at);
        sp.advance = setTimeout(function () {
          sp.advance = null;
          if (!sp.on || sp.run !== run || sp.q !== q) return;
          if (sp.list && sp.li >= sp.list.length) { spFinish("All done!"); return; }
          spServe();
        }, SP_RIGHT_MS);
        spPaintProgress();
      } else {
        sp.wrong++; sp.streak = 0;
        spPaintStreak(false);
        SFX.wrong();
        spMiss(q, i);
        spPause();
        spShowTeach(q);
      }
    }
    /* a wrong pick: one line from the worked answer, the clock waits, nothing moves on until Next */
    function spShowTeach(q) {
      sp.teach = true;
      sp.teachAt = Date.now();
      var line = typeof q.line === "string" && q.line ? q.line : spTeachLine(q);
      spEl.teachLine.textContent = line;
      spEl.teach.hidden = false;
      spEl.skip.hidden = true;
      el.shell.classList.add("sr-sp-teaching");
      var d = DOOR_BY_ID[q.door];
      spEl.watch.hidden = !(d && d.watch && q.review);
      if (!spEl.watch.hidden) { spEl.watch.textContent = d.watch; spEl.watch.setAttribute("aria-pressed", "false"); }
      unlockStimulus();
      el.tools.hidden = true;
      spSay("Not this one. " + line);
      fitQuestion();
      spReveal();
      try { spEl.next.focus({ preventScroll: true }); } catch (e) {}
    }
    /* A phone (one column): the teach card sits fixed along the bottom (sprint.css), so Next is always in reach, and
       the prompt holds to the top of the screen; the scroller makes room under the card and moves just enough to
       show the marked answers. A wide screen fits everything already (fitQuestion). */
    function spReveal() {
      var sc = el.scroller;
      if (!sc) return;
      sc.style.paddingBottom = "";
      if (window.innerWidth >= 761 || spEl.teach.hidden) return;
      /* a spacer as tall as the panel (and its shadow), so nothing on the question can end up hidden behind it */
      var th = spEl.teach.getBoundingClientRect().height, q = sp.q, room = Math.ceil(th + 24);
      sc.style.paddingBottom = room + "px";
      sc.style.scrollPaddingBottom = room + "px";
      /* the new padding resizes the scroller, and its fit (fitQuestion, a frame later) briefly unsets the picture's
         height, which would clamp a scroll made now: scroll once that has settled */
      setTimeout(function () {
        if (!sp.teach || sp.q !== q || spEl.teach.hidden) return;
        var b = sc.getBoundingClientRect(), opts = el.options.getBoundingClientRect();
        var need = opts.bottom - (b.bottom - spEl.teach.getBoundingClientRect().height - 20);
        if (need > 0) sc.scrollTop += need;
      }, 120);
    }
    function spUnreveal() { if (el.scroller) { el.scroller.style.paddingBottom = ""; el.scroller.style.scrollPaddingBottom = ""; } }
    function spContinue() {
      if (!sp.on || !sp.teach || Date.now() - sp.teachAt < 250) return;
      SFX.ui("next");
      sp.teach = false;
      spEl.teach.hidden = true;
      el.shell.classList.remove("sr-sp-teaching");
      spUnreveal();
      if (el.replayPanel && !el.replayPanel.hidden) setReplayOpen(false);
      if (sp.list && sp.li >= sp.list.length) { spFinish("All done!"); return; }
      spResume();
      spServe();
    }
    /* Skip: no points, the streak stays, the clock keeps running; the question waits in the round's misses */
    function spSkip() {
      if (!sp.on || sp.locked || sp.teach || !sp.q) return;
      SFX.ui("skip");
      sp.skipped++;
      spNoteRung(sp.q);
      spMiss(sp.q, null);
      sp.locked = true;
      spSay("Skipped.");
      spPaintProgress();
      if (sp.list && sp.li >= sp.list.length) { spFinish("All done!"); return; }
      spServe();
    }
    function spWatch() {
      if (!sp.on || !sp.teach || !sp.q || !sp.q.review) return;
      var open = el.replayPanel.hidden;
      if (open) SFX.fold(); else SFX.ui("back");
      setReplayOpen(open);
      var d = DOOR_BY_ID[sp.q.door];
      spEl.watch.textContent = open ? "Back to the question" : (d && d.watch ? d.watch : "Watch it");
      spEl.watch.setAttribute("aria-pressed", open ? "true" : "false");
      el.tools.hidden = true;
    }

    /* ---- the clock: a deadline, painted every 200 ms; it waits on the teach card and while the tab is hidden ---- */
    function spStartClock() { spStopClock(); sp.tick = setInterval(spPaintClock, 200); spPaintClock(); }
    function spStopClock() { if (sp.tick) { clearInterval(sp.tick); sp.tick = null; } }
    function spPaintClock() {
      if (!sp.on || !sp.timed || sp.paused || sp.hidPause) return;
      var left = sp.deadline - Date.now();
      if (left <= 0) { spPaintTime(0); spStopClock(); SFX.timeUp(); spFinish("Time!"); return; }
      /* a tick as each of the last five seconds starts (the clock turns red pen at ten) */
      var sec = Math.ceil(left / 1000);
      if (sec <= 5 && sec !== sp.tickSec) { sp.tickSec = sec; SFX.tick(sec); }
      spPaintTime(left);
    }
    function spPaintTime(left) {
      var sec = Math.max(0, Math.ceil(left / 1000)), m = Math.floor(sec / 60), s = sec % 60;
      spEl.clockNum.textContent = m + ":" + (s < 10 ? "0" : "") + s;
      spEl.clock.setAttribute("aria-label", m + " minutes " + s + " seconds left");
      spEl.barFill.style.width = (Math.max(0, Math.min(1, left / Math.max(1, sp.total))) * 100).toFixed(2) + "%";
      spEl.clock.classList.toggle("is-low", left <= 10000);
      spEl.bar.classList.toggle("is-low", left <= 10000);
    }
    /* a practice round has no clock: the pill counts the questions and the bar fills */
    function spPaintProgress() {
      if (sp.timed) return;
      var done = sp.right + sp.wrong + sp.skipped, total = Math.max(1, sp.total);
      spEl.clockNum.textContent = Math.min(done, total) + "/" + total;
      spEl.clock.setAttribute("aria-label", Math.min(done, total) + " of " + total + " done");
      spEl.barFill.style.width = (Math.min(1, done / total) * 100).toFixed(2) + "%";
      spEl.clock.classList.remove("is-low");
      spEl.bar.classList.remove("is-low");
    }
    function spPause() {
      if (!sp.timed || sp.paused) return;
      sp.paused = true;
      sp.left = Math.max(0, sp.deadline - Date.now());
      spEl.clock.classList.add("is-paused");
    }
    function spResume() {
      if (!sp.paused) return;
      sp.paused = false;
      spEl.clock.classList.remove("is-paused");
      sp.deadline = Date.now() + sp.left;
      spPaintClock();
    }
    document.addEventListener("visibilitychange", function () {
      if (!sp.on || !sp.timed) return;
      if (document.hidden) {
        if (sp.hidPause) return;
        sp.hidPause = true;
        sp.hidLeft = sp.paused ? null : Math.max(0, sp.deadline - Date.now());
      } else if (sp.hidPause) {
        sp.hidPause = false;
        if (sp.hidLeft != null) sp.deadline = Date.now() + sp.hidLeft;
        sp.hidLeft = null;
      }
    });

    /* ---- the end of a round ---- */
    function spStopAll() {
      spStopClock();
      if (sp.advance) { clearTimeout(sp.advance); sp.advance = null; }
      spCancelPrebuild();
      sp.next = null;
    }
    function spFinish(title) {
      if (!sp.on) return;
      sp.on = false; sp.locked = true; sp.teach = false;
      state.sprintActive = false;
      spStopAll();
      if (el.replayPanel && !el.replayPanel.hidden) setReplayOpen(false);
      if (state.viewer) { state.viewer.stop(); state.viewer = null; }
      state.current = null;
      clearFeedback();
      /* the last question leaves the page, so its drawing never shares an id with its copy in the missed cards */
      el.stimulus.innerHTML = ""; el.options.innerHTML = "";
      spEl.teach.hidden = true;
      el.shell.classList.remove("sr-sp-teaching");
      spUnreveal();
      var answered = sp.right + sp.wrong;
      /* a finished sprint keeps its wrong and skipped questions for later (a quit round keeps nothing) */
      if (sp.kind === "sprint" && sp.misses.length) spAddMisses(sp.misses);
      var prev = sp.kind === "sprint" ? spBestOf(sp.round) : 0;
      var isPb = sp.kind === "sprint" && sp.score > prev && sp.score > 0;
      if (isPb) spSetBest(sp.round, sp.score);
      /* the finish waits for the time-up sound (or the last press); a new best sparkles about 900 ms after it */
      if (answered) {
        var share = sp.right / answered, at = title === "Time!" ? 700 : 120;
        SFX.after(at, function () { SFX.finish(share); });
        if (isPb) SFX.after(at + 900, function () { SFX.best(); });
      }
      spRenderResults(title, isPb, prev);
      applyModeVisibility();
      spEl.scorebox.hidden = true; spEl.clock.hidden = true; spEl.bar.hidden = true; spEl.foot.hidden = true;
      spEl.results.hidden = false;
      spRefreshLauncher();
      spSay(title + " " + spFmt(sp.score) + " points, " + sp.right + " right." + (isPb ? " New best." : ""));
      if (el.scroller) el.scroller.scrollTop = 0;
      /* the buttons wait a moment, so the press that ended the round cannot start the next */
      sp.resAt = Date.now();
      try { spEl.resTitle.focus({ preventScroll: true }); } catch (e) {}
    }
    function spMeta() {
      if (sp.kind === "misses") return "Your missed questions · no clock";
      if (sp.kind === "review") return "Your wrong ones · no clock";
      /* "Level 3" when every question came from one level, "Levels 2 to 4" when a smart mix spread wider */
      var r = sp.round, lv = r.level !== "my" ? SP_LEVELS[r.level]
        : !sp.maxRung ? "" : sp.minRung === sp.maxRung ? "Level @" + sp.maxRung + "@" : "Levels @" + sp.minRung + "@ to @" + sp.maxRung + "@";
      return spTypeName(r.type) + " · ~@" + (r.len === "300" ? 5 : 3) + "@ minutes~" + (lv ? " · " + lv : "");
    }
    function spRenderResults(title, isPb, prev) {
      spEl.resTitle.textContent = title;
      spEl.resScore.textContent = spFmt(sp.score);
      spEl.resHead.classList.toggle("is-pb", isPb);
      spEl.resHead.classList.toggle("is-zero", sp.score === 0);
      spBump(spEl.resHead, "is-in");
      spEl.resMeta.innerHTML = spNums(spMeta() + (sp.kind === "sprint" && !isPb && prev ? " · your best is @" + spFmt(prev) + "@" : ""));
      spEl.resRight.textContent = String(sp.right);
      spEl.resStreak.textContent = String(sp.bestStreak);
      spEl.resMiss.textContent = String(sp.misses.length);
      var html = "";
      sp.misses.slice(0, SP_SHOW_MISSED).forEach(function (m, k) {
        var q = m.q, d = DOOR_BY_ID[q.door], ans = q.options[q.correctIdx] || {};
        html += "<div class='sr-mcard'><p class='sr-mcard-head'><span class='sr-stk' data-k='" + esc(q.door) + "' aria-hidden='true'></span><span class='sr-mcard-name'>" + esc(d ? d.label : q.door) + "</span>" +
          (m.skipped ? "<span class='sr-mcard-tag'>Skipped</span>" : "") + "</p>" +
          "<div class='sr-mcard-body'><div class='sr-mcard-q'>" + spUniq(q.stimulusHtml, "m" + k) + "</div>" +
          "<div class='sr-mcard-a'><span class='sr-mcard-albl'>Answer</span><div class='sr-mcard-abox'>" + spUniq(ans.html, "a" + k) +
          "<span class='sr-mcard-tick' aria-hidden='true'>" + ICO.tick + "</span></div><span class='cnt-sr-only'>The answer is " + letterFor(q.correctIdx) + ".</span></div></div></div>";
      });
      spEl.resList.innerHTML = html;
      spEl.resList.hidden = !sp.misses.length;
      var more = sp.misses.length - SP_SHOW_MISSED;
      spEl.resMore.hidden = more <= 0;
      if (more > 0) spEl.resMore.innerHTML = spNums("and @" + more + "@ more");
      spEl.resReview.hidden = !sp.misses.length;
      spEl.resReviewLabel.innerHTML = sp.misses.length === 1 ? "Practise it" : spNums("Practise my @" + sp.misses.length + "@");
    }
    /* the app closed (button, Escape): a round still running is dropped, nothing saved */
    function spShellClosed() {
      if (sp.on) { sp.on = false; spStopAll(); }
      state.sprintActive = false;
      sp.locked = true; sp.teach = false;
      if (el.shell) el.shell.classList.remove("sr-sp-on", "sr-sp-teaching");
      if (spOk) {
        spEl.results.hidden = true; spEl.teach.hidden = true;
        [spEl.chip, spEl.scorebox, spEl.clock, spEl.bar, spEl.foot].forEach(function (n) { n.hidden = true; });
        spRefreshLauncher();
      }
      if (state.mode === "sprint") state.mode = "practice";
    }
    /* After the fit (ui.js fitQuestion): a new CSS zoom reaches layout a frame late in Chrome, so a fit made right after
       another one can measure the old zoom and leave the drawing taller than its box (beside the replay, over the
       teach card). In a sprint the drawing is checked once the zoom has landed and trimmed until it sits inside. */
    var spFitCheck = 0;
    function spAfterFit() {
      if (!state.sprintActive || !spOk) return;
      var token = ++spFitCheck, tries = 0;
      var later = function (fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); };
      var check = function () {
        if (token !== spFitCheck || !state.sprintActive) return;
        var st = el.stimulus, q = sp.q;
        if (!st || !st.classList.contains("sr-fit") || (q && q.matchArt) || !st.getClientRects().length) return;
        var kids = Array.prototype.filter.call(st.children, function (c) { return !c.classList.contains("cnt-fold-pill") && !c.classList.contains("sr-visually-hidden"); });
        if (!kids.length) return;
        var b = st.getBoundingClientRect(), cs = getComputedStyle(st), px = function (v) { return parseFloat(v) || 0; };
        var room = b.height - px(cs.borderTopWidth) - px(cs.paddingTop) - px(cs.borderBottomWidth) - px(cs.paddingBottom);
        /* heights only: a figure is a block as wide as its box whatever the zoom, so its width says nothing */
        var lo = Infinity, hi = -Infinity;
        kids.forEach(function (k) { var r = k.getBoundingClientRect(); if (!r.width && !r.height) return; lo = Math.min(lo, r.top); hi = Math.max(hi, r.bottom); });
        if (!(hi > lo) || !(room > 0)) return;
        var f = room / (hi - lo);
        if (!(f < 0.995)) return;
        var z = Math.max(0.4, (parseFloat(getComputedStyle(kids[0]).zoom) || 1) * f * 0.98);
        kids.forEach(function (k) { k.style.zoom = String(z); });
        st.style.setProperty("--sr-zoom", String(z));
        if (++tries < 3) later(check);
      };
      later(check);
    }
    /* another mode takes the shell (setMode): the sprint's own pieces step aside */
    function spLeaveMode() {
      if (!spOk || state.sprintActive) return;
      if (el.shell) el.shell.classList.remove("sr-sp-on", "sr-sp-teaching");
      spEl.results.hidden = true; spEl.teach.hidden = true;
      [spEl.chip, spEl.scorebox, spEl.clock, spEl.bar, spEl.foot].forEach(function (n) { n.hidden = true; });
    }
    /* a fit for the sprint: the answers, the teach card and the streak row all stay above the fold */
    function spFitEnd() {
      if (!state.sprintActive || !spOk || window.innerWidth < 761) return 0;
      var y = 0;
      [spEl.teach, spEl.foot].forEach(function (n) { if (n && !n.hidden && n.getClientRects().length) y = Math.max(y, n.getBoundingClientRect().bottom); });
      return y;
    }

    /* ---- events ---- */
    function spResultsReady() { return !sp.on && !spEl.results.hidden && Date.now() - (sp.resAt || 0) > 600; }
    function spShuffle(a) { return typeof shuffle === "function" ? shuffle(a.slice()) : a.slice(); }
    if (spOk) {
      spEl.go.addEventListener("click", function () { SFX.ui("play"); spStartFromRound(); });
      spEl.pill.addEventListener("click", function () { SFX.ui("open"); spOpenSheet(null); });
      spEl.choose.addEventListener("click", function () {
        SFX.ui("open");
        var smooth = !(window.__srReduceMotion || reduceMotion);
        try { spEl.wallSec.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" }); } catch (e) { spEl.wallSec.scrollIntoView(); }
        try { spEl.wallSec.focus({ preventScroll: true }); } catch (e) {}
      });
      /* every sticker plucks its own note (the doors keep the notes they had on the old launcher) and opens the sheet;
         Mock test is wired by the shell (data-open-test) */
      spEl.wall.addEventListener("click", function (e) {
        var t = e.target && e.target.closest ? e.target.closest(".sr-stile[data-door]") : null;
        if (!t) return;
        var id = t.getAttribute("data-door");
        if (id === "mixed") SFX.ui("on"); else SFX.ui("level", DOORS.indexOf(DOOR_BY_ID[id]) + 1);
        spOpenSheet(id);
      });
      spSegClick(spEl.len, "len");
      spSegClick(spEl.level, "level");
      spEl.play.addEventListener("click", function () { if (!spSheet.open) return; SFX.ui("play"); spCloseSheet(true); spStartFromRound(); });
      Array.prototype.forEach.call(spEl.sheet.querySelectorAll("[data-sp-sheet-close]"), function (b) { b.addEventListener("click", function () { spCloseSheet(false); }); });
      spEl.missGo.addEventListener("click", function () {
        var list = spGetMisses();
        if (!list.length) { spRefreshLauncher(); return; }
        SFX.ui("play");
        spStart({ kind: "misses", round: spGetRound(), list: spShuffle(list).map(function (m) { var q = m.q; q.at = m.at; return q; }) });
      });
      spEl.missClear.addEventListener("click", function () {
        SFX.ui("off");
        spDrop(SP_KEYS.misses);
        spRefreshLauncher();
        try { spEl.go.focus({ preventScroll: true }); } catch (e) {}
      });
      spEl.next.addEventListener("click", spContinue);
      spEl.skip.addEventListener("click", spSkip);
      spEl.watch.addEventListener("click", spWatch);
      spEl.resReview.addEventListener("click", function () {
        if (!spResultsReady() || !sp.misses.length) return;
        SFX.ui("play");
        spStart({ kind: "review", round: sp.round, list: sp.misses.map(function (m) { var q = m.q; q.at = m.at; return q; }) });
      });
      spEl.resAgain.addEventListener("click", function () {
        if (!spResultsReady()) return;
        SFX.ui("restart");
        spStart({ kind: "sprint", round: sp.kind === "sprint" ? sp.round : spGetRound() });
      });
      spEl.resChange.addEventListener("click", function () {
        if (!spResultsReady()) return;
        if (typeof closeShell === "function") closeShell();
        /* after the shell gives the page its scroll position back */
        setTimeout(function () {
          try { spEl.wallSec.scrollIntoView({ block: "start" }); } catch (e) {}
          try { spEl.wallSec.focus({ preventScroll: true }); } catch (e) {}
        }, 60);
      });
      /* the round's keys: A to E (or 1 to 5) answer, S skips, Enter, Space or N go on from the teach card.
         A focused button keeps Enter and Space for itself; a held key never repeats an answer */
      document.addEventListener("keydown", function (e) {
        if (!sp.on || state.mode !== "sprint" || spSheet.open) return;
        var t = e.target;
        if (t && (t.tagName === "INPUT" || t.tagName === "SELECT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        var k = String(e.key || "").toLowerCase();
        if (e.repeat) { if (k === "enter" || k === " " || k === "s" || /^[a-e1-5]$/.test(k)) e.preventDefault(); return; }
        if ((k === "enter" || k === " ") && t && (t.tagName === "BUTTON" || t.tagName === "SUMMARY" || t.tagName === "A")) return;
        if (k === " " && t && t.classList && t.classList.contains("sr-viewer")) return;
        if (sp.teach) {
          if (k === "enter" || k === " " || k === "n") { e.preventDefault(); spContinue(); }
          return;
        }
        if (sp.locked || !sp.q) return;
        var idx = ["a", "b", "c", "d", "e"].indexOf(k);
        if (idx === -1 && k >= "1" && k <= "5") idx = Number(k) - 1;
        if (idx > -1 && idx < sp.q.options.length) { e.preventDefault(); spPick(idx); return; }
        if (k === "s") { e.preventDefault(); spSkip(); }
      });
    }

    /* ---- boot: the saved round is the picked puzzle; draw the launcher ---- */
    (function () {
      if (!spOk) return;
      var r = spGetRound();
      if (state.door !== r.type) selectDoor(r.type);
      spFillDemo();
      spRefreshLauncher();
    })();
    window.__shlcSpatialDebug.sprint = {
      sp: sp, el: spEl, start: spStart, startFromRound: spStartFromRound, pick: spPick, skip: spSkip, next: spContinue, finish: spFinish,
      openSheet: spOpenSheet, closeSheet: spCloseSheet, getRound: spGetRound, getMisses: spGetMisses, bestOf: spBestOf, mult: spMult,
      refresh: spRefreshLauncher, teachLine: spTeachLine, trim: spTrimQ, keys: SP_KEYS
    };
    /* ============================================================
       18. ARCADE SHELL (lifted from Cube Nets v3)
       The page shows a launcher card. Practice or Test opens a fixed
       full-screen shell; Esc or the round close button returns to the
       page. Nothing opens on load, except when the URL carries #play.
       ============================================================ */
    var shell = root.querySelector("[data-shell]");
    var scrollLock = { on: false, y: 0 };
    function lockScroll() {
      if (scrollLock.on) return;
      scrollLock.on = true;
      scrollLock.y = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = "fixed";
      document.body.style.top = (-scrollLock.y) + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.documentElement.style.overflow = "hidden";
    }
    function unlockScroll() {
      if (!scrollLock.on) return;
      scrollLock.on = false;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.documentElement.style.overflow = "";
      var y = scrollLock.y;
      window.scrollTo(0, y);
      setTimeout(function () { window.scrollTo(0, y); }, 0);
    }
    function shellOpen() { return shell.classList.contains("is-open"); }
    function openShell(mode, startNow) {
      srShellOpening();
      root.classList.add("app-open");
      shell.classList.add("is-open");
      shell.setAttribute("aria-hidden", "false");
      lockScroll();
      el.summary.classList.remove("is-open");
      if (mode === "test") {
        setMode("test");
        if (startNow) startTest();
      } else if (mode === "lab") {
        setMode("lab");
      } else if (mode === "sprint") {
        spBeginInShell();
      } else {
        setMode("practice");
      }
      if (el.scroller) el.scroller.scrollTop = 0;
      srShellOpened();
    }
    function closeShell() {
      if (!shellOpen()) return;
      if (state.testActive && testAnsweredCount()) {
        SFX.ui("ask");
        if (!window.confirm("End the test now? You will see your marks for the questions answered so far.")) return;
        finishSession();
        return;
      }
      SFX.hush();
      SFX.ui("close");
      if (state.testActive || state.practiceActive) {
        state.testActive = false;
        state.practiceActive = false;
        state.current = null;
        state.testQs = null;
        state.testEnd = null;
        stopTimer();
        setControlsLocked(false);
      }
      if (state.viewer) { state.viewer.stop(); state.viewer = null; }
      shell.classList.remove("is-open");
      shell.setAttribute("aria-hidden", "true");
      root.classList.remove("app-open");
      unlockScroll();
      el.summary.classList.remove("is-open");
      state.mode = "practice";
      clearFeedback();
      el.panel.hidden = true;
      el.labPanel.hidden = true;
      renderIntroBest();
      updateChip();
      srShellClosed();
    }
    var srPractiseBtn = root.querySelector("[data-open-practice]");
    if (srPractiseBtn) srPractiseBtn.addEventListener("click", function () { SFX.ui("play"); openShell("practice", false); });
    el.openTestBtn.addEventListener("click", function () { SFX.ui("play"); openShell("test", true); });
    el.closeBtn.addEventListener("click", closeShell);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && shellOpen()) { e.preventDefault(); closeShell(); }
    });
    if (window.location.hash === "#play") openShell("practice", false);
  });
})();
